import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  _date: any;
  _uuid: any;
  float8: any;
  jsonb: any;
  object: any;
  platform: any;
  timestamptz: any;
  tournament_stages_scalar: any;
  uuid: any;
};

export type AddMatchParticipantsInput = {
  matchId: Scalars['uuid'];
  participants: Array<Maybe<Scalars['uuid']>>;
};

export type AddMatchParticipantsOutput = {
  __typename?: 'AddMatchParticipantsOutput';
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
};

export type ChangePasswordInput = {
  email: Scalars['String'];
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type ChangePasswordOutput = {
  __typename?: 'ChangePasswordOutput';
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type CheckIfTeamExistsInput = {
  name: Scalars['String'];
  nickname: Scalars['String'];
  teamType: Scalars['String'];
};

export type CheckIfTeamExistsOutput = {
  __typename?: 'CheckIfTeamExistsOutput';
  error?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type CreateBattleRoyaleMatchInput = {
  excludeParticipants?: Maybe<Array<Scalars['uuid']>>;
  matchTime: Scalars['String'];
  name: Scalars['String'];
  tournamentId: Scalars['uuid'];
};

export type CreateMatchInput = {
  game: Scalars['String'];
  matchTime: Scalars['String'];
  matchType: Scalars['String'];
  maxParticipants: Scalars['Int'];
  minParticipants: Scalars['Int'];
  name: Scalars['String'];
  participants: Array<Maybe<Scalars['uuid']>>;
  tournamentId: Scalars['uuid'];
};

export type CreateMatchOutput = {
  __typename?: 'CreateMatchOutput';
  error?: Maybe<Scalars['String']>;
  matchId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type CreateTeamInput = {
  avatar?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nickname: Scalars['String'];
  ownerId?: Maybe<Scalars['String']>;
  teamMembers?: Maybe<Array<Maybe<Scalars['String']>>>;
  teamType: Scalars['String'];
};

export type CreateTeamOutput = {
  __typename?: 'CreateTeamOutput';
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type CreateTournamentInput = {
  description?: Maybe<Scalars['String']>;
  endDate: Scalars['String'];
  endTime: Scalars['String'];
  gameId: Scalars['String'];
  maximumParticipants: Scalars['Int'];
  name: Scalars['String'];
  platform: Platform;
  posterURL: Scalars['String'];
  region: Scalars['String'];
  registrationFee: Scalars['String'];
  registrationStart: Scalars['String'];
  registrationStop: Scalars['String'];
  rewards?: Maybe<Scalars['String']>;
  rules: Scalars['String'];
  sponsorId: Scalars['String'];
  startDate: Scalars['String'];
  startTime: Scalars['String'];
  teamType: Scalars['String'];
  tournamentStructure: TournamentStructure;
  tournamentType: Scalars['String'];
};

export type CreateTournamentOutput = {
  __typename?: 'CreateTournamentOutput';
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  tournamentId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type GameStatsInput = {
  entries?: Maybe<Scalars['String']>;
  gameId: Scalars['uuid'];
  sortBy?: Maybe<Scalars['String']>;
};

export type GameStatsOutput = {
  __typename?: 'GameStatsOutput';
  stats?: Maybe<Array<Maybe<Scalars['object']>>>;
};

export type GenerateResetPasswordTokenInput = {
  email: Scalars['String'];
};

export type GenerateResetPasswordTokenOutput = {
  __typename?: 'GenerateResetPasswordTokenOutput';
  resetToken?: Maybe<Scalars['String']>;
};

export type GetPlayerTournamentsStatsInput = {
  filters: Array<Scalars['object']>;
};

export type GetTournamentStatsInput = {
  filters?: Maybe<Scalars['object']>;
  tournamentIds: Array<Scalars['uuid']>;
};

export type GetTournamentStatsOutput = {
  __typename?: 'GetTournamentStatsOutput';
  stats?: Maybe<Scalars['object']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LoginOutput = {
  __typename?: 'LoginOutput';
  accessToken?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type MagicLinkLoginInput = {
  code: Scalars['String'];
};

export type MagicLinkLoginOutput = {
  __typename?: 'MagicLinkLoginOutput';
  accessToken: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type MeOutput = {
  __typename?: 'MeOutput';
  avatar?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Boolean']>;
  details?: Maybe<Scalars['jsonb']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  locale?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  partyDetails: Array<Party_Details>;
  partyDetails_aggregate: Party_Details_Aggregate;
  phone_number?: Maybe<Scalars['String']>;
  /** An array relationship */
  tournament_registrations: Array<Tournament_Registrations>;
  /** An aggregate relationship */
  tournament_registrations_aggregate: Tournament_Registrations_Aggregate;
};


export type MeOutputPartyDetailsArgs = {
  distinct_on?: Maybe<Array<Party_Details_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Details_Order_By>>;
  where?: Maybe<Party_Details_Bool_Exp>;
};


export type MeOutputPartyDetails_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Details_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Details_Order_By>>;
  where?: Maybe<Party_Details_Bool_Exp>;
};


export type MeOutputTournament_RegistrationsArgs = {
  distinct_on?: Maybe<Array<Tournament_Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Registrations_Order_By>>;
  where?: Maybe<Tournament_Registrations_Bool_Exp>;
};


export type MeOutputTournament_Registrations_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Registrations_Order_By>>;
  where?: Maybe<Tournament_Registrations_Bool_Exp>;
};

export type MyStatsOutput = {
  __typename?: 'MyStatsOutput';
  id: Scalars['ID'];
  party?: Maybe<Parties>;
  ranks?: Maybe<Scalars['object']>;
  scores?: Maybe<Scalars['object']>;
};

export enum Platform {
  Console = 'Console',
  Cross = 'Cross',
  Mobile = 'Mobile',
  Pc = 'PC',
  Platform = 'Platform'
}

export type RecordMatchResultInput = {
  actualParticipants: Array<Maybe<Scalars['uuid']>>;
  assists?: Maybe<Scalars['object']>;
  deaths?: Maybe<Scalars['object']>;
  draws?: Maybe<Scalars['object']>;
  goalDifference?: Maybe<Scalars['object']>;
  goalsAgainst?: Maybe<Scalars['object']>;
  goalsFor?: Maybe<Scalars['object']>;
  kills?: Maybe<Scalars['object']>;
  losses?: Maybe<Scalars['object']>;
  matchId: Scalars['uuid'];
  tournamentId: Scalars['uuid'];
  wins?: Maybe<Scalars['object']>;
};

export type RecordMatchResultOutput = {
  __typename?: 'RecordMatchResultOutput';
  matchResultId?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type RegisterTeamForTournamentInput = {
  teamId: Scalars['String'];
  tournamentId: Scalars['String'];
};

export type RegisterTeamForTournamentOutput = {
  __typename?: 'RegisterTeamForTournamentOutput';
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type RemoveMatchParticipantsInput = {
  matchId: Scalars['uuid'];
  participants: Array<Maybe<Scalars['uuid']>>;
};

export type RemoveMatchParticipantsOutput = {
  __typename?: 'RemoveMatchParticipantsOutput';
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ResetPasswordInput = {
  email: Scalars['String'];
  newPassword: Scalars['String'];
  token: Scalars['String'];
};

export type ResetPasswordOutput = {
  __typename?: 'ResetPasswordOutput';
  code?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type SendLobbyLinkInput = {
  lobbyLink: Scalars['String'];
  matchId: Scalars['uuid'];
};

export type SendLobbyLinkOutput = {
  __typename?: 'SendLobbyLinkOutput';
  message?: Maybe<Scalars['String']>;
};

export type SignupInput = {
  avatar?: Maybe<Scalars['String']>;
  dateOfBirth: Scalars['String'];
  email: Scalars['String'];
  enableMFA: Scalars['Boolean'];
  gender: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nickname?: Maybe<Scalars['String']>;
  partyType?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  phoneNumber: Scalars['String'];
  preferredGames?: Maybe<Array<Scalars['String']>>;
};

export type SignupOutput = {
  __typename?: 'SignupOutput';
  message?: Maybe<Scalars['String']>;
  partyId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type StatsInput = {
  leaderboardId: Scalars['String'];
  partyId?: Maybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>;
};

export enum TournamentStructure {
  BestOfThree = 'BEST_OF_THREE',
  DoubleElimination = 'DOUBLE_ELIMINATION',
  Knockout = 'KNOCKOUT',
  RoundRobin = 'ROUND_ROBIN',
  SingleElimination = 'SINGLE_ELIMINATION',
  SwissSystem = 'SWISS_SYSTEM'
}

export type UpdateProfileInput = {
  avatar?: Maybe<Scalars['String']>;
  bio: Scalars['String'];
  email: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nickname: Scalars['String'];
  phoneNumber: Scalars['String'];
  preferredGames?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UpdateProfileOutput = {
  __typename?: 'UpdateProfileOutput';
  id: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "_date". All fields are combined with logical 'AND'. */
export type _Date_Comparison_Exp = {
  _eq?: Maybe<Scalars['_date']>;
  _gt?: Maybe<Scalars['_date']>;
  _gte?: Maybe<Scalars['_date']>;
  _in?: Maybe<Array<Scalars['_date']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['_date']>;
  _lte?: Maybe<Scalars['_date']>;
  _neq?: Maybe<Scalars['_date']>;
  _nin?: Maybe<Array<Scalars['_date']>>;
};

/** Boolean expression to compare columns of type "_uuid". All fields are combined with logical 'AND'. */
export type _Uuid_Comparison_Exp = {
  _eq?: Maybe<Scalars['_uuid']>;
  _gt?: Maybe<Scalars['_uuid']>;
  _gte?: Maybe<Scalars['_uuid']>;
  _in?: Maybe<Array<Scalars['_uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['_uuid']>;
  _lte?: Maybe<Scalars['_uuid']>;
  _neq?: Maybe<Scalars['_uuid']>;
  _nin?: Maybe<Array<Scalars['_uuid']>>;
};

/** columns and relationships of "audit_logs" */
export type Audit_Logs = {
  __typename?: 'audit_logs';
  change_data?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_name: Scalars['String'];
  id: Scalars['uuid'];
  reason?: Maybe<Scalars['String']>;
  resource: Scalars['String'];
  service: Scalars['String'];
  user_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "audit_logs" */
export type Audit_LogsChange_DataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "audit_logs" */
export type Audit_Logs_Aggregate = {
  __typename?: 'audit_logs_aggregate';
  aggregate?: Maybe<Audit_Logs_Aggregate_Fields>;
  nodes: Array<Audit_Logs>;
};

/** aggregate fields of "audit_logs" */
export type Audit_Logs_Aggregate_Fields = {
  __typename?: 'audit_logs_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Audit_Logs_Max_Fields>;
  min?: Maybe<Audit_Logs_Min_Fields>;
};


/** aggregate fields of "audit_logs" */
export type Audit_Logs_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Audit_Logs_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Audit_Logs_Append_Input = {
  change_data?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "audit_logs". All fields are combined with a logical 'AND'. */
export type Audit_Logs_Bool_Exp = {
  _and?: Maybe<Array<Audit_Logs_Bool_Exp>>;
  _not?: Maybe<Audit_Logs_Bool_Exp>;
  _or?: Maybe<Array<Audit_Logs_Bool_Exp>>;
  change_data?: Maybe<Jsonb_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  event_name?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  reason?: Maybe<String_Comparison_Exp>;
  resource?: Maybe<String_Comparison_Exp>;
  service?: Maybe<String_Comparison_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "audit_logs" */
export enum Audit_Logs_Constraint {
  /** unique or primary key constraint on columns "id" */
  AuditLogsPkey = 'audit_logs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Audit_Logs_Delete_At_Path_Input = {
  change_data?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Audit_Logs_Delete_Elem_Input = {
  change_data?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Audit_Logs_Delete_Key_Input = {
  change_data?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "audit_logs" */
export type Audit_Logs_Insert_Input = {
  change_data?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Audit_Logs_Max_Fields = {
  __typename?: 'audit_logs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  event_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Audit_Logs_Min_Fields = {
  __typename?: 'audit_logs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  event_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "audit_logs" */
export type Audit_Logs_Mutation_Response = {
  __typename?: 'audit_logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Audit_Logs>;
};

/** on_conflict condition type for table "audit_logs" */
export type Audit_Logs_On_Conflict = {
  constraint: Audit_Logs_Constraint;
  update_columns?: Array<Audit_Logs_Update_Column>;
  where?: Maybe<Audit_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "audit_logs". */
export type Audit_Logs_Order_By = {
  change_data?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  event_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  reason?: Maybe<Order_By>;
  resource?: Maybe<Order_By>;
  service?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: audit_logs */
export type Audit_Logs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Audit_Logs_Prepend_Input = {
  change_data?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "audit_logs" */
export enum Audit_Logs_Select_Column {
  /** column name */
  ChangeData = 'change_data',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventName = 'event_name',
  /** column name */
  Id = 'id',
  /** column name */
  Reason = 'reason',
  /** column name */
  Resource = 'resource',
  /** column name */
  Service = 'service',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "audit_logs" */
export type Audit_Logs_Set_Input = {
  change_data?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "audit_logs" */
export type Audit_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Audit_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audit_Logs_Stream_Cursor_Value_Input = {
  change_data?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "audit_logs" */
export enum Audit_Logs_Update_Column {
  /** column name */
  ChangeData = 'change_data',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventName = 'event_name',
  /** column name */
  Id = 'id',
  /** column name */
  Reason = 'reason',
  /** column name */
  Resource = 'resource',
  /** column name */
  Service = 'service',
  /** column name */
  UserId = 'user_id'
}

export type Audit_Logs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Audit_Logs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Audit_Logs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Audit_Logs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Audit_Logs_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Audit_Logs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Audit_Logs_Set_Input>;
  where: Audit_Logs_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "flags" */
export type Flags = {
  __typename?: 'flags';
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An array relationship */
  match_flags: Array<Match_Flags>;
  /** An aggregate relationship */
  match_flags_aggregate: Match_Flags_Aggregate;
  name: Scalars['String'];
  /** An array relationship */
  party_flags: Array<Party_Flags>;
  /** An aggregate relationship */
  party_flags_aggregate: Party_Flags_Aggregate;
  /** An array relationship */
  tournament_flags: Array<Tournament_Flags>;
  /** An aggregate relationship */
  tournament_flags_aggregate: Tournament_Flags_Aggregate;
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_flags: Array<User_Flags>;
  /** An aggregate relationship */
  user_flags_aggregate: User_Flags_Aggregate;
  value?: Maybe<Scalars['String']>;
};


/** columns and relationships of "flags" */
export type FlagsMatch_FlagsArgs = {
  distinct_on?: Maybe<Array<Match_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Match_Flags_Order_By>>;
  where?: Maybe<Match_Flags_Bool_Exp>;
};


/** columns and relationships of "flags" */
export type FlagsMatch_Flags_AggregateArgs = {
  distinct_on?: Maybe<Array<Match_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Match_Flags_Order_By>>;
  where?: Maybe<Match_Flags_Bool_Exp>;
};


/** columns and relationships of "flags" */
export type FlagsParty_FlagsArgs = {
  distinct_on?: Maybe<Array<Party_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Flags_Order_By>>;
  where?: Maybe<Party_Flags_Bool_Exp>;
};


/** columns and relationships of "flags" */
export type FlagsParty_Flags_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Flags_Order_By>>;
  where?: Maybe<Party_Flags_Bool_Exp>;
};


/** columns and relationships of "flags" */
export type FlagsTournament_FlagsArgs = {
  distinct_on?: Maybe<Array<Tournament_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Flags_Order_By>>;
  where?: Maybe<Tournament_Flags_Bool_Exp>;
};


/** columns and relationships of "flags" */
export type FlagsTournament_Flags_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Flags_Order_By>>;
  where?: Maybe<Tournament_Flags_Bool_Exp>;
};


/** columns and relationships of "flags" */
export type FlagsUser_FlagsArgs = {
  distinct_on?: Maybe<Array<User_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Flags_Order_By>>;
  where?: Maybe<User_Flags_Bool_Exp>;
};


/** columns and relationships of "flags" */
export type FlagsUser_Flags_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Flags_Order_By>>;
  where?: Maybe<User_Flags_Bool_Exp>;
};

/** aggregated selection of "flags" */
export type Flags_Aggregate = {
  __typename?: 'flags_aggregate';
  aggregate?: Maybe<Flags_Aggregate_Fields>;
  nodes: Array<Flags>;
};

/** aggregate fields of "flags" */
export type Flags_Aggregate_Fields = {
  __typename?: 'flags_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Flags_Max_Fields>;
  min?: Maybe<Flags_Min_Fields>;
};


/** aggregate fields of "flags" */
export type Flags_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Flags_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "flags". All fields are combined with a logical 'AND'. */
export type Flags_Bool_Exp = {
  _and?: Maybe<Array<Flags_Bool_Exp>>;
  _not?: Maybe<Flags_Bool_Exp>;
  _or?: Maybe<Array<Flags_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  match_flags?: Maybe<Match_Flags_Bool_Exp>;
  match_flags_aggregate?: Maybe<Match_Flags_Aggregate_Bool_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  party_flags?: Maybe<Party_Flags_Bool_Exp>;
  party_flags_aggregate?: Maybe<Party_Flags_Aggregate_Bool_Exp>;
  tournament_flags?: Maybe<Tournament_Flags_Bool_Exp>;
  tournament_flags_aggregate?: Maybe<Tournament_Flags_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user_flags?: Maybe<User_Flags_Bool_Exp>;
  user_flags_aggregate?: Maybe<User_Flags_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "flags" */
export enum Flags_Constraint {
  /** unique or primary key constraint on columns "id" */
  FlagsPkey = 'flags_pkey',
  /** unique or primary key constraint on columns "value" */
  FlagsValueUnique = 'flags_value_unique'
}

/** input type for inserting data into table "flags" */
export type Flags_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  match_flags?: Maybe<Match_Flags_Arr_Rel_Insert_Input>;
  name?: Maybe<Scalars['String']>;
  party_flags?: Maybe<Party_Flags_Arr_Rel_Insert_Input>;
  tournament_flags?: Maybe<Tournament_Flags_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_flags?: Maybe<User_Flags_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Flags_Max_Fields = {
  __typename?: 'flags_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Flags_Min_Fields = {
  __typename?: 'flags_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "flags" */
export type Flags_Mutation_Response = {
  __typename?: 'flags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Flags>;
};

/** input type for inserting object relation for remote table "flags" */
export type Flags_Obj_Rel_Insert_Input = {
  data: Flags_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Flags_On_Conflict>;
};

/** on_conflict condition type for table "flags" */
export type Flags_On_Conflict = {
  constraint: Flags_Constraint;
  update_columns?: Array<Flags_Update_Column>;
  where?: Maybe<Flags_Bool_Exp>;
};

/** Ordering options when selecting data from "flags". */
export type Flags_Order_By = {
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  match_flags_aggregate?: Maybe<Match_Flags_Aggregate_Order_By>;
  name?: Maybe<Order_By>;
  party_flags_aggregate?: Maybe<Party_Flags_Aggregate_Order_By>;
  tournament_flags_aggregate?: Maybe<Tournament_Flags_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
  user_flags_aggregate?: Maybe<User_Flags_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: flags */
export type Flags_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "flags" */
export enum Flags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "flags" */
export type Flags_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "flags" */
export type Flags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Flags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Flags_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "flags" */
export enum Flags_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Flags_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Flags_Set_Input>;
  where: Flags_Bool_Exp;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: Maybe<Scalars['float8']>;
  _gt?: Maybe<Scalars['float8']>;
  _gte?: Maybe<Scalars['float8']>;
  _in?: Maybe<Array<Scalars['float8']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['float8']>;
  _lte?: Maybe<Scalars['float8']>;
  _neq?: Maybe<Scalars['float8']>;
  _nin?: Maybe<Array<Scalars['float8']>>;
};

/** columns and relationships of "games" */
export type Games = {
  __typename?: 'games';
  banner_url?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An array relationship */
  matches: Array<Matches>;
  /** An aggregate relationship */
  matches_aggregate: Matches_Aggregate;
  metadata?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  poster_url?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  /** An array relationship */
  tournaments: Array<Tournaments>;
  /** An aggregate relationship */
  tournaments_aggregate: Tournaments_Aggregate;
  /** An object relationship */
  type: Types;
  type_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "games" */
export type GamesMatchesArgs = {
  distinct_on?: Maybe<Array<Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Matches_Order_By>>;
  where?: Maybe<Matches_Bool_Exp>;
};


/** columns and relationships of "games" */
export type GamesMatches_AggregateArgs = {
  distinct_on?: Maybe<Array<Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Matches_Order_By>>;
  where?: Maybe<Matches_Bool_Exp>;
};


/** columns and relationships of "games" */
export type GamesMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "games" */
export type GamesTournamentsArgs = {
  distinct_on?: Maybe<Array<Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournaments_Order_By>>;
  where?: Maybe<Tournaments_Bool_Exp>;
};


/** columns and relationships of "games" */
export type GamesTournaments_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournaments_Order_By>>;
  where?: Maybe<Tournaments_Bool_Exp>;
};

/** aggregated selection of "games" */
export type Games_Aggregate = {
  __typename?: 'games_aggregate';
  aggregate?: Maybe<Games_Aggregate_Fields>;
  nodes: Array<Games>;
};

export type Games_Aggregate_Bool_Exp = {
  count?: Maybe<Games_Aggregate_Bool_Exp_Count>;
};

export type Games_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Games_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Games_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "games" */
export type Games_Aggregate_Fields = {
  __typename?: 'games_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Games_Max_Fields>;
  min?: Maybe<Games_Min_Fields>;
};


/** aggregate fields of "games" */
export type Games_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Games_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "games" */
export type Games_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Games_Max_Order_By>;
  min?: Maybe<Games_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Games_Append_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "games" */
export type Games_Arr_Rel_Insert_Input = {
  data: Array<Games_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Games_On_Conflict>;
};

/** Boolean expression to filter rows from the table "games". All fields are combined with a logical 'AND'. */
export type Games_Bool_Exp = {
  _and?: Maybe<Array<Games_Bool_Exp>>;
  _not?: Maybe<Games_Bool_Exp>;
  _or?: Maybe<Array<Games_Bool_Exp>>;
  banner_url?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  matches?: Maybe<Matches_Bool_Exp>;
  matches_aggregate?: Maybe<Matches_Aggregate_Bool_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  poster_url?: Maybe<String_Comparison_Exp>;
  slug?: Maybe<String_Comparison_Exp>;
  tournaments?: Maybe<Tournaments_Bool_Exp>;
  tournaments_aggregate?: Maybe<Tournaments_Aggregate_Bool_Exp>;
  type?: Maybe<Types_Bool_Exp>;
  type_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "games" */
export enum Games_Constraint {
  /** unique or primary key constraint on columns "id" */
  GamesPkey = 'games_pkey',
  /** unique or primary key constraint on columns "poster_url" */
  GamesPosterKey = 'games_poster_key',
  /** unique or primary key constraint on columns "slug" */
  GamesSlugKey = 'games_slug_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Games_Delete_At_Path_Input = {
  metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Games_Delete_Elem_Input = {
  metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Games_Delete_Key_Input = {
  metadata?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "games" */
export type Games_Insert_Input = {
  banner_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  matches?: Maybe<Matches_Arr_Rel_Insert_Input>;
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  poster_url?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  tournaments?: Maybe<Tournaments_Arr_Rel_Insert_Input>;
  type?: Maybe<Types_Obj_Rel_Insert_Input>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Games_Max_Fields = {
  __typename?: 'games_max_fields';
  banner_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  poster_url?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "games" */
export type Games_Max_Order_By = {
  banner_url?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  poster_url?: Maybe<Order_By>;
  slug?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Games_Min_Fields = {
  __typename?: 'games_min_fields';
  banner_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  poster_url?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "games" */
export type Games_Min_Order_By = {
  banner_url?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  poster_url?: Maybe<Order_By>;
  slug?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "games" */
export type Games_Mutation_Response = {
  __typename?: 'games_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Games>;
};

/** input type for inserting object relation for remote table "games" */
export type Games_Obj_Rel_Insert_Input = {
  data: Games_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Games_On_Conflict>;
};

/** on_conflict condition type for table "games" */
export type Games_On_Conflict = {
  constraint: Games_Constraint;
  update_columns?: Array<Games_Update_Column>;
  where?: Maybe<Games_Bool_Exp>;
};

/** Ordering options when selecting data from "games". */
export type Games_Order_By = {
  banner_url?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  matches_aggregate?: Maybe<Matches_Aggregate_Order_By>;
  metadata?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  poster_url?: Maybe<Order_By>;
  slug?: Maybe<Order_By>;
  tournaments_aggregate?: Maybe<Tournaments_Aggregate_Order_By>;
  type?: Maybe<Types_Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: games */
export type Games_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Games_Prepend_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "games" */
export enum Games_Select_Column {
  /** column name */
  BannerUrl = 'banner_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PosterUrl = 'poster_url',
  /** column name */
  Slug = 'slug',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "games" */
export type Games_Set_Input = {
  banner_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  poster_url?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "games" */
export type Games_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Games_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Games_Stream_Cursor_Value_Input = {
  banner_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  poster_url?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "games" */
export enum Games_Update_Column {
  /** column name */
  BannerUrl = 'banner_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PosterUrl = 'poster_url',
  /** column name */
  Slug = 'slug',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Games_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Games_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Games_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Games_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Games_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Games_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Games_Set_Input>;
  where: Games_Bool_Exp;
};

/** Temp table */
export type Hub_Registrations = {
  __typename?: 'hub_registrations';
  contact_name: Scalars['String'];
  contact_number: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  location: Scalars['String'];
  name: Scalars['String'];
  selected_qualifiers: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
  website?: Maybe<Scalars['String']>;
};


/** Temp table */
export type Hub_RegistrationsSelected_QualifiersArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "hub_registrations" */
export type Hub_Registrations_Aggregate = {
  __typename?: 'hub_registrations_aggregate';
  aggregate?: Maybe<Hub_Registrations_Aggregate_Fields>;
  nodes: Array<Hub_Registrations>;
};

/** aggregate fields of "hub_registrations" */
export type Hub_Registrations_Aggregate_Fields = {
  __typename?: 'hub_registrations_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Hub_Registrations_Max_Fields>;
  min?: Maybe<Hub_Registrations_Min_Fields>;
};


/** aggregate fields of "hub_registrations" */
export type Hub_Registrations_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Hub_Registrations_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Hub_Registrations_Append_Input = {
  selected_qualifiers?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "hub_registrations". All fields are combined with a logical 'AND'. */
export type Hub_Registrations_Bool_Exp = {
  _and?: Maybe<Array<Hub_Registrations_Bool_Exp>>;
  _not?: Maybe<Hub_Registrations_Bool_Exp>;
  _or?: Maybe<Array<Hub_Registrations_Bool_Exp>>;
  contact_name?: Maybe<String_Comparison_Exp>;
  contact_number?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  location?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  selected_qualifiers?: Maybe<Jsonb_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  website?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hub_registrations" */
export enum Hub_Registrations_Constraint {
  /** unique or primary key constraint on columns "name" */
  HubRegistrationNameKey = 'hub_registration_name_key',
  /** unique or primary key constraint on columns "id" */
  HubRegistrationPkey = 'hub_registration_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Hub_Registrations_Delete_At_Path_Input = {
  selected_qualifiers?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Hub_Registrations_Delete_Elem_Input = {
  selected_qualifiers?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Hub_Registrations_Delete_Key_Input = {
  selected_qualifiers?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "hub_registrations" */
export type Hub_Registrations_Insert_Input = {
  contact_name?: Maybe<Scalars['String']>;
  contact_number?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  selected_qualifiers?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  website?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hub_Registrations_Max_Fields = {
  __typename?: 'hub_registrations_max_fields';
  contact_name?: Maybe<Scalars['String']>;
  contact_number?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  website?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hub_Registrations_Min_Fields = {
  __typename?: 'hub_registrations_min_fields';
  contact_name?: Maybe<Scalars['String']>;
  contact_number?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  website?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hub_registrations" */
export type Hub_Registrations_Mutation_Response = {
  __typename?: 'hub_registrations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hub_Registrations>;
};

/** on_conflict condition type for table "hub_registrations" */
export type Hub_Registrations_On_Conflict = {
  constraint: Hub_Registrations_Constraint;
  update_columns?: Array<Hub_Registrations_Update_Column>;
  where?: Maybe<Hub_Registrations_Bool_Exp>;
};

/** Ordering options when selecting data from "hub_registrations". */
export type Hub_Registrations_Order_By = {
  contact_name?: Maybe<Order_By>;
  contact_number?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  selected_qualifiers?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  website?: Maybe<Order_By>;
};

/** primary key columns input for table: hub_registrations */
export type Hub_Registrations_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Hub_Registrations_Prepend_Input = {
  selected_qualifiers?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "hub_registrations" */
export enum Hub_Registrations_Select_Column {
  /** column name */
  ContactName = 'contact_name',
  /** column name */
  ContactNumber = 'contact_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  SelectedQualifiers = 'selected_qualifiers',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Website = 'website'
}

/** input type for updating data in table "hub_registrations" */
export type Hub_Registrations_Set_Input = {
  contact_name?: Maybe<Scalars['String']>;
  contact_number?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  selected_qualifiers?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  website?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "hub_registrations" */
export type Hub_Registrations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hub_Registrations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hub_Registrations_Stream_Cursor_Value_Input = {
  contact_name?: Maybe<Scalars['String']>;
  contact_number?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  selected_qualifiers?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  website?: Maybe<Scalars['String']>;
};

/** update columns of table "hub_registrations" */
export enum Hub_Registrations_Update_Column {
  /** column name */
  ContactName = 'contact_name',
  /** column name */
  ContactNumber = 'contact_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  SelectedQualifiers = 'selected_qualifiers',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Website = 'website'
}

export type Hub_Registrations_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Hub_Registrations_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Hub_Registrations_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Hub_Registrations_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Hub_Registrations_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Hub_Registrations_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Hub_Registrations_Set_Input>;
  where: Hub_Registrations_Bool_Exp;
};

/** columns and relationships of "invites" */
export type Invites = {
  __typename?: 'invites';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  invite_code: Scalars['uuid'];
  invited: Scalars['uuid'];
  invited_to?: Maybe<Scalars['uuid']>;
  invitee: Scalars['uuid'];
  /** An object relationship */
  party: Parties;
  /** An object relationship */
  partyByInvitedTo?: Maybe<Parties>;
  /** An object relationship */
  partyByInvitee: Parties;
  /** An object relationship */
  party_invite?: Maybe<Party_Invites>;
  /** An array relationship */
  party_invites: Array<Party_Invites>;
  /** An aggregate relationship */
  party_invites_aggregate: Party_Invites_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "invites" */
export type InvitesParty_InvitesArgs = {
  distinct_on?: Maybe<Array<Party_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Invites_Order_By>>;
  where?: Maybe<Party_Invites_Bool_Exp>;
};


/** columns and relationships of "invites" */
export type InvitesParty_Invites_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Invites_Order_By>>;
  where?: Maybe<Party_Invites_Bool_Exp>;
};

/** aggregated selection of "invites" */
export type Invites_Aggregate = {
  __typename?: 'invites_aggregate';
  aggregate?: Maybe<Invites_Aggregate_Fields>;
  nodes: Array<Invites>;
};

export type Invites_Aggregate_Bool_Exp = {
  count?: Maybe<Invites_Aggregate_Bool_Exp_Count>;
};

export type Invites_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Invites_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Invites_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invites" */
export type Invites_Aggregate_Fields = {
  __typename?: 'invites_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Invites_Max_Fields>;
  min?: Maybe<Invites_Min_Fields>;
};


/** aggregate fields of "invites" */
export type Invites_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Invites_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invites" */
export type Invites_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Invites_Max_Order_By>;
  min?: Maybe<Invites_Min_Order_By>;
};

/** input type for inserting array relation for remote table "invites" */
export type Invites_Arr_Rel_Insert_Input = {
  data: Array<Invites_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Invites_On_Conflict>;
};

/** Boolean expression to filter rows from the table "invites". All fields are combined with a logical 'AND'. */
export type Invites_Bool_Exp = {
  _and?: Maybe<Array<Invites_Bool_Exp>>;
  _not?: Maybe<Invites_Bool_Exp>;
  _or?: Maybe<Array<Invites_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  invite_code?: Maybe<Uuid_Comparison_Exp>;
  invited?: Maybe<Uuid_Comparison_Exp>;
  invited_to?: Maybe<Uuid_Comparison_Exp>;
  invitee?: Maybe<Uuid_Comparison_Exp>;
  party?: Maybe<Parties_Bool_Exp>;
  partyByInvitedTo?: Maybe<Parties_Bool_Exp>;
  partyByInvitee?: Maybe<Parties_Bool_Exp>;
  party_invite?: Maybe<Party_Invites_Bool_Exp>;
  party_invites?: Maybe<Party_Invites_Bool_Exp>;
  party_invites_aggregate?: Maybe<Party_Invites_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "invites" */
export enum Invites_Constraint {
  /** unique or primary key constraint on columns "id" */
  InvitesPkey = 'invites_pkey'
}

/** input type for inserting data into table "invites" */
export type Invites_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invite_code?: Maybe<Scalars['uuid']>;
  invited?: Maybe<Scalars['uuid']>;
  invited_to?: Maybe<Scalars['uuid']>;
  invitee?: Maybe<Scalars['uuid']>;
  party?: Maybe<Parties_Obj_Rel_Insert_Input>;
  partyByInvitedTo?: Maybe<Parties_Obj_Rel_Insert_Input>;
  partyByInvitee?: Maybe<Parties_Obj_Rel_Insert_Input>;
  party_invite?: Maybe<Party_Invites_Obj_Rel_Insert_Input>;
  party_invites?: Maybe<Party_Invites_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Invites_Max_Fields = {
  __typename?: 'invites_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invite_code?: Maybe<Scalars['uuid']>;
  invited?: Maybe<Scalars['uuid']>;
  invited_to?: Maybe<Scalars['uuid']>;
  invitee?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "invites" */
export type Invites_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invite_code?: Maybe<Order_By>;
  invited?: Maybe<Order_By>;
  invited_to?: Maybe<Order_By>;
  invitee?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Invites_Min_Fields = {
  __typename?: 'invites_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invite_code?: Maybe<Scalars['uuid']>;
  invited?: Maybe<Scalars['uuid']>;
  invited_to?: Maybe<Scalars['uuid']>;
  invitee?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "invites" */
export type Invites_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invite_code?: Maybe<Order_By>;
  invited?: Maybe<Order_By>;
  invited_to?: Maybe<Order_By>;
  invitee?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "invites" */
export type Invites_Mutation_Response = {
  __typename?: 'invites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invites>;
};

/** input type for inserting object relation for remote table "invites" */
export type Invites_Obj_Rel_Insert_Input = {
  data: Invites_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Invites_On_Conflict>;
};

/** on_conflict condition type for table "invites" */
export type Invites_On_Conflict = {
  constraint: Invites_Constraint;
  update_columns?: Array<Invites_Update_Column>;
  where?: Maybe<Invites_Bool_Exp>;
};

/** Ordering options when selecting data from "invites". */
export type Invites_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invite_code?: Maybe<Order_By>;
  invited?: Maybe<Order_By>;
  invited_to?: Maybe<Order_By>;
  invitee?: Maybe<Order_By>;
  party?: Maybe<Parties_Order_By>;
  partyByInvitedTo?: Maybe<Parties_Order_By>;
  partyByInvitee?: Maybe<Parties_Order_By>;
  party_invite?: Maybe<Party_Invites_Order_By>;
  party_invites_aggregate?: Maybe<Party_Invites_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: invites */
export type Invites_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "invites" */
export enum Invites_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InviteCode = 'invite_code',
  /** column name */
  Invited = 'invited',
  /** column name */
  InvitedTo = 'invited_to',
  /** column name */
  Invitee = 'invitee',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "invites" */
export type Invites_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invite_code?: Maybe<Scalars['uuid']>;
  invited?: Maybe<Scalars['uuid']>;
  invited_to?: Maybe<Scalars['uuid']>;
  invitee?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "invites" */
export type Invites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invites_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invite_code?: Maybe<Scalars['uuid']>;
  invited?: Maybe<Scalars['uuid']>;
  invited_to?: Maybe<Scalars['uuid']>;
  invitee?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "invites" */
export enum Invites_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InviteCode = 'invite_code',
  /** column name */
  Invited = 'invited',
  /** column name */
  InvitedTo = 'invited_to',
  /** column name */
  Invitee = 'invitee',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Invites_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Invites_Set_Input>;
  where: Invites_Bool_Exp;
};

export type Jsonb_Cast_Exp = {
  String?: Maybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: Maybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: Maybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: Maybe<Scalars['jsonb']>;
  _eq?: Maybe<Scalars['jsonb']>;
  _gt?: Maybe<Scalars['jsonb']>;
  _gte?: Maybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: Maybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: Maybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: Maybe<Array<Scalars['String']>>;
  _in?: Maybe<Array<Scalars['jsonb']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['jsonb']>;
  _lte?: Maybe<Scalars['jsonb']>;
  _neq?: Maybe<Scalars['jsonb']>;
  _nin?: Maybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "live_event_messages" */
export type Live_Event_Messages = {
  __typename?: 'live_event_messages';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  is_moderated: Scalars['Boolean'];
  /** An object relationship */
  live_event: Live_Events;
  live_event_id: Scalars['uuid'];
  /** An object relationship */
  live_event_message?: Maybe<Live_Event_Messages>;
  /** An array relationship */
  live_event_messages: Array<Live_Event_Messages>;
  /** An aggregate relationship */
  live_event_messages_aggregate: Live_Event_Messages_Aggregate;
  message: Scalars['String'];
  parent_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  party: Parties;
  sender: Scalars['uuid'];
  /** An object relationship */
  status: Statuses;
  status_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "live_event_messages" */
export type Live_Event_MessagesLive_Event_MessagesArgs = {
  distinct_on?: Maybe<Array<Live_Event_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Event_Messages_Order_By>>;
  where?: Maybe<Live_Event_Messages_Bool_Exp>;
};


/** columns and relationships of "live_event_messages" */
export type Live_Event_MessagesLive_Event_Messages_AggregateArgs = {
  distinct_on?: Maybe<Array<Live_Event_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Event_Messages_Order_By>>;
  where?: Maybe<Live_Event_Messages_Bool_Exp>;
};

/** aggregated selection of "live_event_messages" */
export type Live_Event_Messages_Aggregate = {
  __typename?: 'live_event_messages_aggregate';
  aggregate?: Maybe<Live_Event_Messages_Aggregate_Fields>;
  nodes: Array<Live_Event_Messages>;
};

export type Live_Event_Messages_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Live_Event_Messages_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Live_Event_Messages_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Live_Event_Messages_Aggregate_Bool_Exp_Count>;
};

export type Live_Event_Messages_Aggregate_Bool_Exp_Bool_And = {
  arguments: Live_Event_Messages_Select_Column_Live_Event_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Live_Event_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Live_Event_Messages_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Live_Event_Messages_Select_Column_Live_Event_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Live_Event_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Live_Event_Messages_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Live_Event_Messages_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Live_Event_Messages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "live_event_messages" */
export type Live_Event_Messages_Aggregate_Fields = {
  __typename?: 'live_event_messages_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Live_Event_Messages_Max_Fields>;
  min?: Maybe<Live_Event_Messages_Min_Fields>;
};


/** aggregate fields of "live_event_messages" */
export type Live_Event_Messages_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Live_Event_Messages_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "live_event_messages" */
export type Live_Event_Messages_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Live_Event_Messages_Max_Order_By>;
  min?: Maybe<Live_Event_Messages_Min_Order_By>;
};

/** input type for inserting array relation for remote table "live_event_messages" */
export type Live_Event_Messages_Arr_Rel_Insert_Input = {
  data: Array<Live_Event_Messages_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Live_Event_Messages_On_Conflict>;
};

/** Boolean expression to filter rows from the table "live_event_messages". All fields are combined with a logical 'AND'. */
export type Live_Event_Messages_Bool_Exp = {
  _and?: Maybe<Array<Live_Event_Messages_Bool_Exp>>;
  _not?: Maybe<Live_Event_Messages_Bool_Exp>;
  _or?: Maybe<Array<Live_Event_Messages_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  is_moderated?: Maybe<Boolean_Comparison_Exp>;
  live_event?: Maybe<Live_Events_Bool_Exp>;
  live_event_id?: Maybe<Uuid_Comparison_Exp>;
  live_event_message?: Maybe<Live_Event_Messages_Bool_Exp>;
  live_event_messages?: Maybe<Live_Event_Messages_Bool_Exp>;
  live_event_messages_aggregate?: Maybe<Live_Event_Messages_Aggregate_Bool_Exp>;
  message?: Maybe<String_Comparison_Exp>;
  parent_id?: Maybe<Uuid_Comparison_Exp>;
  party?: Maybe<Parties_Bool_Exp>;
  sender?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<Statuses_Bool_Exp>;
  status_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "live_event_messages" */
export enum Live_Event_Messages_Constraint {
  /** unique or primary key constraint on columns "id" */
  LiveEventMessagesPkey = 'live_event_messages_pkey'
}

/** input type for inserting data into table "live_event_messages" */
export type Live_Event_Messages_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_moderated?: Maybe<Scalars['Boolean']>;
  live_event?: Maybe<Live_Events_Obj_Rel_Insert_Input>;
  live_event_id?: Maybe<Scalars['uuid']>;
  live_event_message?: Maybe<Live_Event_Messages_Obj_Rel_Insert_Input>;
  live_event_messages?: Maybe<Live_Event_Messages_Arr_Rel_Insert_Input>;
  message?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['uuid']>;
  party?: Maybe<Parties_Obj_Rel_Insert_Input>;
  sender?: Maybe<Scalars['uuid']>;
  status?: Maybe<Statuses_Obj_Rel_Insert_Input>;
  status_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Live_Event_Messages_Max_Fields = {
  __typename?: 'live_event_messages_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  live_event_id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['uuid']>;
  sender?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "live_event_messages" */
export type Live_Event_Messages_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  live_event_id?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
  sender?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Live_Event_Messages_Min_Fields = {
  __typename?: 'live_event_messages_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  live_event_id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['uuid']>;
  sender?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "live_event_messages" */
export type Live_Event_Messages_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  live_event_id?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
  sender?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "live_event_messages" */
export type Live_Event_Messages_Mutation_Response = {
  __typename?: 'live_event_messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Live_Event_Messages>;
};

/** input type for inserting object relation for remote table "live_event_messages" */
export type Live_Event_Messages_Obj_Rel_Insert_Input = {
  data: Live_Event_Messages_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Live_Event_Messages_On_Conflict>;
};

/** on_conflict condition type for table "live_event_messages" */
export type Live_Event_Messages_On_Conflict = {
  constraint: Live_Event_Messages_Constraint;
  update_columns?: Array<Live_Event_Messages_Update_Column>;
  where?: Maybe<Live_Event_Messages_Bool_Exp>;
};

/** Ordering options when selecting data from "live_event_messages". */
export type Live_Event_Messages_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_moderated?: Maybe<Order_By>;
  live_event?: Maybe<Live_Events_Order_By>;
  live_event_id?: Maybe<Order_By>;
  live_event_message?: Maybe<Live_Event_Messages_Order_By>;
  live_event_messages_aggregate?: Maybe<Live_Event_Messages_Aggregate_Order_By>;
  message?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
  party?: Maybe<Parties_Order_By>;
  sender?: Maybe<Order_By>;
  status?: Maybe<Statuses_Order_By>;
  status_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: live_event_messages */
export type Live_Event_Messages_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "live_event_messages" */
export enum Live_Event_Messages_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsModerated = 'is_moderated',
  /** column name */
  LiveEventId = 'live_event_id',
  /** column name */
  Message = 'message',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  Sender = 'sender',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "live_event_messages_aggregate_bool_exp_bool_and_arguments_columns" columns of table "live_event_messages" */
export enum Live_Event_Messages_Select_Column_Live_Event_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsModerated = 'is_moderated'
}

/** select "live_event_messages_aggregate_bool_exp_bool_or_arguments_columns" columns of table "live_event_messages" */
export enum Live_Event_Messages_Select_Column_Live_Event_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsModerated = 'is_moderated'
}

/** input type for updating data in table "live_event_messages" */
export type Live_Event_Messages_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_moderated?: Maybe<Scalars['Boolean']>;
  live_event_id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['uuid']>;
  sender?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "live_event_messages" */
export type Live_Event_Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Live_Event_Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Live_Event_Messages_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_moderated?: Maybe<Scalars['Boolean']>;
  live_event_id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['uuid']>;
  sender?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "live_event_messages" */
export enum Live_Event_Messages_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsModerated = 'is_moderated',
  /** column name */
  LiveEventId = 'live_event_id',
  /** column name */
  Message = 'message',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  Sender = 'sender',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Live_Event_Messages_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Live_Event_Messages_Set_Input>;
  where: Live_Event_Messages_Bool_Exp;
};

/** columns and relationships of "live_events" */
export type Live_Events = {
  __typename?: 'live_events';
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  event_end?: Maybe<Scalars['timestamptz']>;
  event_start?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An array relationship */
  live_event_messages: Array<Live_Event_Messages>;
  /** An aggregate relationship */
  live_event_messages_aggregate: Live_Event_Messages_Aggregate;
  moderate_messages: Scalars['Boolean'];
  name: Scalars['String'];
  /** An object relationship */
  status: Statuses;
  status_id: Scalars['uuid'];
  stream_url?: Maybe<Scalars['String']>;
  /** An object relationship */
  type?: Maybe<Types>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "live_events" */
export type Live_EventsLive_Event_MessagesArgs = {
  distinct_on?: Maybe<Array<Live_Event_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Event_Messages_Order_By>>;
  where?: Maybe<Live_Event_Messages_Bool_Exp>;
};


/** columns and relationships of "live_events" */
export type Live_EventsLive_Event_Messages_AggregateArgs = {
  distinct_on?: Maybe<Array<Live_Event_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Event_Messages_Order_By>>;
  where?: Maybe<Live_Event_Messages_Bool_Exp>;
};

/** aggregated selection of "live_events" */
export type Live_Events_Aggregate = {
  __typename?: 'live_events_aggregate';
  aggregate?: Maybe<Live_Events_Aggregate_Fields>;
  nodes: Array<Live_Events>;
};

export type Live_Events_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Live_Events_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Live_Events_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Live_Events_Aggregate_Bool_Exp_Count>;
};

export type Live_Events_Aggregate_Bool_Exp_Bool_And = {
  arguments: Live_Events_Select_Column_Live_Events_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Live_Events_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Live_Events_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Live_Events_Select_Column_Live_Events_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Live_Events_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Live_Events_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Live_Events_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Live_Events_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "live_events" */
export type Live_Events_Aggregate_Fields = {
  __typename?: 'live_events_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Live_Events_Max_Fields>;
  min?: Maybe<Live_Events_Min_Fields>;
};


/** aggregate fields of "live_events" */
export type Live_Events_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Live_Events_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "live_events" */
export type Live_Events_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Live_Events_Max_Order_By>;
  min?: Maybe<Live_Events_Min_Order_By>;
};

/** input type for inserting array relation for remote table "live_events" */
export type Live_Events_Arr_Rel_Insert_Input = {
  data: Array<Live_Events_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Live_Events_On_Conflict>;
};

/** Boolean expression to filter rows from the table "live_events". All fields are combined with a logical 'AND'. */
export type Live_Events_Bool_Exp = {
  _and?: Maybe<Array<Live_Events_Bool_Exp>>;
  _not?: Maybe<Live_Events_Bool_Exp>;
  _or?: Maybe<Array<Live_Events_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  event_end?: Maybe<Timestamptz_Comparison_Exp>;
  event_start?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  live_event_messages?: Maybe<Live_Event_Messages_Bool_Exp>;
  live_event_messages_aggregate?: Maybe<Live_Event_Messages_Aggregate_Bool_Exp>;
  moderate_messages?: Maybe<Boolean_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  status?: Maybe<Statuses_Bool_Exp>;
  status_id?: Maybe<Uuid_Comparison_Exp>;
  stream_url?: Maybe<String_Comparison_Exp>;
  type?: Maybe<Types_Bool_Exp>;
  type_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "live_events" */
export enum Live_Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  LiveEventsPkey = 'live_events_pkey',
  /** unique or primary key constraint on columns "stream_url" */
  LiveEventsStreamUrlKey = 'live_events_stream_url_key',
  /** unique or primary key constraint on columns "name", "type_id" */
  UniqueLiveEvent = 'unique_live_event'
}

/** input type for inserting data into table "live_events" */
export type Live_Events_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  event_end?: Maybe<Scalars['timestamptz']>;
  event_start?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  live_event_messages?: Maybe<Live_Event_Messages_Arr_Rel_Insert_Input>;
  moderate_messages?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Statuses_Obj_Rel_Insert_Input>;
  status_id?: Maybe<Scalars['uuid']>;
  stream_url?: Maybe<Scalars['String']>;
  type?: Maybe<Types_Obj_Rel_Insert_Input>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Live_Events_Max_Fields = {
  __typename?: 'live_events_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  event_end?: Maybe<Scalars['timestamptz']>;
  event_start?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status_id?: Maybe<Scalars['uuid']>;
  stream_url?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "live_events" */
export type Live_Events_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  event_end?: Maybe<Order_By>;
  event_start?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  stream_url?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Live_Events_Min_Fields = {
  __typename?: 'live_events_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  event_end?: Maybe<Scalars['timestamptz']>;
  event_start?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status_id?: Maybe<Scalars['uuid']>;
  stream_url?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "live_events" */
export type Live_Events_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  event_end?: Maybe<Order_By>;
  event_start?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  stream_url?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "live_events" */
export type Live_Events_Mutation_Response = {
  __typename?: 'live_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Live_Events>;
};

/** input type for inserting object relation for remote table "live_events" */
export type Live_Events_Obj_Rel_Insert_Input = {
  data: Live_Events_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Live_Events_On_Conflict>;
};

/** on_conflict condition type for table "live_events" */
export type Live_Events_On_Conflict = {
  constraint: Live_Events_Constraint;
  update_columns?: Array<Live_Events_Update_Column>;
  where?: Maybe<Live_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "live_events". */
export type Live_Events_Order_By = {
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  event_end?: Maybe<Order_By>;
  event_start?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  live_event_messages_aggregate?: Maybe<Live_Event_Messages_Aggregate_Order_By>;
  moderate_messages?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status?: Maybe<Statuses_Order_By>;
  status_id?: Maybe<Order_By>;
  stream_url?: Maybe<Order_By>;
  type?: Maybe<Types_Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: live_events */
export type Live_Events_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "live_events" */
export enum Live_Events_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  EventEnd = 'event_end',
  /** column name */
  EventStart = 'event_start',
  /** column name */
  Id = 'id',
  /** column name */
  ModerateMessages = 'moderate_messages',
  /** column name */
  Name = 'name',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  StreamUrl = 'stream_url',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "live_events_aggregate_bool_exp_bool_and_arguments_columns" columns of table "live_events" */
export enum Live_Events_Select_Column_Live_Events_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ModerateMessages = 'moderate_messages'
}

/** select "live_events_aggregate_bool_exp_bool_or_arguments_columns" columns of table "live_events" */
export enum Live_Events_Select_Column_Live_Events_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ModerateMessages = 'moderate_messages'
}

/** input type for updating data in table "live_events" */
export type Live_Events_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  event_end?: Maybe<Scalars['timestamptz']>;
  event_start?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  moderate_messages?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  status_id?: Maybe<Scalars['uuid']>;
  stream_url?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "live_events" */
export type Live_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Live_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Live_Events_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  event_end?: Maybe<Scalars['timestamptz']>;
  event_start?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  moderate_messages?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  status_id?: Maybe<Scalars['uuid']>;
  stream_url?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "live_events" */
export enum Live_Events_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  EventEnd = 'event_end',
  /** column name */
  EventStart = 'event_start',
  /** column name */
  Id = 'id',
  /** column name */
  ModerateMessages = 'moderate_messages',
  /** column name */
  Name = 'name',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  StreamUrl = 'stream_url',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Live_Events_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Live_Events_Set_Input>;
  where: Live_Events_Bool_Exp;
};

/** columns and relationships of "match_flags" */
export type Match_Flags = {
  __typename?: 'match_flags';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  flag: Flags;
  flag_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  match: Matches;
  match_id: Scalars['uuid'];
};

/** aggregated selection of "match_flags" */
export type Match_Flags_Aggregate = {
  __typename?: 'match_flags_aggregate';
  aggregate?: Maybe<Match_Flags_Aggregate_Fields>;
  nodes: Array<Match_Flags>;
};

export type Match_Flags_Aggregate_Bool_Exp = {
  count?: Maybe<Match_Flags_Aggregate_Bool_Exp_Count>;
};

export type Match_Flags_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Match_Flags_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Match_Flags_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "match_flags" */
export type Match_Flags_Aggregate_Fields = {
  __typename?: 'match_flags_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Match_Flags_Max_Fields>;
  min?: Maybe<Match_Flags_Min_Fields>;
};


/** aggregate fields of "match_flags" */
export type Match_Flags_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Match_Flags_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "match_flags" */
export type Match_Flags_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Match_Flags_Max_Order_By>;
  min?: Maybe<Match_Flags_Min_Order_By>;
};

/** input type for inserting array relation for remote table "match_flags" */
export type Match_Flags_Arr_Rel_Insert_Input = {
  data: Array<Match_Flags_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Match_Flags_On_Conflict>;
};

/** Boolean expression to filter rows from the table "match_flags". All fields are combined with a logical 'AND'. */
export type Match_Flags_Bool_Exp = {
  _and?: Maybe<Array<Match_Flags_Bool_Exp>>;
  _not?: Maybe<Match_Flags_Bool_Exp>;
  _or?: Maybe<Array<Match_Flags_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  flag?: Maybe<Flags_Bool_Exp>;
  flag_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  match?: Maybe<Matches_Bool_Exp>;
  match_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "match_flags" */
export enum Match_Flags_Constraint {
  /** unique or primary key constraint on columns "id" */
  MatchFlagsPkey = 'match_flags_pkey'
}

/** input type for inserting data into table "match_flags" */
export type Match_Flags_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  flag?: Maybe<Flags_Obj_Rel_Insert_Input>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  match?: Maybe<Matches_Obj_Rel_Insert_Input>;
  match_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Match_Flags_Max_Fields = {
  __typename?: 'match_flags_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "match_flags" */
export type Match_Flags_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  flag_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  match_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Match_Flags_Min_Fields = {
  __typename?: 'match_flags_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "match_flags" */
export type Match_Flags_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  flag_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  match_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "match_flags" */
export type Match_Flags_Mutation_Response = {
  __typename?: 'match_flags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Match_Flags>;
};

/** on_conflict condition type for table "match_flags" */
export type Match_Flags_On_Conflict = {
  constraint: Match_Flags_Constraint;
  update_columns?: Array<Match_Flags_Update_Column>;
  where?: Maybe<Match_Flags_Bool_Exp>;
};

/** Ordering options when selecting data from "match_flags". */
export type Match_Flags_Order_By = {
  created_at?: Maybe<Order_By>;
  flag?: Maybe<Flags_Order_By>;
  flag_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  match?: Maybe<Matches_Order_By>;
  match_id?: Maybe<Order_By>;
};

/** primary key columns input for table: match_flags */
export type Match_Flags_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "match_flags" */
export enum Match_Flags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlagId = 'flag_id',
  /** column name */
  Id = 'id',
  /** column name */
  MatchId = 'match_id'
}

/** input type for updating data in table "match_flags" */
export type Match_Flags_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "match_flags" */
export type Match_Flags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Match_Flags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Match_Flags_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "match_flags" */
export enum Match_Flags_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlagId = 'flag_id',
  /** column name */
  Id = 'id',
  /** column name */
  MatchId = 'match_id'
}

export type Match_Flags_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Match_Flags_Set_Input>;
  where: Match_Flags_Bool_Exp;
};

/** columns and relationships of "match_rewards" */
export type Match_Rewards = {
  __typename?: 'match_rewards';
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  match: Matches;
  match_id: Scalars['uuid'];
  /** An object relationship */
  reward: Rewards;
  reward_id: Scalars['uuid'];
  value: Scalars['float8'];
};

/** aggregated selection of "match_rewards" */
export type Match_Rewards_Aggregate = {
  __typename?: 'match_rewards_aggregate';
  aggregate?: Maybe<Match_Rewards_Aggregate_Fields>;
  nodes: Array<Match_Rewards>;
};

export type Match_Rewards_Aggregate_Bool_Exp = {
  avg?: Maybe<Match_Rewards_Aggregate_Bool_Exp_Avg>;
  corr?: Maybe<Match_Rewards_Aggregate_Bool_Exp_Corr>;
  count?: Maybe<Match_Rewards_Aggregate_Bool_Exp_Count>;
  covar_samp?: Maybe<Match_Rewards_Aggregate_Bool_Exp_Covar_Samp>;
  max?: Maybe<Match_Rewards_Aggregate_Bool_Exp_Max>;
  min?: Maybe<Match_Rewards_Aggregate_Bool_Exp_Min>;
  stddev_samp?: Maybe<Match_Rewards_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: Maybe<Match_Rewards_Aggregate_Bool_Exp_Sum>;
  var_samp?: Maybe<Match_Rewards_Aggregate_Bool_Exp_Var_Samp>;
};

export type Match_Rewards_Aggregate_Bool_Exp_Avg = {
  arguments: Match_Rewards_Select_Column_Match_Rewards_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Match_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Match_Rewards_Aggregate_Bool_Exp_Corr = {
  arguments: Match_Rewards_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Match_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Match_Rewards_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Match_Rewards_Select_Column_Match_Rewards_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Match_Rewards_Select_Column_Match_Rewards_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Match_Rewards_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Match_Rewards_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Match_Rewards_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Match_Rewards_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Match_Rewards_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Match_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Match_Rewards_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Match_Rewards_Select_Column_Match_Rewards_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Match_Rewards_Select_Column_Match_Rewards_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Match_Rewards_Aggregate_Bool_Exp_Max = {
  arguments: Match_Rewards_Select_Column_Match_Rewards_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Match_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Match_Rewards_Aggregate_Bool_Exp_Min = {
  arguments: Match_Rewards_Select_Column_Match_Rewards_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Match_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Match_Rewards_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Match_Rewards_Select_Column_Match_Rewards_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Match_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Match_Rewards_Aggregate_Bool_Exp_Sum = {
  arguments: Match_Rewards_Select_Column_Match_Rewards_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Match_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Match_Rewards_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Match_Rewards_Select_Column_Match_Rewards_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Match_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "match_rewards" */
export type Match_Rewards_Aggregate_Fields = {
  __typename?: 'match_rewards_aggregate_fields';
  avg?: Maybe<Match_Rewards_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Match_Rewards_Max_Fields>;
  min?: Maybe<Match_Rewards_Min_Fields>;
  stddev?: Maybe<Match_Rewards_Stddev_Fields>;
  stddev_pop?: Maybe<Match_Rewards_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Match_Rewards_Stddev_Samp_Fields>;
  sum?: Maybe<Match_Rewards_Sum_Fields>;
  var_pop?: Maybe<Match_Rewards_Var_Pop_Fields>;
  var_samp?: Maybe<Match_Rewards_Var_Samp_Fields>;
  variance?: Maybe<Match_Rewards_Variance_Fields>;
};


/** aggregate fields of "match_rewards" */
export type Match_Rewards_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Match_Rewards_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "match_rewards" */
export type Match_Rewards_Aggregate_Order_By = {
  avg?: Maybe<Match_Rewards_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Match_Rewards_Max_Order_By>;
  min?: Maybe<Match_Rewards_Min_Order_By>;
  stddev?: Maybe<Match_Rewards_Stddev_Order_By>;
  stddev_pop?: Maybe<Match_Rewards_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Match_Rewards_Stddev_Samp_Order_By>;
  sum?: Maybe<Match_Rewards_Sum_Order_By>;
  var_pop?: Maybe<Match_Rewards_Var_Pop_Order_By>;
  var_samp?: Maybe<Match_Rewards_Var_Samp_Order_By>;
  variance?: Maybe<Match_Rewards_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "match_rewards" */
export type Match_Rewards_Arr_Rel_Insert_Input = {
  data: Array<Match_Rewards_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Match_Rewards_On_Conflict>;
};

/** aggregate avg on columns */
export type Match_Rewards_Avg_Fields = {
  __typename?: 'match_rewards_avg_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "match_rewards" */
export type Match_Rewards_Avg_Order_By = {
  value?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "match_rewards". All fields are combined with a logical 'AND'. */
export type Match_Rewards_Bool_Exp = {
  _and?: Maybe<Array<Match_Rewards_Bool_Exp>>;
  _not?: Maybe<Match_Rewards_Bool_Exp>;
  _or?: Maybe<Array<Match_Rewards_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  match?: Maybe<Matches_Bool_Exp>;
  match_id?: Maybe<Uuid_Comparison_Exp>;
  reward?: Maybe<Rewards_Bool_Exp>;
  reward_id?: Maybe<Uuid_Comparison_Exp>;
  value?: Maybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "match_rewards" */
export enum Match_Rewards_Constraint {
  /** unique or primary key constraint on columns "id" */
  MatchRewardsPkey = 'match_rewards_pkey',
  /** unique or primary key constraint on columns "match_id", "reward_id" */
  UniqueMatchRewards = 'unique_match_rewards'
}

/** input type for incrementing numeric columns in table "match_rewards" */
export type Match_Rewards_Inc_Input = {
  value?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "match_rewards" */
export type Match_Rewards_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  match?: Maybe<Matches_Obj_Rel_Insert_Input>;
  match_id?: Maybe<Scalars['uuid']>;
  reward?: Maybe<Rewards_Obj_Rel_Insert_Input>;
  reward_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Match_Rewards_Max_Fields = {
  __typename?: 'match_rewards_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
  reward_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "match_rewards" */
export type Match_Rewards_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  match_id?: Maybe<Order_By>;
  reward_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Match_Rewards_Min_Fields = {
  __typename?: 'match_rewards_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
  reward_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "match_rewards" */
export type Match_Rewards_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  match_id?: Maybe<Order_By>;
  reward_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "match_rewards" */
export type Match_Rewards_Mutation_Response = {
  __typename?: 'match_rewards_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Match_Rewards>;
};

/** on_conflict condition type for table "match_rewards" */
export type Match_Rewards_On_Conflict = {
  constraint: Match_Rewards_Constraint;
  update_columns?: Array<Match_Rewards_Update_Column>;
  where?: Maybe<Match_Rewards_Bool_Exp>;
};

/** Ordering options when selecting data from "match_rewards". */
export type Match_Rewards_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  match?: Maybe<Matches_Order_By>;
  match_id?: Maybe<Order_By>;
  reward?: Maybe<Rewards_Order_By>;
  reward_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: match_rewards */
export type Match_Rewards_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "match_rewards" */
export enum Match_Rewards_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  RewardId = 'reward_id',
  /** column name */
  Value = 'value'
}

/** select "match_rewards_aggregate_bool_exp_avg_arguments_columns" columns of table "match_rewards" */
export enum Match_Rewards_Select_Column_Match_Rewards_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "match_rewards_aggregate_bool_exp_corr_arguments_columns" columns of table "match_rewards" */
export enum Match_Rewards_Select_Column_Match_Rewards_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "match_rewards_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "match_rewards" */
export enum Match_Rewards_Select_Column_Match_Rewards_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "match_rewards_aggregate_bool_exp_max_arguments_columns" columns of table "match_rewards" */
export enum Match_Rewards_Select_Column_Match_Rewards_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "match_rewards_aggregate_bool_exp_min_arguments_columns" columns of table "match_rewards" */
export enum Match_Rewards_Select_Column_Match_Rewards_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "match_rewards_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "match_rewards" */
export enum Match_Rewards_Select_Column_Match_Rewards_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "match_rewards_aggregate_bool_exp_sum_arguments_columns" columns of table "match_rewards" */
export enum Match_Rewards_Select_Column_Match_Rewards_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "match_rewards_aggregate_bool_exp_var_samp_arguments_columns" columns of table "match_rewards" */
export enum Match_Rewards_Select_Column_Match_Rewards_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "match_rewards" */
export type Match_Rewards_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
  reward_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Match_Rewards_Stddev_Fields = {
  __typename?: 'match_rewards_stddev_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "match_rewards" */
export type Match_Rewards_Stddev_Order_By = {
  value?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Match_Rewards_Stddev_Pop_Fields = {
  __typename?: 'match_rewards_stddev_pop_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "match_rewards" */
export type Match_Rewards_Stddev_Pop_Order_By = {
  value?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Match_Rewards_Stddev_Samp_Fields = {
  __typename?: 'match_rewards_stddev_samp_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "match_rewards" */
export type Match_Rewards_Stddev_Samp_Order_By = {
  value?: Maybe<Order_By>;
};

/** Streaming cursor of the table "match_rewards" */
export type Match_Rewards_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Match_Rewards_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Match_Rewards_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
  reward_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Match_Rewards_Sum_Fields = {
  __typename?: 'match_rewards_sum_fields';
  value?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "match_rewards" */
export type Match_Rewards_Sum_Order_By = {
  value?: Maybe<Order_By>;
};

/** update columns of table "match_rewards" */
export enum Match_Rewards_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  RewardId = 'reward_id',
  /** column name */
  Value = 'value'
}

export type Match_Rewards_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Match_Rewards_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Match_Rewards_Set_Input>;
  where: Match_Rewards_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Match_Rewards_Var_Pop_Fields = {
  __typename?: 'match_rewards_var_pop_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "match_rewards" */
export type Match_Rewards_Var_Pop_Order_By = {
  value?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Match_Rewards_Var_Samp_Fields = {
  __typename?: 'match_rewards_var_samp_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "match_rewards" */
export type Match_Rewards_Var_Samp_Order_By = {
  value?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Match_Rewards_Variance_Fields = {
  __typename?: 'match_rewards_variance_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "match_rewards" */
export type Match_Rewards_Variance_Order_By = {
  value?: Maybe<Order_By>;
};

/** columns and relationships of "matches" */
export type Matches = {
  __typename?: 'matches';
  actual_start?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  game: Games;
  game_id: Scalars['uuid'];
  id: Scalars['uuid'];
  lobby_link?: Maybe<Scalars['String']>;
  /** An array relationship */
  match_flags: Array<Match_Flags>;
  /** An aggregate relationship */
  match_flags_aggregate: Match_Flags_Aggregate;
  /** Match particpants */
  match_participants?: Maybe<Array<Parties>>;
  /** An array relationship */
  match_rewards: Array<Match_Rewards>;
  /** An aggregate relationship */
  match_rewards_aggregate: Match_Rewards_Aggregate;
  match_time?: Maybe<Scalars['timestamptz']>;
  max_participants: Scalars['Int'];
  metadata?: Maybe<Scalars['jsonb']>;
  min_participants: Scalars['Int'];
  name: Scalars['String'];
  participants?: Maybe<Scalars['_uuid']>;
  scheduled_start?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  status: Statuses;
  status_id: Scalars['uuid'];
  /** An object relationship */
  tournament: Tournaments;
  tournament_id: Scalars['uuid'];
  /** An array relationship */
  tournament_results: Array<Tournament_Results>;
  /** An aggregate relationship */
  tournament_results_aggregate: Tournament_Results_Aggregate;
  /** An object relationship */
  type: Types;
  type_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "matches" */
export type MatchesMatch_FlagsArgs = {
  distinct_on?: Maybe<Array<Match_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Match_Flags_Order_By>>;
  where?: Maybe<Match_Flags_Bool_Exp>;
};


/** columns and relationships of "matches" */
export type MatchesMatch_Flags_AggregateArgs = {
  distinct_on?: Maybe<Array<Match_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Match_Flags_Order_By>>;
  where?: Maybe<Match_Flags_Bool_Exp>;
};


/** columns and relationships of "matches" */
export type MatchesMatch_ParticipantsArgs = {
  distinct_on?: Maybe<Array<Parties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Parties_Order_By>>;
  where?: Maybe<Parties_Bool_Exp>;
};


/** columns and relationships of "matches" */
export type MatchesMatch_RewardsArgs = {
  distinct_on?: Maybe<Array<Match_Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Match_Rewards_Order_By>>;
  where?: Maybe<Match_Rewards_Bool_Exp>;
};


/** columns and relationships of "matches" */
export type MatchesMatch_Rewards_AggregateArgs = {
  distinct_on?: Maybe<Array<Match_Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Match_Rewards_Order_By>>;
  where?: Maybe<Match_Rewards_Bool_Exp>;
};


/** columns and relationships of "matches" */
export type MatchesMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "matches" */
export type MatchesTournament_ResultsArgs = {
  distinct_on?: Maybe<Array<Tournament_Results_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Results_Order_By>>;
  where?: Maybe<Tournament_Results_Bool_Exp>;
};


/** columns and relationships of "matches" */
export type MatchesTournament_Results_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Results_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Results_Order_By>>;
  where?: Maybe<Tournament_Results_Bool_Exp>;
};

/** aggregated selection of "matches" */
export type Matches_Aggregate = {
  __typename?: 'matches_aggregate';
  aggregate?: Maybe<Matches_Aggregate_Fields>;
  nodes: Array<Matches>;
};

export type Matches_Aggregate_Bool_Exp = {
  count?: Maybe<Matches_Aggregate_Bool_Exp_Count>;
};

export type Matches_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Matches_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Matches_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "matches" */
export type Matches_Aggregate_Fields = {
  __typename?: 'matches_aggregate_fields';
  avg?: Maybe<Matches_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Matches_Max_Fields>;
  min?: Maybe<Matches_Min_Fields>;
  stddev?: Maybe<Matches_Stddev_Fields>;
  stddev_pop?: Maybe<Matches_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Matches_Stddev_Samp_Fields>;
  sum?: Maybe<Matches_Sum_Fields>;
  var_pop?: Maybe<Matches_Var_Pop_Fields>;
  var_samp?: Maybe<Matches_Var_Samp_Fields>;
  variance?: Maybe<Matches_Variance_Fields>;
};


/** aggregate fields of "matches" */
export type Matches_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Matches_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "matches" */
export type Matches_Aggregate_Order_By = {
  avg?: Maybe<Matches_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Matches_Max_Order_By>;
  min?: Maybe<Matches_Min_Order_By>;
  stddev?: Maybe<Matches_Stddev_Order_By>;
  stddev_pop?: Maybe<Matches_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Matches_Stddev_Samp_Order_By>;
  sum?: Maybe<Matches_Sum_Order_By>;
  var_pop?: Maybe<Matches_Var_Pop_Order_By>;
  var_samp?: Maybe<Matches_Var_Samp_Order_By>;
  variance?: Maybe<Matches_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Matches_Append_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "matches" */
export type Matches_Arr_Rel_Insert_Input = {
  data: Array<Matches_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Matches_On_Conflict>;
};

/** aggregate avg on columns */
export type Matches_Avg_Fields = {
  __typename?: 'matches_avg_fields';
  max_participants?: Maybe<Scalars['Float']>;
  min_participants?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "matches" */
export type Matches_Avg_Order_By = {
  max_participants?: Maybe<Order_By>;
  min_participants?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "matches". All fields are combined with a logical 'AND'. */
export type Matches_Bool_Exp = {
  _and?: Maybe<Array<Matches_Bool_Exp>>;
  _not?: Maybe<Matches_Bool_Exp>;
  _or?: Maybe<Array<Matches_Bool_Exp>>;
  actual_start?: Maybe<Timestamptz_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  game?: Maybe<Games_Bool_Exp>;
  game_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  lobby_link?: Maybe<String_Comparison_Exp>;
  match_flags?: Maybe<Match_Flags_Bool_Exp>;
  match_flags_aggregate?: Maybe<Match_Flags_Aggregate_Bool_Exp>;
  match_participants?: Maybe<Parties_Bool_Exp>;
  match_rewards?: Maybe<Match_Rewards_Bool_Exp>;
  match_rewards_aggregate?: Maybe<Match_Rewards_Aggregate_Bool_Exp>;
  match_time?: Maybe<Timestamptz_Comparison_Exp>;
  max_participants?: Maybe<Int_Comparison_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  min_participants?: Maybe<Int_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  participants?: Maybe<_Uuid_Comparison_Exp>;
  scheduled_start?: Maybe<Timestamptz_Comparison_Exp>;
  status?: Maybe<Statuses_Bool_Exp>;
  status_id?: Maybe<Uuid_Comparison_Exp>;
  tournament?: Maybe<Tournaments_Bool_Exp>;
  tournament_id?: Maybe<Uuid_Comparison_Exp>;
  tournament_results?: Maybe<Tournament_Results_Bool_Exp>;
  tournament_results_aggregate?: Maybe<Tournament_Results_Aggregate_Bool_Exp>;
  type?: Maybe<Types_Bool_Exp>;
  type_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "matches" */
export enum Matches_Constraint {
  /** unique or primary key constraint on columns "id" */
  MatchesPkey = 'matches_pkey',
  /** unique or primary key constraint on columns "name", "tournament_id", "type_id" */
  UniqueMatches = 'unique_matches'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Matches_Delete_At_Path_Input = {
  metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Matches_Delete_Elem_Input = {
  metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Matches_Delete_Key_Input = {
  metadata?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "matches" */
export type Matches_Inc_Input = {
  max_participants?: Maybe<Scalars['Int']>;
  min_participants?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "matches" */
export type Matches_Insert_Input = {
  actual_start?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  game?: Maybe<Games_Obj_Rel_Insert_Input>;
  game_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lobby_link?: Maybe<Scalars['String']>;
  match_flags?: Maybe<Match_Flags_Arr_Rel_Insert_Input>;
  match_rewards?: Maybe<Match_Rewards_Arr_Rel_Insert_Input>;
  match_time?: Maybe<Scalars['timestamptz']>;
  max_participants?: Maybe<Scalars['Int']>;
  metadata?: Maybe<Scalars['jsonb']>;
  min_participants?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  participants?: Maybe<Scalars['_uuid']>;
  scheduled_start?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Statuses_Obj_Rel_Insert_Input>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament?: Maybe<Tournaments_Obj_Rel_Insert_Input>;
  tournament_id?: Maybe<Scalars['uuid']>;
  tournament_results?: Maybe<Tournament_Results_Arr_Rel_Insert_Input>;
  type?: Maybe<Types_Obj_Rel_Insert_Input>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Matches_Max_Fields = {
  __typename?: 'matches_max_fields';
  actual_start?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  game_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lobby_link?: Maybe<Scalars['String']>;
  match_time?: Maybe<Scalars['timestamptz']>;
  max_participants?: Maybe<Scalars['Int']>;
  min_participants?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  scheduled_start?: Maybe<Scalars['timestamptz']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "matches" */
export type Matches_Max_Order_By = {
  actual_start?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  game_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lobby_link?: Maybe<Order_By>;
  match_time?: Maybe<Order_By>;
  max_participants?: Maybe<Order_By>;
  min_participants?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  scheduled_start?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Matches_Min_Fields = {
  __typename?: 'matches_min_fields';
  actual_start?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  game_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lobby_link?: Maybe<Scalars['String']>;
  match_time?: Maybe<Scalars['timestamptz']>;
  max_participants?: Maybe<Scalars['Int']>;
  min_participants?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  scheduled_start?: Maybe<Scalars['timestamptz']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "matches" */
export type Matches_Min_Order_By = {
  actual_start?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  game_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lobby_link?: Maybe<Order_By>;
  match_time?: Maybe<Order_By>;
  max_participants?: Maybe<Order_By>;
  min_participants?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  scheduled_start?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "matches" */
export type Matches_Mutation_Response = {
  __typename?: 'matches_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Matches>;
};

/** input type for inserting object relation for remote table "matches" */
export type Matches_Obj_Rel_Insert_Input = {
  data: Matches_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Matches_On_Conflict>;
};

/** on_conflict condition type for table "matches" */
export type Matches_On_Conflict = {
  constraint: Matches_Constraint;
  update_columns?: Array<Matches_Update_Column>;
  where?: Maybe<Matches_Bool_Exp>;
};

/** Ordering options when selecting data from "matches". */
export type Matches_Order_By = {
  actual_start?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  game?: Maybe<Games_Order_By>;
  game_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lobby_link?: Maybe<Order_By>;
  match_flags_aggregate?: Maybe<Match_Flags_Aggregate_Order_By>;
  match_participants_aggregate?: Maybe<Parties_Aggregate_Order_By>;
  match_rewards_aggregate?: Maybe<Match_Rewards_Aggregate_Order_By>;
  match_time?: Maybe<Order_By>;
  max_participants?: Maybe<Order_By>;
  metadata?: Maybe<Order_By>;
  min_participants?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  participants?: Maybe<Order_By>;
  scheduled_start?: Maybe<Order_By>;
  status?: Maybe<Statuses_Order_By>;
  status_id?: Maybe<Order_By>;
  tournament?: Maybe<Tournaments_Order_By>;
  tournament_id?: Maybe<Order_By>;
  tournament_results_aggregate?: Maybe<Tournament_Results_Aggregate_Order_By>;
  type?: Maybe<Types_Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: matches */
export type Matches_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Matches_Prepend_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "matches" */
export enum Matches_Select_Column {
  /** column name */
  ActualStart = 'actual_start',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GameId = 'game_id',
  /** column name */
  Id = 'id',
  /** column name */
  LobbyLink = 'lobby_link',
  /** column name */
  MatchTime = 'match_time',
  /** column name */
  MaxParticipants = 'max_participants',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MinParticipants = 'min_participants',
  /** column name */
  Name = 'name',
  /** column name */
  Participants = 'participants',
  /** column name */
  ScheduledStart = 'scheduled_start',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TournamentId = 'tournament_id',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "matches" */
export type Matches_Set_Input = {
  actual_start?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  game_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lobby_link?: Maybe<Scalars['String']>;
  match_time?: Maybe<Scalars['timestamptz']>;
  max_participants?: Maybe<Scalars['Int']>;
  metadata?: Maybe<Scalars['jsonb']>;
  min_participants?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  participants?: Maybe<Scalars['_uuid']>;
  scheduled_start?: Maybe<Scalars['timestamptz']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Matches_Stddev_Fields = {
  __typename?: 'matches_stddev_fields';
  max_participants?: Maybe<Scalars['Float']>;
  min_participants?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "matches" */
export type Matches_Stddev_Order_By = {
  max_participants?: Maybe<Order_By>;
  min_participants?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Matches_Stddev_Pop_Fields = {
  __typename?: 'matches_stddev_pop_fields';
  max_participants?: Maybe<Scalars['Float']>;
  min_participants?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "matches" */
export type Matches_Stddev_Pop_Order_By = {
  max_participants?: Maybe<Order_By>;
  min_participants?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Matches_Stddev_Samp_Fields = {
  __typename?: 'matches_stddev_samp_fields';
  max_participants?: Maybe<Scalars['Float']>;
  min_participants?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "matches" */
export type Matches_Stddev_Samp_Order_By = {
  max_participants?: Maybe<Order_By>;
  min_participants?: Maybe<Order_By>;
};

/** Streaming cursor of the table "matches" */
export type Matches_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Matches_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Matches_Stream_Cursor_Value_Input = {
  actual_start?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  game_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  lobby_link?: Maybe<Scalars['String']>;
  match_time?: Maybe<Scalars['timestamptz']>;
  max_participants?: Maybe<Scalars['Int']>;
  metadata?: Maybe<Scalars['jsonb']>;
  min_participants?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  participants?: Maybe<Scalars['_uuid']>;
  scheduled_start?: Maybe<Scalars['timestamptz']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Matches_Sum_Fields = {
  __typename?: 'matches_sum_fields';
  max_participants?: Maybe<Scalars['Int']>;
  min_participants?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "matches" */
export type Matches_Sum_Order_By = {
  max_participants?: Maybe<Order_By>;
  min_participants?: Maybe<Order_By>;
};

/** update columns of table "matches" */
export enum Matches_Update_Column {
  /** column name */
  ActualStart = 'actual_start',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GameId = 'game_id',
  /** column name */
  Id = 'id',
  /** column name */
  LobbyLink = 'lobby_link',
  /** column name */
  MatchTime = 'match_time',
  /** column name */
  MaxParticipants = 'max_participants',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MinParticipants = 'min_participants',
  /** column name */
  Name = 'name',
  /** column name */
  Participants = 'participants',
  /** column name */
  ScheduledStart = 'scheduled_start',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TournamentId = 'tournament_id',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Matches_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Matches_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Matches_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Matches_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Matches_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Matches_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Matches_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Matches_Set_Input>;
  where: Matches_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Matches_Var_Pop_Fields = {
  __typename?: 'matches_var_pop_fields';
  max_participants?: Maybe<Scalars['Float']>;
  min_participants?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "matches" */
export type Matches_Var_Pop_Order_By = {
  max_participants?: Maybe<Order_By>;
  min_participants?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Matches_Var_Samp_Fields = {
  __typename?: 'matches_var_samp_fields';
  max_participants?: Maybe<Scalars['Float']>;
  min_participants?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "matches" */
export type Matches_Var_Samp_Order_By = {
  max_participants?: Maybe<Order_By>;
  min_participants?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Matches_Variance_Fields = {
  __typename?: 'matches_variance_fields';
  max_participants?: Maybe<Scalars['Float']>;
  min_participants?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "matches" */
export type Matches_Variance_Order_By = {
  max_participants?: Maybe<Order_By>;
  min_participants?: Maybe<Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  addMatchParticipants?: Maybe<AddMatchParticipantsOutput>;
  changePassword?: Maybe<ChangePasswordOutput>;
  createBattleRoyaleMatch?: Maybe<CreateMatchOutput>;
  /** Create Tournament Match */
  createMatch?: Maybe<CreateMatchOutput>;
  createTeam?: Maybe<CreateTeamOutput>;
  createTournament?: Maybe<CreateTournamentOutput>;
  /** delete data from the table: "audit_logs" */
  delete_audit_logs?: Maybe<Audit_Logs_Mutation_Response>;
  /** delete single row from the table: "audit_logs" */
  delete_audit_logs_by_pk?: Maybe<Audit_Logs>;
  /** delete data from the table: "flags" */
  delete_flags?: Maybe<Flags_Mutation_Response>;
  /** delete single row from the table: "flags" */
  delete_flags_by_pk?: Maybe<Flags>;
  /** delete data from the table: "games" */
  delete_games?: Maybe<Games_Mutation_Response>;
  /** delete single row from the table: "games" */
  delete_games_by_pk?: Maybe<Games>;
  /** delete data from the table: "hub_registrations" */
  delete_hub_registrations?: Maybe<Hub_Registrations_Mutation_Response>;
  /** delete single row from the table: "hub_registrations" */
  delete_hub_registrations_by_pk?: Maybe<Hub_Registrations>;
  /** delete data from the table: "invites" */
  delete_invites?: Maybe<Invites_Mutation_Response>;
  /** delete single row from the table: "invites" */
  delete_invites_by_pk?: Maybe<Invites>;
  /** delete data from the table: "live_event_messages" */
  delete_live_event_messages?: Maybe<Live_Event_Messages_Mutation_Response>;
  /** delete single row from the table: "live_event_messages" */
  delete_live_event_messages_by_pk?: Maybe<Live_Event_Messages>;
  /** delete data from the table: "live_events" */
  delete_live_events?: Maybe<Live_Events_Mutation_Response>;
  /** delete single row from the table: "live_events" */
  delete_live_events_by_pk?: Maybe<Live_Events>;
  /** delete data from the table: "match_flags" */
  delete_match_flags?: Maybe<Match_Flags_Mutation_Response>;
  /** delete single row from the table: "match_flags" */
  delete_match_flags_by_pk?: Maybe<Match_Flags>;
  /** delete data from the table: "match_rewards" */
  delete_match_rewards?: Maybe<Match_Rewards_Mutation_Response>;
  /** delete single row from the table: "match_rewards" */
  delete_match_rewards_by_pk?: Maybe<Match_Rewards>;
  /** delete data from the table: "matches" */
  delete_matches?: Maybe<Matches_Mutation_Response>;
  /** delete single row from the table: "matches" */
  delete_matches_by_pk?: Maybe<Matches>;
  /** delete data from the table: "parties" */
  delete_parties?: Maybe<Parties_Mutation_Response>;
  /** delete single row from the table: "parties" */
  delete_parties_by_pk?: Maybe<Parties>;
  /** delete data from the table: "party_details" */
  delete_party_details?: Maybe<Party_Details_Mutation_Response>;
  /** delete single row from the table: "party_details" */
  delete_party_details_by_pk?: Maybe<Party_Details>;
  /** delete data from the table: "party_flags" */
  delete_party_flags?: Maybe<Party_Flags_Mutation_Response>;
  /** delete single row from the table: "party_flags" */
  delete_party_flags_by_pk?: Maybe<Party_Flags>;
  /** delete data from the table: "party_invites" */
  delete_party_invites?: Maybe<Party_Invites_Mutation_Response>;
  /** delete single row from the table: "party_invites" */
  delete_party_invites_by_pk?: Maybe<Party_Invites>;
  /** delete data from the table: "party_relationships" */
  delete_party_relationships?: Maybe<Party_Relationships_Mutation_Response>;
  /** delete single row from the table: "party_relationships" */
  delete_party_relationships_by_pk?: Maybe<Party_Relationships>;
  /** delete data from the table: "party_statuses" */
  delete_party_statuses?: Maybe<Party_Statuses_Mutation_Response>;
  /** delete single row from the table: "party_statuses" */
  delete_party_statuses_by_pk?: Maybe<Party_Statuses>;
  /** delete data from the table: "reward_redemptions" */
  delete_reward_redemptions?: Maybe<Reward_Redemptions_Mutation_Response>;
  /** delete single row from the table: "reward_redemptions" */
  delete_reward_redemptions_by_pk?: Maybe<Reward_Redemptions>;
  /** delete data from the table: "rewards" */
  delete_rewards?: Maybe<Rewards_Mutation_Response>;
  /** delete single row from the table: "rewards" */
  delete_rewards_by_pk?: Maybe<Rewards>;
  /** delete data from the table: "series" */
  delete_series?: Maybe<Series_Mutation_Response>;
  /** delete single row from the table: "series" */
  delete_series_by_pk?: Maybe<Series>;
  /** delete data from the table: "series_sponsors" */
  delete_series_sponsors?: Maybe<Series_Sponsors_Mutation_Response>;
  /** delete single row from the table: "series_sponsors" */
  delete_series_sponsors_by_pk?: Maybe<Series_Sponsors>;
  /** delete data from the table: "series_tournaments" */
  delete_series_tournaments?: Maybe<Series_Tournaments_Mutation_Response>;
  /** delete single row from the table: "series_tournaments" */
  delete_series_tournaments_by_pk?: Maybe<Series_Tournaments>;
  /** delete data from the table: "statuses" */
  delete_statuses?: Maybe<Statuses_Mutation_Response>;
  /** delete single row from the table: "statuses" */
  delete_statuses_by_pk?: Maybe<Statuses>;
  /** delete data from the table: "tournament_details" */
  delete_tournament_details?: Maybe<Tournament_Details_Mutation_Response>;
  /** delete single row from the table: "tournament_details" */
  delete_tournament_details_by_pk?: Maybe<Tournament_Details>;
  /** delete data from the table: "tournament_flags" */
  delete_tournament_flags?: Maybe<Tournament_Flags_Mutation_Response>;
  /** delete single row from the table: "tournament_flags" */
  delete_tournament_flags_by_pk?: Maybe<Tournament_Flags>;
  /** delete data from the table: "tournament_invites" */
  delete_tournament_invites?: Maybe<Tournament_Invites_Mutation_Response>;
  /** delete single row from the table: "tournament_invites" */
  delete_tournament_invites_by_pk?: Maybe<Tournament_Invites>;
  /** delete data from the table: "tournament_registrations" */
  delete_tournament_registrations?: Maybe<Tournament_Registrations_Mutation_Response>;
  /** delete single row from the table: "tournament_registrations" */
  delete_tournament_registrations_by_pk?: Maybe<Tournament_Registrations>;
  /** delete data from the table: "tournament_results" */
  delete_tournament_results?: Maybe<Tournament_Results_Mutation_Response>;
  /** delete single row from the table: "tournament_results" */
  delete_tournament_results_by_pk?: Maybe<Tournament_Results>;
  /** delete data from the table: "tournament_rewards" */
  delete_tournament_rewards?: Maybe<Tournament_Rewards_Mutation_Response>;
  /** delete single row from the table: "tournament_rewards" */
  delete_tournament_rewards_by_pk?: Maybe<Tournament_Rewards>;
  /** delete data from the table: "tournament_sponsors" */
  delete_tournament_sponsors?: Maybe<Tournament_Sponsors_Mutation_Response>;
  /** delete single row from the table: "tournament_sponsors" */
  delete_tournament_sponsors_by_pk?: Maybe<Tournament_Sponsors>;
  /** delete data from the table: "tournament_stages" */
  delete_tournament_stages?: Maybe<Tournament_Stages_Mutation_Response>;
  /** delete single row from the table: "tournament_stages" */
  delete_tournament_stages_by_pk?: Maybe<Tournament_Stages>;
  /** delete data from the table: "tournament_statuses" */
  delete_tournament_statuses?: Maybe<Tournament_Statuses_Mutation_Response>;
  /** delete single row from the table: "tournament_statuses" */
  delete_tournament_statuses_by_pk?: Maybe<Tournament_Statuses>;
  /** delete data from the table: "tournaments" */
  delete_tournaments?: Maybe<Tournaments_Mutation_Response>;
  /** delete single row from the table: "tournaments" */
  delete_tournaments_by_pk?: Maybe<Tournaments>;
  /** delete data from the table: "types" */
  delete_types?: Maybe<Types_Mutation_Response>;
  /** delete single row from the table: "types" */
  delete_types_by_pk?: Maybe<Types>;
  /** delete data from the table: "user_flags" */
  delete_user_flags?: Maybe<User_Flags_Mutation_Response>;
  /** delete single row from the table: "user_flags" */
  delete_user_flags_by_pk?: Maybe<User_Flags>;
  /** delete data from the table: "user_mfa_factors" */
  delete_user_mfa_factors?: Maybe<User_Mfa_Factors_Mutation_Response>;
  /** delete single row from the table: "user_mfa_factors" */
  delete_user_mfa_factors_by_pk?: Maybe<User_Mfa_Factors>;
  /** delete data from the table: "user_statuses" */
  delete_user_statuses?: Maybe<User_Statuses_Mutation_Response>;
  /** delete single row from the table: "user_statuses" */
  delete_user_statuses_by_pk?: Maybe<User_Statuses>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  generateResetPasswordToken?: Maybe<GenerateResetPasswordTokenOutput>;
  getStats?: Maybe<MyStatsOutput>;
  /** insert data into the table: "audit_logs" */
  insert_audit_logs?: Maybe<Audit_Logs_Mutation_Response>;
  /** insert a single row into the table: "audit_logs" */
  insert_audit_logs_one?: Maybe<Audit_Logs>;
  /** insert data into the table: "flags" */
  insert_flags?: Maybe<Flags_Mutation_Response>;
  /** insert a single row into the table: "flags" */
  insert_flags_one?: Maybe<Flags>;
  /** insert data into the table: "games" */
  insert_games?: Maybe<Games_Mutation_Response>;
  /** insert a single row into the table: "games" */
  insert_games_one?: Maybe<Games>;
  /** insert data into the table: "hub_registrations" */
  insert_hub_registrations?: Maybe<Hub_Registrations_Mutation_Response>;
  /** insert a single row into the table: "hub_registrations" */
  insert_hub_registrations_one?: Maybe<Hub_Registrations>;
  /** insert data into the table: "invites" */
  insert_invites?: Maybe<Invites_Mutation_Response>;
  /** insert a single row into the table: "invites" */
  insert_invites_one?: Maybe<Invites>;
  /** insert data into the table: "live_event_messages" */
  insert_live_event_messages?: Maybe<Live_Event_Messages_Mutation_Response>;
  /** insert a single row into the table: "live_event_messages" */
  insert_live_event_messages_one?: Maybe<Live_Event_Messages>;
  /** insert data into the table: "live_events" */
  insert_live_events?: Maybe<Live_Events_Mutation_Response>;
  /** insert a single row into the table: "live_events" */
  insert_live_events_one?: Maybe<Live_Events>;
  /** insert data into the table: "match_flags" */
  insert_match_flags?: Maybe<Match_Flags_Mutation_Response>;
  /** insert a single row into the table: "match_flags" */
  insert_match_flags_one?: Maybe<Match_Flags>;
  /** insert data into the table: "match_rewards" */
  insert_match_rewards?: Maybe<Match_Rewards_Mutation_Response>;
  /** insert a single row into the table: "match_rewards" */
  insert_match_rewards_one?: Maybe<Match_Rewards>;
  /** insert data into the table: "matches" */
  insert_matches?: Maybe<Matches_Mutation_Response>;
  /** insert a single row into the table: "matches" */
  insert_matches_one?: Maybe<Matches>;
  /** insert data into the table: "parties" */
  insert_parties?: Maybe<Parties_Mutation_Response>;
  /** insert a single row into the table: "parties" */
  insert_parties_one?: Maybe<Parties>;
  /** insert data into the table: "party_details" */
  insert_party_details?: Maybe<Party_Details_Mutation_Response>;
  /** insert a single row into the table: "party_details" */
  insert_party_details_one?: Maybe<Party_Details>;
  /** insert data into the table: "party_flags" */
  insert_party_flags?: Maybe<Party_Flags_Mutation_Response>;
  /** insert a single row into the table: "party_flags" */
  insert_party_flags_one?: Maybe<Party_Flags>;
  /** insert data into the table: "party_invites" */
  insert_party_invites?: Maybe<Party_Invites_Mutation_Response>;
  /** insert a single row into the table: "party_invites" */
  insert_party_invites_one?: Maybe<Party_Invites>;
  /** insert data into the table: "party_relationships" */
  insert_party_relationships?: Maybe<Party_Relationships_Mutation_Response>;
  /** insert a single row into the table: "party_relationships" */
  insert_party_relationships_one?: Maybe<Party_Relationships>;
  /** insert data into the table: "party_statuses" */
  insert_party_statuses?: Maybe<Party_Statuses_Mutation_Response>;
  /** insert a single row into the table: "party_statuses" */
  insert_party_statuses_one?: Maybe<Party_Statuses>;
  /** insert data into the table: "reward_redemptions" */
  insert_reward_redemptions?: Maybe<Reward_Redemptions_Mutation_Response>;
  /** insert a single row into the table: "reward_redemptions" */
  insert_reward_redemptions_one?: Maybe<Reward_Redemptions>;
  /** insert data into the table: "rewards" */
  insert_rewards?: Maybe<Rewards_Mutation_Response>;
  /** insert a single row into the table: "rewards" */
  insert_rewards_one?: Maybe<Rewards>;
  /** insert data into the table: "series" */
  insert_series?: Maybe<Series_Mutation_Response>;
  /** insert a single row into the table: "series" */
  insert_series_one?: Maybe<Series>;
  /** insert data into the table: "series_sponsors" */
  insert_series_sponsors?: Maybe<Series_Sponsors_Mutation_Response>;
  /** insert a single row into the table: "series_sponsors" */
  insert_series_sponsors_one?: Maybe<Series_Sponsors>;
  /** insert data into the table: "series_tournaments" */
  insert_series_tournaments?: Maybe<Series_Tournaments_Mutation_Response>;
  /** insert a single row into the table: "series_tournaments" */
  insert_series_tournaments_one?: Maybe<Series_Tournaments>;
  /** insert data into the table: "statuses" */
  insert_statuses?: Maybe<Statuses_Mutation_Response>;
  /** insert a single row into the table: "statuses" */
  insert_statuses_one?: Maybe<Statuses>;
  /** insert data into the table: "tournament_details" */
  insert_tournament_details?: Maybe<Tournament_Details_Mutation_Response>;
  /** insert a single row into the table: "tournament_details" */
  insert_tournament_details_one?: Maybe<Tournament_Details>;
  /** insert data into the table: "tournament_flags" */
  insert_tournament_flags?: Maybe<Tournament_Flags_Mutation_Response>;
  /** insert a single row into the table: "tournament_flags" */
  insert_tournament_flags_one?: Maybe<Tournament_Flags>;
  /** insert data into the table: "tournament_invites" */
  insert_tournament_invites?: Maybe<Tournament_Invites_Mutation_Response>;
  /** insert a single row into the table: "tournament_invites" */
  insert_tournament_invites_one?: Maybe<Tournament_Invites>;
  /** insert data into the table: "tournament_registrations" */
  insert_tournament_registrations?: Maybe<Tournament_Registrations_Mutation_Response>;
  /** insert a single row into the table: "tournament_registrations" */
  insert_tournament_registrations_one?: Maybe<Tournament_Registrations>;
  /** insert data into the table: "tournament_results" */
  insert_tournament_results?: Maybe<Tournament_Results_Mutation_Response>;
  /** insert a single row into the table: "tournament_results" */
  insert_tournament_results_one?: Maybe<Tournament_Results>;
  /** insert data into the table: "tournament_rewards" */
  insert_tournament_rewards?: Maybe<Tournament_Rewards_Mutation_Response>;
  /** insert a single row into the table: "tournament_rewards" */
  insert_tournament_rewards_one?: Maybe<Tournament_Rewards>;
  /** insert data into the table: "tournament_sponsors" */
  insert_tournament_sponsors?: Maybe<Tournament_Sponsors_Mutation_Response>;
  /** insert a single row into the table: "tournament_sponsors" */
  insert_tournament_sponsors_one?: Maybe<Tournament_Sponsors>;
  /** insert data into the table: "tournament_stages" */
  insert_tournament_stages?: Maybe<Tournament_Stages_Mutation_Response>;
  /** insert a single row into the table: "tournament_stages" */
  insert_tournament_stages_one?: Maybe<Tournament_Stages>;
  /** insert data into the table: "tournament_statuses" */
  insert_tournament_statuses?: Maybe<Tournament_Statuses_Mutation_Response>;
  /** insert a single row into the table: "tournament_statuses" */
  insert_tournament_statuses_one?: Maybe<Tournament_Statuses>;
  /** insert data into the table: "tournaments" */
  insert_tournaments?: Maybe<Tournaments_Mutation_Response>;
  /** insert a single row into the table: "tournaments" */
  insert_tournaments_one?: Maybe<Tournaments>;
  /** insert data into the table: "types" */
  insert_types?: Maybe<Types_Mutation_Response>;
  /** insert a single row into the table: "types" */
  insert_types_one?: Maybe<Types>;
  /** insert data into the table: "user_flags" */
  insert_user_flags?: Maybe<User_Flags_Mutation_Response>;
  /** insert a single row into the table: "user_flags" */
  insert_user_flags_one?: Maybe<User_Flags>;
  /** insert data into the table: "user_mfa_factors" */
  insert_user_mfa_factors?: Maybe<User_Mfa_Factors_Mutation_Response>;
  /** insert a single row into the table: "user_mfa_factors" */
  insert_user_mfa_factors_one?: Maybe<User_Mfa_Factors>;
  /** insert data into the table: "user_statuses" */
  insert_user_statuses?: Maybe<User_Statuses_Mutation_Response>;
  /** insert a single row into the table: "user_statuses" */
  insert_user_statuses_one?: Maybe<User_Statuses>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  login?: Maybe<LoginOutput>;
  magicLinkLogin?: Maybe<MagicLinkLoginOutput>;
  recordMatchResult?: Maybe<RecordMatchResultOutput>;
  registerTeamForTournament?: Maybe<RegisterTeamForTournamentOutput>;
  removeMatchParticipants?: Maybe<RemoveMatchParticipantsOutput>;
  resetPassword?: Maybe<ResetPasswordOutput>;
  sendLobbyLink?: Maybe<SendLobbyLinkOutput>;
  /** Signup */
  signup?: Maybe<SignupOutput>;
  updateProfile?: Maybe<UpdateProfileOutput>;
  /** update data of the table: "audit_logs" */
  update_audit_logs?: Maybe<Audit_Logs_Mutation_Response>;
  /** update single row of the table: "audit_logs" */
  update_audit_logs_by_pk?: Maybe<Audit_Logs>;
  /** update multiples rows of table: "audit_logs" */
  update_audit_logs_many?: Maybe<Array<Maybe<Audit_Logs_Mutation_Response>>>;
  /** update data of the table: "flags" */
  update_flags?: Maybe<Flags_Mutation_Response>;
  /** update single row of the table: "flags" */
  update_flags_by_pk?: Maybe<Flags>;
  /** update multiples rows of table: "flags" */
  update_flags_many?: Maybe<Array<Maybe<Flags_Mutation_Response>>>;
  /** update data of the table: "games" */
  update_games?: Maybe<Games_Mutation_Response>;
  /** update single row of the table: "games" */
  update_games_by_pk?: Maybe<Games>;
  /** update multiples rows of table: "games" */
  update_games_many?: Maybe<Array<Maybe<Games_Mutation_Response>>>;
  /** update data of the table: "hub_registrations" */
  update_hub_registrations?: Maybe<Hub_Registrations_Mutation_Response>;
  /** update single row of the table: "hub_registrations" */
  update_hub_registrations_by_pk?: Maybe<Hub_Registrations>;
  /** update multiples rows of table: "hub_registrations" */
  update_hub_registrations_many?: Maybe<Array<Maybe<Hub_Registrations_Mutation_Response>>>;
  /** update data of the table: "invites" */
  update_invites?: Maybe<Invites_Mutation_Response>;
  /** update single row of the table: "invites" */
  update_invites_by_pk?: Maybe<Invites>;
  /** update multiples rows of table: "invites" */
  update_invites_many?: Maybe<Array<Maybe<Invites_Mutation_Response>>>;
  /** update data of the table: "live_event_messages" */
  update_live_event_messages?: Maybe<Live_Event_Messages_Mutation_Response>;
  /** update single row of the table: "live_event_messages" */
  update_live_event_messages_by_pk?: Maybe<Live_Event_Messages>;
  /** update multiples rows of table: "live_event_messages" */
  update_live_event_messages_many?: Maybe<Array<Maybe<Live_Event_Messages_Mutation_Response>>>;
  /** update data of the table: "live_events" */
  update_live_events?: Maybe<Live_Events_Mutation_Response>;
  /** update single row of the table: "live_events" */
  update_live_events_by_pk?: Maybe<Live_Events>;
  /** update multiples rows of table: "live_events" */
  update_live_events_many?: Maybe<Array<Maybe<Live_Events_Mutation_Response>>>;
  /** update data of the table: "match_flags" */
  update_match_flags?: Maybe<Match_Flags_Mutation_Response>;
  /** update single row of the table: "match_flags" */
  update_match_flags_by_pk?: Maybe<Match_Flags>;
  /** update multiples rows of table: "match_flags" */
  update_match_flags_many?: Maybe<Array<Maybe<Match_Flags_Mutation_Response>>>;
  /** update data of the table: "match_rewards" */
  update_match_rewards?: Maybe<Match_Rewards_Mutation_Response>;
  /** update single row of the table: "match_rewards" */
  update_match_rewards_by_pk?: Maybe<Match_Rewards>;
  /** update multiples rows of table: "match_rewards" */
  update_match_rewards_many?: Maybe<Array<Maybe<Match_Rewards_Mutation_Response>>>;
  /** update data of the table: "matches" */
  update_matches?: Maybe<Matches_Mutation_Response>;
  /** update single row of the table: "matches" */
  update_matches_by_pk?: Maybe<Matches>;
  /** update multiples rows of table: "matches" */
  update_matches_many?: Maybe<Array<Maybe<Matches_Mutation_Response>>>;
  /** update data of the table: "parties" */
  update_parties?: Maybe<Parties_Mutation_Response>;
  /** update single row of the table: "parties" */
  update_parties_by_pk?: Maybe<Parties>;
  /** update multiples rows of table: "parties" */
  update_parties_many?: Maybe<Array<Maybe<Parties_Mutation_Response>>>;
  /** update data of the table: "party_details" */
  update_party_details?: Maybe<Party_Details_Mutation_Response>;
  /** update single row of the table: "party_details" */
  update_party_details_by_pk?: Maybe<Party_Details>;
  /** update multiples rows of table: "party_details" */
  update_party_details_many?: Maybe<Array<Maybe<Party_Details_Mutation_Response>>>;
  /** update data of the table: "party_flags" */
  update_party_flags?: Maybe<Party_Flags_Mutation_Response>;
  /** update single row of the table: "party_flags" */
  update_party_flags_by_pk?: Maybe<Party_Flags>;
  /** update multiples rows of table: "party_flags" */
  update_party_flags_many?: Maybe<Array<Maybe<Party_Flags_Mutation_Response>>>;
  /** update data of the table: "party_invites" */
  update_party_invites?: Maybe<Party_Invites_Mutation_Response>;
  /** update single row of the table: "party_invites" */
  update_party_invites_by_pk?: Maybe<Party_Invites>;
  /** update multiples rows of table: "party_invites" */
  update_party_invites_many?: Maybe<Array<Maybe<Party_Invites_Mutation_Response>>>;
  /** update data of the table: "party_relationships" */
  update_party_relationships?: Maybe<Party_Relationships_Mutation_Response>;
  /** update single row of the table: "party_relationships" */
  update_party_relationships_by_pk?: Maybe<Party_Relationships>;
  /** update multiples rows of table: "party_relationships" */
  update_party_relationships_many?: Maybe<Array<Maybe<Party_Relationships_Mutation_Response>>>;
  /** update data of the table: "party_statuses" */
  update_party_statuses?: Maybe<Party_Statuses_Mutation_Response>;
  /** update single row of the table: "party_statuses" */
  update_party_statuses_by_pk?: Maybe<Party_Statuses>;
  /** update multiples rows of table: "party_statuses" */
  update_party_statuses_many?: Maybe<Array<Maybe<Party_Statuses_Mutation_Response>>>;
  /** update data of the table: "reward_redemptions" */
  update_reward_redemptions?: Maybe<Reward_Redemptions_Mutation_Response>;
  /** update single row of the table: "reward_redemptions" */
  update_reward_redemptions_by_pk?: Maybe<Reward_Redemptions>;
  /** update multiples rows of table: "reward_redemptions" */
  update_reward_redemptions_many?: Maybe<Array<Maybe<Reward_Redemptions_Mutation_Response>>>;
  /** update data of the table: "rewards" */
  update_rewards?: Maybe<Rewards_Mutation_Response>;
  /** update single row of the table: "rewards" */
  update_rewards_by_pk?: Maybe<Rewards>;
  /** update multiples rows of table: "rewards" */
  update_rewards_many?: Maybe<Array<Maybe<Rewards_Mutation_Response>>>;
  /** update data of the table: "series" */
  update_series?: Maybe<Series_Mutation_Response>;
  /** update single row of the table: "series" */
  update_series_by_pk?: Maybe<Series>;
  /** update multiples rows of table: "series" */
  update_series_many?: Maybe<Array<Maybe<Series_Mutation_Response>>>;
  /** update data of the table: "series_sponsors" */
  update_series_sponsors?: Maybe<Series_Sponsors_Mutation_Response>;
  /** update single row of the table: "series_sponsors" */
  update_series_sponsors_by_pk?: Maybe<Series_Sponsors>;
  /** update multiples rows of table: "series_sponsors" */
  update_series_sponsors_many?: Maybe<Array<Maybe<Series_Sponsors_Mutation_Response>>>;
  /** update data of the table: "series_tournaments" */
  update_series_tournaments?: Maybe<Series_Tournaments_Mutation_Response>;
  /** update single row of the table: "series_tournaments" */
  update_series_tournaments_by_pk?: Maybe<Series_Tournaments>;
  /** update multiples rows of table: "series_tournaments" */
  update_series_tournaments_many?: Maybe<Array<Maybe<Series_Tournaments_Mutation_Response>>>;
  /** update data of the table: "statuses" */
  update_statuses?: Maybe<Statuses_Mutation_Response>;
  /** update single row of the table: "statuses" */
  update_statuses_by_pk?: Maybe<Statuses>;
  /** update multiples rows of table: "statuses" */
  update_statuses_many?: Maybe<Array<Maybe<Statuses_Mutation_Response>>>;
  /** update data of the table: "tournament_details" */
  update_tournament_details?: Maybe<Tournament_Details_Mutation_Response>;
  /** update single row of the table: "tournament_details" */
  update_tournament_details_by_pk?: Maybe<Tournament_Details>;
  /** update multiples rows of table: "tournament_details" */
  update_tournament_details_many?: Maybe<Array<Maybe<Tournament_Details_Mutation_Response>>>;
  /** update data of the table: "tournament_flags" */
  update_tournament_flags?: Maybe<Tournament_Flags_Mutation_Response>;
  /** update single row of the table: "tournament_flags" */
  update_tournament_flags_by_pk?: Maybe<Tournament_Flags>;
  /** update multiples rows of table: "tournament_flags" */
  update_tournament_flags_many?: Maybe<Array<Maybe<Tournament_Flags_Mutation_Response>>>;
  /** update data of the table: "tournament_invites" */
  update_tournament_invites?: Maybe<Tournament_Invites_Mutation_Response>;
  /** update single row of the table: "tournament_invites" */
  update_tournament_invites_by_pk?: Maybe<Tournament_Invites>;
  /** update multiples rows of table: "tournament_invites" */
  update_tournament_invites_many?: Maybe<Array<Maybe<Tournament_Invites_Mutation_Response>>>;
  /** update data of the table: "tournament_registrations" */
  update_tournament_registrations?: Maybe<Tournament_Registrations_Mutation_Response>;
  /** update single row of the table: "tournament_registrations" */
  update_tournament_registrations_by_pk?: Maybe<Tournament_Registrations>;
  /** update multiples rows of table: "tournament_registrations" */
  update_tournament_registrations_many?: Maybe<Array<Maybe<Tournament_Registrations_Mutation_Response>>>;
  /** update data of the table: "tournament_results" */
  update_tournament_results?: Maybe<Tournament_Results_Mutation_Response>;
  /** update single row of the table: "tournament_results" */
  update_tournament_results_by_pk?: Maybe<Tournament_Results>;
  /** update multiples rows of table: "tournament_results" */
  update_tournament_results_many?: Maybe<Array<Maybe<Tournament_Results_Mutation_Response>>>;
  /** update data of the table: "tournament_rewards" */
  update_tournament_rewards?: Maybe<Tournament_Rewards_Mutation_Response>;
  /** update single row of the table: "tournament_rewards" */
  update_tournament_rewards_by_pk?: Maybe<Tournament_Rewards>;
  /** update multiples rows of table: "tournament_rewards" */
  update_tournament_rewards_many?: Maybe<Array<Maybe<Tournament_Rewards_Mutation_Response>>>;
  /** update data of the table: "tournament_sponsors" */
  update_tournament_sponsors?: Maybe<Tournament_Sponsors_Mutation_Response>;
  /** update single row of the table: "tournament_sponsors" */
  update_tournament_sponsors_by_pk?: Maybe<Tournament_Sponsors>;
  /** update multiples rows of table: "tournament_sponsors" */
  update_tournament_sponsors_many?: Maybe<Array<Maybe<Tournament_Sponsors_Mutation_Response>>>;
  /** update data of the table: "tournament_stages" */
  update_tournament_stages?: Maybe<Tournament_Stages_Mutation_Response>;
  /** update single row of the table: "tournament_stages" */
  update_tournament_stages_by_pk?: Maybe<Tournament_Stages>;
  /** update multiples rows of table: "tournament_stages" */
  update_tournament_stages_many?: Maybe<Array<Maybe<Tournament_Stages_Mutation_Response>>>;
  /** update data of the table: "tournament_statuses" */
  update_tournament_statuses?: Maybe<Tournament_Statuses_Mutation_Response>;
  /** update single row of the table: "tournament_statuses" */
  update_tournament_statuses_by_pk?: Maybe<Tournament_Statuses>;
  /** update multiples rows of table: "tournament_statuses" */
  update_tournament_statuses_many?: Maybe<Array<Maybe<Tournament_Statuses_Mutation_Response>>>;
  /** update data of the table: "tournaments" */
  update_tournaments?: Maybe<Tournaments_Mutation_Response>;
  /** update single row of the table: "tournaments" */
  update_tournaments_by_pk?: Maybe<Tournaments>;
  /** update multiples rows of table: "tournaments" */
  update_tournaments_many?: Maybe<Array<Maybe<Tournaments_Mutation_Response>>>;
  /** update data of the table: "types" */
  update_types?: Maybe<Types_Mutation_Response>;
  /** update single row of the table: "types" */
  update_types_by_pk?: Maybe<Types>;
  /** update multiples rows of table: "types" */
  update_types_many?: Maybe<Array<Maybe<Types_Mutation_Response>>>;
  /** update data of the table: "user_flags" */
  update_user_flags?: Maybe<User_Flags_Mutation_Response>;
  /** update single row of the table: "user_flags" */
  update_user_flags_by_pk?: Maybe<User_Flags>;
  /** update multiples rows of table: "user_flags" */
  update_user_flags_many?: Maybe<Array<Maybe<User_Flags_Mutation_Response>>>;
  /** update data of the table: "user_mfa_factors" */
  update_user_mfa_factors?: Maybe<User_Mfa_Factors_Mutation_Response>;
  /** update single row of the table: "user_mfa_factors" */
  update_user_mfa_factors_by_pk?: Maybe<User_Mfa_Factors>;
  /** update multiples rows of table: "user_mfa_factors" */
  update_user_mfa_factors_many?: Maybe<Array<Maybe<User_Mfa_Factors_Mutation_Response>>>;
  /** update data of the table: "user_statuses" */
  update_user_statuses?: Maybe<User_Statuses_Mutation_Response>;
  /** update single row of the table: "user_statuses" */
  update_user_statuses_by_pk?: Maybe<User_Statuses>;
  /** update multiples rows of table: "user_statuses" */
  update_user_statuses_many?: Maybe<Array<Maybe<User_Statuses_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootAddMatchParticipantsArgs = {
  params: AddMatchParticipantsInput;
};


/** mutation root */
export type Mutation_RootChangePasswordArgs = {
  params: ChangePasswordInput;
};


/** mutation root */
export type Mutation_RootCreateBattleRoyaleMatchArgs = {
  params: CreateBattleRoyaleMatchInput;
};


/** mutation root */
export type Mutation_RootCreateMatchArgs = {
  params: CreateMatchInput;
};


/** mutation root */
export type Mutation_RootCreateTeamArgs = {
  params: CreateTeamInput;
};


/** mutation root */
export type Mutation_RootCreateTournamentArgs = {
  params: CreateTournamentInput;
};


/** mutation root */
export type Mutation_RootDelete_Audit_LogsArgs = {
  where: Audit_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Audit_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_FlagsArgs = {
  where: Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Flags_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_GamesArgs = {
  where: Games_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Games_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Hub_RegistrationsArgs = {
  where: Hub_Registrations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hub_Registrations_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_InvitesArgs = {
  where: Invites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invites_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Live_Event_MessagesArgs = {
  where: Live_Event_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Live_Event_Messages_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Live_EventsArgs = {
  where: Live_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Live_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Match_FlagsArgs = {
  where: Match_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Match_Flags_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Match_RewardsArgs = {
  where: Match_Rewards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Match_Rewards_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_MatchesArgs = {
  where: Matches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Matches_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PartiesArgs = {
  where: Parties_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parties_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Party_DetailsArgs = {
  where: Party_Details_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Party_Details_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Party_FlagsArgs = {
  where: Party_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Party_Flags_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Party_InvitesArgs = {
  where: Party_Invites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Party_Invites_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Party_RelationshipsArgs = {
  where: Party_Relationships_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Party_Relationships_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Party_StatusesArgs = {
  where: Party_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Party_Statuses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Reward_RedemptionsArgs = {
  where: Reward_Redemptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reward_Redemptions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_RewardsArgs = {
  where: Rewards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rewards_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SeriesArgs = {
  where: Series_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Series_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Series_SponsorsArgs = {
  where: Series_Sponsors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Series_Sponsors_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Series_TournamentsArgs = {
  where: Series_Tournaments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Series_Tournaments_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_StatusesArgs = {
  where: Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Statuses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Tournament_DetailsArgs = {
  where: Tournament_Details_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tournament_Details_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Tournament_FlagsArgs = {
  where: Tournament_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tournament_Flags_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Tournament_InvitesArgs = {
  where: Tournament_Invites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tournament_Invites_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Tournament_RegistrationsArgs = {
  where: Tournament_Registrations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tournament_Registrations_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Tournament_ResultsArgs = {
  where: Tournament_Results_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tournament_Results_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Tournament_RewardsArgs = {
  where: Tournament_Rewards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tournament_Rewards_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Tournament_SponsorsArgs = {
  where: Tournament_Sponsors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tournament_Sponsors_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Tournament_StagesArgs = {
  where: Tournament_Stages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tournament_Stages_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Tournament_StatusesArgs = {
  where: Tournament_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tournament_Statuses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_TournamentsArgs = {
  where: Tournaments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tournaments_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_TypesArgs = {
  where: Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_FlagsArgs = {
  where: User_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Flags_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_Mfa_FactorsArgs = {
  where: User_Mfa_Factors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Mfa_Factors_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_StatusesArgs = {
  where: User_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Statuses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootGenerateResetPasswordTokenArgs = {
  params: GenerateResetPasswordTokenInput;
};


/** mutation root */
export type Mutation_RootGetStatsArgs = {
  params: StatsInput;
};


/** mutation root */
export type Mutation_RootInsert_Audit_LogsArgs = {
  objects: Array<Audit_Logs_Insert_Input>;
  on_conflict?: Maybe<Audit_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Audit_Logs_OneArgs = {
  object: Audit_Logs_Insert_Input;
  on_conflict?: Maybe<Audit_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FlagsArgs = {
  objects: Array<Flags_Insert_Input>;
  on_conflict?: Maybe<Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flags_OneArgs = {
  object: Flags_Insert_Input;
  on_conflict?: Maybe<Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GamesArgs = {
  objects: Array<Games_Insert_Input>;
  on_conflict?: Maybe<Games_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Games_OneArgs = {
  object: Games_Insert_Input;
  on_conflict?: Maybe<Games_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hub_RegistrationsArgs = {
  objects: Array<Hub_Registrations_Insert_Input>;
  on_conflict?: Maybe<Hub_Registrations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hub_Registrations_OneArgs = {
  object: Hub_Registrations_Insert_Input;
  on_conflict?: Maybe<Hub_Registrations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InvitesArgs = {
  objects: Array<Invites_Insert_Input>;
  on_conflict?: Maybe<Invites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invites_OneArgs = {
  object: Invites_Insert_Input;
  on_conflict?: Maybe<Invites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Live_Event_MessagesArgs = {
  objects: Array<Live_Event_Messages_Insert_Input>;
  on_conflict?: Maybe<Live_Event_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Live_Event_Messages_OneArgs = {
  object: Live_Event_Messages_Insert_Input;
  on_conflict?: Maybe<Live_Event_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Live_EventsArgs = {
  objects: Array<Live_Events_Insert_Input>;
  on_conflict?: Maybe<Live_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Live_Events_OneArgs = {
  object: Live_Events_Insert_Input;
  on_conflict?: Maybe<Live_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Match_FlagsArgs = {
  objects: Array<Match_Flags_Insert_Input>;
  on_conflict?: Maybe<Match_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Match_Flags_OneArgs = {
  object: Match_Flags_Insert_Input;
  on_conflict?: Maybe<Match_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Match_RewardsArgs = {
  objects: Array<Match_Rewards_Insert_Input>;
  on_conflict?: Maybe<Match_Rewards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Match_Rewards_OneArgs = {
  object: Match_Rewards_Insert_Input;
  on_conflict?: Maybe<Match_Rewards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MatchesArgs = {
  objects: Array<Matches_Insert_Input>;
  on_conflict?: Maybe<Matches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Matches_OneArgs = {
  object: Matches_Insert_Input;
  on_conflict?: Maybe<Matches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PartiesArgs = {
  objects: Array<Parties_Insert_Input>;
  on_conflict?: Maybe<Parties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parties_OneArgs = {
  object: Parties_Insert_Input;
  on_conflict?: Maybe<Parties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Party_DetailsArgs = {
  objects: Array<Party_Details_Insert_Input>;
  on_conflict?: Maybe<Party_Details_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Party_Details_OneArgs = {
  object: Party_Details_Insert_Input;
  on_conflict?: Maybe<Party_Details_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Party_FlagsArgs = {
  objects: Array<Party_Flags_Insert_Input>;
  on_conflict?: Maybe<Party_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Party_Flags_OneArgs = {
  object: Party_Flags_Insert_Input;
  on_conflict?: Maybe<Party_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Party_InvitesArgs = {
  objects: Array<Party_Invites_Insert_Input>;
  on_conflict?: Maybe<Party_Invites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Party_Invites_OneArgs = {
  object: Party_Invites_Insert_Input;
  on_conflict?: Maybe<Party_Invites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Party_RelationshipsArgs = {
  objects: Array<Party_Relationships_Insert_Input>;
  on_conflict?: Maybe<Party_Relationships_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Party_Relationships_OneArgs = {
  object: Party_Relationships_Insert_Input;
  on_conflict?: Maybe<Party_Relationships_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Party_StatusesArgs = {
  objects: Array<Party_Statuses_Insert_Input>;
  on_conflict?: Maybe<Party_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Party_Statuses_OneArgs = {
  object: Party_Statuses_Insert_Input;
  on_conflict?: Maybe<Party_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reward_RedemptionsArgs = {
  objects: Array<Reward_Redemptions_Insert_Input>;
  on_conflict?: Maybe<Reward_Redemptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reward_Redemptions_OneArgs = {
  object: Reward_Redemptions_Insert_Input;
  on_conflict?: Maybe<Reward_Redemptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RewardsArgs = {
  objects: Array<Rewards_Insert_Input>;
  on_conflict?: Maybe<Rewards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rewards_OneArgs = {
  object: Rewards_Insert_Input;
  on_conflict?: Maybe<Rewards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SeriesArgs = {
  objects: Array<Series_Insert_Input>;
  on_conflict?: Maybe<Series_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Series_OneArgs = {
  object: Series_Insert_Input;
  on_conflict?: Maybe<Series_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Series_SponsorsArgs = {
  objects: Array<Series_Sponsors_Insert_Input>;
  on_conflict?: Maybe<Series_Sponsors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Series_Sponsors_OneArgs = {
  object: Series_Sponsors_Insert_Input;
  on_conflict?: Maybe<Series_Sponsors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Series_TournamentsArgs = {
  objects: Array<Series_Tournaments_Insert_Input>;
  on_conflict?: Maybe<Series_Tournaments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Series_Tournaments_OneArgs = {
  object: Series_Tournaments_Insert_Input;
  on_conflict?: Maybe<Series_Tournaments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StatusesArgs = {
  objects: Array<Statuses_Insert_Input>;
  on_conflict?: Maybe<Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Statuses_OneArgs = {
  object: Statuses_Insert_Input;
  on_conflict?: Maybe<Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tournament_DetailsArgs = {
  objects: Array<Tournament_Details_Insert_Input>;
  on_conflict?: Maybe<Tournament_Details_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tournament_Details_OneArgs = {
  object: Tournament_Details_Insert_Input;
  on_conflict?: Maybe<Tournament_Details_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tournament_FlagsArgs = {
  objects: Array<Tournament_Flags_Insert_Input>;
  on_conflict?: Maybe<Tournament_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tournament_Flags_OneArgs = {
  object: Tournament_Flags_Insert_Input;
  on_conflict?: Maybe<Tournament_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tournament_InvitesArgs = {
  objects: Array<Tournament_Invites_Insert_Input>;
  on_conflict?: Maybe<Tournament_Invites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tournament_Invites_OneArgs = {
  object: Tournament_Invites_Insert_Input;
  on_conflict?: Maybe<Tournament_Invites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tournament_RegistrationsArgs = {
  objects: Array<Tournament_Registrations_Insert_Input>;
  on_conflict?: Maybe<Tournament_Registrations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tournament_Registrations_OneArgs = {
  object: Tournament_Registrations_Insert_Input;
  on_conflict?: Maybe<Tournament_Registrations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tournament_ResultsArgs = {
  objects: Array<Tournament_Results_Insert_Input>;
  on_conflict?: Maybe<Tournament_Results_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tournament_Results_OneArgs = {
  object: Tournament_Results_Insert_Input;
  on_conflict?: Maybe<Tournament_Results_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tournament_RewardsArgs = {
  objects: Array<Tournament_Rewards_Insert_Input>;
  on_conflict?: Maybe<Tournament_Rewards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tournament_Rewards_OneArgs = {
  object: Tournament_Rewards_Insert_Input;
  on_conflict?: Maybe<Tournament_Rewards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tournament_SponsorsArgs = {
  objects: Array<Tournament_Sponsors_Insert_Input>;
  on_conflict?: Maybe<Tournament_Sponsors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tournament_Sponsors_OneArgs = {
  object: Tournament_Sponsors_Insert_Input;
  on_conflict?: Maybe<Tournament_Sponsors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tournament_StagesArgs = {
  objects: Array<Tournament_Stages_Insert_Input>;
  on_conflict?: Maybe<Tournament_Stages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tournament_Stages_OneArgs = {
  object: Tournament_Stages_Insert_Input;
  on_conflict?: Maybe<Tournament_Stages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tournament_StatusesArgs = {
  objects: Array<Tournament_Statuses_Insert_Input>;
  on_conflict?: Maybe<Tournament_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tournament_Statuses_OneArgs = {
  object: Tournament_Statuses_Insert_Input;
  on_conflict?: Maybe<Tournament_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TournamentsArgs = {
  objects: Array<Tournaments_Insert_Input>;
  on_conflict?: Maybe<Tournaments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tournaments_OneArgs = {
  object: Tournaments_Insert_Input;
  on_conflict?: Maybe<Tournaments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TypesArgs = {
  objects: Array<Types_Insert_Input>;
  on_conflict?: Maybe<Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Types_OneArgs = {
  object: Types_Insert_Input;
  on_conflict?: Maybe<Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_FlagsArgs = {
  objects: Array<User_Flags_Insert_Input>;
  on_conflict?: Maybe<User_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Flags_OneArgs = {
  object: User_Flags_Insert_Input;
  on_conflict?: Maybe<User_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Mfa_FactorsArgs = {
  objects: Array<User_Mfa_Factors_Insert_Input>;
  on_conflict?: Maybe<User_Mfa_Factors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Mfa_Factors_OneArgs = {
  object: User_Mfa_Factors_Insert_Input;
  on_conflict?: Maybe<User_Mfa_Factors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_StatusesArgs = {
  objects: Array<User_Statuses_Insert_Input>;
  on_conflict?: Maybe<User_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Statuses_OneArgs = {
  object: User_Statuses_Insert_Input;
  on_conflict?: Maybe<User_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: Maybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: Maybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootLoginArgs = {
  params: LoginInput;
};


/** mutation root */
export type Mutation_RootMagicLinkLoginArgs = {
  params: MagicLinkLoginInput;
};


/** mutation root */
export type Mutation_RootRecordMatchResultArgs = {
  params: RecordMatchResultInput;
};


/** mutation root */
export type Mutation_RootRegisterTeamForTournamentArgs = {
  params: RegisterTeamForTournamentInput;
};


/** mutation root */
export type Mutation_RootRemoveMatchParticipantsArgs = {
  params: RemoveMatchParticipantsInput;
};


/** mutation root */
export type Mutation_RootResetPasswordArgs = {
  params: ResetPasswordInput;
};


/** mutation root */
export type Mutation_RootSendLobbyLinkArgs = {
  params: SendLobbyLinkInput;
};


/** mutation root */
export type Mutation_RootSignupArgs = {
  params: SignupInput;
};


/** mutation root */
export type Mutation_RootUpdateProfileArgs = {
  params: UpdateProfileInput;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_LogsArgs = {
  _append?: Maybe<Audit_Logs_Append_Input>;
  _delete_at_path?: Maybe<Audit_Logs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Audit_Logs_Delete_Elem_Input>;
  _delete_key?: Maybe<Audit_Logs_Delete_Key_Input>;
  _prepend?: Maybe<Audit_Logs_Prepend_Input>;
  _set?: Maybe<Audit_Logs_Set_Input>;
  where: Audit_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_Logs_By_PkArgs = {
  _append?: Maybe<Audit_Logs_Append_Input>;
  _delete_at_path?: Maybe<Audit_Logs_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Audit_Logs_Delete_Elem_Input>;
  _delete_key?: Maybe<Audit_Logs_Delete_Key_Input>;
  _prepend?: Maybe<Audit_Logs_Prepend_Input>;
  _set?: Maybe<Audit_Logs_Set_Input>;
  pk_columns: Audit_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_Logs_ManyArgs = {
  updates: Array<Audit_Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FlagsArgs = {
  _set?: Maybe<Flags_Set_Input>;
  where: Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Flags_By_PkArgs = {
  _set?: Maybe<Flags_Set_Input>;
  pk_columns: Flags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Flags_ManyArgs = {
  updates: Array<Flags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GamesArgs = {
  _append?: Maybe<Games_Append_Input>;
  _delete_at_path?: Maybe<Games_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Games_Delete_Elem_Input>;
  _delete_key?: Maybe<Games_Delete_Key_Input>;
  _prepend?: Maybe<Games_Prepend_Input>;
  _set?: Maybe<Games_Set_Input>;
  where: Games_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Games_By_PkArgs = {
  _append?: Maybe<Games_Append_Input>;
  _delete_at_path?: Maybe<Games_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Games_Delete_Elem_Input>;
  _delete_key?: Maybe<Games_Delete_Key_Input>;
  _prepend?: Maybe<Games_Prepend_Input>;
  _set?: Maybe<Games_Set_Input>;
  pk_columns: Games_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Games_ManyArgs = {
  updates: Array<Games_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hub_RegistrationsArgs = {
  _append?: Maybe<Hub_Registrations_Append_Input>;
  _delete_at_path?: Maybe<Hub_Registrations_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Hub_Registrations_Delete_Elem_Input>;
  _delete_key?: Maybe<Hub_Registrations_Delete_Key_Input>;
  _prepend?: Maybe<Hub_Registrations_Prepend_Input>;
  _set?: Maybe<Hub_Registrations_Set_Input>;
  where: Hub_Registrations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hub_Registrations_By_PkArgs = {
  _append?: Maybe<Hub_Registrations_Append_Input>;
  _delete_at_path?: Maybe<Hub_Registrations_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Hub_Registrations_Delete_Elem_Input>;
  _delete_key?: Maybe<Hub_Registrations_Delete_Key_Input>;
  _prepend?: Maybe<Hub_Registrations_Prepend_Input>;
  _set?: Maybe<Hub_Registrations_Set_Input>;
  pk_columns: Hub_Registrations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hub_Registrations_ManyArgs = {
  updates: Array<Hub_Registrations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InvitesArgs = {
  _set?: Maybe<Invites_Set_Input>;
  where: Invites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invites_By_PkArgs = {
  _set?: Maybe<Invites_Set_Input>;
  pk_columns: Invites_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invites_ManyArgs = {
  updates: Array<Invites_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Live_Event_MessagesArgs = {
  _set?: Maybe<Live_Event_Messages_Set_Input>;
  where: Live_Event_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Live_Event_Messages_By_PkArgs = {
  _set?: Maybe<Live_Event_Messages_Set_Input>;
  pk_columns: Live_Event_Messages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Live_Event_Messages_ManyArgs = {
  updates: Array<Live_Event_Messages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Live_EventsArgs = {
  _set?: Maybe<Live_Events_Set_Input>;
  where: Live_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Live_Events_By_PkArgs = {
  _set?: Maybe<Live_Events_Set_Input>;
  pk_columns: Live_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Live_Events_ManyArgs = {
  updates: Array<Live_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Match_FlagsArgs = {
  _set?: Maybe<Match_Flags_Set_Input>;
  where: Match_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Match_Flags_By_PkArgs = {
  _set?: Maybe<Match_Flags_Set_Input>;
  pk_columns: Match_Flags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Match_Flags_ManyArgs = {
  updates: Array<Match_Flags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Match_RewardsArgs = {
  _inc?: Maybe<Match_Rewards_Inc_Input>;
  _set?: Maybe<Match_Rewards_Set_Input>;
  where: Match_Rewards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Match_Rewards_By_PkArgs = {
  _inc?: Maybe<Match_Rewards_Inc_Input>;
  _set?: Maybe<Match_Rewards_Set_Input>;
  pk_columns: Match_Rewards_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Match_Rewards_ManyArgs = {
  updates: Array<Match_Rewards_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MatchesArgs = {
  _append?: Maybe<Matches_Append_Input>;
  _delete_at_path?: Maybe<Matches_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Matches_Delete_Elem_Input>;
  _delete_key?: Maybe<Matches_Delete_Key_Input>;
  _inc?: Maybe<Matches_Inc_Input>;
  _prepend?: Maybe<Matches_Prepend_Input>;
  _set?: Maybe<Matches_Set_Input>;
  where: Matches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Matches_By_PkArgs = {
  _append?: Maybe<Matches_Append_Input>;
  _delete_at_path?: Maybe<Matches_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Matches_Delete_Elem_Input>;
  _delete_key?: Maybe<Matches_Delete_Key_Input>;
  _inc?: Maybe<Matches_Inc_Input>;
  _prepend?: Maybe<Matches_Prepend_Input>;
  _set?: Maybe<Matches_Set_Input>;
  pk_columns: Matches_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Matches_ManyArgs = {
  updates: Array<Matches_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PartiesArgs = {
  _set?: Maybe<Parties_Set_Input>;
  where: Parties_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parties_By_PkArgs = {
  _set?: Maybe<Parties_Set_Input>;
  pk_columns: Parties_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parties_ManyArgs = {
  updates: Array<Parties_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Party_DetailsArgs = {
  _set?: Maybe<Party_Details_Set_Input>;
  where: Party_Details_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Party_Details_By_PkArgs = {
  _set?: Maybe<Party_Details_Set_Input>;
  pk_columns: Party_Details_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Party_Details_ManyArgs = {
  updates: Array<Party_Details_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Party_FlagsArgs = {
  _set?: Maybe<Party_Flags_Set_Input>;
  where: Party_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Party_Flags_By_PkArgs = {
  _set?: Maybe<Party_Flags_Set_Input>;
  pk_columns: Party_Flags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Party_Flags_ManyArgs = {
  updates: Array<Party_Flags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Party_InvitesArgs = {
  _set?: Maybe<Party_Invites_Set_Input>;
  where: Party_Invites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Party_Invites_By_PkArgs = {
  _set?: Maybe<Party_Invites_Set_Input>;
  pk_columns: Party_Invites_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Party_Invites_ManyArgs = {
  updates: Array<Party_Invites_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Party_RelationshipsArgs = {
  _set?: Maybe<Party_Relationships_Set_Input>;
  where: Party_Relationships_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Party_Relationships_By_PkArgs = {
  _set?: Maybe<Party_Relationships_Set_Input>;
  pk_columns: Party_Relationships_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Party_Relationships_ManyArgs = {
  updates: Array<Party_Relationships_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Party_StatusesArgs = {
  _set?: Maybe<Party_Statuses_Set_Input>;
  where: Party_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Party_Statuses_By_PkArgs = {
  _set?: Maybe<Party_Statuses_Set_Input>;
  pk_columns: Party_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Party_Statuses_ManyArgs = {
  updates: Array<Party_Statuses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Reward_RedemptionsArgs = {
  _inc?: Maybe<Reward_Redemptions_Inc_Input>;
  _set?: Maybe<Reward_Redemptions_Set_Input>;
  where: Reward_Redemptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reward_Redemptions_By_PkArgs = {
  _inc?: Maybe<Reward_Redemptions_Inc_Input>;
  _set?: Maybe<Reward_Redemptions_Set_Input>;
  pk_columns: Reward_Redemptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reward_Redemptions_ManyArgs = {
  updates: Array<Reward_Redemptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RewardsArgs = {
  _append?: Maybe<Rewards_Append_Input>;
  _delete_at_path?: Maybe<Rewards_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Rewards_Delete_Elem_Input>;
  _delete_key?: Maybe<Rewards_Delete_Key_Input>;
  _prepend?: Maybe<Rewards_Prepend_Input>;
  _set?: Maybe<Rewards_Set_Input>;
  where: Rewards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rewards_By_PkArgs = {
  _append?: Maybe<Rewards_Append_Input>;
  _delete_at_path?: Maybe<Rewards_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Rewards_Delete_Elem_Input>;
  _delete_key?: Maybe<Rewards_Delete_Key_Input>;
  _prepend?: Maybe<Rewards_Prepend_Input>;
  _set?: Maybe<Rewards_Set_Input>;
  pk_columns: Rewards_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rewards_ManyArgs = {
  updates: Array<Rewards_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SeriesArgs = {
  _set?: Maybe<Series_Set_Input>;
  where: Series_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Series_By_PkArgs = {
  _set?: Maybe<Series_Set_Input>;
  pk_columns: Series_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Series_ManyArgs = {
  updates: Array<Series_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Series_SponsorsArgs = {
  _set?: Maybe<Series_Sponsors_Set_Input>;
  where: Series_Sponsors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Series_Sponsors_By_PkArgs = {
  _set?: Maybe<Series_Sponsors_Set_Input>;
  pk_columns: Series_Sponsors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Series_Sponsors_ManyArgs = {
  updates: Array<Series_Sponsors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Series_TournamentsArgs = {
  _set?: Maybe<Series_Tournaments_Set_Input>;
  where: Series_Tournaments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Series_Tournaments_By_PkArgs = {
  _set?: Maybe<Series_Tournaments_Set_Input>;
  pk_columns: Series_Tournaments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Series_Tournaments_ManyArgs = {
  updates: Array<Series_Tournaments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StatusesArgs = {
  _set?: Maybe<Statuses_Set_Input>;
  where: Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Statuses_By_PkArgs = {
  _set?: Maybe<Statuses_Set_Input>;
  pk_columns: Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Statuses_ManyArgs = {
  updates: Array<Statuses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_DetailsArgs = {
  _set?: Maybe<Tournament_Details_Set_Input>;
  where: Tournament_Details_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_Details_By_PkArgs = {
  _set?: Maybe<Tournament_Details_Set_Input>;
  pk_columns: Tournament_Details_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_Details_ManyArgs = {
  updates: Array<Tournament_Details_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_FlagsArgs = {
  _set?: Maybe<Tournament_Flags_Set_Input>;
  where: Tournament_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_Flags_By_PkArgs = {
  _set?: Maybe<Tournament_Flags_Set_Input>;
  pk_columns: Tournament_Flags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_Flags_ManyArgs = {
  updates: Array<Tournament_Flags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_InvitesArgs = {
  _set?: Maybe<Tournament_Invites_Set_Input>;
  where: Tournament_Invites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_Invites_By_PkArgs = {
  _set?: Maybe<Tournament_Invites_Set_Input>;
  pk_columns: Tournament_Invites_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_Invites_ManyArgs = {
  updates: Array<Tournament_Invites_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_RegistrationsArgs = {
  _set?: Maybe<Tournament_Registrations_Set_Input>;
  where: Tournament_Registrations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_Registrations_By_PkArgs = {
  _set?: Maybe<Tournament_Registrations_Set_Input>;
  pk_columns: Tournament_Registrations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_Registrations_ManyArgs = {
  updates: Array<Tournament_Registrations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_ResultsArgs = {
  _append?: Maybe<Tournament_Results_Append_Input>;
  _delete_at_path?: Maybe<Tournament_Results_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Tournament_Results_Delete_Elem_Input>;
  _delete_key?: Maybe<Tournament_Results_Delete_Key_Input>;
  _prepend?: Maybe<Tournament_Results_Prepend_Input>;
  _set?: Maybe<Tournament_Results_Set_Input>;
  where: Tournament_Results_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_Results_By_PkArgs = {
  _append?: Maybe<Tournament_Results_Append_Input>;
  _delete_at_path?: Maybe<Tournament_Results_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Tournament_Results_Delete_Elem_Input>;
  _delete_key?: Maybe<Tournament_Results_Delete_Key_Input>;
  _prepend?: Maybe<Tournament_Results_Prepend_Input>;
  _set?: Maybe<Tournament_Results_Set_Input>;
  pk_columns: Tournament_Results_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_Results_ManyArgs = {
  updates: Array<Tournament_Results_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_RewardsArgs = {
  _inc?: Maybe<Tournament_Rewards_Inc_Input>;
  _set?: Maybe<Tournament_Rewards_Set_Input>;
  where: Tournament_Rewards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_Rewards_By_PkArgs = {
  _inc?: Maybe<Tournament_Rewards_Inc_Input>;
  _set?: Maybe<Tournament_Rewards_Set_Input>;
  pk_columns: Tournament_Rewards_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_Rewards_ManyArgs = {
  updates: Array<Tournament_Rewards_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_SponsorsArgs = {
  _set?: Maybe<Tournament_Sponsors_Set_Input>;
  where: Tournament_Sponsors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_Sponsors_By_PkArgs = {
  _set?: Maybe<Tournament_Sponsors_Set_Input>;
  pk_columns: Tournament_Sponsors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_Sponsors_ManyArgs = {
  updates: Array<Tournament_Sponsors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_StagesArgs = {
  _append?: Maybe<Tournament_Stages_Append_Input>;
  _delete_at_path?: Maybe<Tournament_Stages_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Tournament_Stages_Delete_Elem_Input>;
  _delete_key?: Maybe<Tournament_Stages_Delete_Key_Input>;
  _prepend?: Maybe<Tournament_Stages_Prepend_Input>;
  _set?: Maybe<Tournament_Stages_Set_Input>;
  where: Tournament_Stages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_Stages_By_PkArgs = {
  _append?: Maybe<Tournament_Stages_Append_Input>;
  _delete_at_path?: Maybe<Tournament_Stages_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Tournament_Stages_Delete_Elem_Input>;
  _delete_key?: Maybe<Tournament_Stages_Delete_Key_Input>;
  _prepend?: Maybe<Tournament_Stages_Prepend_Input>;
  _set?: Maybe<Tournament_Stages_Set_Input>;
  pk_columns: Tournament_Stages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_Stages_ManyArgs = {
  updates: Array<Tournament_Stages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_StatusesArgs = {
  _set?: Maybe<Tournament_Statuses_Set_Input>;
  where: Tournament_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_Statuses_By_PkArgs = {
  _set?: Maybe<Tournament_Statuses_Set_Input>;
  pk_columns: Tournament_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tournament_Statuses_ManyArgs = {
  updates: Array<Tournament_Statuses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TournamentsArgs = {
  _set?: Maybe<Tournaments_Set_Input>;
  where: Tournaments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tournaments_By_PkArgs = {
  _set?: Maybe<Tournaments_Set_Input>;
  pk_columns: Tournaments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tournaments_ManyArgs = {
  updates: Array<Tournaments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TypesArgs = {
  _set?: Maybe<Types_Set_Input>;
  where: Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Types_By_PkArgs = {
  _set?: Maybe<Types_Set_Input>;
  pk_columns: Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Types_ManyArgs = {
  updates: Array<Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_FlagsArgs = {
  _set?: Maybe<User_Flags_Set_Input>;
  where: User_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Flags_By_PkArgs = {
  _set?: Maybe<User_Flags_Set_Input>;
  pk_columns: User_Flags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Flags_ManyArgs = {
  updates: Array<User_Flags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Mfa_FactorsArgs = {
  _set?: Maybe<User_Mfa_Factors_Set_Input>;
  where: User_Mfa_Factors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Mfa_Factors_By_PkArgs = {
  _set?: Maybe<User_Mfa_Factors_Set_Input>;
  pk_columns: User_Mfa_Factors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Mfa_Factors_ManyArgs = {
  updates: Array<User_Mfa_Factors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_StatusesArgs = {
  _set?: Maybe<User_Statuses_Set_Input>;
  where: User_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Statuses_By_PkArgs = {
  _set?: Maybe<User_Statuses_Set_Input>;
  pk_columns: User_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Statuses_ManyArgs = {
  updates: Array<User_Statuses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _set?: Maybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _set?: Maybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "parties" */
export type Parties = {
  __typename?: 'parties';
  avatar?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  id: Scalars['uuid'];
  /** An array relationship */
  invites: Array<Invites>;
  /** An array relationship */
  invitesByInvitedTo: Array<Invites>;
  /** An aggregate relationship */
  invitesByInvitedTo_aggregate: Invites_Aggregate;
  /** An array relationship */
  invitesByInvitee: Array<Invites>;
  /** An aggregate relationship */
  invitesByInvitee_aggregate: Invites_Aggregate;
  /** An aggregate relationship */
  invites_aggregate: Invites_Aggregate;
  /** An array relationship */
  live_event_messages: Array<Live_Event_Messages>;
  /** An aggregate relationship */
  live_event_messages_aggregate: Live_Event_Messages_Aggregate;
  locale?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nickname?: Maybe<Scalars['String']>;
  /** An array relationship */
  partyRelationshipsByParticipant: Array<Party_Relationships>;
  /** An aggregate relationship */
  partyRelationshipsByParticipant_aggregate: Party_Relationships_Aggregate;
  /** An array relationship */
  party_details: Array<Party_Details>;
  /** An aggregate relationship */
  party_details_aggregate: Party_Details_Aggregate;
  /** An array relationship */
  party_flags: Array<Party_Flags>;
  /** An aggregate relationship */
  party_flags_aggregate: Party_Flags_Aggregate;
  /** An array relationship */
  party_invites: Array<Party_Invites>;
  /** An aggregate relationship */
  party_invites_aggregate: Party_Invites_Aggregate;
  /** An array relationship */
  party_relationships: Array<Party_Relationships>;
  /** An aggregate relationship */
  party_relationships_aggregate: Party_Relationships_Aggregate;
  /** An array relationship */
  party_statuses: Array<Party_Statuses>;
  /** An aggregate relationship */
  party_statuses_aggregate: Party_Statuses_Aggregate;
  phone_number: Scalars['String'];
  /** An array relationship */
  reward_redemptions: Array<Reward_Redemptions>;
  /** An aggregate relationship */
  reward_redemptions_aggregate: Reward_Redemptions_Aggregate;
  /** An array relationship */
  series: Array<Series>;
  /** An aggregate relationship */
  series_aggregate: Series_Aggregate;
  /** An array relationship */
  series_sponsors: Array<Series_Sponsors>;
  /** An aggregate relationship */
  series_sponsors_aggregate: Series_Sponsors_Aggregate;
  /** An array relationship */
  tournamentRegistrationsByRegisteredById: Array<Tournament_Registrations>;
  /** An aggregate relationship */
  tournamentRegistrationsByRegisteredById_aggregate: Tournament_Registrations_Aggregate;
  /** An array relationship */
  tournament_invites: Array<Tournament_Invites>;
  /** An aggregate relationship */
  tournament_invites_aggregate: Tournament_Invites_Aggregate;
  /** An array relationship */
  tournament_registrations: Array<Tournament_Registrations>;
  /** An aggregate relationship */
  tournament_registrations_aggregate: Tournament_Registrations_Aggregate;
  /** An array relationship */
  tournament_results: Array<Tournament_Results>;
  /** An aggregate relationship */
  tournament_results_aggregate: Tournament_Results_Aggregate;
  /** An array relationship */
  tournament_sponsors: Array<Tournament_Sponsors>;
  /** An aggregate relationship */
  tournament_sponsors_aggregate: Tournament_Sponsors_Aggregate;
  /** An object relationship */
  type: Types;
  type_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "parties" */
export type PartiesInvitesArgs = {
  distinct_on?: Maybe<Array<Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invites_Order_By>>;
  where?: Maybe<Invites_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesInvitesByInvitedToArgs = {
  distinct_on?: Maybe<Array<Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invites_Order_By>>;
  where?: Maybe<Invites_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesInvitesByInvitedTo_AggregateArgs = {
  distinct_on?: Maybe<Array<Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invites_Order_By>>;
  where?: Maybe<Invites_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesInvitesByInviteeArgs = {
  distinct_on?: Maybe<Array<Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invites_Order_By>>;
  where?: Maybe<Invites_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesInvitesByInvitee_AggregateArgs = {
  distinct_on?: Maybe<Array<Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invites_Order_By>>;
  where?: Maybe<Invites_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesInvites_AggregateArgs = {
  distinct_on?: Maybe<Array<Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invites_Order_By>>;
  where?: Maybe<Invites_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesLive_Event_MessagesArgs = {
  distinct_on?: Maybe<Array<Live_Event_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Event_Messages_Order_By>>;
  where?: Maybe<Live_Event_Messages_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesLive_Event_Messages_AggregateArgs = {
  distinct_on?: Maybe<Array<Live_Event_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Event_Messages_Order_By>>;
  where?: Maybe<Live_Event_Messages_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesPartyRelationshipsByParticipantArgs = {
  distinct_on?: Maybe<Array<Party_Relationships_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Relationships_Order_By>>;
  where?: Maybe<Party_Relationships_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesPartyRelationshipsByParticipant_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Relationships_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Relationships_Order_By>>;
  where?: Maybe<Party_Relationships_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesParty_DetailsArgs = {
  distinct_on?: Maybe<Array<Party_Details_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Details_Order_By>>;
  where?: Maybe<Party_Details_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesParty_Details_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Details_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Details_Order_By>>;
  where?: Maybe<Party_Details_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesParty_FlagsArgs = {
  distinct_on?: Maybe<Array<Party_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Flags_Order_By>>;
  where?: Maybe<Party_Flags_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesParty_Flags_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Flags_Order_By>>;
  where?: Maybe<Party_Flags_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesParty_InvitesArgs = {
  distinct_on?: Maybe<Array<Party_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Invites_Order_By>>;
  where?: Maybe<Party_Invites_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesParty_Invites_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Invites_Order_By>>;
  where?: Maybe<Party_Invites_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesParty_RelationshipsArgs = {
  distinct_on?: Maybe<Array<Party_Relationships_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Relationships_Order_By>>;
  where?: Maybe<Party_Relationships_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesParty_Relationships_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Relationships_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Relationships_Order_By>>;
  where?: Maybe<Party_Relationships_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesParty_StatusesArgs = {
  distinct_on?: Maybe<Array<Party_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Statuses_Order_By>>;
  where?: Maybe<Party_Statuses_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesParty_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Statuses_Order_By>>;
  where?: Maybe<Party_Statuses_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesReward_RedemptionsArgs = {
  distinct_on?: Maybe<Array<Reward_Redemptions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Reward_Redemptions_Order_By>>;
  where?: Maybe<Reward_Redemptions_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesReward_Redemptions_AggregateArgs = {
  distinct_on?: Maybe<Array<Reward_Redemptions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Reward_Redemptions_Order_By>>;
  where?: Maybe<Reward_Redemptions_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesSeriesArgs = {
  distinct_on?: Maybe<Array<Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Order_By>>;
  where?: Maybe<Series_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesSeries_AggregateArgs = {
  distinct_on?: Maybe<Array<Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Order_By>>;
  where?: Maybe<Series_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesSeries_SponsorsArgs = {
  distinct_on?: Maybe<Array<Series_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Sponsors_Order_By>>;
  where?: Maybe<Series_Sponsors_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesSeries_Sponsors_AggregateArgs = {
  distinct_on?: Maybe<Array<Series_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Sponsors_Order_By>>;
  where?: Maybe<Series_Sponsors_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesTournamentRegistrationsByRegisteredByIdArgs = {
  distinct_on?: Maybe<Array<Tournament_Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Registrations_Order_By>>;
  where?: Maybe<Tournament_Registrations_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesTournamentRegistrationsByRegisteredById_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Registrations_Order_By>>;
  where?: Maybe<Tournament_Registrations_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesTournament_InvitesArgs = {
  distinct_on?: Maybe<Array<Tournament_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Invites_Order_By>>;
  where?: Maybe<Tournament_Invites_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesTournament_Invites_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Invites_Order_By>>;
  where?: Maybe<Tournament_Invites_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesTournament_RegistrationsArgs = {
  distinct_on?: Maybe<Array<Tournament_Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Registrations_Order_By>>;
  where?: Maybe<Tournament_Registrations_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesTournament_Registrations_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Registrations_Order_By>>;
  where?: Maybe<Tournament_Registrations_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesTournament_ResultsArgs = {
  distinct_on?: Maybe<Array<Tournament_Results_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Results_Order_By>>;
  where?: Maybe<Tournament_Results_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesTournament_Results_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Results_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Results_Order_By>>;
  where?: Maybe<Tournament_Results_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesTournament_SponsorsArgs = {
  distinct_on?: Maybe<Array<Tournament_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Sponsors_Order_By>>;
  where?: Maybe<Tournament_Sponsors_Bool_Exp>;
};


/** columns and relationships of "parties" */
export type PartiesTournament_Sponsors_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Sponsors_Order_By>>;
  where?: Maybe<Tournament_Sponsors_Bool_Exp>;
};

/** aggregated selection of "parties" */
export type Parties_Aggregate = {
  __typename?: 'parties_aggregate';
  aggregate?: Maybe<Parties_Aggregate_Fields>;
  nodes: Array<Parties>;
};

export type Parties_Aggregate_Bool_Exp = {
  count?: Maybe<Parties_Aggregate_Bool_Exp_Count>;
};

export type Parties_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Parties_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Parties_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parties" */
export type Parties_Aggregate_Fields = {
  __typename?: 'parties_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Parties_Max_Fields>;
  min?: Maybe<Parties_Min_Fields>;
};


/** aggregate fields of "parties" */
export type Parties_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Parties_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "parties" */
export type Parties_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Parties_Max_Order_By>;
  min?: Maybe<Parties_Min_Order_By>;
};

/** input type for inserting array relation for remote table "parties" */
export type Parties_Arr_Rel_Insert_Input = {
  data: Array<Parties_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Parties_On_Conflict>;
};

/** Boolean expression to filter rows from the table "parties". All fields are combined with a logical 'AND'. */
export type Parties_Bool_Exp = {
  _and?: Maybe<Array<Parties_Bool_Exp>>;
  _not?: Maybe<Parties_Bool_Exp>;
  _or?: Maybe<Array<Parties_Bool_Exp>>;
  avatar?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  invites?: Maybe<Invites_Bool_Exp>;
  invitesByInvitedTo?: Maybe<Invites_Bool_Exp>;
  invitesByInvitedTo_aggregate?: Maybe<Invites_Aggregate_Bool_Exp>;
  invitesByInvitee?: Maybe<Invites_Bool_Exp>;
  invitesByInvitee_aggregate?: Maybe<Invites_Aggregate_Bool_Exp>;
  invites_aggregate?: Maybe<Invites_Aggregate_Bool_Exp>;
  live_event_messages?: Maybe<Live_Event_Messages_Bool_Exp>;
  live_event_messages_aggregate?: Maybe<Live_Event_Messages_Aggregate_Bool_Exp>;
  locale?: Maybe<String_Comparison_Exp>;
  location?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  nickname?: Maybe<String_Comparison_Exp>;
  partyRelationshipsByParticipant?: Maybe<Party_Relationships_Bool_Exp>;
  partyRelationshipsByParticipant_aggregate?: Maybe<Party_Relationships_Aggregate_Bool_Exp>;
  party_details?: Maybe<Party_Details_Bool_Exp>;
  party_details_aggregate?: Maybe<Party_Details_Aggregate_Bool_Exp>;
  party_flags?: Maybe<Party_Flags_Bool_Exp>;
  party_flags_aggregate?: Maybe<Party_Flags_Aggregate_Bool_Exp>;
  party_invites?: Maybe<Party_Invites_Bool_Exp>;
  party_invites_aggregate?: Maybe<Party_Invites_Aggregate_Bool_Exp>;
  party_relationships?: Maybe<Party_Relationships_Bool_Exp>;
  party_relationships_aggregate?: Maybe<Party_Relationships_Aggregate_Bool_Exp>;
  party_statuses?: Maybe<Party_Statuses_Bool_Exp>;
  party_statuses_aggregate?: Maybe<Party_Statuses_Aggregate_Bool_Exp>;
  phone_number?: Maybe<String_Comparison_Exp>;
  reward_redemptions?: Maybe<Reward_Redemptions_Bool_Exp>;
  reward_redemptions_aggregate?: Maybe<Reward_Redemptions_Aggregate_Bool_Exp>;
  series?: Maybe<Series_Bool_Exp>;
  series_aggregate?: Maybe<Series_Aggregate_Bool_Exp>;
  series_sponsors?: Maybe<Series_Sponsors_Bool_Exp>;
  series_sponsors_aggregate?: Maybe<Series_Sponsors_Aggregate_Bool_Exp>;
  tournamentRegistrationsByRegisteredById?: Maybe<Tournament_Registrations_Bool_Exp>;
  tournamentRegistrationsByRegisteredById_aggregate?: Maybe<Tournament_Registrations_Aggregate_Bool_Exp>;
  tournament_invites?: Maybe<Tournament_Invites_Bool_Exp>;
  tournament_invites_aggregate?: Maybe<Tournament_Invites_Aggregate_Bool_Exp>;
  tournament_registrations?: Maybe<Tournament_Registrations_Bool_Exp>;
  tournament_registrations_aggregate?: Maybe<Tournament_Registrations_Aggregate_Bool_Exp>;
  tournament_results?: Maybe<Tournament_Results_Bool_Exp>;
  tournament_results_aggregate?: Maybe<Tournament_Results_Aggregate_Bool_Exp>;
  tournament_sponsors?: Maybe<Tournament_Sponsors_Bool_Exp>;
  tournament_sponsors_aggregate?: Maybe<Tournament_Sponsors_Aggregate_Bool_Exp>;
  type?: Maybe<Types_Bool_Exp>;
  type_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "parties" */
export enum Parties_Constraint {
  /** unique or primary key constraint on columns "email" */
  PartiesEmailUnique = 'parties_email_unique',
  /** unique or primary key constraint on columns "phone_number" */
  PartiesPhoneNumberUnique = 'parties_phone_number_unique',
  /** unique or primary key constraint on columns "id" */
  PartiesPkey = 'parties_pkey',
  /** unique or primary key constraint on columns "name", "email", "phone_number" */
  UniqueParty = 'unique_party'
}

/** input type for inserting data into table "parties" */
export type Parties_Insert_Input = {
  avatar?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  invites?: Maybe<Invites_Arr_Rel_Insert_Input>;
  invitesByInvitedTo?: Maybe<Invites_Arr_Rel_Insert_Input>;
  invitesByInvitee?: Maybe<Invites_Arr_Rel_Insert_Input>;
  live_event_messages?: Maybe<Live_Event_Messages_Arr_Rel_Insert_Input>;
  locale?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  partyRelationshipsByParticipant?: Maybe<Party_Relationships_Arr_Rel_Insert_Input>;
  party_details?: Maybe<Party_Details_Arr_Rel_Insert_Input>;
  party_flags?: Maybe<Party_Flags_Arr_Rel_Insert_Input>;
  party_invites?: Maybe<Party_Invites_Arr_Rel_Insert_Input>;
  party_relationships?: Maybe<Party_Relationships_Arr_Rel_Insert_Input>;
  party_statuses?: Maybe<Party_Statuses_Arr_Rel_Insert_Input>;
  phone_number?: Maybe<Scalars['String']>;
  reward_redemptions?: Maybe<Reward_Redemptions_Arr_Rel_Insert_Input>;
  series?: Maybe<Series_Arr_Rel_Insert_Input>;
  series_sponsors?: Maybe<Series_Sponsors_Arr_Rel_Insert_Input>;
  tournamentRegistrationsByRegisteredById?: Maybe<Tournament_Registrations_Arr_Rel_Insert_Input>;
  tournament_invites?: Maybe<Tournament_Invites_Arr_Rel_Insert_Input>;
  tournament_registrations?: Maybe<Tournament_Registrations_Arr_Rel_Insert_Input>;
  tournament_results?: Maybe<Tournament_Results_Arr_Rel_Insert_Input>;
  tournament_sponsors?: Maybe<Tournament_Sponsors_Arr_Rel_Insert_Input>;
  type?: Maybe<Types_Obj_Rel_Insert_Input>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Parties_Max_Fields = {
  __typename?: 'parties_max_fields';
  avatar?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "parties" */
export type Parties_Max_Order_By = {
  avatar?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  locale?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  nickname?: Maybe<Order_By>;
  phone_number?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Parties_Min_Fields = {
  __typename?: 'parties_min_fields';
  avatar?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "parties" */
export type Parties_Min_Order_By = {
  avatar?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  locale?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  nickname?: Maybe<Order_By>;
  phone_number?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "parties" */
export type Parties_Mutation_Response = {
  __typename?: 'parties_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Parties>;
};

/** input type for inserting object relation for remote table "parties" */
export type Parties_Obj_Rel_Insert_Input = {
  data: Parties_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Parties_On_Conflict>;
};

/** on_conflict condition type for table "parties" */
export type Parties_On_Conflict = {
  constraint: Parties_Constraint;
  update_columns?: Array<Parties_Update_Column>;
  where?: Maybe<Parties_Bool_Exp>;
};

/** Ordering options when selecting data from "parties". */
export type Parties_Order_By = {
  avatar?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invitesByInvitedTo_aggregate?: Maybe<Invites_Aggregate_Order_By>;
  invitesByInvitee_aggregate?: Maybe<Invites_Aggregate_Order_By>;
  invites_aggregate?: Maybe<Invites_Aggregate_Order_By>;
  live_event_messages_aggregate?: Maybe<Live_Event_Messages_Aggregate_Order_By>;
  locale?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  nickname?: Maybe<Order_By>;
  partyRelationshipsByParticipant_aggregate?: Maybe<Party_Relationships_Aggregate_Order_By>;
  party_details_aggregate?: Maybe<Party_Details_Aggregate_Order_By>;
  party_flags_aggregate?: Maybe<Party_Flags_Aggregate_Order_By>;
  party_invites_aggregate?: Maybe<Party_Invites_Aggregate_Order_By>;
  party_relationships_aggregate?: Maybe<Party_Relationships_Aggregate_Order_By>;
  party_statuses_aggregate?: Maybe<Party_Statuses_Aggregate_Order_By>;
  phone_number?: Maybe<Order_By>;
  reward_redemptions_aggregate?: Maybe<Reward_Redemptions_Aggregate_Order_By>;
  series_aggregate?: Maybe<Series_Aggregate_Order_By>;
  series_sponsors_aggregate?: Maybe<Series_Sponsors_Aggregate_Order_By>;
  tournamentRegistrationsByRegisteredById_aggregate?: Maybe<Tournament_Registrations_Aggregate_Order_By>;
  tournament_invites_aggregate?: Maybe<Tournament_Invites_Aggregate_Order_By>;
  tournament_registrations_aggregate?: Maybe<Tournament_Registrations_Aggregate_Order_By>;
  tournament_results_aggregate?: Maybe<Tournament_Results_Aggregate_Order_By>;
  tournament_sponsors_aggregate?: Maybe<Tournament_Sponsors_Aggregate_Order_By>;
  type?: Maybe<Types_Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: parties */
export type Parties_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "parties" */
export enum Parties_Select_Column {
  /** column name */
  Avatar = 'avatar',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Locale = 'locale',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "parties" */
export type Parties_Set_Input = {
  avatar?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "parties" */
export type Parties_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parties_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parties_Stream_Cursor_Value_Input = {
  avatar?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "parties" */
export enum Parties_Update_Column {
  /** column name */
  Avatar = 'avatar',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Locale = 'locale',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Parties_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Parties_Set_Input>;
  where: Parties_Bool_Exp;
};

/** columns and relationships of "party_details" */
export type Party_Details = {
  __typename?: 'party_details';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  key: Scalars['String'];
  /** An object relationship */
  party: Parties;
  party_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  value?: Maybe<Scalars['String']>;
};

/** aggregated selection of "party_details" */
export type Party_Details_Aggregate = {
  __typename?: 'party_details_aggregate';
  aggregate?: Maybe<Party_Details_Aggregate_Fields>;
  nodes: Array<Party_Details>;
};

export type Party_Details_Aggregate_Bool_Exp = {
  count?: Maybe<Party_Details_Aggregate_Bool_Exp_Count>;
};

export type Party_Details_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Party_Details_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Party_Details_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "party_details" */
export type Party_Details_Aggregate_Fields = {
  __typename?: 'party_details_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Party_Details_Max_Fields>;
  min?: Maybe<Party_Details_Min_Fields>;
};


/** aggregate fields of "party_details" */
export type Party_Details_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Party_Details_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "party_details" */
export type Party_Details_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Party_Details_Max_Order_By>;
  min?: Maybe<Party_Details_Min_Order_By>;
};

/** input type for inserting array relation for remote table "party_details" */
export type Party_Details_Arr_Rel_Insert_Input = {
  data: Array<Party_Details_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Party_Details_On_Conflict>;
};

/** Boolean expression to filter rows from the table "party_details". All fields are combined with a logical 'AND'. */
export type Party_Details_Bool_Exp = {
  _and?: Maybe<Array<Party_Details_Bool_Exp>>;
  _not?: Maybe<Party_Details_Bool_Exp>;
  _or?: Maybe<Array<Party_Details_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  key?: Maybe<String_Comparison_Exp>;
  party?: Maybe<Parties_Bool_Exp>;
  party_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "party_details" */
export enum Party_Details_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartyDetailsPkey = 'party_details_pkey',
  /** unique or primary key constraint on columns "key", "party_id" */
  UniquePartyDetail = 'unique_party_detail'
}

/** input type for inserting data into table "party_details" */
export type Party_Details_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  party?: Maybe<Parties_Obj_Rel_Insert_Input>;
  party_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Party_Details_Max_Fields = {
  __typename?: 'party_details_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  party_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "party_details" */
export type Party_Details_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  party_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Party_Details_Min_Fields = {
  __typename?: 'party_details_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  party_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "party_details" */
export type Party_Details_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  party_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "party_details" */
export type Party_Details_Mutation_Response = {
  __typename?: 'party_details_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Party_Details>;
};

/** on_conflict condition type for table "party_details" */
export type Party_Details_On_Conflict = {
  constraint: Party_Details_Constraint;
  update_columns?: Array<Party_Details_Update_Column>;
  where?: Maybe<Party_Details_Bool_Exp>;
};

/** Ordering options when selecting data from "party_details". */
export type Party_Details_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  party?: Maybe<Parties_Order_By>;
  party_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: party_details */
export type Party_Details_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "party_details" */
export enum Party_Details_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  PartyId = 'party_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "party_details" */
export type Party_Details_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  party_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "party_details" */
export type Party_Details_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Party_Details_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Party_Details_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  party_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "party_details" */
export enum Party_Details_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  PartyId = 'party_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Party_Details_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Party_Details_Set_Input>;
  where: Party_Details_Bool_Exp;
};

/** columns and relationships of "party_flags" */
export type Party_Flags = {
  __typename?: 'party_flags';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  flag: Flags;
  flag_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  party: Parties;
  party_id: Scalars['uuid'];
};

/** aggregated selection of "party_flags" */
export type Party_Flags_Aggregate = {
  __typename?: 'party_flags_aggregate';
  aggregate?: Maybe<Party_Flags_Aggregate_Fields>;
  nodes: Array<Party_Flags>;
};

export type Party_Flags_Aggregate_Bool_Exp = {
  count?: Maybe<Party_Flags_Aggregate_Bool_Exp_Count>;
};

export type Party_Flags_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Party_Flags_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Party_Flags_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "party_flags" */
export type Party_Flags_Aggregate_Fields = {
  __typename?: 'party_flags_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Party_Flags_Max_Fields>;
  min?: Maybe<Party_Flags_Min_Fields>;
};


/** aggregate fields of "party_flags" */
export type Party_Flags_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Party_Flags_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "party_flags" */
export type Party_Flags_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Party_Flags_Max_Order_By>;
  min?: Maybe<Party_Flags_Min_Order_By>;
};

/** input type for inserting array relation for remote table "party_flags" */
export type Party_Flags_Arr_Rel_Insert_Input = {
  data: Array<Party_Flags_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Party_Flags_On_Conflict>;
};

/** Boolean expression to filter rows from the table "party_flags". All fields are combined with a logical 'AND'. */
export type Party_Flags_Bool_Exp = {
  _and?: Maybe<Array<Party_Flags_Bool_Exp>>;
  _not?: Maybe<Party_Flags_Bool_Exp>;
  _or?: Maybe<Array<Party_Flags_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  flag?: Maybe<Flags_Bool_Exp>;
  flag_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  party?: Maybe<Parties_Bool_Exp>;
  party_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "party_flags" */
export enum Party_Flags_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartyFlagsPkey = 'party_flags_pkey'
}

/** input type for inserting data into table "party_flags" */
export type Party_Flags_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  flag?: Maybe<Flags_Obj_Rel_Insert_Input>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  party?: Maybe<Parties_Obj_Rel_Insert_Input>;
  party_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Party_Flags_Max_Fields = {
  __typename?: 'party_flags_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "party_flags" */
export type Party_Flags_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  flag_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  party_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Party_Flags_Min_Fields = {
  __typename?: 'party_flags_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "party_flags" */
export type Party_Flags_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  flag_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  party_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "party_flags" */
export type Party_Flags_Mutation_Response = {
  __typename?: 'party_flags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Party_Flags>;
};

/** on_conflict condition type for table "party_flags" */
export type Party_Flags_On_Conflict = {
  constraint: Party_Flags_Constraint;
  update_columns?: Array<Party_Flags_Update_Column>;
  where?: Maybe<Party_Flags_Bool_Exp>;
};

/** Ordering options when selecting data from "party_flags". */
export type Party_Flags_Order_By = {
  created_at?: Maybe<Order_By>;
  flag?: Maybe<Flags_Order_By>;
  flag_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  party?: Maybe<Parties_Order_By>;
  party_id?: Maybe<Order_By>;
};

/** primary key columns input for table: party_flags */
export type Party_Flags_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "party_flags" */
export enum Party_Flags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlagId = 'flag_id',
  /** column name */
  Id = 'id',
  /** column name */
  PartyId = 'party_id'
}

/** input type for updating data in table "party_flags" */
export type Party_Flags_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "party_flags" */
export type Party_Flags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Party_Flags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Party_Flags_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "party_flags" */
export enum Party_Flags_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlagId = 'flag_id',
  /** column name */
  Id = 'id',
  /** column name */
  PartyId = 'party_id'
}

export type Party_Flags_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Party_Flags_Set_Input>;
  where: Party_Flags_Bool_Exp;
};

/** columns and relationships of "party_invites" */
export type Party_Invites = {
  __typename?: 'party_invites';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  invite: Invites;
  invite_id: Scalars['uuid'];
  /** An object relationship */
  party: Parties;
  party_id: Scalars['uuid'];
  /** An object relationship */
  status: Statuses;
  status_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "party_invites" */
export type Party_Invites_Aggregate = {
  __typename?: 'party_invites_aggregate';
  aggregate?: Maybe<Party_Invites_Aggregate_Fields>;
  nodes: Array<Party_Invites>;
};

export type Party_Invites_Aggregate_Bool_Exp = {
  count?: Maybe<Party_Invites_Aggregate_Bool_Exp_Count>;
};

export type Party_Invites_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Party_Invites_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Party_Invites_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "party_invites" */
export type Party_Invites_Aggregate_Fields = {
  __typename?: 'party_invites_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Party_Invites_Max_Fields>;
  min?: Maybe<Party_Invites_Min_Fields>;
};


/** aggregate fields of "party_invites" */
export type Party_Invites_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Party_Invites_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "party_invites" */
export type Party_Invites_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Party_Invites_Max_Order_By>;
  min?: Maybe<Party_Invites_Min_Order_By>;
};

/** input type for inserting array relation for remote table "party_invites" */
export type Party_Invites_Arr_Rel_Insert_Input = {
  data: Array<Party_Invites_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Party_Invites_On_Conflict>;
};

/** Boolean expression to filter rows from the table "party_invites". All fields are combined with a logical 'AND'. */
export type Party_Invites_Bool_Exp = {
  _and?: Maybe<Array<Party_Invites_Bool_Exp>>;
  _not?: Maybe<Party_Invites_Bool_Exp>;
  _or?: Maybe<Array<Party_Invites_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  invite?: Maybe<Invites_Bool_Exp>;
  invite_id?: Maybe<Uuid_Comparison_Exp>;
  party?: Maybe<Parties_Bool_Exp>;
  party_id?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<Statuses_Bool_Exp>;
  status_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "party_invites" */
export enum Party_Invites_Constraint {
  /** unique or primary key constraint on columns "invite_id" */
  PartyInvitesInviteIdUnique = 'party_invites_invite_id_unique',
  /** unique or primary key constraint on columns "id" */
  PartyInvitesPkey = 'party_invites_pkey',
  /** unique or primary key constraint on columns "invite_id", "party_id" */
  UniquePartyInvites = 'unique_party_invites'
}

/** input type for inserting data into table "party_invites" */
export type Party_Invites_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invite?: Maybe<Invites_Obj_Rel_Insert_Input>;
  invite_id?: Maybe<Scalars['uuid']>;
  party?: Maybe<Parties_Obj_Rel_Insert_Input>;
  party_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Statuses_Obj_Rel_Insert_Input>;
  status_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Party_Invites_Max_Fields = {
  __typename?: 'party_invites_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invite_id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "party_invites" */
export type Party_Invites_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invite_id?: Maybe<Order_By>;
  party_id?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Party_Invites_Min_Fields = {
  __typename?: 'party_invites_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invite_id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "party_invites" */
export type Party_Invites_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invite_id?: Maybe<Order_By>;
  party_id?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "party_invites" */
export type Party_Invites_Mutation_Response = {
  __typename?: 'party_invites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Party_Invites>;
};

/** input type for inserting object relation for remote table "party_invites" */
export type Party_Invites_Obj_Rel_Insert_Input = {
  data: Party_Invites_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Party_Invites_On_Conflict>;
};

/** on_conflict condition type for table "party_invites" */
export type Party_Invites_On_Conflict = {
  constraint: Party_Invites_Constraint;
  update_columns?: Array<Party_Invites_Update_Column>;
  where?: Maybe<Party_Invites_Bool_Exp>;
};

/** Ordering options when selecting data from "party_invites". */
export type Party_Invites_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invite?: Maybe<Invites_Order_By>;
  invite_id?: Maybe<Order_By>;
  party?: Maybe<Parties_Order_By>;
  party_id?: Maybe<Order_By>;
  status?: Maybe<Statuses_Order_By>;
  status_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: party_invites */
export type Party_Invites_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "party_invites" */
export enum Party_Invites_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InviteId = 'invite_id',
  /** column name */
  PartyId = 'party_id',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "party_invites" */
export type Party_Invites_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invite_id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "party_invites" */
export type Party_Invites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Party_Invites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Party_Invites_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invite_id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "party_invites" */
export enum Party_Invites_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InviteId = 'invite_id',
  /** column name */
  PartyId = 'party_id',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Party_Invites_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Party_Invites_Set_Input>;
  where: Party_Invites_Bool_Exp;
};

/** columns and relationships of "party_relationships" */
export type Party_Relationships = {
  __typename?: 'party_relationships';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  owner: Scalars['uuid'];
  participant: Scalars['uuid'];
  /** An object relationship */
  partyByOwner: Parties;
  /** An object relationship */
  partyByParticipant: Parties;
  /** An object relationship */
  status: Statuses;
  status_id: Scalars['uuid'];
  /** An object relationship */
  type: Types;
  type_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "party_relationships" */
export type Party_Relationships_Aggregate = {
  __typename?: 'party_relationships_aggregate';
  aggregate?: Maybe<Party_Relationships_Aggregate_Fields>;
  nodes: Array<Party_Relationships>;
};

export type Party_Relationships_Aggregate_Bool_Exp = {
  count?: Maybe<Party_Relationships_Aggregate_Bool_Exp_Count>;
};

export type Party_Relationships_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Party_Relationships_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Party_Relationships_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "party_relationships" */
export type Party_Relationships_Aggregate_Fields = {
  __typename?: 'party_relationships_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Party_Relationships_Max_Fields>;
  min?: Maybe<Party_Relationships_Min_Fields>;
};


/** aggregate fields of "party_relationships" */
export type Party_Relationships_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Party_Relationships_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "party_relationships" */
export type Party_Relationships_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Party_Relationships_Max_Order_By>;
  min?: Maybe<Party_Relationships_Min_Order_By>;
};

/** input type for inserting array relation for remote table "party_relationships" */
export type Party_Relationships_Arr_Rel_Insert_Input = {
  data: Array<Party_Relationships_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Party_Relationships_On_Conflict>;
};

/** Boolean expression to filter rows from the table "party_relationships". All fields are combined with a logical 'AND'. */
export type Party_Relationships_Bool_Exp = {
  _and?: Maybe<Array<Party_Relationships_Bool_Exp>>;
  _not?: Maybe<Party_Relationships_Bool_Exp>;
  _or?: Maybe<Array<Party_Relationships_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  owner?: Maybe<Uuid_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  partyByOwner?: Maybe<Parties_Bool_Exp>;
  partyByParticipant?: Maybe<Parties_Bool_Exp>;
  status?: Maybe<Statuses_Bool_Exp>;
  status_id?: Maybe<Uuid_Comparison_Exp>;
  type?: Maybe<Types_Bool_Exp>;
  type_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "party_relationships" */
export enum Party_Relationships_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartyRelationshipsPkey = 'party_relationships_pkey',
  /** unique or primary key constraint on columns "participant", "owner", "type_id" */
  UniquePartyRelationships = 'unique_party_relationships'
}

/** input type for inserting data into table "party_relationships" */
export type Party_Relationships_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  partyByOwner?: Maybe<Parties_Obj_Rel_Insert_Input>;
  partyByParticipant?: Maybe<Parties_Obj_Rel_Insert_Input>;
  status?: Maybe<Statuses_Obj_Rel_Insert_Input>;
  status_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Types_Obj_Rel_Insert_Input>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Party_Relationships_Max_Fields = {
  __typename?: 'party_relationships_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "party_relationships" */
export type Party_Relationships_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  owner?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Party_Relationships_Min_Fields = {
  __typename?: 'party_relationships_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "party_relationships" */
export type Party_Relationships_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  owner?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "party_relationships" */
export type Party_Relationships_Mutation_Response = {
  __typename?: 'party_relationships_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Party_Relationships>;
};

/** on_conflict condition type for table "party_relationships" */
export type Party_Relationships_On_Conflict = {
  constraint: Party_Relationships_Constraint;
  update_columns?: Array<Party_Relationships_Update_Column>;
  where?: Maybe<Party_Relationships_Bool_Exp>;
};

/** Ordering options when selecting data from "party_relationships". */
export type Party_Relationships_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  owner?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  partyByOwner?: Maybe<Parties_Order_By>;
  partyByParticipant?: Maybe<Parties_Order_By>;
  status?: Maybe<Statuses_Order_By>;
  status_id?: Maybe<Order_By>;
  type?: Maybe<Types_Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: party_relationships */
export type Party_Relationships_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "party_relationships" */
export enum Party_Relationships_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  Participant = 'participant',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "party_relationships" */
export type Party_Relationships_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "party_relationships" */
export type Party_Relationships_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Party_Relationships_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Party_Relationships_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "party_relationships" */
export enum Party_Relationships_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  Participant = 'participant',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Party_Relationships_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Party_Relationships_Set_Input>;
  where: Party_Relationships_Bool_Exp;
};

/** columns and relationships of "party_statuses" */
export type Party_Statuses = {
  __typename?: 'party_statuses';
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  party: Parties;
  party_id: Scalars['uuid'];
  /** An object relationship */
  status: Statuses;
  status_id: Scalars['uuid'];
};

/** aggregated selection of "party_statuses" */
export type Party_Statuses_Aggregate = {
  __typename?: 'party_statuses_aggregate';
  aggregate?: Maybe<Party_Statuses_Aggregate_Fields>;
  nodes: Array<Party_Statuses>;
};

export type Party_Statuses_Aggregate_Bool_Exp = {
  count?: Maybe<Party_Statuses_Aggregate_Bool_Exp_Count>;
};

export type Party_Statuses_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Party_Statuses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Party_Statuses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "party_statuses" */
export type Party_Statuses_Aggregate_Fields = {
  __typename?: 'party_statuses_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Party_Statuses_Max_Fields>;
  min?: Maybe<Party_Statuses_Min_Fields>;
};


/** aggregate fields of "party_statuses" */
export type Party_Statuses_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Party_Statuses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "party_statuses" */
export type Party_Statuses_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Party_Statuses_Max_Order_By>;
  min?: Maybe<Party_Statuses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "party_statuses" */
export type Party_Statuses_Arr_Rel_Insert_Input = {
  data: Array<Party_Statuses_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Party_Statuses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "party_statuses". All fields are combined with a logical 'AND'. */
export type Party_Statuses_Bool_Exp = {
  _and?: Maybe<Array<Party_Statuses_Bool_Exp>>;
  _not?: Maybe<Party_Statuses_Bool_Exp>;
  _or?: Maybe<Array<Party_Statuses_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  party?: Maybe<Parties_Bool_Exp>;
  party_id?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<Statuses_Bool_Exp>;
  status_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "party_statuses" */
export enum Party_Statuses_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartyStatusesPkey = 'party_statuses_pkey'
}

/** input type for inserting data into table "party_statuses" */
export type Party_Statuses_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party?: Maybe<Parties_Obj_Rel_Insert_Input>;
  party_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Statuses_Obj_Rel_Insert_Input>;
  status_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Party_Statuses_Max_Fields = {
  __typename?: 'party_statuses_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "party_statuses" */
export type Party_Statuses_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  party_id?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Party_Statuses_Min_Fields = {
  __typename?: 'party_statuses_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "party_statuses" */
export type Party_Statuses_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  party_id?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "party_statuses" */
export type Party_Statuses_Mutation_Response = {
  __typename?: 'party_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Party_Statuses>;
};

/** on_conflict condition type for table "party_statuses" */
export type Party_Statuses_On_Conflict = {
  constraint: Party_Statuses_Constraint;
  update_columns?: Array<Party_Statuses_Update_Column>;
  where?: Maybe<Party_Statuses_Bool_Exp>;
};

/** Ordering options when selecting data from "party_statuses". */
export type Party_Statuses_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  party?: Maybe<Parties_Order_By>;
  party_id?: Maybe<Order_By>;
  status?: Maybe<Statuses_Order_By>;
  status_id?: Maybe<Order_By>;
};

/** primary key columns input for table: party_statuses */
export type Party_Statuses_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "party_statuses" */
export enum Party_Statuses_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PartyId = 'party_id',
  /** column name */
  StatusId = 'status_id'
}

/** input type for updating data in table "party_statuses" */
export type Party_Statuses_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "party_statuses" */
export type Party_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Party_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Party_Statuses_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "party_statuses" */
export enum Party_Statuses_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PartyId = 'party_id',
  /** column name */
  StatusId = 'status_id'
}

export type Party_Statuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Party_Statuses_Set_Input>;
  where: Party_Statuses_Bool_Exp;
};

/** Boolean expression to compare columns of type "platform". All fields are combined with logical 'AND'. */
export type Platform_Comparison_Exp = {
  _eq?: Maybe<Scalars['platform']>;
  _gt?: Maybe<Scalars['platform']>;
  _gte?: Maybe<Scalars['platform']>;
  _in?: Maybe<Array<Scalars['platform']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['platform']>;
  _lte?: Maybe<Scalars['platform']>;
  _neq?: Maybe<Scalars['platform']>;
  _nin?: Maybe<Array<Scalars['platform']>>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "audit_logs" */
  audit_logs: Array<Audit_Logs>;
  /** fetch aggregated fields from the table: "audit_logs" */
  audit_logs_aggregate: Audit_Logs_Aggregate;
  /** fetch data from the table: "audit_logs" using primary key columns */
  audit_logs_by_pk?: Maybe<Audit_Logs>;
  checkIfTeamExists?: Maybe<CheckIfTeamExistsOutput>;
  /** fetch data from the table: "flags" */
  flags: Array<Flags>;
  /** fetch aggregated fields from the table: "flags" */
  flags_aggregate: Flags_Aggregate;
  /** fetch data from the table: "flags" using primary key columns */
  flags_by_pk?: Maybe<Flags>;
  /** An array relationship */
  games: Array<Games>;
  /** An aggregate relationship */
  games_aggregate: Games_Aggregate;
  /** fetch data from the table: "games" using primary key columns */
  games_by_pk?: Maybe<Games>;
  getGameStats?: Maybe<GameStatsOutput>;
  getPlayerTournamentsStats?: Maybe<GetTournamentStatsOutput>;
  getTournamentStats?: Maybe<GetTournamentStatsOutput>;
  /** fetch data from the table: "hub_registrations" */
  hub_registrations: Array<Hub_Registrations>;
  /** fetch aggregated fields from the table: "hub_registrations" */
  hub_registrations_aggregate: Hub_Registrations_Aggregate;
  /** fetch data from the table: "hub_registrations" using primary key columns */
  hub_registrations_by_pk?: Maybe<Hub_Registrations>;
  /** An array relationship */
  invites: Array<Invites>;
  /** An aggregate relationship */
  invites_aggregate: Invites_Aggregate;
  /** fetch data from the table: "invites" using primary key columns */
  invites_by_pk?: Maybe<Invites>;
  /** An array relationship */
  live_event_messages: Array<Live_Event_Messages>;
  /** An aggregate relationship */
  live_event_messages_aggregate: Live_Event_Messages_Aggregate;
  /** fetch data from the table: "live_event_messages" using primary key columns */
  live_event_messages_by_pk?: Maybe<Live_Event_Messages>;
  /** An array relationship */
  live_events: Array<Live_Events>;
  /** An aggregate relationship */
  live_events_aggregate: Live_Events_Aggregate;
  /** fetch data from the table: "live_events" using primary key columns */
  live_events_by_pk?: Maybe<Live_Events>;
  /** An array relationship */
  match_flags: Array<Match_Flags>;
  /** An aggregate relationship */
  match_flags_aggregate: Match_Flags_Aggregate;
  /** fetch data from the table: "match_flags" using primary key columns */
  match_flags_by_pk?: Maybe<Match_Flags>;
  /** An array relationship */
  match_rewards: Array<Match_Rewards>;
  /** An aggregate relationship */
  match_rewards_aggregate: Match_Rewards_Aggregate;
  /** fetch data from the table: "match_rewards" using primary key columns */
  match_rewards_by_pk?: Maybe<Match_Rewards>;
  /** An array relationship */
  matches: Array<Matches>;
  /** An aggregate relationship */
  matches_aggregate: Matches_Aggregate;
  /** fetch data from the table: "matches" using primary key columns */
  matches_by_pk?: Maybe<Matches>;
  me?: Maybe<MeOutput>;
  myStats?: Maybe<MyStatsOutput>;
  /** An array relationship */
  parties: Array<Parties>;
  /** An aggregate relationship */
  parties_aggregate: Parties_Aggregate;
  /** fetch data from the table: "parties" using primary key columns */
  parties_by_pk?: Maybe<Parties>;
  /** An array relationship */
  party_details: Array<Party_Details>;
  /** An aggregate relationship */
  party_details_aggregate: Party_Details_Aggregate;
  /** fetch data from the table: "party_details" using primary key columns */
  party_details_by_pk?: Maybe<Party_Details>;
  /** An array relationship */
  party_flags: Array<Party_Flags>;
  /** An aggregate relationship */
  party_flags_aggregate: Party_Flags_Aggregate;
  /** fetch data from the table: "party_flags" using primary key columns */
  party_flags_by_pk?: Maybe<Party_Flags>;
  /** An array relationship */
  party_invites: Array<Party_Invites>;
  /** An aggregate relationship */
  party_invites_aggregate: Party_Invites_Aggregate;
  /** fetch data from the table: "party_invites" using primary key columns */
  party_invites_by_pk?: Maybe<Party_Invites>;
  /** An array relationship */
  party_relationships: Array<Party_Relationships>;
  /** An aggregate relationship */
  party_relationships_aggregate: Party_Relationships_Aggregate;
  /** fetch data from the table: "party_relationships" using primary key columns */
  party_relationships_by_pk?: Maybe<Party_Relationships>;
  /** An array relationship */
  party_statuses: Array<Party_Statuses>;
  /** An aggregate relationship */
  party_statuses_aggregate: Party_Statuses_Aggregate;
  /** fetch data from the table: "party_statuses" using primary key columns */
  party_statuses_by_pk?: Maybe<Party_Statuses>;
  /** An array relationship */
  reward_redemptions: Array<Reward_Redemptions>;
  /** An aggregate relationship */
  reward_redemptions_aggregate: Reward_Redemptions_Aggregate;
  /** fetch data from the table: "reward_redemptions" using primary key columns */
  reward_redemptions_by_pk?: Maybe<Reward_Redemptions>;
  /** An array relationship */
  rewards: Array<Rewards>;
  /** An aggregate relationship */
  rewards_aggregate: Rewards_Aggregate;
  /** fetch data from the table: "rewards" using primary key columns */
  rewards_by_pk?: Maybe<Rewards>;
  /** execute function "search_gamers" which returns "parties" */
  search_gamers: Array<Parties>;
  /** execute function "search_gamers" and query aggregates on result of table type "parties" */
  search_gamers_aggregate: Parties_Aggregate;
  /** An array relationship */
  series: Array<Series>;
  /** An aggregate relationship */
  series_aggregate: Series_Aggregate;
  /** fetch data from the table: "series" using primary key columns */
  series_by_pk?: Maybe<Series>;
  /** An array relationship */
  series_sponsors: Array<Series_Sponsors>;
  /** An aggregate relationship */
  series_sponsors_aggregate: Series_Sponsors_Aggregate;
  /** fetch data from the table: "series_sponsors" using primary key columns */
  series_sponsors_by_pk?: Maybe<Series_Sponsors>;
  /** An array relationship */
  series_tournaments: Array<Series_Tournaments>;
  /** An aggregate relationship */
  series_tournaments_aggregate: Series_Tournaments_Aggregate;
  /** fetch data from the table: "series_tournaments" using primary key columns */
  series_tournaments_by_pk?: Maybe<Series_Tournaments>;
  /** execute function "stage_participants" which returns "parties" */
  stage_participants: Array<Parties>;
  /** execute function "stage_participants" and query aggregates on result of table type "parties" */
  stage_participants_aggregate: Parties_Aggregate;
  /** fetch data from the table: "statuses" */
  statuses: Array<Statuses>;
  /** fetch aggregated fields from the table: "statuses" */
  statuses_aggregate: Statuses_Aggregate;
  /** fetch data from the table: "statuses" using primary key columns */
  statuses_by_pk?: Maybe<Statuses>;
  /** An array relationship */
  tournament_details: Array<Tournament_Details>;
  /** An aggregate relationship */
  tournament_details_aggregate: Tournament_Details_Aggregate;
  /** fetch data from the table: "tournament_details" using primary key columns */
  tournament_details_by_pk?: Maybe<Tournament_Details>;
  /** An array relationship */
  tournament_flags: Array<Tournament_Flags>;
  /** An aggregate relationship */
  tournament_flags_aggregate: Tournament_Flags_Aggregate;
  /** fetch data from the table: "tournament_flags" using primary key columns */
  tournament_flags_by_pk?: Maybe<Tournament_Flags>;
  /** An array relationship */
  tournament_invites: Array<Tournament_Invites>;
  /** An aggregate relationship */
  tournament_invites_aggregate: Tournament_Invites_Aggregate;
  /** fetch data from the table: "tournament_invites" using primary key columns */
  tournament_invites_by_pk?: Maybe<Tournament_Invites>;
  /** An array relationship */
  tournament_registrations: Array<Tournament_Registrations>;
  /** An aggregate relationship */
  tournament_registrations_aggregate: Tournament_Registrations_Aggregate;
  /** fetch data from the table: "tournament_registrations" using primary key columns */
  tournament_registrations_by_pk?: Maybe<Tournament_Registrations>;
  /** An array relationship */
  tournament_results: Array<Tournament_Results>;
  /** An aggregate relationship */
  tournament_results_aggregate: Tournament_Results_Aggregate;
  /** fetch data from the table: "tournament_results" using primary key columns */
  tournament_results_by_pk?: Maybe<Tournament_Results>;
  /** An array relationship */
  tournament_rewards: Array<Tournament_Rewards>;
  /** An aggregate relationship */
  tournament_rewards_aggregate: Tournament_Rewards_Aggregate;
  /** fetch data from the table: "tournament_rewards" using primary key columns */
  tournament_rewards_by_pk?: Maybe<Tournament_Rewards>;
  /** An array relationship */
  tournament_sponsors: Array<Tournament_Sponsors>;
  /** An aggregate relationship */
  tournament_sponsors_aggregate: Tournament_Sponsors_Aggregate;
  /** fetch data from the table: "tournament_sponsors" using primary key columns */
  tournament_sponsors_by_pk?: Maybe<Tournament_Sponsors>;
  /** An array relationship */
  tournament_stages: Array<Tournament_Stages>;
  /** An aggregate relationship */
  tournament_stages_aggregate: Tournament_Stages_Aggregate;
  /** fetch data from the table: "tournament_stages" using primary key columns */
  tournament_stages_by_pk?: Maybe<Tournament_Stages>;
  /** An array relationship */
  tournament_statuses: Array<Tournament_Statuses>;
  /** An aggregate relationship */
  tournament_statuses_aggregate: Tournament_Statuses_Aggregate;
  /** fetch data from the table: "tournament_statuses" using primary key columns */
  tournament_statuses_by_pk?: Maybe<Tournament_Statuses>;
  /** An array relationship */
  tournaments: Array<Tournaments>;
  /** An aggregate relationship */
  tournaments_aggregate: Tournaments_Aggregate;
  /** fetch data from the table: "tournaments" using primary key columns */
  tournaments_by_pk?: Maybe<Tournaments>;
  /** fetch data from the table: "types" */
  types: Array<Types>;
  /** fetch aggregated fields from the table: "types" */
  types_aggregate: Types_Aggregate;
  /** fetch data from the table: "types" using primary key columns */
  types_by_pk?: Maybe<Types>;
  /** An array relationship */
  user_flags: Array<User_Flags>;
  /** An aggregate relationship */
  user_flags_aggregate: User_Flags_Aggregate;
  /** fetch data from the table: "user_flags" using primary key columns */
  user_flags_by_pk?: Maybe<User_Flags>;
  /** An array relationship */
  user_mfa_factors: Array<User_Mfa_Factors>;
  /** An aggregate relationship */
  user_mfa_factors_aggregate: User_Mfa_Factors_Aggregate;
  /** fetch data from the table: "user_mfa_factors" using primary key columns */
  user_mfa_factors_by_pk?: Maybe<User_Mfa_Factors>;
  /** An array relationship */
  user_statuses: Array<User_Statuses>;
  /** An aggregate relationship */
  user_statuses_aggregate: User_Statuses_Aggregate;
  /** fetch data from the table: "user_statuses" using primary key columns */
  user_statuses_by_pk?: Maybe<User_Statuses>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


export type Query_RootAudit_LogsArgs = {
  distinct_on?: Maybe<Array<Audit_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Audit_Logs_Order_By>>;
  where?: Maybe<Audit_Logs_Bool_Exp>;
};


export type Query_RootAudit_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Audit_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Audit_Logs_Order_By>>;
  where?: Maybe<Audit_Logs_Bool_Exp>;
};


export type Query_RootAudit_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCheckIfTeamExistsArgs = {
  params: CheckIfTeamExistsInput;
};


export type Query_RootFlagsArgs = {
  distinct_on?: Maybe<Array<Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flags_Order_By>>;
  where?: Maybe<Flags_Bool_Exp>;
};


export type Query_RootFlags_AggregateArgs = {
  distinct_on?: Maybe<Array<Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flags_Order_By>>;
  where?: Maybe<Flags_Bool_Exp>;
};


export type Query_RootFlags_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGamesArgs = {
  distinct_on?: Maybe<Array<Games_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Games_Order_By>>;
  where?: Maybe<Games_Bool_Exp>;
};


export type Query_RootGames_AggregateArgs = {
  distinct_on?: Maybe<Array<Games_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Games_Order_By>>;
  where?: Maybe<Games_Bool_Exp>;
};


export type Query_RootGames_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGetGameStatsArgs = {
  params: GameStatsInput;
};


export type Query_RootGetPlayerTournamentsStatsArgs = {
  params: GetPlayerTournamentsStatsInput;
};


export type Query_RootGetTournamentStatsArgs = {
  params: GetTournamentStatsInput;
};


export type Query_RootHub_RegistrationsArgs = {
  distinct_on?: Maybe<Array<Hub_Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Hub_Registrations_Order_By>>;
  where?: Maybe<Hub_Registrations_Bool_Exp>;
};


export type Query_RootHub_Registrations_AggregateArgs = {
  distinct_on?: Maybe<Array<Hub_Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Hub_Registrations_Order_By>>;
  where?: Maybe<Hub_Registrations_Bool_Exp>;
};


export type Query_RootHub_Registrations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootInvitesArgs = {
  distinct_on?: Maybe<Array<Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invites_Order_By>>;
  where?: Maybe<Invites_Bool_Exp>;
};


export type Query_RootInvites_AggregateArgs = {
  distinct_on?: Maybe<Array<Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invites_Order_By>>;
  where?: Maybe<Invites_Bool_Exp>;
};


export type Query_RootInvites_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLive_Event_MessagesArgs = {
  distinct_on?: Maybe<Array<Live_Event_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Event_Messages_Order_By>>;
  where?: Maybe<Live_Event_Messages_Bool_Exp>;
};


export type Query_RootLive_Event_Messages_AggregateArgs = {
  distinct_on?: Maybe<Array<Live_Event_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Event_Messages_Order_By>>;
  where?: Maybe<Live_Event_Messages_Bool_Exp>;
};


export type Query_RootLive_Event_Messages_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLive_EventsArgs = {
  distinct_on?: Maybe<Array<Live_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Events_Order_By>>;
  where?: Maybe<Live_Events_Bool_Exp>;
};


export type Query_RootLive_Events_AggregateArgs = {
  distinct_on?: Maybe<Array<Live_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Events_Order_By>>;
  where?: Maybe<Live_Events_Bool_Exp>;
};


export type Query_RootLive_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMatch_FlagsArgs = {
  distinct_on?: Maybe<Array<Match_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Match_Flags_Order_By>>;
  where?: Maybe<Match_Flags_Bool_Exp>;
};


export type Query_RootMatch_Flags_AggregateArgs = {
  distinct_on?: Maybe<Array<Match_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Match_Flags_Order_By>>;
  where?: Maybe<Match_Flags_Bool_Exp>;
};


export type Query_RootMatch_Flags_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMatch_RewardsArgs = {
  distinct_on?: Maybe<Array<Match_Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Match_Rewards_Order_By>>;
  where?: Maybe<Match_Rewards_Bool_Exp>;
};


export type Query_RootMatch_Rewards_AggregateArgs = {
  distinct_on?: Maybe<Array<Match_Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Match_Rewards_Order_By>>;
  where?: Maybe<Match_Rewards_Bool_Exp>;
};


export type Query_RootMatch_Rewards_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMatchesArgs = {
  distinct_on?: Maybe<Array<Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Matches_Order_By>>;
  where?: Maybe<Matches_Bool_Exp>;
};


export type Query_RootMatches_AggregateArgs = {
  distinct_on?: Maybe<Array<Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Matches_Order_By>>;
  where?: Maybe<Matches_Bool_Exp>;
};


export type Query_RootMatches_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPartiesArgs = {
  distinct_on?: Maybe<Array<Parties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Parties_Order_By>>;
  where?: Maybe<Parties_Bool_Exp>;
};


export type Query_RootParties_AggregateArgs = {
  distinct_on?: Maybe<Array<Parties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Parties_Order_By>>;
  where?: Maybe<Parties_Bool_Exp>;
};


export type Query_RootParties_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootParty_DetailsArgs = {
  distinct_on?: Maybe<Array<Party_Details_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Details_Order_By>>;
  where?: Maybe<Party_Details_Bool_Exp>;
};


export type Query_RootParty_Details_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Details_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Details_Order_By>>;
  where?: Maybe<Party_Details_Bool_Exp>;
};


export type Query_RootParty_Details_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootParty_FlagsArgs = {
  distinct_on?: Maybe<Array<Party_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Flags_Order_By>>;
  where?: Maybe<Party_Flags_Bool_Exp>;
};


export type Query_RootParty_Flags_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Flags_Order_By>>;
  where?: Maybe<Party_Flags_Bool_Exp>;
};


export type Query_RootParty_Flags_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootParty_InvitesArgs = {
  distinct_on?: Maybe<Array<Party_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Invites_Order_By>>;
  where?: Maybe<Party_Invites_Bool_Exp>;
};


export type Query_RootParty_Invites_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Invites_Order_By>>;
  where?: Maybe<Party_Invites_Bool_Exp>;
};


export type Query_RootParty_Invites_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootParty_RelationshipsArgs = {
  distinct_on?: Maybe<Array<Party_Relationships_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Relationships_Order_By>>;
  where?: Maybe<Party_Relationships_Bool_Exp>;
};


export type Query_RootParty_Relationships_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Relationships_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Relationships_Order_By>>;
  where?: Maybe<Party_Relationships_Bool_Exp>;
};


export type Query_RootParty_Relationships_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootParty_StatusesArgs = {
  distinct_on?: Maybe<Array<Party_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Statuses_Order_By>>;
  where?: Maybe<Party_Statuses_Bool_Exp>;
};


export type Query_RootParty_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Statuses_Order_By>>;
  where?: Maybe<Party_Statuses_Bool_Exp>;
};


export type Query_RootParty_Statuses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootReward_RedemptionsArgs = {
  distinct_on?: Maybe<Array<Reward_Redemptions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Reward_Redemptions_Order_By>>;
  where?: Maybe<Reward_Redemptions_Bool_Exp>;
};


export type Query_RootReward_Redemptions_AggregateArgs = {
  distinct_on?: Maybe<Array<Reward_Redemptions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Reward_Redemptions_Order_By>>;
  where?: Maybe<Reward_Redemptions_Bool_Exp>;
};


export type Query_RootReward_Redemptions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRewardsArgs = {
  distinct_on?: Maybe<Array<Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Rewards_Order_By>>;
  where?: Maybe<Rewards_Bool_Exp>;
};


export type Query_RootRewards_AggregateArgs = {
  distinct_on?: Maybe<Array<Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Rewards_Order_By>>;
  where?: Maybe<Rewards_Bool_Exp>;
};


export type Query_RootRewards_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSearch_GamersArgs = {
  args: Search_Gamers_Args;
  distinct_on?: Maybe<Array<Parties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Parties_Order_By>>;
  where?: Maybe<Parties_Bool_Exp>;
};


export type Query_RootSearch_Gamers_AggregateArgs = {
  args: Search_Gamers_Args;
  distinct_on?: Maybe<Array<Parties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Parties_Order_By>>;
  where?: Maybe<Parties_Bool_Exp>;
};


export type Query_RootSeriesArgs = {
  distinct_on?: Maybe<Array<Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Order_By>>;
  where?: Maybe<Series_Bool_Exp>;
};


export type Query_RootSeries_AggregateArgs = {
  distinct_on?: Maybe<Array<Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Order_By>>;
  where?: Maybe<Series_Bool_Exp>;
};


export type Query_RootSeries_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSeries_SponsorsArgs = {
  distinct_on?: Maybe<Array<Series_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Sponsors_Order_By>>;
  where?: Maybe<Series_Sponsors_Bool_Exp>;
};


export type Query_RootSeries_Sponsors_AggregateArgs = {
  distinct_on?: Maybe<Array<Series_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Sponsors_Order_By>>;
  where?: Maybe<Series_Sponsors_Bool_Exp>;
};


export type Query_RootSeries_Sponsors_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSeries_TournamentsArgs = {
  distinct_on?: Maybe<Array<Series_Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Tournaments_Order_By>>;
  where?: Maybe<Series_Tournaments_Bool_Exp>;
};


export type Query_RootSeries_Tournaments_AggregateArgs = {
  distinct_on?: Maybe<Array<Series_Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Tournaments_Order_By>>;
  where?: Maybe<Series_Tournaments_Bool_Exp>;
};


export type Query_RootSeries_Tournaments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootStage_ParticipantsArgs = {
  args: Stage_Participants_Args;
  distinct_on?: Maybe<Array<Parties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Parties_Order_By>>;
  where?: Maybe<Parties_Bool_Exp>;
};


export type Query_RootStage_Participants_AggregateArgs = {
  args: Stage_Participants_Args;
  distinct_on?: Maybe<Array<Parties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Parties_Order_By>>;
  where?: Maybe<Parties_Bool_Exp>;
};


export type Query_RootStatusesArgs = {
  distinct_on?: Maybe<Array<Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Statuses_Order_By>>;
  where?: Maybe<Statuses_Bool_Exp>;
};


export type Query_RootStatuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Statuses_Order_By>>;
  where?: Maybe<Statuses_Bool_Exp>;
};


export type Query_RootStatuses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTournament_DetailsArgs = {
  distinct_on?: Maybe<Array<Tournament_Details_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Details_Order_By>>;
  where?: Maybe<Tournament_Details_Bool_Exp>;
};


export type Query_RootTournament_Details_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Details_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Details_Order_By>>;
  where?: Maybe<Tournament_Details_Bool_Exp>;
};


export type Query_RootTournament_Details_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTournament_FlagsArgs = {
  distinct_on?: Maybe<Array<Tournament_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Flags_Order_By>>;
  where?: Maybe<Tournament_Flags_Bool_Exp>;
};


export type Query_RootTournament_Flags_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Flags_Order_By>>;
  where?: Maybe<Tournament_Flags_Bool_Exp>;
};


export type Query_RootTournament_Flags_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTournament_InvitesArgs = {
  distinct_on?: Maybe<Array<Tournament_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Invites_Order_By>>;
  where?: Maybe<Tournament_Invites_Bool_Exp>;
};


export type Query_RootTournament_Invites_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Invites_Order_By>>;
  where?: Maybe<Tournament_Invites_Bool_Exp>;
};


export type Query_RootTournament_Invites_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTournament_RegistrationsArgs = {
  distinct_on?: Maybe<Array<Tournament_Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Registrations_Order_By>>;
  where?: Maybe<Tournament_Registrations_Bool_Exp>;
};


export type Query_RootTournament_Registrations_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Registrations_Order_By>>;
  where?: Maybe<Tournament_Registrations_Bool_Exp>;
};


export type Query_RootTournament_Registrations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTournament_ResultsArgs = {
  distinct_on?: Maybe<Array<Tournament_Results_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Results_Order_By>>;
  where?: Maybe<Tournament_Results_Bool_Exp>;
};


export type Query_RootTournament_Results_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Results_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Results_Order_By>>;
  where?: Maybe<Tournament_Results_Bool_Exp>;
};


export type Query_RootTournament_Results_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTournament_RewardsArgs = {
  distinct_on?: Maybe<Array<Tournament_Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Rewards_Order_By>>;
  where?: Maybe<Tournament_Rewards_Bool_Exp>;
};


export type Query_RootTournament_Rewards_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Rewards_Order_By>>;
  where?: Maybe<Tournament_Rewards_Bool_Exp>;
};


export type Query_RootTournament_Rewards_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTournament_SponsorsArgs = {
  distinct_on?: Maybe<Array<Tournament_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Sponsors_Order_By>>;
  where?: Maybe<Tournament_Sponsors_Bool_Exp>;
};


export type Query_RootTournament_Sponsors_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Sponsors_Order_By>>;
  where?: Maybe<Tournament_Sponsors_Bool_Exp>;
};


export type Query_RootTournament_Sponsors_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTournament_StagesArgs = {
  distinct_on?: Maybe<Array<Tournament_Stages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Stages_Order_By>>;
  where?: Maybe<Tournament_Stages_Bool_Exp>;
};


export type Query_RootTournament_Stages_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Stages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Stages_Order_By>>;
  where?: Maybe<Tournament_Stages_Bool_Exp>;
};


export type Query_RootTournament_Stages_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTournament_StatusesArgs = {
  distinct_on?: Maybe<Array<Tournament_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Statuses_Order_By>>;
  where?: Maybe<Tournament_Statuses_Bool_Exp>;
};


export type Query_RootTournament_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Statuses_Order_By>>;
  where?: Maybe<Tournament_Statuses_Bool_Exp>;
};


export type Query_RootTournament_Statuses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTournamentsArgs = {
  distinct_on?: Maybe<Array<Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournaments_Order_By>>;
  where?: Maybe<Tournaments_Bool_Exp>;
};


export type Query_RootTournaments_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournaments_Order_By>>;
  where?: Maybe<Tournaments_Bool_Exp>;
};


export type Query_RootTournaments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTypesArgs = {
  distinct_on?: Maybe<Array<Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Types_Order_By>>;
  where?: Maybe<Types_Bool_Exp>;
};


export type Query_RootTypes_AggregateArgs = {
  distinct_on?: Maybe<Array<Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Types_Order_By>>;
  where?: Maybe<Types_Bool_Exp>;
};


export type Query_RootTypes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_FlagsArgs = {
  distinct_on?: Maybe<Array<User_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Flags_Order_By>>;
  where?: Maybe<User_Flags_Bool_Exp>;
};


export type Query_RootUser_Flags_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Flags_Order_By>>;
  where?: Maybe<User_Flags_Bool_Exp>;
};


export type Query_RootUser_Flags_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_Mfa_FactorsArgs = {
  distinct_on?: Maybe<Array<User_Mfa_Factors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Mfa_Factors_Order_By>>;
  where?: Maybe<User_Mfa_Factors_Bool_Exp>;
};


export type Query_RootUser_Mfa_Factors_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Mfa_Factors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Mfa_Factors_Order_By>>;
  where?: Maybe<User_Mfa_Factors_Bool_Exp>;
};


export type Query_RootUser_Mfa_Factors_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_StatusesArgs = {
  distinct_on?: Maybe<Array<User_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Statuses_Order_By>>;
  where?: Maybe<User_Statuses_Bool_Exp>;
};


export type Query_RootUser_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Statuses_Order_By>>;
  where?: Maybe<User_Statuses_Bool_Exp>;
};


export type Query_RootUser_Statuses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};

/** columns and relationships of "reward_redemptions" */
export type Reward_Redemptions = {
  __typename?: 'reward_redemptions';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  is_voided: Scalars['Boolean'];
  /** An object relationship */
  party: Parties;
  party_id: Scalars['uuid'];
  redemption_count: Scalars['Int'];
  /** An object relationship */
  reward: Rewards;
  reward_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  void_reason?: Maybe<Scalars['String']>;
};

/** aggregated selection of "reward_redemptions" */
export type Reward_Redemptions_Aggregate = {
  __typename?: 'reward_redemptions_aggregate';
  aggregate?: Maybe<Reward_Redemptions_Aggregate_Fields>;
  nodes: Array<Reward_Redemptions>;
};

export type Reward_Redemptions_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Reward_Redemptions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Reward_Redemptions_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Reward_Redemptions_Aggregate_Bool_Exp_Count>;
};

export type Reward_Redemptions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Reward_Redemptions_Select_Column_Reward_Redemptions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Reward_Redemptions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Reward_Redemptions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Reward_Redemptions_Select_Column_Reward_Redemptions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Reward_Redemptions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Reward_Redemptions_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Reward_Redemptions_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Reward_Redemptions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "reward_redemptions" */
export type Reward_Redemptions_Aggregate_Fields = {
  __typename?: 'reward_redemptions_aggregate_fields';
  avg?: Maybe<Reward_Redemptions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Reward_Redemptions_Max_Fields>;
  min?: Maybe<Reward_Redemptions_Min_Fields>;
  stddev?: Maybe<Reward_Redemptions_Stddev_Fields>;
  stddev_pop?: Maybe<Reward_Redemptions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reward_Redemptions_Stddev_Samp_Fields>;
  sum?: Maybe<Reward_Redemptions_Sum_Fields>;
  var_pop?: Maybe<Reward_Redemptions_Var_Pop_Fields>;
  var_samp?: Maybe<Reward_Redemptions_Var_Samp_Fields>;
  variance?: Maybe<Reward_Redemptions_Variance_Fields>;
};


/** aggregate fields of "reward_redemptions" */
export type Reward_Redemptions_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Reward_Redemptions_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "reward_redemptions" */
export type Reward_Redemptions_Aggregate_Order_By = {
  avg?: Maybe<Reward_Redemptions_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Reward_Redemptions_Max_Order_By>;
  min?: Maybe<Reward_Redemptions_Min_Order_By>;
  stddev?: Maybe<Reward_Redemptions_Stddev_Order_By>;
  stddev_pop?: Maybe<Reward_Redemptions_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Reward_Redemptions_Stddev_Samp_Order_By>;
  sum?: Maybe<Reward_Redemptions_Sum_Order_By>;
  var_pop?: Maybe<Reward_Redemptions_Var_Pop_Order_By>;
  var_samp?: Maybe<Reward_Redemptions_Var_Samp_Order_By>;
  variance?: Maybe<Reward_Redemptions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "reward_redemptions" */
export type Reward_Redemptions_Arr_Rel_Insert_Input = {
  data: Array<Reward_Redemptions_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Reward_Redemptions_On_Conflict>;
};

/** aggregate avg on columns */
export type Reward_Redemptions_Avg_Fields = {
  __typename?: 'reward_redemptions_avg_fields';
  redemption_count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "reward_redemptions" */
export type Reward_Redemptions_Avg_Order_By = {
  redemption_count?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "reward_redemptions". All fields are combined with a logical 'AND'. */
export type Reward_Redemptions_Bool_Exp = {
  _and?: Maybe<Array<Reward_Redemptions_Bool_Exp>>;
  _not?: Maybe<Reward_Redemptions_Bool_Exp>;
  _or?: Maybe<Array<Reward_Redemptions_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  is_voided?: Maybe<Boolean_Comparison_Exp>;
  party?: Maybe<Parties_Bool_Exp>;
  party_id?: Maybe<Uuid_Comparison_Exp>;
  redemption_count?: Maybe<Int_Comparison_Exp>;
  reward?: Maybe<Rewards_Bool_Exp>;
  reward_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  void_reason?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "reward_redemptions" */
export enum Reward_Redemptions_Constraint {
  /** unique or primary key constraint on columns "id" */
  RewardRedemptionsPkey = 'reward_redemptions_pkey'
}

/** input type for incrementing numeric columns in table "reward_redemptions" */
export type Reward_Redemptions_Inc_Input = {
  redemption_count?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "reward_redemptions" */
export type Reward_Redemptions_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_voided?: Maybe<Scalars['Boolean']>;
  party?: Maybe<Parties_Obj_Rel_Insert_Input>;
  party_id?: Maybe<Scalars['uuid']>;
  redemption_count?: Maybe<Scalars['Int']>;
  reward?: Maybe<Rewards_Obj_Rel_Insert_Input>;
  reward_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  void_reason?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Reward_Redemptions_Max_Fields = {
  __typename?: 'reward_redemptions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  redemption_count?: Maybe<Scalars['Int']>;
  reward_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  void_reason?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "reward_redemptions" */
export type Reward_Redemptions_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  party_id?: Maybe<Order_By>;
  redemption_count?: Maybe<Order_By>;
  reward_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  void_reason?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Reward_Redemptions_Min_Fields = {
  __typename?: 'reward_redemptions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  redemption_count?: Maybe<Scalars['Int']>;
  reward_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  void_reason?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "reward_redemptions" */
export type Reward_Redemptions_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  party_id?: Maybe<Order_By>;
  redemption_count?: Maybe<Order_By>;
  reward_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  void_reason?: Maybe<Order_By>;
};

/** response of any mutation on the table "reward_redemptions" */
export type Reward_Redemptions_Mutation_Response = {
  __typename?: 'reward_redemptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Reward_Redemptions>;
};

/** on_conflict condition type for table "reward_redemptions" */
export type Reward_Redemptions_On_Conflict = {
  constraint: Reward_Redemptions_Constraint;
  update_columns?: Array<Reward_Redemptions_Update_Column>;
  where?: Maybe<Reward_Redemptions_Bool_Exp>;
};

/** Ordering options when selecting data from "reward_redemptions". */
export type Reward_Redemptions_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_voided?: Maybe<Order_By>;
  party?: Maybe<Parties_Order_By>;
  party_id?: Maybe<Order_By>;
  redemption_count?: Maybe<Order_By>;
  reward?: Maybe<Rewards_Order_By>;
  reward_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  void_reason?: Maybe<Order_By>;
};

/** primary key columns input for table: reward_redemptions */
export type Reward_Redemptions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "reward_redemptions" */
export enum Reward_Redemptions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsVoided = 'is_voided',
  /** column name */
  PartyId = 'party_id',
  /** column name */
  RedemptionCount = 'redemption_count',
  /** column name */
  RewardId = 'reward_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VoidReason = 'void_reason'
}

/** select "reward_redemptions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "reward_redemptions" */
export enum Reward_Redemptions_Select_Column_Reward_Redemptions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsVoided = 'is_voided'
}

/** select "reward_redemptions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "reward_redemptions" */
export enum Reward_Redemptions_Select_Column_Reward_Redemptions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsVoided = 'is_voided'
}

/** input type for updating data in table "reward_redemptions" */
export type Reward_Redemptions_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_voided?: Maybe<Scalars['Boolean']>;
  party_id?: Maybe<Scalars['uuid']>;
  redemption_count?: Maybe<Scalars['Int']>;
  reward_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  void_reason?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Reward_Redemptions_Stddev_Fields = {
  __typename?: 'reward_redemptions_stddev_fields';
  redemption_count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "reward_redemptions" */
export type Reward_Redemptions_Stddev_Order_By = {
  redemption_count?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Reward_Redemptions_Stddev_Pop_Fields = {
  __typename?: 'reward_redemptions_stddev_pop_fields';
  redemption_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "reward_redemptions" */
export type Reward_Redemptions_Stddev_Pop_Order_By = {
  redemption_count?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Reward_Redemptions_Stddev_Samp_Fields = {
  __typename?: 'reward_redemptions_stddev_samp_fields';
  redemption_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "reward_redemptions" */
export type Reward_Redemptions_Stddev_Samp_Order_By = {
  redemption_count?: Maybe<Order_By>;
};

/** Streaming cursor of the table "reward_redemptions" */
export type Reward_Redemptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reward_Redemptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reward_Redemptions_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_voided?: Maybe<Scalars['Boolean']>;
  party_id?: Maybe<Scalars['uuid']>;
  redemption_count?: Maybe<Scalars['Int']>;
  reward_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  void_reason?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Reward_Redemptions_Sum_Fields = {
  __typename?: 'reward_redemptions_sum_fields';
  redemption_count?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "reward_redemptions" */
export type Reward_Redemptions_Sum_Order_By = {
  redemption_count?: Maybe<Order_By>;
};

/** update columns of table "reward_redemptions" */
export enum Reward_Redemptions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsVoided = 'is_voided',
  /** column name */
  PartyId = 'party_id',
  /** column name */
  RedemptionCount = 'redemption_count',
  /** column name */
  RewardId = 'reward_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VoidReason = 'void_reason'
}

export type Reward_Redemptions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Reward_Redemptions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Reward_Redemptions_Set_Input>;
  where: Reward_Redemptions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Reward_Redemptions_Var_Pop_Fields = {
  __typename?: 'reward_redemptions_var_pop_fields';
  redemption_count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "reward_redemptions" */
export type Reward_Redemptions_Var_Pop_Order_By = {
  redemption_count?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Reward_Redemptions_Var_Samp_Fields = {
  __typename?: 'reward_redemptions_var_samp_fields';
  redemption_count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "reward_redemptions" */
export type Reward_Redemptions_Var_Samp_Order_By = {
  redemption_count?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Reward_Redemptions_Variance_Fields = {
  __typename?: 'reward_redemptions_variance_fields';
  redemption_count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "reward_redemptions" */
export type Reward_Redemptions_Variance_Order_By = {
  redemption_count?: Maybe<Order_By>;
};

/** columns and relationships of "rewards" */
export type Rewards = {
  __typename?: 'rewards';
  artwork_url: Scalars['String'];
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An array relationship */
  match_rewards: Array<Match_Rewards>;
  /** An aggregate relationship */
  match_rewards_aggregate: Match_Rewards_Aggregate;
  multiple_redemptions: Scalars['Boolean'];
  name: Scalars['String'];
  redemption_criteria: Scalars['jsonb'];
  /** An array relationship */
  reward_redemptions: Array<Reward_Redemptions>;
  /** An aggregate relationship */
  reward_redemptions_aggregate: Reward_Redemptions_Aggregate;
  /** An array relationship */
  tournament_rewards: Array<Tournament_Rewards>;
  /** An aggregate relationship */
  tournament_rewards_aggregate: Tournament_Rewards_Aggregate;
  /** An object relationship */
  type: Types;
  type_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "rewards" */
export type RewardsMatch_RewardsArgs = {
  distinct_on?: Maybe<Array<Match_Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Match_Rewards_Order_By>>;
  where?: Maybe<Match_Rewards_Bool_Exp>;
};


/** columns and relationships of "rewards" */
export type RewardsMatch_Rewards_AggregateArgs = {
  distinct_on?: Maybe<Array<Match_Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Match_Rewards_Order_By>>;
  where?: Maybe<Match_Rewards_Bool_Exp>;
};


/** columns and relationships of "rewards" */
export type RewardsRedemption_CriteriaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "rewards" */
export type RewardsReward_RedemptionsArgs = {
  distinct_on?: Maybe<Array<Reward_Redemptions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Reward_Redemptions_Order_By>>;
  where?: Maybe<Reward_Redemptions_Bool_Exp>;
};


/** columns and relationships of "rewards" */
export type RewardsReward_Redemptions_AggregateArgs = {
  distinct_on?: Maybe<Array<Reward_Redemptions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Reward_Redemptions_Order_By>>;
  where?: Maybe<Reward_Redemptions_Bool_Exp>;
};


/** columns and relationships of "rewards" */
export type RewardsTournament_RewardsArgs = {
  distinct_on?: Maybe<Array<Tournament_Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Rewards_Order_By>>;
  where?: Maybe<Tournament_Rewards_Bool_Exp>;
};


/** columns and relationships of "rewards" */
export type RewardsTournament_Rewards_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Rewards_Order_By>>;
  where?: Maybe<Tournament_Rewards_Bool_Exp>;
};

/** aggregated selection of "rewards" */
export type Rewards_Aggregate = {
  __typename?: 'rewards_aggregate';
  aggregate?: Maybe<Rewards_Aggregate_Fields>;
  nodes: Array<Rewards>;
};

export type Rewards_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Rewards_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Rewards_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Rewards_Aggregate_Bool_Exp_Count>;
};

export type Rewards_Aggregate_Bool_Exp_Bool_And = {
  arguments: Rewards_Select_Column_Rewards_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Rewards_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Rewards_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Rewards_Select_Column_Rewards_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Rewards_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Rewards_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Rewards_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Rewards_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "rewards" */
export type Rewards_Aggregate_Fields = {
  __typename?: 'rewards_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Rewards_Max_Fields>;
  min?: Maybe<Rewards_Min_Fields>;
};


/** aggregate fields of "rewards" */
export type Rewards_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Rewards_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "rewards" */
export type Rewards_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Rewards_Max_Order_By>;
  min?: Maybe<Rewards_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Rewards_Append_Input = {
  redemption_criteria?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "rewards" */
export type Rewards_Arr_Rel_Insert_Input = {
  data: Array<Rewards_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Rewards_On_Conflict>;
};

/** Boolean expression to filter rows from the table "rewards". All fields are combined with a logical 'AND'. */
export type Rewards_Bool_Exp = {
  _and?: Maybe<Array<Rewards_Bool_Exp>>;
  _not?: Maybe<Rewards_Bool_Exp>;
  _or?: Maybe<Array<Rewards_Bool_Exp>>;
  artwork_url?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  is_active?: Maybe<Boolean_Comparison_Exp>;
  match_rewards?: Maybe<Match_Rewards_Bool_Exp>;
  match_rewards_aggregate?: Maybe<Match_Rewards_Aggregate_Bool_Exp>;
  multiple_redemptions?: Maybe<Boolean_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  redemption_criteria?: Maybe<Jsonb_Comparison_Exp>;
  reward_redemptions?: Maybe<Reward_Redemptions_Bool_Exp>;
  reward_redemptions_aggregate?: Maybe<Reward_Redemptions_Aggregate_Bool_Exp>;
  tournament_rewards?: Maybe<Tournament_Rewards_Bool_Exp>;
  tournament_rewards_aggregate?: Maybe<Tournament_Rewards_Aggregate_Bool_Exp>;
  type?: Maybe<Types_Bool_Exp>;
  type_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "rewards" */
export enum Rewards_Constraint {
  /** unique or primary key constraint on columns "id" */
  RewardsPkey = 'rewards_pkey',
  /** unique or primary key constraint on columns "is_active", "name", "type_id" */
  UniqueRewards = 'unique_rewards'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Rewards_Delete_At_Path_Input = {
  redemption_criteria?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Rewards_Delete_Elem_Input = {
  redemption_criteria?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Rewards_Delete_Key_Input = {
  redemption_criteria?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "rewards" */
export type Rewards_Insert_Input = {
  artwork_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  is_active?: Maybe<Scalars['Boolean']>;
  match_rewards?: Maybe<Match_Rewards_Arr_Rel_Insert_Input>;
  multiple_redemptions?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  redemption_criteria?: Maybe<Scalars['jsonb']>;
  reward_redemptions?: Maybe<Reward_Redemptions_Arr_Rel_Insert_Input>;
  tournament_rewards?: Maybe<Tournament_Rewards_Arr_Rel_Insert_Input>;
  type?: Maybe<Types_Obj_Rel_Insert_Input>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Rewards_Max_Fields = {
  __typename?: 'rewards_max_fields';
  artwork_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "rewards" */
export type Rewards_Max_Order_By = {
  artwork_url?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Rewards_Min_Fields = {
  __typename?: 'rewards_min_fields';
  artwork_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "rewards" */
export type Rewards_Min_Order_By = {
  artwork_url?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "rewards" */
export type Rewards_Mutation_Response = {
  __typename?: 'rewards_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Rewards>;
};

/** input type for inserting object relation for remote table "rewards" */
export type Rewards_Obj_Rel_Insert_Input = {
  data: Rewards_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Rewards_On_Conflict>;
};

/** on_conflict condition type for table "rewards" */
export type Rewards_On_Conflict = {
  constraint: Rewards_Constraint;
  update_columns?: Array<Rewards_Update_Column>;
  where?: Maybe<Rewards_Bool_Exp>;
};

/** Ordering options when selecting data from "rewards". */
export type Rewards_Order_By = {
  artwork_url?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_active?: Maybe<Order_By>;
  match_rewards_aggregate?: Maybe<Match_Rewards_Aggregate_Order_By>;
  multiple_redemptions?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  redemption_criteria?: Maybe<Order_By>;
  reward_redemptions_aggregate?: Maybe<Reward_Redemptions_Aggregate_Order_By>;
  tournament_rewards_aggregate?: Maybe<Tournament_Rewards_Aggregate_Order_By>;
  type?: Maybe<Types_Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: rewards */
export type Rewards_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Rewards_Prepend_Input = {
  redemption_criteria?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "rewards" */
export enum Rewards_Select_Column {
  /** column name */
  ArtworkUrl = 'artwork_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MultipleRedemptions = 'multiple_redemptions',
  /** column name */
  Name = 'name',
  /** column name */
  RedemptionCriteria = 'redemption_criteria',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "rewards_aggregate_bool_exp_bool_and_arguments_columns" columns of table "rewards" */
export enum Rewards_Select_Column_Rewards_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MultipleRedemptions = 'multiple_redemptions'
}

/** select "rewards_aggregate_bool_exp_bool_or_arguments_columns" columns of table "rewards" */
export enum Rewards_Select_Column_Rewards_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MultipleRedemptions = 'multiple_redemptions'
}

/** input type for updating data in table "rewards" */
export type Rewards_Set_Input = {
  artwork_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  is_active?: Maybe<Scalars['Boolean']>;
  multiple_redemptions?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  redemption_criteria?: Maybe<Scalars['jsonb']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "rewards" */
export type Rewards_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rewards_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rewards_Stream_Cursor_Value_Input = {
  artwork_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  is_active?: Maybe<Scalars['Boolean']>;
  multiple_redemptions?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  redemption_criteria?: Maybe<Scalars['jsonb']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "rewards" */
export enum Rewards_Update_Column {
  /** column name */
  ArtworkUrl = 'artwork_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MultipleRedemptions = 'multiple_redemptions',
  /** column name */
  Name = 'name',
  /** column name */
  RedemptionCriteria = 'redemption_criteria',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Rewards_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Rewards_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Rewards_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Rewards_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Rewards_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Rewards_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Rewards_Set_Input>;
  where: Rewards_Bool_Exp;
};

export type Search_Gamers_Args = {
  search?: Maybe<Scalars['String']>;
};

/** columns and relationships of "series" */
export type Series = {
  __typename?: 'series';
  cover_photo_url?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by: Scalars['uuid'];
  description?: Maybe<Scalars['String']>;
  end_date: Scalars['timestamptz'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  party: Parties;
  platform: Scalars['platform'];
  poster_url?: Maybe<Scalars['String']>;
  /** An array relationship */
  series_sponsors: Array<Series_Sponsors>;
  /** An aggregate relationship */
  series_sponsors_aggregate: Series_Sponsors_Aggregate;
  /** An array relationship */
  series_tournaments: Array<Series_Tournaments>;
  /** An aggregate relationship */
  series_tournaments_aggregate: Series_Tournaments_Aggregate;
  slug?: Maybe<Scalars['String']>;
  start_date: Scalars['timestamptz'];
  /** An object relationship */
  status: Statuses;
  status_id: Scalars['uuid'];
  /** An object relationship */
  type: Types;
  type_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "series" */
export type SeriesSeries_SponsorsArgs = {
  distinct_on?: Maybe<Array<Series_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Sponsors_Order_By>>;
  where?: Maybe<Series_Sponsors_Bool_Exp>;
};


/** columns and relationships of "series" */
export type SeriesSeries_Sponsors_AggregateArgs = {
  distinct_on?: Maybe<Array<Series_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Sponsors_Order_By>>;
  where?: Maybe<Series_Sponsors_Bool_Exp>;
};


/** columns and relationships of "series" */
export type SeriesSeries_TournamentsArgs = {
  distinct_on?: Maybe<Array<Series_Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Tournaments_Order_By>>;
  where?: Maybe<Series_Tournaments_Bool_Exp>;
};


/** columns and relationships of "series" */
export type SeriesSeries_Tournaments_AggregateArgs = {
  distinct_on?: Maybe<Array<Series_Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Tournaments_Order_By>>;
  where?: Maybe<Series_Tournaments_Bool_Exp>;
};

/** aggregated selection of "series" */
export type Series_Aggregate = {
  __typename?: 'series_aggregate';
  aggregate?: Maybe<Series_Aggregate_Fields>;
  nodes: Array<Series>;
};

export type Series_Aggregate_Bool_Exp = {
  count?: Maybe<Series_Aggregate_Bool_Exp_Count>;
};

export type Series_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Series_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Series_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "series" */
export type Series_Aggregate_Fields = {
  __typename?: 'series_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Series_Max_Fields>;
  min?: Maybe<Series_Min_Fields>;
};


/** aggregate fields of "series" */
export type Series_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Series_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "series" */
export type Series_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Series_Max_Order_By>;
  min?: Maybe<Series_Min_Order_By>;
};

/** input type for inserting array relation for remote table "series" */
export type Series_Arr_Rel_Insert_Input = {
  data: Array<Series_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Series_On_Conflict>;
};

/** Boolean expression to filter rows from the table "series". All fields are combined with a logical 'AND'. */
export type Series_Bool_Exp = {
  _and?: Maybe<Array<Series_Bool_Exp>>;
  _not?: Maybe<Series_Bool_Exp>;
  _or?: Maybe<Array<Series_Bool_Exp>>;
  cover_photo_url?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  end_date?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  party?: Maybe<Parties_Bool_Exp>;
  platform?: Maybe<Platform_Comparison_Exp>;
  poster_url?: Maybe<String_Comparison_Exp>;
  series_sponsors?: Maybe<Series_Sponsors_Bool_Exp>;
  series_sponsors_aggregate?: Maybe<Series_Sponsors_Aggregate_Bool_Exp>;
  series_tournaments?: Maybe<Series_Tournaments_Bool_Exp>;
  series_tournaments_aggregate?: Maybe<Series_Tournaments_Aggregate_Bool_Exp>;
  slug?: Maybe<String_Comparison_Exp>;
  start_date?: Maybe<Timestamptz_Comparison_Exp>;
  status?: Maybe<Statuses_Bool_Exp>;
  status_id?: Maybe<Uuid_Comparison_Exp>;
  type?: Maybe<Types_Bool_Exp>;
  type_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "series" */
export enum Series_Constraint {
  /** unique or primary key constraint on columns "name" */
  CompetitionsNameUnique = 'competitions_name_unique',
  /** unique or primary key constraint on columns "id" */
  CompetitionsPkey = 'competitions_pkey'
}

/** input type for inserting data into table "series" */
export type Series_Insert_Input = {
  cover_photo_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  party?: Maybe<Parties_Obj_Rel_Insert_Input>;
  platform?: Maybe<Scalars['platform']>;
  poster_url?: Maybe<Scalars['String']>;
  series_sponsors?: Maybe<Series_Sponsors_Arr_Rel_Insert_Input>;
  series_tournaments?: Maybe<Series_Tournaments_Arr_Rel_Insert_Input>;
  slug?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Statuses_Obj_Rel_Insert_Input>;
  status_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Types_Obj_Rel_Insert_Input>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Series_Max_Fields = {
  __typename?: 'series_max_fields';
  cover_photo_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['platform']>;
  poster_url?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "series" */
export type Series_Max_Order_By = {
  cover_photo_url?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  platform?: Maybe<Order_By>;
  poster_url?: Maybe<Order_By>;
  slug?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Series_Min_Fields = {
  __typename?: 'series_min_fields';
  cover_photo_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['platform']>;
  poster_url?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "series" */
export type Series_Min_Order_By = {
  cover_photo_url?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  platform?: Maybe<Order_By>;
  poster_url?: Maybe<Order_By>;
  slug?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "series" */
export type Series_Mutation_Response = {
  __typename?: 'series_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Series>;
};

/** input type for inserting object relation for remote table "series" */
export type Series_Obj_Rel_Insert_Input = {
  data: Series_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Series_On_Conflict>;
};

/** on_conflict condition type for table "series" */
export type Series_On_Conflict = {
  constraint: Series_Constraint;
  update_columns?: Array<Series_Update_Column>;
  where?: Maybe<Series_Bool_Exp>;
};

/** Ordering options when selecting data from "series". */
export type Series_Order_By = {
  cover_photo_url?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  party?: Maybe<Parties_Order_By>;
  platform?: Maybe<Order_By>;
  poster_url?: Maybe<Order_By>;
  series_sponsors_aggregate?: Maybe<Series_Sponsors_Aggregate_Order_By>;
  series_tournaments_aggregate?: Maybe<Series_Tournaments_Aggregate_Order_By>;
  slug?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  status?: Maybe<Statuses_Order_By>;
  status_id?: Maybe<Order_By>;
  type?: Maybe<Types_Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: series */
export type Series_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "series" */
export enum Series_Select_Column {
  /** column name */
  CoverPhotoUrl = 'cover_photo_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Platform = 'platform',
  /** column name */
  PosterUrl = 'poster_url',
  /** column name */
  Slug = 'slug',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "series" */
export type Series_Set_Input = {
  cover_photo_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['platform']>;
  poster_url?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "series_sponsors" */
export type Series_Sponsors = {
  __typename?: 'series_sponsors';
  /** An object relationship */
  circuit: Series;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  party: Parties;
  party_id: Scalars['uuid'];
  series_id: Scalars['uuid'];
  /** An object relationship */
  status: Statuses;
  status_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "series_sponsors" */
export type Series_Sponsors_Aggregate = {
  __typename?: 'series_sponsors_aggregate';
  aggregate?: Maybe<Series_Sponsors_Aggregate_Fields>;
  nodes: Array<Series_Sponsors>;
};

export type Series_Sponsors_Aggregate_Bool_Exp = {
  count?: Maybe<Series_Sponsors_Aggregate_Bool_Exp_Count>;
};

export type Series_Sponsors_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Series_Sponsors_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Series_Sponsors_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "series_sponsors" */
export type Series_Sponsors_Aggregate_Fields = {
  __typename?: 'series_sponsors_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Series_Sponsors_Max_Fields>;
  min?: Maybe<Series_Sponsors_Min_Fields>;
};


/** aggregate fields of "series_sponsors" */
export type Series_Sponsors_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Series_Sponsors_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "series_sponsors" */
export type Series_Sponsors_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Series_Sponsors_Max_Order_By>;
  min?: Maybe<Series_Sponsors_Min_Order_By>;
};

/** input type for inserting array relation for remote table "series_sponsors" */
export type Series_Sponsors_Arr_Rel_Insert_Input = {
  data: Array<Series_Sponsors_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Series_Sponsors_On_Conflict>;
};

/** Boolean expression to filter rows from the table "series_sponsors". All fields are combined with a logical 'AND'. */
export type Series_Sponsors_Bool_Exp = {
  _and?: Maybe<Array<Series_Sponsors_Bool_Exp>>;
  _not?: Maybe<Series_Sponsors_Bool_Exp>;
  _or?: Maybe<Array<Series_Sponsors_Bool_Exp>>;
  circuit?: Maybe<Series_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  party?: Maybe<Parties_Bool_Exp>;
  party_id?: Maybe<Uuid_Comparison_Exp>;
  series_id?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<Statuses_Bool_Exp>;
  status_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "series_sponsors" */
export enum Series_Sponsors_Constraint {
  /** unique or primary key constraint on columns "id" */
  CircuitSponsorsPkey = 'circuit_sponsors_pkey',
  /** unique or primary key constraint on columns "status_id", "series_id", "party_id" */
  UniqueCircuitSponsors = 'unique_circuit_sponsors'
}

/** input type for inserting data into table "series_sponsors" */
export type Series_Sponsors_Insert_Input = {
  circuit?: Maybe<Series_Obj_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party?: Maybe<Parties_Obj_Rel_Insert_Input>;
  party_id?: Maybe<Scalars['uuid']>;
  series_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Statuses_Obj_Rel_Insert_Input>;
  status_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Series_Sponsors_Max_Fields = {
  __typename?: 'series_sponsors_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  series_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "series_sponsors" */
export type Series_Sponsors_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  party_id?: Maybe<Order_By>;
  series_id?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Series_Sponsors_Min_Fields = {
  __typename?: 'series_sponsors_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  series_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "series_sponsors" */
export type Series_Sponsors_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  party_id?: Maybe<Order_By>;
  series_id?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "series_sponsors" */
export type Series_Sponsors_Mutation_Response = {
  __typename?: 'series_sponsors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Series_Sponsors>;
};

/** on_conflict condition type for table "series_sponsors" */
export type Series_Sponsors_On_Conflict = {
  constraint: Series_Sponsors_Constraint;
  update_columns?: Array<Series_Sponsors_Update_Column>;
  where?: Maybe<Series_Sponsors_Bool_Exp>;
};

/** Ordering options when selecting data from "series_sponsors". */
export type Series_Sponsors_Order_By = {
  circuit?: Maybe<Series_Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  party?: Maybe<Parties_Order_By>;
  party_id?: Maybe<Order_By>;
  series_id?: Maybe<Order_By>;
  status?: Maybe<Statuses_Order_By>;
  status_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: series_sponsors */
export type Series_Sponsors_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "series_sponsors" */
export enum Series_Sponsors_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PartyId = 'party_id',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "series_sponsors" */
export type Series_Sponsors_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  series_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "series_sponsors" */
export type Series_Sponsors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Series_Sponsors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Series_Sponsors_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  series_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "series_sponsors" */
export enum Series_Sponsors_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PartyId = 'party_id',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Series_Sponsors_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Series_Sponsors_Set_Input>;
  where: Series_Sponsors_Bool_Exp;
};

/** Streaming cursor of the table "series" */
export type Series_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Series_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Series_Stream_Cursor_Value_Input = {
  cover_photo_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['platform']>;
  poster_url?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "series_tournaments" */
export type Series_Tournaments = {
  __typename?: 'series_tournaments';
  /** An object relationship */
  circuit: Series;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date: Scalars['timestamptz'];
  id: Scalars['uuid'];
  series_id: Scalars['uuid'];
  start_date: Scalars['timestamptz'];
  /** An object relationship */
  status: Statuses;
  status_id: Scalars['uuid'];
  /** An object relationship */
  tournament: Tournaments;
  tournament_id: Scalars['uuid'];
};

/** aggregated selection of "series_tournaments" */
export type Series_Tournaments_Aggregate = {
  __typename?: 'series_tournaments_aggregate';
  aggregate?: Maybe<Series_Tournaments_Aggregate_Fields>;
  nodes: Array<Series_Tournaments>;
};

export type Series_Tournaments_Aggregate_Bool_Exp = {
  count?: Maybe<Series_Tournaments_Aggregate_Bool_Exp_Count>;
};

export type Series_Tournaments_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Series_Tournaments_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Series_Tournaments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "series_tournaments" */
export type Series_Tournaments_Aggregate_Fields = {
  __typename?: 'series_tournaments_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Series_Tournaments_Max_Fields>;
  min?: Maybe<Series_Tournaments_Min_Fields>;
};


/** aggregate fields of "series_tournaments" */
export type Series_Tournaments_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Series_Tournaments_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "series_tournaments" */
export type Series_Tournaments_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Series_Tournaments_Max_Order_By>;
  min?: Maybe<Series_Tournaments_Min_Order_By>;
};

/** input type for inserting array relation for remote table "series_tournaments" */
export type Series_Tournaments_Arr_Rel_Insert_Input = {
  data: Array<Series_Tournaments_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Series_Tournaments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "series_tournaments". All fields are combined with a logical 'AND'. */
export type Series_Tournaments_Bool_Exp = {
  _and?: Maybe<Array<Series_Tournaments_Bool_Exp>>;
  _not?: Maybe<Series_Tournaments_Bool_Exp>;
  _or?: Maybe<Array<Series_Tournaments_Bool_Exp>>;
  circuit?: Maybe<Series_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  end_date?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  series_id?: Maybe<Uuid_Comparison_Exp>;
  start_date?: Maybe<Timestamptz_Comparison_Exp>;
  status?: Maybe<Statuses_Bool_Exp>;
  status_id?: Maybe<Uuid_Comparison_Exp>;
  tournament?: Maybe<Tournaments_Bool_Exp>;
  tournament_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "series_tournaments" */
export enum Series_Tournaments_Constraint {
  /** unique or primary key constraint on columns "id" */
  CompetitionTournamentsPkey = 'competition_tournaments_pkey',
  /** unique or primary key constraint on columns "tournament_id", "series_id" */
  UniqueCompetitionTournaments = 'unique_competition_tournaments'
}

/** input type for inserting data into table "series_tournaments" */
export type Series_Tournaments_Insert_Input = {
  circuit?: Maybe<Series_Obj_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  series_id?: Maybe<Scalars['uuid']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Statuses_Obj_Rel_Insert_Input>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament?: Maybe<Tournaments_Obj_Rel_Insert_Input>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Series_Tournaments_Max_Fields = {
  __typename?: 'series_tournaments_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  series_id?: Maybe<Scalars['uuid']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "series_tournaments" */
export type Series_Tournaments_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  series_id?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Series_Tournaments_Min_Fields = {
  __typename?: 'series_tournaments_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  series_id?: Maybe<Scalars['uuid']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "series_tournaments" */
export type Series_Tournaments_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  series_id?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "series_tournaments" */
export type Series_Tournaments_Mutation_Response = {
  __typename?: 'series_tournaments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Series_Tournaments>;
};

/** on_conflict condition type for table "series_tournaments" */
export type Series_Tournaments_On_Conflict = {
  constraint: Series_Tournaments_Constraint;
  update_columns?: Array<Series_Tournaments_Update_Column>;
  where?: Maybe<Series_Tournaments_Bool_Exp>;
};

/** Ordering options when selecting data from "series_tournaments". */
export type Series_Tournaments_Order_By = {
  circuit?: Maybe<Series_Order_By>;
  created_at?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  series_id?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  status?: Maybe<Statuses_Order_By>;
  status_id?: Maybe<Order_By>;
  tournament?: Maybe<Tournaments_Order_By>;
  tournament_id?: Maybe<Order_By>;
};

/** primary key columns input for table: series_tournaments */
export type Series_Tournaments_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "series_tournaments" */
export enum Series_Tournaments_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TournamentId = 'tournament_id'
}

/** input type for updating data in table "series_tournaments" */
export type Series_Tournaments_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  series_id?: Maybe<Scalars['uuid']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "series_tournaments" */
export type Series_Tournaments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Series_Tournaments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Series_Tournaments_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  series_id?: Maybe<Scalars['uuid']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "series_tournaments" */
export enum Series_Tournaments_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TournamentId = 'tournament_id'
}

export type Series_Tournaments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Series_Tournaments_Set_Input>;
  where: Series_Tournaments_Bool_Exp;
};

/** update columns of table "series" */
export enum Series_Update_Column {
  /** column name */
  CoverPhotoUrl = 'cover_photo_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Platform = 'platform',
  /** column name */
  PosterUrl = 'poster_url',
  /** column name */
  Slug = 'slug',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Series_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Series_Set_Input>;
  where: Series_Bool_Exp;
};

export type Stage_Participants_Args = {
  tournament_stages_row?: Maybe<Scalars['tournament_stages_scalar']>;
};

/** columns and relationships of "statuses" */
export type Statuses = {
  __typename?: 'statuses';
  /** An array relationship */
  circuit_sponsors: Array<Series_Sponsors>;
  /** An aggregate relationship */
  circuit_sponsors_aggregate: Series_Sponsors_Aggregate;
  /** An array relationship */
  circuit_tournaments: Array<Series_Tournaments>;
  /** An aggregate relationship */
  circuit_tournaments_aggregate: Series_Tournaments_Aggregate;
  /** An array relationship */
  circuits: Array<Series>;
  /** An aggregate relationship */
  circuits_aggregate: Series_Aggregate;
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An array relationship */
  live_event_messages: Array<Live_Event_Messages>;
  /** An aggregate relationship */
  live_event_messages_aggregate: Live_Event_Messages_Aggregate;
  /** An array relationship */
  live_events: Array<Live_Events>;
  /** An aggregate relationship */
  live_events_aggregate: Live_Events_Aggregate;
  /** An array relationship */
  matches: Array<Matches>;
  /** An aggregate relationship */
  matches_aggregate: Matches_Aggregate;
  name: Scalars['String'];
  /** An array relationship */
  party_invites: Array<Party_Invites>;
  /** An aggregate relationship */
  party_invites_aggregate: Party_Invites_Aggregate;
  /** An array relationship */
  party_relationships: Array<Party_Relationships>;
  /** An aggregate relationship */
  party_relationships_aggregate: Party_Relationships_Aggregate;
  /** An array relationship */
  party_statuses: Array<Party_Statuses>;
  /** An aggregate relationship */
  party_statuses_aggregate: Party_Statuses_Aggregate;
  /** An array relationship */
  tournament_invites: Array<Tournament_Invites>;
  /** An aggregate relationship */
  tournament_invites_aggregate: Tournament_Invites_Aggregate;
  /** An array relationship */
  tournament_registrations: Array<Tournament_Registrations>;
  /** An aggregate relationship */
  tournament_registrations_aggregate: Tournament_Registrations_Aggregate;
  /** An array relationship */
  tournament_sponsors: Array<Tournament_Sponsors>;
  /** An aggregate relationship */
  tournament_sponsors_aggregate: Tournament_Sponsors_Aggregate;
  /** An array relationship */
  tournament_stages: Array<Tournament_Stages>;
  /** An aggregate relationship */
  tournament_stages_aggregate: Tournament_Stages_Aggregate;
  /** An array relationship */
  tournament_statuses: Array<Tournament_Statuses>;
  /** An aggregate relationship */
  tournament_statuses_aggregate: Tournament_Statuses_Aggregate;
  /** An array relationship */
  tournaments: Array<Tournaments>;
  /** An aggregate relationship */
  tournaments_aggregate: Tournaments_Aggregate;
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_statuses: Array<User_Statuses>;
  /** An aggregate relationship */
  user_statuses_aggregate: User_Statuses_Aggregate;
  value?: Maybe<Scalars['String']>;
};


/** columns and relationships of "statuses" */
export type StatusesCircuit_SponsorsArgs = {
  distinct_on?: Maybe<Array<Series_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Sponsors_Order_By>>;
  where?: Maybe<Series_Sponsors_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesCircuit_Sponsors_AggregateArgs = {
  distinct_on?: Maybe<Array<Series_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Sponsors_Order_By>>;
  where?: Maybe<Series_Sponsors_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesCircuit_TournamentsArgs = {
  distinct_on?: Maybe<Array<Series_Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Tournaments_Order_By>>;
  where?: Maybe<Series_Tournaments_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesCircuit_Tournaments_AggregateArgs = {
  distinct_on?: Maybe<Array<Series_Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Tournaments_Order_By>>;
  where?: Maybe<Series_Tournaments_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesCircuitsArgs = {
  distinct_on?: Maybe<Array<Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Order_By>>;
  where?: Maybe<Series_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesCircuits_AggregateArgs = {
  distinct_on?: Maybe<Array<Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Order_By>>;
  where?: Maybe<Series_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesLive_Event_MessagesArgs = {
  distinct_on?: Maybe<Array<Live_Event_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Event_Messages_Order_By>>;
  where?: Maybe<Live_Event_Messages_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesLive_Event_Messages_AggregateArgs = {
  distinct_on?: Maybe<Array<Live_Event_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Event_Messages_Order_By>>;
  where?: Maybe<Live_Event_Messages_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesLive_EventsArgs = {
  distinct_on?: Maybe<Array<Live_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Events_Order_By>>;
  where?: Maybe<Live_Events_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesLive_Events_AggregateArgs = {
  distinct_on?: Maybe<Array<Live_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Events_Order_By>>;
  where?: Maybe<Live_Events_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesMatchesArgs = {
  distinct_on?: Maybe<Array<Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Matches_Order_By>>;
  where?: Maybe<Matches_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesMatches_AggregateArgs = {
  distinct_on?: Maybe<Array<Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Matches_Order_By>>;
  where?: Maybe<Matches_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesParty_InvitesArgs = {
  distinct_on?: Maybe<Array<Party_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Invites_Order_By>>;
  where?: Maybe<Party_Invites_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesParty_Invites_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Invites_Order_By>>;
  where?: Maybe<Party_Invites_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesParty_RelationshipsArgs = {
  distinct_on?: Maybe<Array<Party_Relationships_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Relationships_Order_By>>;
  where?: Maybe<Party_Relationships_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesParty_Relationships_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Relationships_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Relationships_Order_By>>;
  where?: Maybe<Party_Relationships_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesParty_StatusesArgs = {
  distinct_on?: Maybe<Array<Party_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Statuses_Order_By>>;
  where?: Maybe<Party_Statuses_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesParty_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Statuses_Order_By>>;
  where?: Maybe<Party_Statuses_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesTournament_InvitesArgs = {
  distinct_on?: Maybe<Array<Tournament_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Invites_Order_By>>;
  where?: Maybe<Tournament_Invites_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesTournament_Invites_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Invites_Order_By>>;
  where?: Maybe<Tournament_Invites_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesTournament_RegistrationsArgs = {
  distinct_on?: Maybe<Array<Tournament_Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Registrations_Order_By>>;
  where?: Maybe<Tournament_Registrations_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesTournament_Registrations_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Registrations_Order_By>>;
  where?: Maybe<Tournament_Registrations_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesTournament_SponsorsArgs = {
  distinct_on?: Maybe<Array<Tournament_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Sponsors_Order_By>>;
  where?: Maybe<Tournament_Sponsors_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesTournament_Sponsors_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Sponsors_Order_By>>;
  where?: Maybe<Tournament_Sponsors_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesTournament_StagesArgs = {
  distinct_on?: Maybe<Array<Tournament_Stages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Stages_Order_By>>;
  where?: Maybe<Tournament_Stages_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesTournament_Stages_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Stages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Stages_Order_By>>;
  where?: Maybe<Tournament_Stages_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesTournament_StatusesArgs = {
  distinct_on?: Maybe<Array<Tournament_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Statuses_Order_By>>;
  where?: Maybe<Tournament_Statuses_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesTournament_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Statuses_Order_By>>;
  where?: Maybe<Tournament_Statuses_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesTournamentsArgs = {
  distinct_on?: Maybe<Array<Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournaments_Order_By>>;
  where?: Maybe<Tournaments_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesTournaments_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournaments_Order_By>>;
  where?: Maybe<Tournaments_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesUser_StatusesArgs = {
  distinct_on?: Maybe<Array<User_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Statuses_Order_By>>;
  where?: Maybe<User_Statuses_Bool_Exp>;
};


/** columns and relationships of "statuses" */
export type StatusesUser_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Statuses_Order_By>>;
  where?: Maybe<User_Statuses_Bool_Exp>;
};

/** aggregated selection of "statuses" */
export type Statuses_Aggregate = {
  __typename?: 'statuses_aggregate';
  aggregate?: Maybe<Statuses_Aggregate_Fields>;
  nodes: Array<Statuses>;
};

/** aggregate fields of "statuses" */
export type Statuses_Aggregate_Fields = {
  __typename?: 'statuses_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Statuses_Max_Fields>;
  min?: Maybe<Statuses_Min_Fields>;
};


/** aggregate fields of "statuses" */
export type Statuses_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Statuses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "statuses". All fields are combined with a logical 'AND'. */
export type Statuses_Bool_Exp = {
  _and?: Maybe<Array<Statuses_Bool_Exp>>;
  _not?: Maybe<Statuses_Bool_Exp>;
  _or?: Maybe<Array<Statuses_Bool_Exp>>;
  circuit_sponsors?: Maybe<Series_Sponsors_Bool_Exp>;
  circuit_sponsors_aggregate?: Maybe<Series_Sponsors_Aggregate_Bool_Exp>;
  circuit_tournaments?: Maybe<Series_Tournaments_Bool_Exp>;
  circuit_tournaments_aggregate?: Maybe<Series_Tournaments_Aggregate_Bool_Exp>;
  circuits?: Maybe<Series_Bool_Exp>;
  circuits_aggregate?: Maybe<Series_Aggregate_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  live_event_messages?: Maybe<Live_Event_Messages_Bool_Exp>;
  live_event_messages_aggregate?: Maybe<Live_Event_Messages_Aggregate_Bool_Exp>;
  live_events?: Maybe<Live_Events_Bool_Exp>;
  live_events_aggregate?: Maybe<Live_Events_Aggregate_Bool_Exp>;
  matches?: Maybe<Matches_Bool_Exp>;
  matches_aggregate?: Maybe<Matches_Aggregate_Bool_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  party_invites?: Maybe<Party_Invites_Bool_Exp>;
  party_invites_aggregate?: Maybe<Party_Invites_Aggregate_Bool_Exp>;
  party_relationships?: Maybe<Party_Relationships_Bool_Exp>;
  party_relationships_aggregate?: Maybe<Party_Relationships_Aggregate_Bool_Exp>;
  party_statuses?: Maybe<Party_Statuses_Bool_Exp>;
  party_statuses_aggregate?: Maybe<Party_Statuses_Aggregate_Bool_Exp>;
  tournament_invites?: Maybe<Tournament_Invites_Bool_Exp>;
  tournament_invites_aggregate?: Maybe<Tournament_Invites_Aggregate_Bool_Exp>;
  tournament_registrations?: Maybe<Tournament_Registrations_Bool_Exp>;
  tournament_registrations_aggregate?: Maybe<Tournament_Registrations_Aggregate_Bool_Exp>;
  tournament_sponsors?: Maybe<Tournament_Sponsors_Bool_Exp>;
  tournament_sponsors_aggregate?: Maybe<Tournament_Sponsors_Aggregate_Bool_Exp>;
  tournament_stages?: Maybe<Tournament_Stages_Bool_Exp>;
  tournament_stages_aggregate?: Maybe<Tournament_Stages_Aggregate_Bool_Exp>;
  tournament_statuses?: Maybe<Tournament_Statuses_Bool_Exp>;
  tournament_statuses_aggregate?: Maybe<Tournament_Statuses_Aggregate_Bool_Exp>;
  tournaments?: Maybe<Tournaments_Bool_Exp>;
  tournaments_aggregate?: Maybe<Tournaments_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user_statuses?: Maybe<User_Statuses_Bool_Exp>;
  user_statuses_aggregate?: Maybe<User_Statuses_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "statuses" */
export enum Statuses_Constraint {
  /** unique or primary key constraint on columns "id" */
  StatusesPkey = 'statuses_pkey',
  /** unique or primary key constraint on columns "value" */
  StatusesValueUnique = 'statuses_value_unique'
}

/** input type for inserting data into table "statuses" */
export type Statuses_Insert_Input = {
  circuit_sponsors?: Maybe<Series_Sponsors_Arr_Rel_Insert_Input>;
  circuit_tournaments?: Maybe<Series_Tournaments_Arr_Rel_Insert_Input>;
  circuits?: Maybe<Series_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  live_event_messages?: Maybe<Live_Event_Messages_Arr_Rel_Insert_Input>;
  live_events?: Maybe<Live_Events_Arr_Rel_Insert_Input>;
  matches?: Maybe<Matches_Arr_Rel_Insert_Input>;
  name?: Maybe<Scalars['String']>;
  party_invites?: Maybe<Party_Invites_Arr_Rel_Insert_Input>;
  party_relationships?: Maybe<Party_Relationships_Arr_Rel_Insert_Input>;
  party_statuses?: Maybe<Party_Statuses_Arr_Rel_Insert_Input>;
  tournament_invites?: Maybe<Tournament_Invites_Arr_Rel_Insert_Input>;
  tournament_registrations?: Maybe<Tournament_Registrations_Arr_Rel_Insert_Input>;
  tournament_sponsors?: Maybe<Tournament_Sponsors_Arr_Rel_Insert_Input>;
  tournament_stages?: Maybe<Tournament_Stages_Arr_Rel_Insert_Input>;
  tournament_statuses?: Maybe<Tournament_Statuses_Arr_Rel_Insert_Input>;
  tournaments?: Maybe<Tournaments_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_statuses?: Maybe<User_Statuses_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Statuses_Max_Fields = {
  __typename?: 'statuses_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Statuses_Min_Fields = {
  __typename?: 'statuses_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "statuses" */
export type Statuses_Mutation_Response = {
  __typename?: 'statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Statuses>;
};

/** input type for inserting object relation for remote table "statuses" */
export type Statuses_Obj_Rel_Insert_Input = {
  data: Statuses_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Statuses_On_Conflict>;
};

/** on_conflict condition type for table "statuses" */
export type Statuses_On_Conflict = {
  constraint: Statuses_Constraint;
  update_columns?: Array<Statuses_Update_Column>;
  where?: Maybe<Statuses_Bool_Exp>;
};

/** Ordering options when selecting data from "statuses". */
export type Statuses_Order_By = {
  circuit_sponsors_aggregate?: Maybe<Series_Sponsors_Aggregate_Order_By>;
  circuit_tournaments_aggregate?: Maybe<Series_Tournaments_Aggregate_Order_By>;
  circuits_aggregate?: Maybe<Series_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  live_event_messages_aggregate?: Maybe<Live_Event_Messages_Aggregate_Order_By>;
  live_events_aggregate?: Maybe<Live_Events_Aggregate_Order_By>;
  matches_aggregate?: Maybe<Matches_Aggregate_Order_By>;
  name?: Maybe<Order_By>;
  party_invites_aggregate?: Maybe<Party_Invites_Aggregate_Order_By>;
  party_relationships_aggregate?: Maybe<Party_Relationships_Aggregate_Order_By>;
  party_statuses_aggregate?: Maybe<Party_Statuses_Aggregate_Order_By>;
  tournament_invites_aggregate?: Maybe<Tournament_Invites_Aggregate_Order_By>;
  tournament_registrations_aggregate?: Maybe<Tournament_Registrations_Aggregate_Order_By>;
  tournament_sponsors_aggregate?: Maybe<Tournament_Sponsors_Aggregate_Order_By>;
  tournament_stages_aggregate?: Maybe<Tournament_Stages_Aggregate_Order_By>;
  tournament_statuses_aggregate?: Maybe<Tournament_Statuses_Aggregate_Order_By>;
  tournaments_aggregate?: Maybe<Tournaments_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
  user_statuses_aggregate?: Maybe<User_Statuses_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: statuses */
export type Statuses_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "statuses" */
export enum Statuses_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "statuses" */
export type Statuses_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "statuses" */
export type Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Statuses_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "statuses" */
export enum Statuses_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Statuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Statuses_Set_Input>;
  where: Statuses_Bool_Exp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "audit_logs" */
  audit_logs: Array<Audit_Logs>;
  /** fetch aggregated fields from the table: "audit_logs" */
  audit_logs_aggregate: Audit_Logs_Aggregate;
  /** fetch data from the table: "audit_logs" using primary key columns */
  audit_logs_by_pk?: Maybe<Audit_Logs>;
  /** fetch data from the table in a streaming manner: "audit_logs" */
  audit_logs_stream: Array<Audit_Logs>;
  /** fetch data from the table: "flags" */
  flags: Array<Flags>;
  /** fetch aggregated fields from the table: "flags" */
  flags_aggregate: Flags_Aggregate;
  /** fetch data from the table: "flags" using primary key columns */
  flags_by_pk?: Maybe<Flags>;
  /** fetch data from the table in a streaming manner: "flags" */
  flags_stream: Array<Flags>;
  /** An array relationship */
  games: Array<Games>;
  /** An aggregate relationship */
  games_aggregate: Games_Aggregate;
  /** fetch data from the table: "games" using primary key columns */
  games_by_pk?: Maybe<Games>;
  /** fetch data from the table in a streaming manner: "games" */
  games_stream: Array<Games>;
  /** fetch data from the table: "hub_registrations" */
  hub_registrations: Array<Hub_Registrations>;
  /** fetch aggregated fields from the table: "hub_registrations" */
  hub_registrations_aggregate: Hub_Registrations_Aggregate;
  /** fetch data from the table: "hub_registrations" using primary key columns */
  hub_registrations_by_pk?: Maybe<Hub_Registrations>;
  /** fetch data from the table in a streaming manner: "hub_registrations" */
  hub_registrations_stream: Array<Hub_Registrations>;
  /** An array relationship */
  invites: Array<Invites>;
  /** An aggregate relationship */
  invites_aggregate: Invites_Aggregate;
  /** fetch data from the table: "invites" using primary key columns */
  invites_by_pk?: Maybe<Invites>;
  /** fetch data from the table in a streaming manner: "invites" */
  invites_stream: Array<Invites>;
  /** An array relationship */
  live_event_messages: Array<Live_Event_Messages>;
  /** An aggregate relationship */
  live_event_messages_aggregate: Live_Event_Messages_Aggregate;
  /** fetch data from the table: "live_event_messages" using primary key columns */
  live_event_messages_by_pk?: Maybe<Live_Event_Messages>;
  /** fetch data from the table in a streaming manner: "live_event_messages" */
  live_event_messages_stream: Array<Live_Event_Messages>;
  /** An array relationship */
  live_events: Array<Live_Events>;
  /** An aggregate relationship */
  live_events_aggregate: Live_Events_Aggregate;
  /** fetch data from the table: "live_events" using primary key columns */
  live_events_by_pk?: Maybe<Live_Events>;
  /** fetch data from the table in a streaming manner: "live_events" */
  live_events_stream: Array<Live_Events>;
  /** An array relationship */
  match_flags: Array<Match_Flags>;
  /** An aggregate relationship */
  match_flags_aggregate: Match_Flags_Aggregate;
  /** fetch data from the table: "match_flags" using primary key columns */
  match_flags_by_pk?: Maybe<Match_Flags>;
  /** fetch data from the table in a streaming manner: "match_flags" */
  match_flags_stream: Array<Match_Flags>;
  /** An array relationship */
  match_rewards: Array<Match_Rewards>;
  /** An aggregate relationship */
  match_rewards_aggregate: Match_Rewards_Aggregate;
  /** fetch data from the table: "match_rewards" using primary key columns */
  match_rewards_by_pk?: Maybe<Match_Rewards>;
  /** fetch data from the table in a streaming manner: "match_rewards" */
  match_rewards_stream: Array<Match_Rewards>;
  /** An array relationship */
  matches: Array<Matches>;
  /** An aggregate relationship */
  matches_aggregate: Matches_Aggregate;
  /** fetch data from the table: "matches" using primary key columns */
  matches_by_pk?: Maybe<Matches>;
  /** fetch data from the table in a streaming manner: "matches" */
  matches_stream: Array<Matches>;
  /** An array relationship */
  parties: Array<Parties>;
  /** An aggregate relationship */
  parties_aggregate: Parties_Aggregate;
  /** fetch data from the table: "parties" using primary key columns */
  parties_by_pk?: Maybe<Parties>;
  /** fetch data from the table in a streaming manner: "parties" */
  parties_stream: Array<Parties>;
  /** An array relationship */
  party_details: Array<Party_Details>;
  /** An aggregate relationship */
  party_details_aggregate: Party_Details_Aggregate;
  /** fetch data from the table: "party_details" using primary key columns */
  party_details_by_pk?: Maybe<Party_Details>;
  /** fetch data from the table in a streaming manner: "party_details" */
  party_details_stream: Array<Party_Details>;
  /** An array relationship */
  party_flags: Array<Party_Flags>;
  /** An aggregate relationship */
  party_flags_aggregate: Party_Flags_Aggregate;
  /** fetch data from the table: "party_flags" using primary key columns */
  party_flags_by_pk?: Maybe<Party_Flags>;
  /** fetch data from the table in a streaming manner: "party_flags" */
  party_flags_stream: Array<Party_Flags>;
  /** An array relationship */
  party_invites: Array<Party_Invites>;
  /** An aggregate relationship */
  party_invites_aggregate: Party_Invites_Aggregate;
  /** fetch data from the table: "party_invites" using primary key columns */
  party_invites_by_pk?: Maybe<Party_Invites>;
  /** fetch data from the table in a streaming manner: "party_invites" */
  party_invites_stream: Array<Party_Invites>;
  /** An array relationship */
  party_relationships: Array<Party_Relationships>;
  /** An aggregate relationship */
  party_relationships_aggregate: Party_Relationships_Aggregate;
  /** fetch data from the table: "party_relationships" using primary key columns */
  party_relationships_by_pk?: Maybe<Party_Relationships>;
  /** fetch data from the table in a streaming manner: "party_relationships" */
  party_relationships_stream: Array<Party_Relationships>;
  /** An array relationship */
  party_statuses: Array<Party_Statuses>;
  /** An aggregate relationship */
  party_statuses_aggregate: Party_Statuses_Aggregate;
  /** fetch data from the table: "party_statuses" using primary key columns */
  party_statuses_by_pk?: Maybe<Party_Statuses>;
  /** fetch data from the table in a streaming manner: "party_statuses" */
  party_statuses_stream: Array<Party_Statuses>;
  /** An array relationship */
  reward_redemptions: Array<Reward_Redemptions>;
  /** An aggregate relationship */
  reward_redemptions_aggregate: Reward_Redemptions_Aggregate;
  /** fetch data from the table: "reward_redemptions" using primary key columns */
  reward_redemptions_by_pk?: Maybe<Reward_Redemptions>;
  /** fetch data from the table in a streaming manner: "reward_redemptions" */
  reward_redemptions_stream: Array<Reward_Redemptions>;
  /** An array relationship */
  rewards: Array<Rewards>;
  /** An aggregate relationship */
  rewards_aggregate: Rewards_Aggregate;
  /** fetch data from the table: "rewards" using primary key columns */
  rewards_by_pk?: Maybe<Rewards>;
  /** fetch data from the table in a streaming manner: "rewards" */
  rewards_stream: Array<Rewards>;
  /** execute function "search_gamers" which returns "parties" */
  search_gamers: Array<Parties>;
  /** execute function "search_gamers" and query aggregates on result of table type "parties" */
  search_gamers_aggregate: Parties_Aggregate;
  /** An array relationship */
  series: Array<Series>;
  /** An aggregate relationship */
  series_aggregate: Series_Aggregate;
  /** fetch data from the table: "series" using primary key columns */
  series_by_pk?: Maybe<Series>;
  /** An array relationship */
  series_sponsors: Array<Series_Sponsors>;
  /** An aggregate relationship */
  series_sponsors_aggregate: Series_Sponsors_Aggregate;
  /** fetch data from the table: "series_sponsors" using primary key columns */
  series_sponsors_by_pk?: Maybe<Series_Sponsors>;
  /** fetch data from the table in a streaming manner: "series_sponsors" */
  series_sponsors_stream: Array<Series_Sponsors>;
  /** fetch data from the table in a streaming manner: "series" */
  series_stream: Array<Series>;
  /** An array relationship */
  series_tournaments: Array<Series_Tournaments>;
  /** An aggregate relationship */
  series_tournaments_aggregate: Series_Tournaments_Aggregate;
  /** fetch data from the table: "series_tournaments" using primary key columns */
  series_tournaments_by_pk?: Maybe<Series_Tournaments>;
  /** fetch data from the table in a streaming manner: "series_tournaments" */
  series_tournaments_stream: Array<Series_Tournaments>;
  /** execute function "stage_participants" which returns "parties" */
  stage_participants: Array<Parties>;
  /** execute function "stage_participants" and query aggregates on result of table type "parties" */
  stage_participants_aggregate: Parties_Aggregate;
  /** fetch data from the table: "statuses" */
  statuses: Array<Statuses>;
  /** fetch aggregated fields from the table: "statuses" */
  statuses_aggregate: Statuses_Aggregate;
  /** fetch data from the table: "statuses" using primary key columns */
  statuses_by_pk?: Maybe<Statuses>;
  /** fetch data from the table in a streaming manner: "statuses" */
  statuses_stream: Array<Statuses>;
  /** An array relationship */
  tournament_details: Array<Tournament_Details>;
  /** An aggregate relationship */
  tournament_details_aggregate: Tournament_Details_Aggregate;
  /** fetch data from the table: "tournament_details" using primary key columns */
  tournament_details_by_pk?: Maybe<Tournament_Details>;
  /** fetch data from the table in a streaming manner: "tournament_details" */
  tournament_details_stream: Array<Tournament_Details>;
  /** An array relationship */
  tournament_flags: Array<Tournament_Flags>;
  /** An aggregate relationship */
  tournament_flags_aggregate: Tournament_Flags_Aggregate;
  /** fetch data from the table: "tournament_flags" using primary key columns */
  tournament_flags_by_pk?: Maybe<Tournament_Flags>;
  /** fetch data from the table in a streaming manner: "tournament_flags" */
  tournament_flags_stream: Array<Tournament_Flags>;
  /** An array relationship */
  tournament_invites: Array<Tournament_Invites>;
  /** An aggregate relationship */
  tournament_invites_aggregate: Tournament_Invites_Aggregate;
  /** fetch data from the table: "tournament_invites" using primary key columns */
  tournament_invites_by_pk?: Maybe<Tournament_Invites>;
  /** fetch data from the table in a streaming manner: "tournament_invites" */
  tournament_invites_stream: Array<Tournament_Invites>;
  /** An array relationship */
  tournament_registrations: Array<Tournament_Registrations>;
  /** An aggregate relationship */
  tournament_registrations_aggregate: Tournament_Registrations_Aggregate;
  /** fetch data from the table: "tournament_registrations" using primary key columns */
  tournament_registrations_by_pk?: Maybe<Tournament_Registrations>;
  /** fetch data from the table in a streaming manner: "tournament_registrations" */
  tournament_registrations_stream: Array<Tournament_Registrations>;
  /** An array relationship */
  tournament_results: Array<Tournament_Results>;
  /** An aggregate relationship */
  tournament_results_aggregate: Tournament_Results_Aggregate;
  /** fetch data from the table: "tournament_results" using primary key columns */
  tournament_results_by_pk?: Maybe<Tournament_Results>;
  /** fetch data from the table in a streaming manner: "tournament_results" */
  tournament_results_stream: Array<Tournament_Results>;
  /** An array relationship */
  tournament_rewards: Array<Tournament_Rewards>;
  /** An aggregate relationship */
  tournament_rewards_aggregate: Tournament_Rewards_Aggregate;
  /** fetch data from the table: "tournament_rewards" using primary key columns */
  tournament_rewards_by_pk?: Maybe<Tournament_Rewards>;
  /** fetch data from the table in a streaming manner: "tournament_rewards" */
  tournament_rewards_stream: Array<Tournament_Rewards>;
  /** An array relationship */
  tournament_sponsors: Array<Tournament_Sponsors>;
  /** An aggregate relationship */
  tournament_sponsors_aggregate: Tournament_Sponsors_Aggregate;
  /** fetch data from the table: "tournament_sponsors" using primary key columns */
  tournament_sponsors_by_pk?: Maybe<Tournament_Sponsors>;
  /** fetch data from the table in a streaming manner: "tournament_sponsors" */
  tournament_sponsors_stream: Array<Tournament_Sponsors>;
  /** An array relationship */
  tournament_stages: Array<Tournament_Stages>;
  /** An aggregate relationship */
  tournament_stages_aggregate: Tournament_Stages_Aggregate;
  /** fetch data from the table: "tournament_stages" using primary key columns */
  tournament_stages_by_pk?: Maybe<Tournament_Stages>;
  /** fetch data from the table in a streaming manner: "tournament_stages" */
  tournament_stages_stream: Array<Tournament_Stages>;
  /** An array relationship */
  tournament_statuses: Array<Tournament_Statuses>;
  /** An aggregate relationship */
  tournament_statuses_aggregate: Tournament_Statuses_Aggregate;
  /** fetch data from the table: "tournament_statuses" using primary key columns */
  tournament_statuses_by_pk?: Maybe<Tournament_Statuses>;
  /** fetch data from the table in a streaming manner: "tournament_statuses" */
  tournament_statuses_stream: Array<Tournament_Statuses>;
  /** An array relationship */
  tournaments: Array<Tournaments>;
  /** An aggregate relationship */
  tournaments_aggregate: Tournaments_Aggregate;
  /** fetch data from the table: "tournaments" using primary key columns */
  tournaments_by_pk?: Maybe<Tournaments>;
  /** fetch data from the table in a streaming manner: "tournaments" */
  tournaments_stream: Array<Tournaments>;
  /** fetch data from the table: "types" */
  types: Array<Types>;
  /** fetch aggregated fields from the table: "types" */
  types_aggregate: Types_Aggregate;
  /** fetch data from the table: "types" using primary key columns */
  types_by_pk?: Maybe<Types>;
  /** fetch data from the table in a streaming manner: "types" */
  types_stream: Array<Types>;
  /** An array relationship */
  user_flags: Array<User_Flags>;
  /** An aggregate relationship */
  user_flags_aggregate: User_Flags_Aggregate;
  /** fetch data from the table: "user_flags" using primary key columns */
  user_flags_by_pk?: Maybe<User_Flags>;
  /** fetch data from the table in a streaming manner: "user_flags" */
  user_flags_stream: Array<User_Flags>;
  /** An array relationship */
  user_mfa_factors: Array<User_Mfa_Factors>;
  /** An aggregate relationship */
  user_mfa_factors_aggregate: User_Mfa_Factors_Aggregate;
  /** fetch data from the table: "user_mfa_factors" using primary key columns */
  user_mfa_factors_by_pk?: Maybe<User_Mfa_Factors>;
  /** fetch data from the table in a streaming manner: "user_mfa_factors" */
  user_mfa_factors_stream: Array<User_Mfa_Factors>;
  /** An array relationship */
  user_statuses: Array<User_Statuses>;
  /** An aggregate relationship */
  user_statuses_aggregate: User_Statuses_Aggregate;
  /** fetch data from the table: "user_statuses" using primary key columns */
  user_statuses_by_pk?: Maybe<User_Statuses>;
  /** fetch data from the table in a streaming manner: "user_statuses" */
  user_statuses_stream: Array<User_Statuses>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
};


export type Subscription_RootAudit_LogsArgs = {
  distinct_on?: Maybe<Array<Audit_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Audit_Logs_Order_By>>;
  where?: Maybe<Audit_Logs_Bool_Exp>;
};


export type Subscription_RootAudit_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Audit_Logs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Audit_Logs_Order_By>>;
  where?: Maybe<Audit_Logs_Bool_Exp>;
};


export type Subscription_RootAudit_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAudit_Logs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Audit_Logs_Stream_Cursor_Input>>;
  where?: Maybe<Audit_Logs_Bool_Exp>;
};


export type Subscription_RootFlagsArgs = {
  distinct_on?: Maybe<Array<Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flags_Order_By>>;
  where?: Maybe<Flags_Bool_Exp>;
};


export type Subscription_RootFlags_AggregateArgs = {
  distinct_on?: Maybe<Array<Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flags_Order_By>>;
  where?: Maybe<Flags_Bool_Exp>;
};


export type Subscription_RootFlags_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFlags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Flags_Stream_Cursor_Input>>;
  where?: Maybe<Flags_Bool_Exp>;
};


export type Subscription_RootGamesArgs = {
  distinct_on?: Maybe<Array<Games_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Games_Order_By>>;
  where?: Maybe<Games_Bool_Exp>;
};


export type Subscription_RootGames_AggregateArgs = {
  distinct_on?: Maybe<Array<Games_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Games_Order_By>>;
  where?: Maybe<Games_Bool_Exp>;
};


export type Subscription_RootGames_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGames_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Games_Stream_Cursor_Input>>;
  where?: Maybe<Games_Bool_Exp>;
};


export type Subscription_RootHub_RegistrationsArgs = {
  distinct_on?: Maybe<Array<Hub_Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Hub_Registrations_Order_By>>;
  where?: Maybe<Hub_Registrations_Bool_Exp>;
};


export type Subscription_RootHub_Registrations_AggregateArgs = {
  distinct_on?: Maybe<Array<Hub_Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Hub_Registrations_Order_By>>;
  where?: Maybe<Hub_Registrations_Bool_Exp>;
};


export type Subscription_RootHub_Registrations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootHub_Registrations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Hub_Registrations_Stream_Cursor_Input>>;
  where?: Maybe<Hub_Registrations_Bool_Exp>;
};


export type Subscription_RootInvitesArgs = {
  distinct_on?: Maybe<Array<Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invites_Order_By>>;
  where?: Maybe<Invites_Bool_Exp>;
};


export type Subscription_RootInvites_AggregateArgs = {
  distinct_on?: Maybe<Array<Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invites_Order_By>>;
  where?: Maybe<Invites_Bool_Exp>;
};


export type Subscription_RootInvites_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootInvites_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Invites_Stream_Cursor_Input>>;
  where?: Maybe<Invites_Bool_Exp>;
};


export type Subscription_RootLive_Event_MessagesArgs = {
  distinct_on?: Maybe<Array<Live_Event_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Event_Messages_Order_By>>;
  where?: Maybe<Live_Event_Messages_Bool_Exp>;
};


export type Subscription_RootLive_Event_Messages_AggregateArgs = {
  distinct_on?: Maybe<Array<Live_Event_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Event_Messages_Order_By>>;
  where?: Maybe<Live_Event_Messages_Bool_Exp>;
};


export type Subscription_RootLive_Event_Messages_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLive_Event_Messages_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Live_Event_Messages_Stream_Cursor_Input>>;
  where?: Maybe<Live_Event_Messages_Bool_Exp>;
};


export type Subscription_RootLive_EventsArgs = {
  distinct_on?: Maybe<Array<Live_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Events_Order_By>>;
  where?: Maybe<Live_Events_Bool_Exp>;
};


export type Subscription_RootLive_Events_AggregateArgs = {
  distinct_on?: Maybe<Array<Live_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Events_Order_By>>;
  where?: Maybe<Live_Events_Bool_Exp>;
};


export type Subscription_RootLive_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLive_Events_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Live_Events_Stream_Cursor_Input>>;
  where?: Maybe<Live_Events_Bool_Exp>;
};


export type Subscription_RootMatch_FlagsArgs = {
  distinct_on?: Maybe<Array<Match_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Match_Flags_Order_By>>;
  where?: Maybe<Match_Flags_Bool_Exp>;
};


export type Subscription_RootMatch_Flags_AggregateArgs = {
  distinct_on?: Maybe<Array<Match_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Match_Flags_Order_By>>;
  where?: Maybe<Match_Flags_Bool_Exp>;
};


export type Subscription_RootMatch_Flags_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMatch_Flags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Match_Flags_Stream_Cursor_Input>>;
  where?: Maybe<Match_Flags_Bool_Exp>;
};


export type Subscription_RootMatch_RewardsArgs = {
  distinct_on?: Maybe<Array<Match_Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Match_Rewards_Order_By>>;
  where?: Maybe<Match_Rewards_Bool_Exp>;
};


export type Subscription_RootMatch_Rewards_AggregateArgs = {
  distinct_on?: Maybe<Array<Match_Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Match_Rewards_Order_By>>;
  where?: Maybe<Match_Rewards_Bool_Exp>;
};


export type Subscription_RootMatch_Rewards_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMatch_Rewards_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Match_Rewards_Stream_Cursor_Input>>;
  where?: Maybe<Match_Rewards_Bool_Exp>;
};


export type Subscription_RootMatchesArgs = {
  distinct_on?: Maybe<Array<Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Matches_Order_By>>;
  where?: Maybe<Matches_Bool_Exp>;
};


export type Subscription_RootMatches_AggregateArgs = {
  distinct_on?: Maybe<Array<Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Matches_Order_By>>;
  where?: Maybe<Matches_Bool_Exp>;
};


export type Subscription_RootMatches_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMatches_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Matches_Stream_Cursor_Input>>;
  where?: Maybe<Matches_Bool_Exp>;
};


export type Subscription_RootPartiesArgs = {
  distinct_on?: Maybe<Array<Parties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Parties_Order_By>>;
  where?: Maybe<Parties_Bool_Exp>;
};


export type Subscription_RootParties_AggregateArgs = {
  distinct_on?: Maybe<Array<Parties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Parties_Order_By>>;
  where?: Maybe<Parties_Bool_Exp>;
};


export type Subscription_RootParties_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootParties_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Parties_Stream_Cursor_Input>>;
  where?: Maybe<Parties_Bool_Exp>;
};


export type Subscription_RootParty_DetailsArgs = {
  distinct_on?: Maybe<Array<Party_Details_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Details_Order_By>>;
  where?: Maybe<Party_Details_Bool_Exp>;
};


export type Subscription_RootParty_Details_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Details_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Details_Order_By>>;
  where?: Maybe<Party_Details_Bool_Exp>;
};


export type Subscription_RootParty_Details_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootParty_Details_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Party_Details_Stream_Cursor_Input>>;
  where?: Maybe<Party_Details_Bool_Exp>;
};


export type Subscription_RootParty_FlagsArgs = {
  distinct_on?: Maybe<Array<Party_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Flags_Order_By>>;
  where?: Maybe<Party_Flags_Bool_Exp>;
};


export type Subscription_RootParty_Flags_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Flags_Order_By>>;
  where?: Maybe<Party_Flags_Bool_Exp>;
};


export type Subscription_RootParty_Flags_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootParty_Flags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Party_Flags_Stream_Cursor_Input>>;
  where?: Maybe<Party_Flags_Bool_Exp>;
};


export type Subscription_RootParty_InvitesArgs = {
  distinct_on?: Maybe<Array<Party_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Invites_Order_By>>;
  where?: Maybe<Party_Invites_Bool_Exp>;
};


export type Subscription_RootParty_Invites_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Invites_Order_By>>;
  where?: Maybe<Party_Invites_Bool_Exp>;
};


export type Subscription_RootParty_Invites_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootParty_Invites_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Party_Invites_Stream_Cursor_Input>>;
  where?: Maybe<Party_Invites_Bool_Exp>;
};


export type Subscription_RootParty_RelationshipsArgs = {
  distinct_on?: Maybe<Array<Party_Relationships_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Relationships_Order_By>>;
  where?: Maybe<Party_Relationships_Bool_Exp>;
};


export type Subscription_RootParty_Relationships_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Relationships_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Relationships_Order_By>>;
  where?: Maybe<Party_Relationships_Bool_Exp>;
};


export type Subscription_RootParty_Relationships_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootParty_Relationships_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Party_Relationships_Stream_Cursor_Input>>;
  where?: Maybe<Party_Relationships_Bool_Exp>;
};


export type Subscription_RootParty_StatusesArgs = {
  distinct_on?: Maybe<Array<Party_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Statuses_Order_By>>;
  where?: Maybe<Party_Statuses_Bool_Exp>;
};


export type Subscription_RootParty_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Statuses_Order_By>>;
  where?: Maybe<Party_Statuses_Bool_Exp>;
};


export type Subscription_RootParty_Statuses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootParty_Statuses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Party_Statuses_Stream_Cursor_Input>>;
  where?: Maybe<Party_Statuses_Bool_Exp>;
};


export type Subscription_RootReward_RedemptionsArgs = {
  distinct_on?: Maybe<Array<Reward_Redemptions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Reward_Redemptions_Order_By>>;
  where?: Maybe<Reward_Redemptions_Bool_Exp>;
};


export type Subscription_RootReward_Redemptions_AggregateArgs = {
  distinct_on?: Maybe<Array<Reward_Redemptions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Reward_Redemptions_Order_By>>;
  where?: Maybe<Reward_Redemptions_Bool_Exp>;
};


export type Subscription_RootReward_Redemptions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootReward_Redemptions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Reward_Redemptions_Stream_Cursor_Input>>;
  where?: Maybe<Reward_Redemptions_Bool_Exp>;
};


export type Subscription_RootRewardsArgs = {
  distinct_on?: Maybe<Array<Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Rewards_Order_By>>;
  where?: Maybe<Rewards_Bool_Exp>;
};


export type Subscription_RootRewards_AggregateArgs = {
  distinct_on?: Maybe<Array<Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Rewards_Order_By>>;
  where?: Maybe<Rewards_Bool_Exp>;
};


export type Subscription_RootRewards_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRewards_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Rewards_Stream_Cursor_Input>>;
  where?: Maybe<Rewards_Bool_Exp>;
};


export type Subscription_RootSearch_GamersArgs = {
  args: Search_Gamers_Args;
  distinct_on?: Maybe<Array<Parties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Parties_Order_By>>;
  where?: Maybe<Parties_Bool_Exp>;
};


export type Subscription_RootSearch_Gamers_AggregateArgs = {
  args: Search_Gamers_Args;
  distinct_on?: Maybe<Array<Parties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Parties_Order_By>>;
  where?: Maybe<Parties_Bool_Exp>;
};


export type Subscription_RootSeriesArgs = {
  distinct_on?: Maybe<Array<Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Order_By>>;
  where?: Maybe<Series_Bool_Exp>;
};


export type Subscription_RootSeries_AggregateArgs = {
  distinct_on?: Maybe<Array<Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Order_By>>;
  where?: Maybe<Series_Bool_Exp>;
};


export type Subscription_RootSeries_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSeries_SponsorsArgs = {
  distinct_on?: Maybe<Array<Series_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Sponsors_Order_By>>;
  where?: Maybe<Series_Sponsors_Bool_Exp>;
};


export type Subscription_RootSeries_Sponsors_AggregateArgs = {
  distinct_on?: Maybe<Array<Series_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Sponsors_Order_By>>;
  where?: Maybe<Series_Sponsors_Bool_Exp>;
};


export type Subscription_RootSeries_Sponsors_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSeries_Sponsors_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Series_Sponsors_Stream_Cursor_Input>>;
  where?: Maybe<Series_Sponsors_Bool_Exp>;
};


export type Subscription_RootSeries_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Series_Stream_Cursor_Input>>;
  where?: Maybe<Series_Bool_Exp>;
};


export type Subscription_RootSeries_TournamentsArgs = {
  distinct_on?: Maybe<Array<Series_Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Tournaments_Order_By>>;
  where?: Maybe<Series_Tournaments_Bool_Exp>;
};


export type Subscription_RootSeries_Tournaments_AggregateArgs = {
  distinct_on?: Maybe<Array<Series_Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Tournaments_Order_By>>;
  where?: Maybe<Series_Tournaments_Bool_Exp>;
};


export type Subscription_RootSeries_Tournaments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSeries_Tournaments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Series_Tournaments_Stream_Cursor_Input>>;
  where?: Maybe<Series_Tournaments_Bool_Exp>;
};


export type Subscription_RootStage_ParticipantsArgs = {
  args: Stage_Participants_Args;
  distinct_on?: Maybe<Array<Parties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Parties_Order_By>>;
  where?: Maybe<Parties_Bool_Exp>;
};


export type Subscription_RootStage_Participants_AggregateArgs = {
  args: Stage_Participants_Args;
  distinct_on?: Maybe<Array<Parties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Parties_Order_By>>;
  where?: Maybe<Parties_Bool_Exp>;
};


export type Subscription_RootStatusesArgs = {
  distinct_on?: Maybe<Array<Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Statuses_Order_By>>;
  where?: Maybe<Statuses_Bool_Exp>;
};


export type Subscription_RootStatuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Statuses_Order_By>>;
  where?: Maybe<Statuses_Bool_Exp>;
};


export type Subscription_RootStatuses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootStatuses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Statuses_Stream_Cursor_Input>>;
  where?: Maybe<Statuses_Bool_Exp>;
};


export type Subscription_RootTournament_DetailsArgs = {
  distinct_on?: Maybe<Array<Tournament_Details_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Details_Order_By>>;
  where?: Maybe<Tournament_Details_Bool_Exp>;
};


export type Subscription_RootTournament_Details_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Details_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Details_Order_By>>;
  where?: Maybe<Tournament_Details_Bool_Exp>;
};


export type Subscription_RootTournament_Details_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTournament_Details_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Tournament_Details_Stream_Cursor_Input>>;
  where?: Maybe<Tournament_Details_Bool_Exp>;
};


export type Subscription_RootTournament_FlagsArgs = {
  distinct_on?: Maybe<Array<Tournament_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Flags_Order_By>>;
  where?: Maybe<Tournament_Flags_Bool_Exp>;
};


export type Subscription_RootTournament_Flags_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Flags_Order_By>>;
  where?: Maybe<Tournament_Flags_Bool_Exp>;
};


export type Subscription_RootTournament_Flags_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTournament_Flags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Tournament_Flags_Stream_Cursor_Input>>;
  where?: Maybe<Tournament_Flags_Bool_Exp>;
};


export type Subscription_RootTournament_InvitesArgs = {
  distinct_on?: Maybe<Array<Tournament_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Invites_Order_By>>;
  where?: Maybe<Tournament_Invites_Bool_Exp>;
};


export type Subscription_RootTournament_Invites_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Invites_Order_By>>;
  where?: Maybe<Tournament_Invites_Bool_Exp>;
};


export type Subscription_RootTournament_Invites_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTournament_Invites_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Tournament_Invites_Stream_Cursor_Input>>;
  where?: Maybe<Tournament_Invites_Bool_Exp>;
};


export type Subscription_RootTournament_RegistrationsArgs = {
  distinct_on?: Maybe<Array<Tournament_Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Registrations_Order_By>>;
  where?: Maybe<Tournament_Registrations_Bool_Exp>;
};


export type Subscription_RootTournament_Registrations_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Registrations_Order_By>>;
  where?: Maybe<Tournament_Registrations_Bool_Exp>;
};


export type Subscription_RootTournament_Registrations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTournament_Registrations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Tournament_Registrations_Stream_Cursor_Input>>;
  where?: Maybe<Tournament_Registrations_Bool_Exp>;
};


export type Subscription_RootTournament_ResultsArgs = {
  distinct_on?: Maybe<Array<Tournament_Results_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Results_Order_By>>;
  where?: Maybe<Tournament_Results_Bool_Exp>;
};


export type Subscription_RootTournament_Results_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Results_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Results_Order_By>>;
  where?: Maybe<Tournament_Results_Bool_Exp>;
};


export type Subscription_RootTournament_Results_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTournament_Results_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Tournament_Results_Stream_Cursor_Input>>;
  where?: Maybe<Tournament_Results_Bool_Exp>;
};


export type Subscription_RootTournament_RewardsArgs = {
  distinct_on?: Maybe<Array<Tournament_Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Rewards_Order_By>>;
  where?: Maybe<Tournament_Rewards_Bool_Exp>;
};


export type Subscription_RootTournament_Rewards_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Rewards_Order_By>>;
  where?: Maybe<Tournament_Rewards_Bool_Exp>;
};


export type Subscription_RootTournament_Rewards_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTournament_Rewards_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Tournament_Rewards_Stream_Cursor_Input>>;
  where?: Maybe<Tournament_Rewards_Bool_Exp>;
};


export type Subscription_RootTournament_SponsorsArgs = {
  distinct_on?: Maybe<Array<Tournament_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Sponsors_Order_By>>;
  where?: Maybe<Tournament_Sponsors_Bool_Exp>;
};


export type Subscription_RootTournament_Sponsors_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Sponsors_Order_By>>;
  where?: Maybe<Tournament_Sponsors_Bool_Exp>;
};


export type Subscription_RootTournament_Sponsors_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTournament_Sponsors_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Tournament_Sponsors_Stream_Cursor_Input>>;
  where?: Maybe<Tournament_Sponsors_Bool_Exp>;
};


export type Subscription_RootTournament_StagesArgs = {
  distinct_on?: Maybe<Array<Tournament_Stages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Stages_Order_By>>;
  where?: Maybe<Tournament_Stages_Bool_Exp>;
};


export type Subscription_RootTournament_Stages_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Stages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Stages_Order_By>>;
  where?: Maybe<Tournament_Stages_Bool_Exp>;
};


export type Subscription_RootTournament_Stages_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTournament_Stages_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Tournament_Stages_Stream_Cursor_Input>>;
  where?: Maybe<Tournament_Stages_Bool_Exp>;
};


export type Subscription_RootTournament_StatusesArgs = {
  distinct_on?: Maybe<Array<Tournament_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Statuses_Order_By>>;
  where?: Maybe<Tournament_Statuses_Bool_Exp>;
};


export type Subscription_RootTournament_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Statuses_Order_By>>;
  where?: Maybe<Tournament_Statuses_Bool_Exp>;
};


export type Subscription_RootTournament_Statuses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTournament_Statuses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Tournament_Statuses_Stream_Cursor_Input>>;
  where?: Maybe<Tournament_Statuses_Bool_Exp>;
};


export type Subscription_RootTournamentsArgs = {
  distinct_on?: Maybe<Array<Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournaments_Order_By>>;
  where?: Maybe<Tournaments_Bool_Exp>;
};


export type Subscription_RootTournaments_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournaments_Order_By>>;
  where?: Maybe<Tournaments_Bool_Exp>;
};


export type Subscription_RootTournaments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTournaments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Tournaments_Stream_Cursor_Input>>;
  where?: Maybe<Tournaments_Bool_Exp>;
};


export type Subscription_RootTypesArgs = {
  distinct_on?: Maybe<Array<Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Types_Order_By>>;
  where?: Maybe<Types_Bool_Exp>;
};


export type Subscription_RootTypes_AggregateArgs = {
  distinct_on?: Maybe<Array<Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Types_Order_By>>;
  where?: Maybe<Types_Bool_Exp>;
};


export type Subscription_RootTypes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTypes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Types_Stream_Cursor_Input>>;
  where?: Maybe<Types_Bool_Exp>;
};


export type Subscription_RootUser_FlagsArgs = {
  distinct_on?: Maybe<Array<User_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Flags_Order_By>>;
  where?: Maybe<User_Flags_Bool_Exp>;
};


export type Subscription_RootUser_Flags_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Flags_Order_By>>;
  where?: Maybe<User_Flags_Bool_Exp>;
};


export type Subscription_RootUser_Flags_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Flags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Flags_Stream_Cursor_Input>>;
  where?: Maybe<User_Flags_Bool_Exp>;
};


export type Subscription_RootUser_Mfa_FactorsArgs = {
  distinct_on?: Maybe<Array<User_Mfa_Factors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Mfa_Factors_Order_By>>;
  where?: Maybe<User_Mfa_Factors_Bool_Exp>;
};


export type Subscription_RootUser_Mfa_Factors_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Mfa_Factors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Mfa_Factors_Order_By>>;
  where?: Maybe<User_Mfa_Factors_Bool_Exp>;
};


export type Subscription_RootUser_Mfa_Factors_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Mfa_Factors_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Mfa_Factors_Stream_Cursor_Input>>;
  where?: Maybe<User_Mfa_Factors_Bool_Exp>;
};


export type Subscription_RootUser_StatusesArgs = {
  distinct_on?: Maybe<Array<User_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Statuses_Order_By>>;
  where?: Maybe<User_Statuses_Bool_Exp>;
};


export type Subscription_RootUser_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Statuses_Order_By>>;
  where?: Maybe<User_Statuses_Bool_Exp>;
};


export type Subscription_RootUser_Statuses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Statuses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Statuses_Stream_Cursor_Input>>;
  where?: Maybe<User_Statuses_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Users_Stream_Cursor_Input>>;
  where?: Maybe<Users_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "tournament_details" */
export type Tournament_Details = {
  __typename?: 'tournament_details';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  key: Scalars['String'];
  /** An object relationship */
  tournament: Tournaments;
  tournament_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  value?: Maybe<Scalars['String']>;
};

/** aggregated selection of "tournament_details" */
export type Tournament_Details_Aggregate = {
  __typename?: 'tournament_details_aggregate';
  aggregate?: Maybe<Tournament_Details_Aggregate_Fields>;
  nodes: Array<Tournament_Details>;
};

export type Tournament_Details_Aggregate_Bool_Exp = {
  count?: Maybe<Tournament_Details_Aggregate_Bool_Exp_Count>;
};

export type Tournament_Details_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Tournament_Details_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tournament_Details_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tournament_details" */
export type Tournament_Details_Aggregate_Fields = {
  __typename?: 'tournament_details_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Tournament_Details_Max_Fields>;
  min?: Maybe<Tournament_Details_Min_Fields>;
};


/** aggregate fields of "tournament_details" */
export type Tournament_Details_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Tournament_Details_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tournament_details" */
export type Tournament_Details_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Tournament_Details_Max_Order_By>;
  min?: Maybe<Tournament_Details_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tournament_details" */
export type Tournament_Details_Arr_Rel_Insert_Input = {
  data: Array<Tournament_Details_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Tournament_Details_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tournament_details". All fields are combined with a logical 'AND'. */
export type Tournament_Details_Bool_Exp = {
  _and?: Maybe<Array<Tournament_Details_Bool_Exp>>;
  _not?: Maybe<Tournament_Details_Bool_Exp>;
  _or?: Maybe<Array<Tournament_Details_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  key?: Maybe<String_Comparison_Exp>;
  tournament?: Maybe<Tournaments_Bool_Exp>;
  tournament_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tournament_details" */
export enum Tournament_Details_Constraint {
  /** unique or primary key constraint on columns "id" */
  TournamentDetailsPkey = 'tournament_details_pkey',
  /** unique or primary key constraint on columns "key", "tournament_id" */
  UniqueTournamentDetail = 'unique_tournament_detail'
}

/** input type for inserting data into table "tournament_details" */
export type Tournament_Details_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  tournament?: Maybe<Tournaments_Obj_Rel_Insert_Input>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Tournament_Details_Max_Fields = {
  __typename?: 'tournament_details_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "tournament_details" */
export type Tournament_Details_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Tournament_Details_Min_Fields = {
  __typename?: 'tournament_details_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "tournament_details" */
export type Tournament_Details_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "tournament_details" */
export type Tournament_Details_Mutation_Response = {
  __typename?: 'tournament_details_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tournament_Details>;
};

/** on_conflict condition type for table "tournament_details" */
export type Tournament_Details_On_Conflict = {
  constraint: Tournament_Details_Constraint;
  update_columns?: Array<Tournament_Details_Update_Column>;
  where?: Maybe<Tournament_Details_Bool_Exp>;
};

/** Ordering options when selecting data from "tournament_details". */
export type Tournament_Details_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  tournament?: Maybe<Tournaments_Order_By>;
  tournament_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: tournament_details */
export type Tournament_Details_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "tournament_details" */
export enum Tournament_Details_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  TournamentId = 'tournament_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "tournament_details" */
export type Tournament_Details_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "tournament_details" */
export type Tournament_Details_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tournament_Details_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tournament_Details_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "tournament_details" */
export enum Tournament_Details_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  TournamentId = 'tournament_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Tournament_Details_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Tournament_Details_Set_Input>;
  where: Tournament_Details_Bool_Exp;
};

/** columns and relationships of "tournament_flags" */
export type Tournament_Flags = {
  __typename?: 'tournament_flags';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  flag: Flags;
  flag_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  tournament: Tournaments;
  tournament_id: Scalars['uuid'];
};

/** aggregated selection of "tournament_flags" */
export type Tournament_Flags_Aggregate = {
  __typename?: 'tournament_flags_aggregate';
  aggregate?: Maybe<Tournament_Flags_Aggregate_Fields>;
  nodes: Array<Tournament_Flags>;
};

export type Tournament_Flags_Aggregate_Bool_Exp = {
  count?: Maybe<Tournament_Flags_Aggregate_Bool_Exp_Count>;
};

export type Tournament_Flags_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Tournament_Flags_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tournament_Flags_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tournament_flags" */
export type Tournament_Flags_Aggregate_Fields = {
  __typename?: 'tournament_flags_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Tournament_Flags_Max_Fields>;
  min?: Maybe<Tournament_Flags_Min_Fields>;
};


/** aggregate fields of "tournament_flags" */
export type Tournament_Flags_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Tournament_Flags_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tournament_flags" */
export type Tournament_Flags_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Tournament_Flags_Max_Order_By>;
  min?: Maybe<Tournament_Flags_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tournament_flags" */
export type Tournament_Flags_Arr_Rel_Insert_Input = {
  data: Array<Tournament_Flags_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Tournament_Flags_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tournament_flags". All fields are combined with a logical 'AND'. */
export type Tournament_Flags_Bool_Exp = {
  _and?: Maybe<Array<Tournament_Flags_Bool_Exp>>;
  _not?: Maybe<Tournament_Flags_Bool_Exp>;
  _or?: Maybe<Array<Tournament_Flags_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  flag?: Maybe<Flags_Bool_Exp>;
  flag_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  tournament?: Maybe<Tournaments_Bool_Exp>;
  tournament_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "tournament_flags" */
export enum Tournament_Flags_Constraint {
  /** unique or primary key constraint on columns "id" */
  TournamentFlagsPkey = 'tournament_flags_pkey'
}

/** input type for inserting data into table "tournament_flags" */
export type Tournament_Flags_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  flag?: Maybe<Flags_Obj_Rel_Insert_Input>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  tournament?: Maybe<Tournaments_Obj_Rel_Insert_Input>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Tournament_Flags_Max_Fields = {
  __typename?: 'tournament_flags_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "tournament_flags" */
export type Tournament_Flags_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  flag_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Tournament_Flags_Min_Fields = {
  __typename?: 'tournament_flags_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "tournament_flags" */
export type Tournament_Flags_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  flag_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "tournament_flags" */
export type Tournament_Flags_Mutation_Response = {
  __typename?: 'tournament_flags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tournament_Flags>;
};

/** on_conflict condition type for table "tournament_flags" */
export type Tournament_Flags_On_Conflict = {
  constraint: Tournament_Flags_Constraint;
  update_columns?: Array<Tournament_Flags_Update_Column>;
  where?: Maybe<Tournament_Flags_Bool_Exp>;
};

/** Ordering options when selecting data from "tournament_flags". */
export type Tournament_Flags_Order_By = {
  created_at?: Maybe<Order_By>;
  flag?: Maybe<Flags_Order_By>;
  flag_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  tournament?: Maybe<Tournaments_Order_By>;
  tournament_id?: Maybe<Order_By>;
};

/** primary key columns input for table: tournament_flags */
export type Tournament_Flags_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "tournament_flags" */
export enum Tournament_Flags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlagId = 'flag_id',
  /** column name */
  Id = 'id',
  /** column name */
  TournamentId = 'tournament_id'
}

/** input type for updating data in table "tournament_flags" */
export type Tournament_Flags_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "tournament_flags" */
export type Tournament_Flags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tournament_Flags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tournament_Flags_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "tournament_flags" */
export enum Tournament_Flags_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlagId = 'flag_id',
  /** column name */
  Id = 'id',
  /** column name */
  TournamentId = 'tournament_id'
}

export type Tournament_Flags_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Tournament_Flags_Set_Input>;
  where: Tournament_Flags_Bool_Exp;
};

/** columns and relationships of "tournament_invites" */
export type Tournament_Invites = {
  __typename?: 'tournament_invites';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  invite_id: Scalars['uuid'];
  /** An object relationship */
  party: Parties;
  /** An object relationship */
  status: Statuses;
  status_id: Scalars['uuid'];
  /** An object relationship */
  tournament: Tournaments;
  tournament_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "tournament_invites" */
export type Tournament_Invites_Aggregate = {
  __typename?: 'tournament_invites_aggregate';
  aggregate?: Maybe<Tournament_Invites_Aggregate_Fields>;
  nodes: Array<Tournament_Invites>;
};

export type Tournament_Invites_Aggregate_Bool_Exp = {
  count?: Maybe<Tournament_Invites_Aggregate_Bool_Exp_Count>;
};

export type Tournament_Invites_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Tournament_Invites_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tournament_Invites_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tournament_invites" */
export type Tournament_Invites_Aggregate_Fields = {
  __typename?: 'tournament_invites_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Tournament_Invites_Max_Fields>;
  min?: Maybe<Tournament_Invites_Min_Fields>;
};


/** aggregate fields of "tournament_invites" */
export type Tournament_Invites_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Tournament_Invites_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tournament_invites" */
export type Tournament_Invites_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Tournament_Invites_Max_Order_By>;
  min?: Maybe<Tournament_Invites_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tournament_invites" */
export type Tournament_Invites_Arr_Rel_Insert_Input = {
  data: Array<Tournament_Invites_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Tournament_Invites_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tournament_invites". All fields are combined with a logical 'AND'. */
export type Tournament_Invites_Bool_Exp = {
  _and?: Maybe<Array<Tournament_Invites_Bool_Exp>>;
  _not?: Maybe<Tournament_Invites_Bool_Exp>;
  _or?: Maybe<Array<Tournament_Invites_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  invite_id?: Maybe<Uuid_Comparison_Exp>;
  party?: Maybe<Parties_Bool_Exp>;
  status?: Maybe<Statuses_Bool_Exp>;
  status_id?: Maybe<Uuid_Comparison_Exp>;
  tournament?: Maybe<Tournaments_Bool_Exp>;
  tournament_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "tournament_invites" */
export enum Tournament_Invites_Constraint {
  /** unique or primary key constraint on columns "id" */
  TournamentInvitesPkey = 'tournament_invites_pkey',
  /** unique or primary key constraint on columns "invite_id", "tournament_id" */
  UniqueTournamentInvites = 'unique_tournament_invites'
}

/** input type for inserting data into table "tournament_invites" */
export type Tournament_Invites_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invite_id?: Maybe<Scalars['uuid']>;
  party?: Maybe<Parties_Obj_Rel_Insert_Input>;
  status?: Maybe<Statuses_Obj_Rel_Insert_Input>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament?: Maybe<Tournaments_Obj_Rel_Insert_Input>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Tournament_Invites_Max_Fields = {
  __typename?: 'tournament_invites_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invite_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "tournament_invites" */
export type Tournament_Invites_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invite_id?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Tournament_Invites_Min_Fields = {
  __typename?: 'tournament_invites_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invite_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "tournament_invites" */
export type Tournament_Invites_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invite_id?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "tournament_invites" */
export type Tournament_Invites_Mutation_Response = {
  __typename?: 'tournament_invites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tournament_Invites>;
};

/** on_conflict condition type for table "tournament_invites" */
export type Tournament_Invites_On_Conflict = {
  constraint: Tournament_Invites_Constraint;
  update_columns?: Array<Tournament_Invites_Update_Column>;
  where?: Maybe<Tournament_Invites_Bool_Exp>;
};

/** Ordering options when selecting data from "tournament_invites". */
export type Tournament_Invites_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invite_id?: Maybe<Order_By>;
  party?: Maybe<Parties_Order_By>;
  status?: Maybe<Statuses_Order_By>;
  status_id?: Maybe<Order_By>;
  tournament?: Maybe<Tournaments_Order_By>;
  tournament_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: tournament_invites */
export type Tournament_Invites_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "tournament_invites" */
export enum Tournament_Invites_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InviteId = 'invite_id',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TournamentId = 'tournament_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "tournament_invites" */
export type Tournament_Invites_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invite_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "tournament_invites" */
export type Tournament_Invites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tournament_Invites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tournament_Invites_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invite_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "tournament_invites" */
export enum Tournament_Invites_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InviteId = 'invite_id',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TournamentId = 'tournament_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Tournament_Invites_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Tournament_Invites_Set_Input>;
  where: Tournament_Invites_Bool_Exp;
};

/** columns and relationships of "tournament_registrations" */
export type Tournament_Registrations = {
  __typename?: 'tournament_registrations';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  party: Parties;
  /** An object relationship */
  partyByRegisteredById: Parties;
  party_id: Scalars['uuid'];
  registered_by_id: Scalars['uuid'];
  /** An object relationship */
  status: Statuses;
  status_id: Scalars['uuid'];
  /** An object relationship */
  tournament: Tournaments;
  tournament_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "tournament_registrations" */
export type Tournament_Registrations_Aggregate = {
  __typename?: 'tournament_registrations_aggregate';
  aggregate?: Maybe<Tournament_Registrations_Aggregate_Fields>;
  nodes: Array<Tournament_Registrations>;
};

export type Tournament_Registrations_Aggregate_Bool_Exp = {
  count?: Maybe<Tournament_Registrations_Aggregate_Bool_Exp_Count>;
};

export type Tournament_Registrations_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Tournament_Registrations_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tournament_Registrations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tournament_registrations" */
export type Tournament_Registrations_Aggregate_Fields = {
  __typename?: 'tournament_registrations_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Tournament_Registrations_Max_Fields>;
  min?: Maybe<Tournament_Registrations_Min_Fields>;
};


/** aggregate fields of "tournament_registrations" */
export type Tournament_Registrations_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Tournament_Registrations_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tournament_registrations" */
export type Tournament_Registrations_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Tournament_Registrations_Max_Order_By>;
  min?: Maybe<Tournament_Registrations_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tournament_registrations" */
export type Tournament_Registrations_Arr_Rel_Insert_Input = {
  data: Array<Tournament_Registrations_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Tournament_Registrations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tournament_registrations". All fields are combined with a logical 'AND'. */
export type Tournament_Registrations_Bool_Exp = {
  _and?: Maybe<Array<Tournament_Registrations_Bool_Exp>>;
  _not?: Maybe<Tournament_Registrations_Bool_Exp>;
  _or?: Maybe<Array<Tournament_Registrations_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  party?: Maybe<Parties_Bool_Exp>;
  partyByRegisteredById?: Maybe<Parties_Bool_Exp>;
  party_id?: Maybe<Uuid_Comparison_Exp>;
  registered_by_id?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<Statuses_Bool_Exp>;
  status_id?: Maybe<Uuid_Comparison_Exp>;
  tournament?: Maybe<Tournaments_Bool_Exp>;
  tournament_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "tournament_registrations" */
export enum Tournament_Registrations_Constraint {
  /** unique or primary key constraint on columns "id" */
  TournamentRegistrationsPkey = 'tournament_registrations_pkey',
  /** unique or primary key constraint on columns "tournament_id", "party_id" */
  UniqueTournamentRegistrations = 'unique_tournament_registrations'
}

/** input type for inserting data into table "tournament_registrations" */
export type Tournament_Registrations_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party?: Maybe<Parties_Obj_Rel_Insert_Input>;
  partyByRegisteredById?: Maybe<Parties_Obj_Rel_Insert_Input>;
  party_id?: Maybe<Scalars['uuid']>;
  registered_by_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Statuses_Obj_Rel_Insert_Input>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament?: Maybe<Tournaments_Obj_Rel_Insert_Input>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Tournament_Registrations_Max_Fields = {
  __typename?: 'tournament_registrations_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  registered_by_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "tournament_registrations" */
export type Tournament_Registrations_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  party_id?: Maybe<Order_By>;
  registered_by_id?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Tournament_Registrations_Min_Fields = {
  __typename?: 'tournament_registrations_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  registered_by_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "tournament_registrations" */
export type Tournament_Registrations_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  party_id?: Maybe<Order_By>;
  registered_by_id?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "tournament_registrations" */
export type Tournament_Registrations_Mutation_Response = {
  __typename?: 'tournament_registrations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tournament_Registrations>;
};

/** on_conflict condition type for table "tournament_registrations" */
export type Tournament_Registrations_On_Conflict = {
  constraint: Tournament_Registrations_Constraint;
  update_columns?: Array<Tournament_Registrations_Update_Column>;
  where?: Maybe<Tournament_Registrations_Bool_Exp>;
};

/** Ordering options when selecting data from "tournament_registrations". */
export type Tournament_Registrations_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  party?: Maybe<Parties_Order_By>;
  partyByRegisteredById?: Maybe<Parties_Order_By>;
  party_id?: Maybe<Order_By>;
  registered_by_id?: Maybe<Order_By>;
  status?: Maybe<Statuses_Order_By>;
  status_id?: Maybe<Order_By>;
  tournament?: Maybe<Tournaments_Order_By>;
  tournament_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: tournament_registrations */
export type Tournament_Registrations_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "tournament_registrations" */
export enum Tournament_Registrations_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PartyId = 'party_id',
  /** column name */
  RegisteredById = 'registered_by_id',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TournamentId = 'tournament_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "tournament_registrations" */
export type Tournament_Registrations_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  registered_by_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "tournament_registrations" */
export type Tournament_Registrations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tournament_Registrations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tournament_Registrations_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  registered_by_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "tournament_registrations" */
export enum Tournament_Registrations_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PartyId = 'party_id',
  /** column name */
  RegisteredById = 'registered_by_id',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TournamentId = 'tournament_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Tournament_Registrations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Tournament_Registrations_Set_Input>;
  where: Tournament_Registrations_Bool_Exp;
};

/** columns and relationships of "tournament_results" */
export type Tournament_Results = {
  __typename?: 'tournament_results';
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  match: Matches;
  match_id: Scalars['uuid'];
  /** An object relationship */
  party: Parties;
  recorded_by: Scalars['uuid'];
  result: Scalars['jsonb'];
  /** An object relationship */
  tournament: Tournaments;
  tournament_id: Scalars['uuid'];
};


/** columns and relationships of "tournament_results" */
export type Tournament_ResultsResultArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "tournament_results" */
export type Tournament_Results_Aggregate = {
  __typename?: 'tournament_results_aggregate';
  aggregate?: Maybe<Tournament_Results_Aggregate_Fields>;
  nodes: Array<Tournament_Results>;
};

export type Tournament_Results_Aggregate_Bool_Exp = {
  count?: Maybe<Tournament_Results_Aggregate_Bool_Exp_Count>;
};

export type Tournament_Results_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Tournament_Results_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tournament_Results_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tournament_results" */
export type Tournament_Results_Aggregate_Fields = {
  __typename?: 'tournament_results_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Tournament_Results_Max_Fields>;
  min?: Maybe<Tournament_Results_Min_Fields>;
};


/** aggregate fields of "tournament_results" */
export type Tournament_Results_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Tournament_Results_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tournament_results" */
export type Tournament_Results_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Tournament_Results_Max_Order_By>;
  min?: Maybe<Tournament_Results_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tournament_Results_Append_Input = {
  result?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "tournament_results" */
export type Tournament_Results_Arr_Rel_Insert_Input = {
  data: Array<Tournament_Results_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Tournament_Results_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tournament_results". All fields are combined with a logical 'AND'. */
export type Tournament_Results_Bool_Exp = {
  _and?: Maybe<Array<Tournament_Results_Bool_Exp>>;
  _not?: Maybe<Tournament_Results_Bool_Exp>;
  _or?: Maybe<Array<Tournament_Results_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  match?: Maybe<Matches_Bool_Exp>;
  match_id?: Maybe<Uuid_Comparison_Exp>;
  party?: Maybe<Parties_Bool_Exp>;
  recorded_by?: Maybe<Uuid_Comparison_Exp>;
  result?: Maybe<Jsonb_Comparison_Exp>;
  tournament?: Maybe<Tournaments_Bool_Exp>;
  tournament_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "tournament_results" */
export enum Tournament_Results_Constraint {
  /** unique or primary key constraint on columns "id" */
  TournamentResultsPkey = 'tournament_results_pkey',
  /** unique or primary key constraint on columns "tournament_id", "match_id" */
  UniqueTournamentResults = 'unique_tournament_results'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tournament_Results_Delete_At_Path_Input = {
  result?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tournament_Results_Delete_Elem_Input = {
  result?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tournament_Results_Delete_Key_Input = {
  result?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "tournament_results" */
export type Tournament_Results_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  match?: Maybe<Matches_Obj_Rel_Insert_Input>;
  match_id?: Maybe<Scalars['uuid']>;
  party?: Maybe<Parties_Obj_Rel_Insert_Input>;
  recorded_by?: Maybe<Scalars['uuid']>;
  result?: Maybe<Scalars['jsonb']>;
  tournament?: Maybe<Tournaments_Obj_Rel_Insert_Input>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Tournament_Results_Max_Fields = {
  __typename?: 'tournament_results_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
  recorded_by?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "tournament_results" */
export type Tournament_Results_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  match_id?: Maybe<Order_By>;
  recorded_by?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Tournament_Results_Min_Fields = {
  __typename?: 'tournament_results_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
  recorded_by?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "tournament_results" */
export type Tournament_Results_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  match_id?: Maybe<Order_By>;
  recorded_by?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "tournament_results" */
export type Tournament_Results_Mutation_Response = {
  __typename?: 'tournament_results_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tournament_Results>;
};

/** on_conflict condition type for table "tournament_results" */
export type Tournament_Results_On_Conflict = {
  constraint: Tournament_Results_Constraint;
  update_columns?: Array<Tournament_Results_Update_Column>;
  where?: Maybe<Tournament_Results_Bool_Exp>;
};

/** Ordering options when selecting data from "tournament_results". */
export type Tournament_Results_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  match?: Maybe<Matches_Order_By>;
  match_id?: Maybe<Order_By>;
  party?: Maybe<Parties_Order_By>;
  recorded_by?: Maybe<Order_By>;
  result?: Maybe<Order_By>;
  tournament?: Maybe<Tournaments_Order_By>;
  tournament_id?: Maybe<Order_By>;
};

/** primary key columns input for table: tournament_results */
export type Tournament_Results_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tournament_Results_Prepend_Input = {
  result?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "tournament_results" */
export enum Tournament_Results_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  RecordedBy = 'recorded_by',
  /** column name */
  Result = 'result',
  /** column name */
  TournamentId = 'tournament_id'
}

/** input type for updating data in table "tournament_results" */
export type Tournament_Results_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
  recorded_by?: Maybe<Scalars['uuid']>;
  result?: Maybe<Scalars['jsonb']>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "tournament_results" */
export type Tournament_Results_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tournament_Results_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tournament_Results_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
  recorded_by?: Maybe<Scalars['uuid']>;
  result?: Maybe<Scalars['jsonb']>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "tournament_results" */
export enum Tournament_Results_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  RecordedBy = 'recorded_by',
  /** column name */
  Result = 'result',
  /** column name */
  TournamentId = 'tournament_id'
}

export type Tournament_Results_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Tournament_Results_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Tournament_Results_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Tournament_Results_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Tournament_Results_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Tournament_Results_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Tournament_Results_Set_Input>;
  where: Tournament_Results_Bool_Exp;
};

/** columns and relationships of "tournament_rewards" */
export type Tournament_Rewards = {
  __typename?: 'tournament_rewards';
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  reward: Rewards;
  reward_id: Scalars['uuid'];
  /** An object relationship */
  tournament: Tournaments;
  tournament_id: Scalars['uuid'];
  value: Scalars['float8'];
};

/** aggregated selection of "tournament_rewards" */
export type Tournament_Rewards_Aggregate = {
  __typename?: 'tournament_rewards_aggregate';
  aggregate?: Maybe<Tournament_Rewards_Aggregate_Fields>;
  nodes: Array<Tournament_Rewards>;
};

export type Tournament_Rewards_Aggregate_Bool_Exp = {
  avg?: Maybe<Tournament_Rewards_Aggregate_Bool_Exp_Avg>;
  corr?: Maybe<Tournament_Rewards_Aggregate_Bool_Exp_Corr>;
  count?: Maybe<Tournament_Rewards_Aggregate_Bool_Exp_Count>;
  covar_samp?: Maybe<Tournament_Rewards_Aggregate_Bool_Exp_Covar_Samp>;
  max?: Maybe<Tournament_Rewards_Aggregate_Bool_Exp_Max>;
  min?: Maybe<Tournament_Rewards_Aggregate_Bool_Exp_Min>;
  stddev_samp?: Maybe<Tournament_Rewards_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: Maybe<Tournament_Rewards_Aggregate_Bool_Exp_Sum>;
  var_samp?: Maybe<Tournament_Rewards_Aggregate_Bool_Exp_Var_Samp>;
};

export type Tournament_Rewards_Aggregate_Bool_Exp_Avg = {
  arguments: Tournament_Rewards_Select_Column_Tournament_Rewards_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tournament_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tournament_Rewards_Aggregate_Bool_Exp_Corr = {
  arguments: Tournament_Rewards_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tournament_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tournament_Rewards_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Tournament_Rewards_Select_Column_Tournament_Rewards_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Tournament_Rewards_Select_Column_Tournament_Rewards_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Tournament_Rewards_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Tournament_Rewards_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tournament_Rewards_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Tournament_Rewards_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Tournament_Rewards_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tournament_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tournament_Rewards_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Tournament_Rewards_Select_Column_Tournament_Rewards_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Tournament_Rewards_Select_Column_Tournament_Rewards_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Tournament_Rewards_Aggregate_Bool_Exp_Max = {
  arguments: Tournament_Rewards_Select_Column_Tournament_Rewards_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tournament_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tournament_Rewards_Aggregate_Bool_Exp_Min = {
  arguments: Tournament_Rewards_Select_Column_Tournament_Rewards_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tournament_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tournament_Rewards_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Tournament_Rewards_Select_Column_Tournament_Rewards_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tournament_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tournament_Rewards_Aggregate_Bool_Exp_Sum = {
  arguments: Tournament_Rewards_Select_Column_Tournament_Rewards_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tournament_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tournament_Rewards_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Tournament_Rewards_Select_Column_Tournament_Rewards_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tournament_Rewards_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "tournament_rewards" */
export type Tournament_Rewards_Aggregate_Fields = {
  __typename?: 'tournament_rewards_aggregate_fields';
  avg?: Maybe<Tournament_Rewards_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Tournament_Rewards_Max_Fields>;
  min?: Maybe<Tournament_Rewards_Min_Fields>;
  stddev?: Maybe<Tournament_Rewards_Stddev_Fields>;
  stddev_pop?: Maybe<Tournament_Rewards_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tournament_Rewards_Stddev_Samp_Fields>;
  sum?: Maybe<Tournament_Rewards_Sum_Fields>;
  var_pop?: Maybe<Tournament_Rewards_Var_Pop_Fields>;
  var_samp?: Maybe<Tournament_Rewards_Var_Samp_Fields>;
  variance?: Maybe<Tournament_Rewards_Variance_Fields>;
};


/** aggregate fields of "tournament_rewards" */
export type Tournament_Rewards_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Tournament_Rewards_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tournament_rewards" */
export type Tournament_Rewards_Aggregate_Order_By = {
  avg?: Maybe<Tournament_Rewards_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Tournament_Rewards_Max_Order_By>;
  min?: Maybe<Tournament_Rewards_Min_Order_By>;
  stddev?: Maybe<Tournament_Rewards_Stddev_Order_By>;
  stddev_pop?: Maybe<Tournament_Rewards_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Tournament_Rewards_Stddev_Samp_Order_By>;
  sum?: Maybe<Tournament_Rewards_Sum_Order_By>;
  var_pop?: Maybe<Tournament_Rewards_Var_Pop_Order_By>;
  var_samp?: Maybe<Tournament_Rewards_Var_Samp_Order_By>;
  variance?: Maybe<Tournament_Rewards_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tournament_rewards" */
export type Tournament_Rewards_Arr_Rel_Insert_Input = {
  data: Array<Tournament_Rewards_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Tournament_Rewards_On_Conflict>;
};

/** aggregate avg on columns */
export type Tournament_Rewards_Avg_Fields = {
  __typename?: 'tournament_rewards_avg_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "tournament_rewards" */
export type Tournament_Rewards_Avg_Order_By = {
  value?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tournament_rewards". All fields are combined with a logical 'AND'. */
export type Tournament_Rewards_Bool_Exp = {
  _and?: Maybe<Array<Tournament_Rewards_Bool_Exp>>;
  _not?: Maybe<Tournament_Rewards_Bool_Exp>;
  _or?: Maybe<Array<Tournament_Rewards_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  reward?: Maybe<Rewards_Bool_Exp>;
  reward_id?: Maybe<Uuid_Comparison_Exp>;
  tournament?: Maybe<Tournaments_Bool_Exp>;
  tournament_id?: Maybe<Uuid_Comparison_Exp>;
  value?: Maybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "tournament_rewards" */
export enum Tournament_Rewards_Constraint {
  /** unique or primary key constraint on columns "id" */
  TournamentRewardsPkey = 'tournament_rewards_pkey',
  /** unique or primary key constraint on columns "tournament_id", "reward_id" */
  UniqueTournamentRewards = 'unique_tournament_rewards'
}

/** input type for incrementing numeric columns in table "tournament_rewards" */
export type Tournament_Rewards_Inc_Input = {
  value?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "tournament_rewards" */
export type Tournament_Rewards_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  reward?: Maybe<Rewards_Obj_Rel_Insert_Input>;
  reward_id?: Maybe<Scalars['uuid']>;
  tournament?: Maybe<Tournaments_Obj_Rel_Insert_Input>;
  tournament_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Tournament_Rewards_Max_Fields = {
  __typename?: 'tournament_rewards_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  reward_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "tournament_rewards" */
export type Tournament_Rewards_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  reward_id?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Tournament_Rewards_Min_Fields = {
  __typename?: 'tournament_rewards_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  reward_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "tournament_rewards" */
export type Tournament_Rewards_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  reward_id?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "tournament_rewards" */
export type Tournament_Rewards_Mutation_Response = {
  __typename?: 'tournament_rewards_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tournament_Rewards>;
};

/** on_conflict condition type for table "tournament_rewards" */
export type Tournament_Rewards_On_Conflict = {
  constraint: Tournament_Rewards_Constraint;
  update_columns?: Array<Tournament_Rewards_Update_Column>;
  where?: Maybe<Tournament_Rewards_Bool_Exp>;
};

/** Ordering options when selecting data from "tournament_rewards". */
export type Tournament_Rewards_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  reward?: Maybe<Rewards_Order_By>;
  reward_id?: Maybe<Order_By>;
  tournament?: Maybe<Tournaments_Order_By>;
  tournament_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: tournament_rewards */
export type Tournament_Rewards_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "tournament_rewards" */
export enum Tournament_Rewards_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RewardId = 'reward_id',
  /** column name */
  TournamentId = 'tournament_id',
  /** column name */
  Value = 'value'
}

/** select "tournament_rewards_aggregate_bool_exp_avg_arguments_columns" columns of table "tournament_rewards" */
export enum Tournament_Rewards_Select_Column_Tournament_Rewards_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "tournament_rewards_aggregate_bool_exp_corr_arguments_columns" columns of table "tournament_rewards" */
export enum Tournament_Rewards_Select_Column_Tournament_Rewards_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "tournament_rewards_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "tournament_rewards" */
export enum Tournament_Rewards_Select_Column_Tournament_Rewards_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "tournament_rewards_aggregate_bool_exp_max_arguments_columns" columns of table "tournament_rewards" */
export enum Tournament_Rewards_Select_Column_Tournament_Rewards_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "tournament_rewards_aggregate_bool_exp_min_arguments_columns" columns of table "tournament_rewards" */
export enum Tournament_Rewards_Select_Column_Tournament_Rewards_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "tournament_rewards_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "tournament_rewards" */
export enum Tournament_Rewards_Select_Column_Tournament_Rewards_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "tournament_rewards_aggregate_bool_exp_sum_arguments_columns" columns of table "tournament_rewards" */
export enum Tournament_Rewards_Select_Column_Tournament_Rewards_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "tournament_rewards_aggregate_bool_exp_var_samp_arguments_columns" columns of table "tournament_rewards" */
export enum Tournament_Rewards_Select_Column_Tournament_Rewards_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "tournament_rewards" */
export type Tournament_Rewards_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  reward_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Tournament_Rewards_Stddev_Fields = {
  __typename?: 'tournament_rewards_stddev_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "tournament_rewards" */
export type Tournament_Rewards_Stddev_Order_By = {
  value?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tournament_Rewards_Stddev_Pop_Fields = {
  __typename?: 'tournament_rewards_stddev_pop_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "tournament_rewards" */
export type Tournament_Rewards_Stddev_Pop_Order_By = {
  value?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tournament_Rewards_Stddev_Samp_Fields = {
  __typename?: 'tournament_rewards_stddev_samp_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "tournament_rewards" */
export type Tournament_Rewards_Stddev_Samp_Order_By = {
  value?: Maybe<Order_By>;
};

/** Streaming cursor of the table "tournament_rewards" */
export type Tournament_Rewards_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tournament_Rewards_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tournament_Rewards_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  reward_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Tournament_Rewards_Sum_Fields = {
  __typename?: 'tournament_rewards_sum_fields';
  value?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "tournament_rewards" */
export type Tournament_Rewards_Sum_Order_By = {
  value?: Maybe<Order_By>;
};

/** update columns of table "tournament_rewards" */
export enum Tournament_Rewards_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RewardId = 'reward_id',
  /** column name */
  TournamentId = 'tournament_id',
  /** column name */
  Value = 'value'
}

export type Tournament_Rewards_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Tournament_Rewards_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Tournament_Rewards_Set_Input>;
  where: Tournament_Rewards_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tournament_Rewards_Var_Pop_Fields = {
  __typename?: 'tournament_rewards_var_pop_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "tournament_rewards" */
export type Tournament_Rewards_Var_Pop_Order_By = {
  value?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tournament_Rewards_Var_Samp_Fields = {
  __typename?: 'tournament_rewards_var_samp_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "tournament_rewards" */
export type Tournament_Rewards_Var_Samp_Order_By = {
  value?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Tournament_Rewards_Variance_Fields = {
  __typename?: 'tournament_rewards_variance_fields';
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "tournament_rewards" */
export type Tournament_Rewards_Variance_Order_By = {
  value?: Maybe<Order_By>;
};

/** columns and relationships of "tournament_sponsors" */
export type Tournament_Sponsors = {
  __typename?: 'tournament_sponsors';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  party: Parties;
  party_id: Scalars['uuid'];
  /** An object relationship */
  status: Statuses;
  status_id: Scalars['uuid'];
  /** An object relationship */
  tournament: Tournaments;
  tournament_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "tournament_sponsors" */
export type Tournament_Sponsors_Aggregate = {
  __typename?: 'tournament_sponsors_aggregate';
  aggregate?: Maybe<Tournament_Sponsors_Aggregate_Fields>;
  nodes: Array<Tournament_Sponsors>;
};

export type Tournament_Sponsors_Aggregate_Bool_Exp = {
  count?: Maybe<Tournament_Sponsors_Aggregate_Bool_Exp_Count>;
};

export type Tournament_Sponsors_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Tournament_Sponsors_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tournament_Sponsors_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tournament_sponsors" */
export type Tournament_Sponsors_Aggregate_Fields = {
  __typename?: 'tournament_sponsors_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Tournament_Sponsors_Max_Fields>;
  min?: Maybe<Tournament_Sponsors_Min_Fields>;
};


/** aggregate fields of "tournament_sponsors" */
export type Tournament_Sponsors_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Tournament_Sponsors_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tournament_sponsors" */
export type Tournament_Sponsors_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Tournament_Sponsors_Max_Order_By>;
  min?: Maybe<Tournament_Sponsors_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tournament_sponsors" */
export type Tournament_Sponsors_Arr_Rel_Insert_Input = {
  data: Array<Tournament_Sponsors_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Tournament_Sponsors_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tournament_sponsors". All fields are combined with a logical 'AND'. */
export type Tournament_Sponsors_Bool_Exp = {
  _and?: Maybe<Array<Tournament_Sponsors_Bool_Exp>>;
  _not?: Maybe<Tournament_Sponsors_Bool_Exp>;
  _or?: Maybe<Array<Tournament_Sponsors_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  party?: Maybe<Parties_Bool_Exp>;
  party_id?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<Statuses_Bool_Exp>;
  status_id?: Maybe<Uuid_Comparison_Exp>;
  tournament?: Maybe<Tournaments_Bool_Exp>;
  tournament_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "tournament_sponsors" */
export enum Tournament_Sponsors_Constraint {
  /** unique or primary key constraint on columns "id" */
  TournamentSponsorsPkey = 'tournament_sponsors_pkey',
  /** unique or primary key constraint on columns "status_id", "tournament_id", "party_id" */
  UniqueTournamentSponsors = 'unique_tournament_sponsors'
}

/** input type for inserting data into table "tournament_sponsors" */
export type Tournament_Sponsors_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party?: Maybe<Parties_Obj_Rel_Insert_Input>;
  party_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Statuses_Obj_Rel_Insert_Input>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament?: Maybe<Tournaments_Obj_Rel_Insert_Input>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Tournament_Sponsors_Max_Fields = {
  __typename?: 'tournament_sponsors_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "tournament_sponsors" */
export type Tournament_Sponsors_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  party_id?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Tournament_Sponsors_Min_Fields = {
  __typename?: 'tournament_sponsors_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "tournament_sponsors" */
export type Tournament_Sponsors_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  party_id?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "tournament_sponsors" */
export type Tournament_Sponsors_Mutation_Response = {
  __typename?: 'tournament_sponsors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tournament_Sponsors>;
};

/** on_conflict condition type for table "tournament_sponsors" */
export type Tournament_Sponsors_On_Conflict = {
  constraint: Tournament_Sponsors_Constraint;
  update_columns?: Array<Tournament_Sponsors_Update_Column>;
  where?: Maybe<Tournament_Sponsors_Bool_Exp>;
};

/** Ordering options when selecting data from "tournament_sponsors". */
export type Tournament_Sponsors_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  party?: Maybe<Parties_Order_By>;
  party_id?: Maybe<Order_By>;
  status?: Maybe<Statuses_Order_By>;
  status_id?: Maybe<Order_By>;
  tournament?: Maybe<Tournaments_Order_By>;
  tournament_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: tournament_sponsors */
export type Tournament_Sponsors_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "tournament_sponsors" */
export enum Tournament_Sponsors_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PartyId = 'party_id',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TournamentId = 'tournament_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "tournament_sponsors" */
export type Tournament_Sponsors_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "tournament_sponsors" */
export type Tournament_Sponsors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tournament_Sponsors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tournament_Sponsors_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  party_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "tournament_sponsors" */
export enum Tournament_Sponsors_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PartyId = 'party_id',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TournamentId = 'tournament_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Tournament_Sponsors_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Tournament_Sponsors_Set_Input>;
  where: Tournament_Sponsors_Bool_Exp;
};

/** columns and relationships of "tournament_stages" */
export type Tournament_Stages = {
  __typename?: 'tournament_stages';
  id: Scalars['uuid'];
  matches: Scalars['_uuid'];
  name?: Maybe<Scalars['String']>;
  next_stage_criteria?: Maybe<Scalars['jsonb']>;
  next_stage_id?: Maybe<Scalars['uuid']>;
  participants: Scalars['_uuid'];
  previous_stage_id?: Maybe<Scalars['uuid']>;
  stage_details: Scalars['jsonb'];
  /** Tournament stage matches */
  stage_matches?: Maybe<Array<Matches>>;
  /** Tournament stage participants */
  stage_participants?: Maybe<Array<Parties>>;
  /** An object relationship */
  status: Statuses;
  status_id: Scalars['uuid'];
  /** An object relationship */
  tournament: Tournaments;
  /** An object relationship */
  tournamentStageByPreviousStageId?: Maybe<Tournament_Stages>;
  /** An array relationship */
  tournamentStagesByPreviousStageId: Array<Tournament_Stages>;
  /** An aggregate relationship */
  tournamentStagesByPreviousStageId_aggregate: Tournament_Stages_Aggregate;
  tournament_id: Scalars['uuid'];
  /** An object relationship */
  tournament_stage?: Maybe<Tournament_Stages>;
  /** An array relationship */
  tournament_stages: Array<Tournament_Stages>;
  /** An aggregate relationship */
  tournament_stages_aggregate: Tournament_Stages_Aggregate;
  /** An object relationship */
  type: Types;
  type_id: Scalars['uuid'];
};


/** columns and relationships of "tournament_stages" */
export type Tournament_StagesNext_Stage_CriteriaArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "tournament_stages" */
export type Tournament_StagesStage_DetailsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "tournament_stages" */
export type Tournament_StagesStage_MatchesArgs = {
  distinct_on?: Maybe<Array<Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Matches_Order_By>>;
  where?: Maybe<Matches_Bool_Exp>;
};


/** columns and relationships of "tournament_stages" */
export type Tournament_StagesStage_ParticipantsArgs = {
  distinct_on?: Maybe<Array<Parties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Parties_Order_By>>;
  where?: Maybe<Parties_Bool_Exp>;
};


/** columns and relationships of "tournament_stages" */
export type Tournament_StagesTournamentStagesByPreviousStageIdArgs = {
  distinct_on?: Maybe<Array<Tournament_Stages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Stages_Order_By>>;
  where?: Maybe<Tournament_Stages_Bool_Exp>;
};


/** columns and relationships of "tournament_stages" */
export type Tournament_StagesTournamentStagesByPreviousStageId_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Stages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Stages_Order_By>>;
  where?: Maybe<Tournament_Stages_Bool_Exp>;
};


/** columns and relationships of "tournament_stages" */
export type Tournament_StagesTournament_StagesArgs = {
  distinct_on?: Maybe<Array<Tournament_Stages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Stages_Order_By>>;
  where?: Maybe<Tournament_Stages_Bool_Exp>;
};


/** columns and relationships of "tournament_stages" */
export type Tournament_StagesTournament_Stages_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Stages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Stages_Order_By>>;
  where?: Maybe<Tournament_Stages_Bool_Exp>;
};

/** aggregated selection of "tournament_stages" */
export type Tournament_Stages_Aggregate = {
  __typename?: 'tournament_stages_aggregate';
  aggregate?: Maybe<Tournament_Stages_Aggregate_Fields>;
  nodes: Array<Tournament_Stages>;
};

export type Tournament_Stages_Aggregate_Bool_Exp = {
  count?: Maybe<Tournament_Stages_Aggregate_Bool_Exp_Count>;
};

export type Tournament_Stages_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Tournament_Stages_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tournament_Stages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tournament_stages" */
export type Tournament_Stages_Aggregate_Fields = {
  __typename?: 'tournament_stages_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Tournament_Stages_Max_Fields>;
  min?: Maybe<Tournament_Stages_Min_Fields>;
};


/** aggregate fields of "tournament_stages" */
export type Tournament_Stages_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Tournament_Stages_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tournament_stages" */
export type Tournament_Stages_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Tournament_Stages_Max_Order_By>;
  min?: Maybe<Tournament_Stages_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tournament_Stages_Append_Input = {
  next_stage_criteria?: Maybe<Scalars['jsonb']>;
  stage_details?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "tournament_stages" */
export type Tournament_Stages_Arr_Rel_Insert_Input = {
  data: Array<Tournament_Stages_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Tournament_Stages_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tournament_stages". All fields are combined with a logical 'AND'. */
export type Tournament_Stages_Bool_Exp = {
  _and?: Maybe<Array<Tournament_Stages_Bool_Exp>>;
  _not?: Maybe<Tournament_Stages_Bool_Exp>;
  _or?: Maybe<Array<Tournament_Stages_Bool_Exp>>;
  id?: Maybe<Uuid_Comparison_Exp>;
  matches?: Maybe<_Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  next_stage_criteria?: Maybe<Jsonb_Comparison_Exp>;
  next_stage_id?: Maybe<Uuid_Comparison_Exp>;
  participants?: Maybe<_Uuid_Comparison_Exp>;
  previous_stage_id?: Maybe<Uuid_Comparison_Exp>;
  stage_details?: Maybe<Jsonb_Comparison_Exp>;
  stage_matches?: Maybe<Matches_Bool_Exp>;
  stage_participants?: Maybe<Parties_Bool_Exp>;
  status?: Maybe<Statuses_Bool_Exp>;
  status_id?: Maybe<Uuid_Comparison_Exp>;
  tournament?: Maybe<Tournaments_Bool_Exp>;
  tournamentStageByPreviousStageId?: Maybe<Tournament_Stages_Bool_Exp>;
  tournamentStagesByPreviousStageId?: Maybe<Tournament_Stages_Bool_Exp>;
  tournamentStagesByPreviousStageId_aggregate?: Maybe<Tournament_Stages_Aggregate_Bool_Exp>;
  tournament_id?: Maybe<Uuid_Comparison_Exp>;
  tournament_stage?: Maybe<Tournament_Stages_Bool_Exp>;
  tournament_stages?: Maybe<Tournament_Stages_Bool_Exp>;
  tournament_stages_aggregate?: Maybe<Tournament_Stages_Aggregate_Bool_Exp>;
  type?: Maybe<Types_Bool_Exp>;
  type_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "tournament_stages" */
export enum Tournament_Stages_Constraint {
  /** unique or primary key constraint on columns "id" */
  TournamentStagesPkey = 'tournament_stages_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tournament_Stages_Delete_At_Path_Input = {
  next_stage_criteria?: Maybe<Array<Scalars['String']>>;
  stage_details?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tournament_Stages_Delete_Elem_Input = {
  next_stage_criteria?: Maybe<Scalars['Int']>;
  stage_details?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tournament_Stages_Delete_Key_Input = {
  next_stage_criteria?: Maybe<Scalars['String']>;
  stage_details?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "tournament_stages" */
export type Tournament_Stages_Insert_Input = {
  id?: Maybe<Scalars['uuid']>;
  matches?: Maybe<Scalars['_uuid']>;
  name?: Maybe<Scalars['String']>;
  next_stage_criteria?: Maybe<Scalars['jsonb']>;
  next_stage_id?: Maybe<Scalars['uuid']>;
  participants?: Maybe<Scalars['_uuid']>;
  previous_stage_id?: Maybe<Scalars['uuid']>;
  stage_details?: Maybe<Scalars['jsonb']>;
  status?: Maybe<Statuses_Obj_Rel_Insert_Input>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament?: Maybe<Tournaments_Obj_Rel_Insert_Input>;
  tournamentStageByPreviousStageId?: Maybe<Tournament_Stages_Obj_Rel_Insert_Input>;
  tournamentStagesByPreviousStageId?: Maybe<Tournament_Stages_Arr_Rel_Insert_Input>;
  tournament_id?: Maybe<Scalars['uuid']>;
  tournament_stage?: Maybe<Tournament_Stages_Obj_Rel_Insert_Input>;
  tournament_stages?: Maybe<Tournament_Stages_Arr_Rel_Insert_Input>;
  type?: Maybe<Types_Obj_Rel_Insert_Input>;
  type_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Tournament_Stages_Max_Fields = {
  __typename?: 'tournament_stages_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  next_stage_id?: Maybe<Scalars['uuid']>;
  previous_stage_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "tournament_stages" */
export type Tournament_Stages_Max_Order_By = {
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  next_stage_id?: Maybe<Order_By>;
  previous_stage_id?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Tournament_Stages_Min_Fields = {
  __typename?: 'tournament_stages_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  next_stage_id?: Maybe<Scalars['uuid']>;
  previous_stage_id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "tournament_stages" */
export type Tournament_Stages_Min_Order_By = {
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  next_stage_id?: Maybe<Order_By>;
  previous_stage_id?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "tournament_stages" */
export type Tournament_Stages_Mutation_Response = {
  __typename?: 'tournament_stages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tournament_Stages>;
};

/** input type for inserting object relation for remote table "tournament_stages" */
export type Tournament_Stages_Obj_Rel_Insert_Input = {
  data: Tournament_Stages_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Tournament_Stages_On_Conflict>;
};

/** on_conflict condition type for table "tournament_stages" */
export type Tournament_Stages_On_Conflict = {
  constraint: Tournament_Stages_Constraint;
  update_columns?: Array<Tournament_Stages_Update_Column>;
  where?: Maybe<Tournament_Stages_Bool_Exp>;
};

/** Ordering options when selecting data from "tournament_stages". */
export type Tournament_Stages_Order_By = {
  id?: Maybe<Order_By>;
  matches?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  next_stage_criteria?: Maybe<Order_By>;
  next_stage_id?: Maybe<Order_By>;
  participants?: Maybe<Order_By>;
  previous_stage_id?: Maybe<Order_By>;
  stage_details?: Maybe<Order_By>;
  stage_matches_aggregate?: Maybe<Matches_Aggregate_Order_By>;
  stage_participants_aggregate?: Maybe<Parties_Aggregate_Order_By>;
  status?: Maybe<Statuses_Order_By>;
  status_id?: Maybe<Order_By>;
  tournament?: Maybe<Tournaments_Order_By>;
  tournamentStageByPreviousStageId?: Maybe<Tournament_Stages_Order_By>;
  tournamentStagesByPreviousStageId_aggregate?: Maybe<Tournament_Stages_Aggregate_Order_By>;
  tournament_id?: Maybe<Order_By>;
  tournament_stage?: Maybe<Tournament_Stages_Order_By>;
  tournament_stages_aggregate?: Maybe<Tournament_Stages_Aggregate_Order_By>;
  type?: Maybe<Types_Order_By>;
  type_id?: Maybe<Order_By>;
};

/** primary key columns input for table: tournament_stages */
export type Tournament_Stages_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tournament_Stages_Prepend_Input = {
  next_stage_criteria?: Maybe<Scalars['jsonb']>;
  stage_details?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "tournament_stages" */
export enum Tournament_Stages_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Matches = 'matches',
  /** column name */
  Name = 'name',
  /** column name */
  NextStageCriteria = 'next_stage_criteria',
  /** column name */
  NextStageId = 'next_stage_id',
  /** column name */
  Participants = 'participants',
  /** column name */
  PreviousStageId = 'previous_stage_id',
  /** column name */
  StageDetails = 'stage_details',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TournamentId = 'tournament_id',
  /** column name */
  TypeId = 'type_id'
}

/** input type for updating data in table "tournament_stages" */
export type Tournament_Stages_Set_Input = {
  id?: Maybe<Scalars['uuid']>;
  matches?: Maybe<Scalars['_uuid']>;
  name?: Maybe<Scalars['String']>;
  next_stage_criteria?: Maybe<Scalars['jsonb']>;
  next_stage_id?: Maybe<Scalars['uuid']>;
  participants?: Maybe<Scalars['_uuid']>;
  previous_stage_id?: Maybe<Scalars['uuid']>;
  stage_details?: Maybe<Scalars['jsonb']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "tournament_stages" */
export type Tournament_Stages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tournament_Stages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tournament_Stages_Stream_Cursor_Value_Input = {
  id?: Maybe<Scalars['uuid']>;
  matches?: Maybe<Scalars['_uuid']>;
  name?: Maybe<Scalars['String']>;
  next_stage_criteria?: Maybe<Scalars['jsonb']>;
  next_stage_id?: Maybe<Scalars['uuid']>;
  participants?: Maybe<Scalars['_uuid']>;
  previous_stage_id?: Maybe<Scalars['uuid']>;
  stage_details?: Maybe<Scalars['jsonb']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "tournament_stages" */
export enum Tournament_Stages_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Matches = 'matches',
  /** column name */
  Name = 'name',
  /** column name */
  NextStageCriteria = 'next_stage_criteria',
  /** column name */
  NextStageId = 'next_stage_id',
  /** column name */
  Participants = 'participants',
  /** column name */
  PreviousStageId = 'previous_stage_id',
  /** column name */
  StageDetails = 'stage_details',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TournamentId = 'tournament_id',
  /** column name */
  TypeId = 'type_id'
}

export type Tournament_Stages_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Tournament_Stages_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Tournament_Stages_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Tournament_Stages_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Tournament_Stages_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Tournament_Stages_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Tournament_Stages_Set_Input>;
  where: Tournament_Stages_Bool_Exp;
};

/** columns and relationships of "tournament_statuses" */
export type Tournament_Statuses = {
  __typename?: 'tournament_statuses';
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  status: Statuses;
  status_id: Scalars['uuid'];
  /** An object relationship */
  tournament: Tournaments;
  tournament_id: Scalars['uuid'];
};

/** aggregated selection of "tournament_statuses" */
export type Tournament_Statuses_Aggregate = {
  __typename?: 'tournament_statuses_aggregate';
  aggregate?: Maybe<Tournament_Statuses_Aggregate_Fields>;
  nodes: Array<Tournament_Statuses>;
};

export type Tournament_Statuses_Aggregate_Bool_Exp = {
  count?: Maybe<Tournament_Statuses_Aggregate_Bool_Exp_Count>;
};

export type Tournament_Statuses_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Tournament_Statuses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tournament_Statuses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tournament_statuses" */
export type Tournament_Statuses_Aggregate_Fields = {
  __typename?: 'tournament_statuses_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Tournament_Statuses_Max_Fields>;
  min?: Maybe<Tournament_Statuses_Min_Fields>;
};


/** aggregate fields of "tournament_statuses" */
export type Tournament_Statuses_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Tournament_Statuses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tournament_statuses" */
export type Tournament_Statuses_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Tournament_Statuses_Max_Order_By>;
  min?: Maybe<Tournament_Statuses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tournament_statuses" */
export type Tournament_Statuses_Arr_Rel_Insert_Input = {
  data: Array<Tournament_Statuses_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Tournament_Statuses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tournament_statuses". All fields are combined with a logical 'AND'. */
export type Tournament_Statuses_Bool_Exp = {
  _and?: Maybe<Array<Tournament_Statuses_Bool_Exp>>;
  _not?: Maybe<Tournament_Statuses_Bool_Exp>;
  _or?: Maybe<Array<Tournament_Statuses_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<Statuses_Bool_Exp>;
  status_id?: Maybe<Uuid_Comparison_Exp>;
  tournament?: Maybe<Tournaments_Bool_Exp>;
  tournament_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "tournament_statuses" */
export enum Tournament_Statuses_Constraint {
  /** unique or primary key constraint on columns "id" */
  TournamentStatusesPkey = 'tournament_statuses_pkey'
}

/** input type for inserting data into table "tournament_statuses" */
export type Tournament_Statuses_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Statuses_Obj_Rel_Insert_Input>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament?: Maybe<Tournaments_Obj_Rel_Insert_Input>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Tournament_Statuses_Max_Fields = {
  __typename?: 'tournament_statuses_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "tournament_statuses" */
export type Tournament_Statuses_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Tournament_Statuses_Min_Fields = {
  __typename?: 'tournament_statuses_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "tournament_statuses" */
export type Tournament_Statuses_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  tournament_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "tournament_statuses" */
export type Tournament_Statuses_Mutation_Response = {
  __typename?: 'tournament_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tournament_Statuses>;
};

/** on_conflict condition type for table "tournament_statuses" */
export type Tournament_Statuses_On_Conflict = {
  constraint: Tournament_Statuses_Constraint;
  update_columns?: Array<Tournament_Statuses_Update_Column>;
  where?: Maybe<Tournament_Statuses_Bool_Exp>;
};

/** Ordering options when selecting data from "tournament_statuses". */
export type Tournament_Statuses_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  status?: Maybe<Statuses_Order_By>;
  status_id?: Maybe<Order_By>;
  tournament?: Maybe<Tournaments_Order_By>;
  tournament_id?: Maybe<Order_By>;
};

/** primary key columns input for table: tournament_statuses */
export type Tournament_Statuses_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "tournament_statuses" */
export enum Tournament_Statuses_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TournamentId = 'tournament_id'
}

/** input type for updating data in table "tournament_statuses" */
export type Tournament_Statuses_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "tournament_statuses" */
export type Tournament_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tournament_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tournament_Statuses_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "tournament_statuses" */
export enum Tournament_Statuses_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TournamentId = 'tournament_id'
}

export type Tournament_Statuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Tournament_Statuses_Set_Input>;
  where: Tournament_Statuses_Bool_Exp;
};

/** columns and relationships of "tournaments" */
export type Tournaments = {
  __typename?: 'tournaments';
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  game: Games;
  game_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An array relationship */
  matches: Array<Matches>;
  /** An aggregate relationship */
  matches_aggregate: Matches_Aggregate;
  name: Scalars['String'];
  /** An array relationship */
  series_tournaments: Array<Series_Tournaments>;
  /** An aggregate relationship */
  series_tournaments_aggregate: Series_Tournaments_Aggregate;
  /** An object relationship */
  status: Statuses;
  status_id: Scalars['uuid'];
  tournament_date?: Maybe<Scalars['_date']>;
  /** An array relationship */
  tournament_details: Array<Tournament_Details>;
  /** An aggregate relationship */
  tournament_details_aggregate: Tournament_Details_Aggregate;
  /** An array relationship */
  tournament_flags: Array<Tournament_Flags>;
  /** An aggregate relationship */
  tournament_flags_aggregate: Tournament_Flags_Aggregate;
  /** An array relationship */
  tournament_invites: Array<Tournament_Invites>;
  /** An aggregate relationship */
  tournament_invites_aggregate: Tournament_Invites_Aggregate;
  /** An array relationship */
  tournament_registrations: Array<Tournament_Registrations>;
  /** An aggregate relationship */
  tournament_registrations_aggregate: Tournament_Registrations_Aggregate;
  /** An array relationship */
  tournament_results: Array<Tournament_Results>;
  /** An aggregate relationship */
  tournament_results_aggregate: Tournament_Results_Aggregate;
  /** An array relationship */
  tournament_rewards: Array<Tournament_Rewards>;
  /** An aggregate relationship */
  tournament_rewards_aggregate: Tournament_Rewards_Aggregate;
  /** An array relationship */
  tournament_sponsors: Array<Tournament_Sponsors>;
  /** An aggregate relationship */
  tournament_sponsors_aggregate: Tournament_Sponsors_Aggregate;
  /** An array relationship */
  tournament_stages: Array<Tournament_Stages>;
  /** An aggregate relationship */
  tournament_stages_aggregate: Tournament_Stages_Aggregate;
  /** An array relationship */
  tournament_statuses: Array<Tournament_Statuses>;
  /** An aggregate relationship */
  tournament_statuses_aggregate: Tournament_Statuses_Aggregate;
  /** An object relationship */
  type: Types;
  type_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "tournaments" */
export type TournamentsMatchesArgs = {
  distinct_on?: Maybe<Array<Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Matches_Order_By>>;
  where?: Maybe<Matches_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsMatches_AggregateArgs = {
  distinct_on?: Maybe<Array<Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Matches_Order_By>>;
  where?: Maybe<Matches_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsSeries_TournamentsArgs = {
  distinct_on?: Maybe<Array<Series_Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Tournaments_Order_By>>;
  where?: Maybe<Series_Tournaments_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsSeries_Tournaments_AggregateArgs = {
  distinct_on?: Maybe<Array<Series_Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Tournaments_Order_By>>;
  where?: Maybe<Series_Tournaments_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsTournament_DetailsArgs = {
  distinct_on?: Maybe<Array<Tournament_Details_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Details_Order_By>>;
  where?: Maybe<Tournament_Details_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsTournament_Details_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Details_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Details_Order_By>>;
  where?: Maybe<Tournament_Details_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsTournament_FlagsArgs = {
  distinct_on?: Maybe<Array<Tournament_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Flags_Order_By>>;
  where?: Maybe<Tournament_Flags_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsTournament_Flags_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Flags_Order_By>>;
  where?: Maybe<Tournament_Flags_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsTournament_InvitesArgs = {
  distinct_on?: Maybe<Array<Tournament_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Invites_Order_By>>;
  where?: Maybe<Tournament_Invites_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsTournament_Invites_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Invites_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Invites_Order_By>>;
  where?: Maybe<Tournament_Invites_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsTournament_RegistrationsArgs = {
  distinct_on?: Maybe<Array<Tournament_Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Registrations_Order_By>>;
  where?: Maybe<Tournament_Registrations_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsTournament_Registrations_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Registrations_Order_By>>;
  where?: Maybe<Tournament_Registrations_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsTournament_ResultsArgs = {
  distinct_on?: Maybe<Array<Tournament_Results_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Results_Order_By>>;
  where?: Maybe<Tournament_Results_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsTournament_Results_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Results_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Results_Order_By>>;
  where?: Maybe<Tournament_Results_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsTournament_RewardsArgs = {
  distinct_on?: Maybe<Array<Tournament_Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Rewards_Order_By>>;
  where?: Maybe<Tournament_Rewards_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsTournament_Rewards_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Rewards_Order_By>>;
  where?: Maybe<Tournament_Rewards_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsTournament_SponsorsArgs = {
  distinct_on?: Maybe<Array<Tournament_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Sponsors_Order_By>>;
  where?: Maybe<Tournament_Sponsors_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsTournament_Sponsors_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Sponsors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Sponsors_Order_By>>;
  where?: Maybe<Tournament_Sponsors_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsTournament_StagesArgs = {
  distinct_on?: Maybe<Array<Tournament_Stages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Stages_Order_By>>;
  where?: Maybe<Tournament_Stages_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsTournament_Stages_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Stages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Stages_Order_By>>;
  where?: Maybe<Tournament_Stages_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsTournament_StatusesArgs = {
  distinct_on?: Maybe<Array<Tournament_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Statuses_Order_By>>;
  where?: Maybe<Tournament_Statuses_Bool_Exp>;
};


/** columns and relationships of "tournaments" */
export type TournamentsTournament_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Statuses_Order_By>>;
  where?: Maybe<Tournament_Statuses_Bool_Exp>;
};

/** aggregated selection of "tournaments" */
export type Tournaments_Aggregate = {
  __typename?: 'tournaments_aggregate';
  aggregate?: Maybe<Tournaments_Aggregate_Fields>;
  nodes: Array<Tournaments>;
};

export type Tournaments_Aggregate_Bool_Exp = {
  count?: Maybe<Tournaments_Aggregate_Bool_Exp_Count>;
};

export type Tournaments_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Tournaments_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Tournaments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tournaments" */
export type Tournaments_Aggregate_Fields = {
  __typename?: 'tournaments_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Tournaments_Max_Fields>;
  min?: Maybe<Tournaments_Min_Fields>;
};


/** aggregate fields of "tournaments" */
export type Tournaments_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Tournaments_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tournaments" */
export type Tournaments_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Tournaments_Max_Order_By>;
  min?: Maybe<Tournaments_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tournaments" */
export type Tournaments_Arr_Rel_Insert_Input = {
  data: Array<Tournaments_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Tournaments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tournaments". All fields are combined with a logical 'AND'. */
export type Tournaments_Bool_Exp = {
  _and?: Maybe<Array<Tournaments_Bool_Exp>>;
  _not?: Maybe<Tournaments_Bool_Exp>;
  _or?: Maybe<Array<Tournaments_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  game?: Maybe<Games_Bool_Exp>;
  game_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  matches?: Maybe<Matches_Bool_Exp>;
  matches_aggregate?: Maybe<Matches_Aggregate_Bool_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  series_tournaments?: Maybe<Series_Tournaments_Bool_Exp>;
  series_tournaments_aggregate?: Maybe<Series_Tournaments_Aggregate_Bool_Exp>;
  status?: Maybe<Statuses_Bool_Exp>;
  status_id?: Maybe<Uuid_Comparison_Exp>;
  tournament_date?: Maybe<_Date_Comparison_Exp>;
  tournament_details?: Maybe<Tournament_Details_Bool_Exp>;
  tournament_details_aggregate?: Maybe<Tournament_Details_Aggregate_Bool_Exp>;
  tournament_flags?: Maybe<Tournament_Flags_Bool_Exp>;
  tournament_flags_aggregate?: Maybe<Tournament_Flags_Aggregate_Bool_Exp>;
  tournament_invites?: Maybe<Tournament_Invites_Bool_Exp>;
  tournament_invites_aggregate?: Maybe<Tournament_Invites_Aggregate_Bool_Exp>;
  tournament_registrations?: Maybe<Tournament_Registrations_Bool_Exp>;
  tournament_registrations_aggregate?: Maybe<Tournament_Registrations_Aggregate_Bool_Exp>;
  tournament_results?: Maybe<Tournament_Results_Bool_Exp>;
  tournament_results_aggregate?: Maybe<Tournament_Results_Aggregate_Bool_Exp>;
  tournament_rewards?: Maybe<Tournament_Rewards_Bool_Exp>;
  tournament_rewards_aggregate?: Maybe<Tournament_Rewards_Aggregate_Bool_Exp>;
  tournament_sponsors?: Maybe<Tournament_Sponsors_Bool_Exp>;
  tournament_sponsors_aggregate?: Maybe<Tournament_Sponsors_Aggregate_Bool_Exp>;
  tournament_stages?: Maybe<Tournament_Stages_Bool_Exp>;
  tournament_stages_aggregate?: Maybe<Tournament_Stages_Aggregate_Bool_Exp>;
  tournament_statuses?: Maybe<Tournament_Statuses_Bool_Exp>;
  tournament_statuses_aggregate?: Maybe<Tournament_Statuses_Aggregate_Bool_Exp>;
  type?: Maybe<Types_Bool_Exp>;
  type_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "tournaments" */
export enum Tournaments_Constraint {
  /** unique or primary key constraint on columns "id" */
  TournamentsPkey = 'tournaments_pkey',
  /** unique or primary key constraint on columns "name", "game_id", "status_id" */
  UniqueTournament = 'unique_tournament'
}

/** input type for inserting data into table "tournaments" */
export type Tournaments_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  game?: Maybe<Games_Obj_Rel_Insert_Input>;
  game_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  matches?: Maybe<Matches_Arr_Rel_Insert_Input>;
  name?: Maybe<Scalars['String']>;
  series_tournaments?: Maybe<Series_Tournaments_Arr_Rel_Insert_Input>;
  status?: Maybe<Statuses_Obj_Rel_Insert_Input>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_date?: Maybe<Scalars['_date']>;
  tournament_details?: Maybe<Tournament_Details_Arr_Rel_Insert_Input>;
  tournament_flags?: Maybe<Tournament_Flags_Arr_Rel_Insert_Input>;
  tournament_invites?: Maybe<Tournament_Invites_Arr_Rel_Insert_Input>;
  tournament_registrations?: Maybe<Tournament_Registrations_Arr_Rel_Insert_Input>;
  tournament_results?: Maybe<Tournament_Results_Arr_Rel_Insert_Input>;
  tournament_rewards?: Maybe<Tournament_Rewards_Arr_Rel_Insert_Input>;
  tournament_sponsors?: Maybe<Tournament_Sponsors_Arr_Rel_Insert_Input>;
  tournament_stages?: Maybe<Tournament_Stages_Arr_Rel_Insert_Input>;
  tournament_statuses?: Maybe<Tournament_Statuses_Arr_Rel_Insert_Input>;
  type?: Maybe<Types_Obj_Rel_Insert_Input>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Tournaments_Max_Fields = {
  __typename?: 'tournaments_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  game_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "tournaments" */
export type Tournaments_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  game_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Tournaments_Min_Fields = {
  __typename?: 'tournaments_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  game_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "tournaments" */
export type Tournaments_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  game_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "tournaments" */
export type Tournaments_Mutation_Response = {
  __typename?: 'tournaments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tournaments>;
};

/** input type for inserting object relation for remote table "tournaments" */
export type Tournaments_Obj_Rel_Insert_Input = {
  data: Tournaments_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Tournaments_On_Conflict>;
};

/** on_conflict condition type for table "tournaments" */
export type Tournaments_On_Conflict = {
  constraint: Tournaments_Constraint;
  update_columns?: Array<Tournaments_Update_Column>;
  where?: Maybe<Tournaments_Bool_Exp>;
};

/** Ordering options when selecting data from "tournaments". */
export type Tournaments_Order_By = {
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  game?: Maybe<Games_Order_By>;
  game_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  matches_aggregate?: Maybe<Matches_Aggregate_Order_By>;
  name?: Maybe<Order_By>;
  series_tournaments_aggregate?: Maybe<Series_Tournaments_Aggregate_Order_By>;
  status?: Maybe<Statuses_Order_By>;
  status_id?: Maybe<Order_By>;
  tournament_date?: Maybe<Order_By>;
  tournament_details_aggregate?: Maybe<Tournament_Details_Aggregate_Order_By>;
  tournament_flags_aggregate?: Maybe<Tournament_Flags_Aggregate_Order_By>;
  tournament_invites_aggregate?: Maybe<Tournament_Invites_Aggregate_Order_By>;
  tournament_registrations_aggregate?: Maybe<Tournament_Registrations_Aggregate_Order_By>;
  tournament_results_aggregate?: Maybe<Tournament_Results_Aggregate_Order_By>;
  tournament_rewards_aggregate?: Maybe<Tournament_Rewards_Aggregate_Order_By>;
  tournament_sponsors_aggregate?: Maybe<Tournament_Sponsors_Aggregate_Order_By>;
  tournament_stages_aggregate?: Maybe<Tournament_Stages_Aggregate_Order_By>;
  tournament_statuses_aggregate?: Maybe<Tournament_Statuses_Aggregate_Order_By>;
  type?: Maybe<Types_Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: tournaments */
export type Tournaments_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "tournaments" */
export enum Tournaments_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  GameId = 'game_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TournamentDate = 'tournament_date',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "tournaments" */
export type Tournaments_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  game_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_date?: Maybe<Scalars['_date']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "tournaments" */
export type Tournaments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tournaments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tournaments_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  game_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  status_id?: Maybe<Scalars['uuid']>;
  tournament_date?: Maybe<Scalars['_date']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "tournaments" */
export enum Tournaments_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  GameId = 'game_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TournamentDate = 'tournament_date',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Tournaments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Tournaments_Set_Input>;
  where: Tournaments_Bool_Exp;
};

/** columns and relationships of "types" */
export type Types = {
  __typename?: 'types';
  /** An array relationship */
  circuits: Array<Series>;
  /** An aggregate relationship */
  circuits_aggregate: Series_Aggregate;
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  games: Array<Games>;
  /** An aggregate relationship */
  games_aggregate: Games_Aggregate;
  id: Scalars['uuid'];
  /** An array relationship */
  live_events: Array<Live_Events>;
  /** An aggregate relationship */
  live_events_aggregate: Live_Events_Aggregate;
  /** An array relationship */
  matches: Array<Matches>;
  /** An aggregate relationship */
  matches_aggregate: Matches_Aggregate;
  name: Scalars['String'];
  /** An array relationship */
  parties: Array<Parties>;
  /** An aggregate relationship */
  parties_aggregate: Parties_Aggregate;
  /** An array relationship */
  party_relationships: Array<Party_Relationships>;
  /** An aggregate relationship */
  party_relationships_aggregate: Party_Relationships_Aggregate;
  /** An array relationship */
  rewards: Array<Rewards>;
  /** An aggregate relationship */
  rewards_aggregate: Rewards_Aggregate;
  /** An array relationship */
  tournament_stages: Array<Tournament_Stages>;
  /** An aggregate relationship */
  tournament_stages_aggregate: Tournament_Stages_Aggregate;
  /** An array relationship */
  tournaments: Array<Tournaments>;
  /** An aggregate relationship */
  tournaments_aggregate: Tournaments_Aggregate;
  updated_at: Scalars['timestamptz'];
  value?: Maybe<Scalars['String']>;
};


/** columns and relationships of "types" */
export type TypesCircuitsArgs = {
  distinct_on?: Maybe<Array<Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Order_By>>;
  where?: Maybe<Series_Bool_Exp>;
};


/** columns and relationships of "types" */
export type TypesCircuits_AggregateArgs = {
  distinct_on?: Maybe<Array<Series_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Series_Order_By>>;
  where?: Maybe<Series_Bool_Exp>;
};


/** columns and relationships of "types" */
export type TypesGamesArgs = {
  distinct_on?: Maybe<Array<Games_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Games_Order_By>>;
  where?: Maybe<Games_Bool_Exp>;
};


/** columns and relationships of "types" */
export type TypesGames_AggregateArgs = {
  distinct_on?: Maybe<Array<Games_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Games_Order_By>>;
  where?: Maybe<Games_Bool_Exp>;
};


/** columns and relationships of "types" */
export type TypesLive_EventsArgs = {
  distinct_on?: Maybe<Array<Live_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Events_Order_By>>;
  where?: Maybe<Live_Events_Bool_Exp>;
};


/** columns and relationships of "types" */
export type TypesLive_Events_AggregateArgs = {
  distinct_on?: Maybe<Array<Live_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Live_Events_Order_By>>;
  where?: Maybe<Live_Events_Bool_Exp>;
};


/** columns and relationships of "types" */
export type TypesMatchesArgs = {
  distinct_on?: Maybe<Array<Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Matches_Order_By>>;
  where?: Maybe<Matches_Bool_Exp>;
};


/** columns and relationships of "types" */
export type TypesMatches_AggregateArgs = {
  distinct_on?: Maybe<Array<Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Matches_Order_By>>;
  where?: Maybe<Matches_Bool_Exp>;
};


/** columns and relationships of "types" */
export type TypesPartiesArgs = {
  distinct_on?: Maybe<Array<Parties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Parties_Order_By>>;
  where?: Maybe<Parties_Bool_Exp>;
};


/** columns and relationships of "types" */
export type TypesParties_AggregateArgs = {
  distinct_on?: Maybe<Array<Parties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Parties_Order_By>>;
  where?: Maybe<Parties_Bool_Exp>;
};


/** columns and relationships of "types" */
export type TypesParty_RelationshipsArgs = {
  distinct_on?: Maybe<Array<Party_Relationships_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Relationships_Order_By>>;
  where?: Maybe<Party_Relationships_Bool_Exp>;
};


/** columns and relationships of "types" */
export type TypesParty_Relationships_AggregateArgs = {
  distinct_on?: Maybe<Array<Party_Relationships_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Party_Relationships_Order_By>>;
  where?: Maybe<Party_Relationships_Bool_Exp>;
};


/** columns and relationships of "types" */
export type TypesRewardsArgs = {
  distinct_on?: Maybe<Array<Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Rewards_Order_By>>;
  where?: Maybe<Rewards_Bool_Exp>;
};


/** columns and relationships of "types" */
export type TypesRewards_AggregateArgs = {
  distinct_on?: Maybe<Array<Rewards_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Rewards_Order_By>>;
  where?: Maybe<Rewards_Bool_Exp>;
};


/** columns and relationships of "types" */
export type TypesTournament_StagesArgs = {
  distinct_on?: Maybe<Array<Tournament_Stages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Stages_Order_By>>;
  where?: Maybe<Tournament_Stages_Bool_Exp>;
};


/** columns and relationships of "types" */
export type TypesTournament_Stages_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournament_Stages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournament_Stages_Order_By>>;
  where?: Maybe<Tournament_Stages_Bool_Exp>;
};


/** columns and relationships of "types" */
export type TypesTournamentsArgs = {
  distinct_on?: Maybe<Array<Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournaments_Order_By>>;
  where?: Maybe<Tournaments_Bool_Exp>;
};


/** columns and relationships of "types" */
export type TypesTournaments_AggregateArgs = {
  distinct_on?: Maybe<Array<Tournaments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tournaments_Order_By>>;
  where?: Maybe<Tournaments_Bool_Exp>;
};

/** aggregated selection of "types" */
export type Types_Aggregate = {
  __typename?: 'types_aggregate';
  aggregate?: Maybe<Types_Aggregate_Fields>;
  nodes: Array<Types>;
};

/** aggregate fields of "types" */
export type Types_Aggregate_Fields = {
  __typename?: 'types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Types_Max_Fields>;
  min?: Maybe<Types_Min_Fields>;
};


/** aggregate fields of "types" */
export type Types_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Types_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "types". All fields are combined with a logical 'AND'. */
export type Types_Bool_Exp = {
  _and?: Maybe<Array<Types_Bool_Exp>>;
  _not?: Maybe<Types_Bool_Exp>;
  _or?: Maybe<Array<Types_Bool_Exp>>;
  circuits?: Maybe<Series_Bool_Exp>;
  circuits_aggregate?: Maybe<Series_Aggregate_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  games?: Maybe<Games_Bool_Exp>;
  games_aggregate?: Maybe<Games_Aggregate_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  live_events?: Maybe<Live_Events_Bool_Exp>;
  live_events_aggregate?: Maybe<Live_Events_Aggregate_Bool_Exp>;
  matches?: Maybe<Matches_Bool_Exp>;
  matches_aggregate?: Maybe<Matches_Aggregate_Bool_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  parties?: Maybe<Parties_Bool_Exp>;
  parties_aggregate?: Maybe<Parties_Aggregate_Bool_Exp>;
  party_relationships?: Maybe<Party_Relationships_Bool_Exp>;
  party_relationships_aggregate?: Maybe<Party_Relationships_Aggregate_Bool_Exp>;
  rewards?: Maybe<Rewards_Bool_Exp>;
  rewards_aggregate?: Maybe<Rewards_Aggregate_Bool_Exp>;
  tournament_stages?: Maybe<Tournament_Stages_Bool_Exp>;
  tournament_stages_aggregate?: Maybe<Tournament_Stages_Aggregate_Bool_Exp>;
  tournaments?: Maybe<Tournaments_Bool_Exp>;
  tournaments_aggregate?: Maybe<Tournaments_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "types" */
export enum Types_Constraint {
  /** unique or primary key constraint on columns "id" */
  TypesPkey = 'types_pkey',
  /** unique or primary key constraint on columns "value" */
  TypesValueUnique = 'types_value_unique'
}

/** input type for inserting data into table "types" */
export type Types_Insert_Input = {
  circuits?: Maybe<Series_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  games?: Maybe<Games_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  live_events?: Maybe<Live_Events_Arr_Rel_Insert_Input>;
  matches?: Maybe<Matches_Arr_Rel_Insert_Input>;
  name?: Maybe<Scalars['String']>;
  parties?: Maybe<Parties_Arr_Rel_Insert_Input>;
  party_relationships?: Maybe<Party_Relationships_Arr_Rel_Insert_Input>;
  rewards?: Maybe<Rewards_Arr_Rel_Insert_Input>;
  tournament_stages?: Maybe<Tournament_Stages_Arr_Rel_Insert_Input>;
  tournaments?: Maybe<Tournaments_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Types_Max_Fields = {
  __typename?: 'types_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Types_Min_Fields = {
  __typename?: 'types_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "types" */
export type Types_Mutation_Response = {
  __typename?: 'types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Types>;
};

/** input type for inserting object relation for remote table "types" */
export type Types_Obj_Rel_Insert_Input = {
  data: Types_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Types_On_Conflict>;
};

/** on_conflict condition type for table "types" */
export type Types_On_Conflict = {
  constraint: Types_Constraint;
  update_columns?: Array<Types_Update_Column>;
  where?: Maybe<Types_Bool_Exp>;
};

/** Ordering options when selecting data from "types". */
export type Types_Order_By = {
  circuits_aggregate?: Maybe<Series_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  games_aggregate?: Maybe<Games_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  live_events_aggregate?: Maybe<Live_Events_Aggregate_Order_By>;
  matches_aggregate?: Maybe<Matches_Aggregate_Order_By>;
  name?: Maybe<Order_By>;
  parties_aggregate?: Maybe<Parties_Aggregate_Order_By>;
  party_relationships_aggregate?: Maybe<Party_Relationships_Aggregate_Order_By>;
  rewards_aggregate?: Maybe<Rewards_Aggregate_Order_By>;
  tournament_stages_aggregate?: Maybe<Tournament_Stages_Aggregate_Order_By>;
  tournaments_aggregate?: Maybe<Tournaments_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: types */
export type Types_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "types" */
export enum Types_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "types" */
export type Types_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "types" */
export type Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Types_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "types" */
export enum Types_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Types_Set_Input>;
  where: Types_Bool_Exp;
};

/** columns and relationships of "user_flags" */
export type User_Flags = {
  __typename?: 'user_flags';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  flag: Flags;
  flag_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_flags" */
export type User_Flags_Aggregate = {
  __typename?: 'user_flags_aggregate';
  aggregate?: Maybe<User_Flags_Aggregate_Fields>;
  nodes: Array<User_Flags>;
};

export type User_Flags_Aggregate_Bool_Exp = {
  count?: Maybe<User_Flags_Aggregate_Bool_Exp_Count>;
};

export type User_Flags_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Flags_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Flags_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_flags" */
export type User_Flags_Aggregate_Fields = {
  __typename?: 'user_flags_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Flags_Max_Fields>;
  min?: Maybe<User_Flags_Min_Fields>;
};


/** aggregate fields of "user_flags" */
export type User_Flags_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Flags_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_flags" */
export type User_Flags_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<User_Flags_Max_Order_By>;
  min?: Maybe<User_Flags_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_flags" */
export type User_Flags_Arr_Rel_Insert_Input = {
  data: Array<User_Flags_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Flags_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_flags". All fields are combined with a logical 'AND'. */
export type User_Flags_Bool_Exp = {
  _and?: Maybe<Array<User_Flags_Bool_Exp>>;
  _not?: Maybe<User_Flags_Bool_Exp>;
  _or?: Maybe<Array<User_Flags_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  flag?: Maybe<Flags_Bool_Exp>;
  flag_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_flags" */
export enum User_Flags_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserFlagsPkey = 'user_flags_pkey'
}

/** input type for inserting data into table "user_flags" */
export type User_Flags_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  flag?: Maybe<Flags_Obj_Rel_Insert_Input>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Flags_Max_Fields = {
  __typename?: 'user_flags_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_flags" */
export type User_Flags_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  flag_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Flags_Min_Fields = {
  __typename?: 'user_flags_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_flags" */
export type User_Flags_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  flag_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_flags" */
export type User_Flags_Mutation_Response = {
  __typename?: 'user_flags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Flags>;
};

/** on_conflict condition type for table "user_flags" */
export type User_Flags_On_Conflict = {
  constraint: User_Flags_Constraint;
  update_columns?: Array<User_Flags_Update_Column>;
  where?: Maybe<User_Flags_Bool_Exp>;
};

/** Ordering options when selecting data from "user_flags". */
export type User_Flags_Order_By = {
  created_at?: Maybe<Order_By>;
  flag?: Maybe<Flags_Order_By>;
  flag_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: user_flags */
export type User_Flags_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_flags" */
export enum User_Flags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlagId = 'flag_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_flags" */
export type User_Flags_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_flags" */
export type User_Flags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Flags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Flags_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  flag_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "user_flags" */
export enum User_Flags_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlagId = 'flag_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

export type User_Flags_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Flags_Set_Input>;
  where: User_Flags_Bool_Exp;
};

/** columns and relationships of "user_mfa_factors" */
export type User_Mfa_Factors = {
  __typename?: 'user_mfa_factors';
  created_at: Scalars['timestamptz'];
  expires_on?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  is_active?: Maybe<Scalars['Boolean']>;
  mfa_type: Scalars['String'];
  secret: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "user_mfa_factors" */
export type User_Mfa_Factors_Aggregate = {
  __typename?: 'user_mfa_factors_aggregate';
  aggregate?: Maybe<User_Mfa_Factors_Aggregate_Fields>;
  nodes: Array<User_Mfa_Factors>;
};

export type User_Mfa_Factors_Aggregate_Bool_Exp = {
  bool_and?: Maybe<User_Mfa_Factors_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<User_Mfa_Factors_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<User_Mfa_Factors_Aggregate_Bool_Exp_Count>;
};

export type User_Mfa_Factors_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Mfa_Factors_Select_Column_User_Mfa_Factors_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Mfa_Factors_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Mfa_Factors_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Mfa_Factors_Select_Column_User_Mfa_Factors_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Mfa_Factors_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Mfa_Factors_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Mfa_Factors_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Mfa_Factors_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_mfa_factors" */
export type User_Mfa_Factors_Aggregate_Fields = {
  __typename?: 'user_mfa_factors_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Mfa_Factors_Max_Fields>;
  min?: Maybe<User_Mfa_Factors_Min_Fields>;
};


/** aggregate fields of "user_mfa_factors" */
export type User_Mfa_Factors_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Mfa_Factors_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_mfa_factors" */
export type User_Mfa_Factors_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<User_Mfa_Factors_Max_Order_By>;
  min?: Maybe<User_Mfa_Factors_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_mfa_factors" */
export type User_Mfa_Factors_Arr_Rel_Insert_Input = {
  data: Array<User_Mfa_Factors_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Mfa_Factors_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_mfa_factors". All fields are combined with a logical 'AND'. */
export type User_Mfa_Factors_Bool_Exp = {
  _and?: Maybe<Array<User_Mfa_Factors_Bool_Exp>>;
  _not?: Maybe<User_Mfa_Factors_Bool_Exp>;
  _or?: Maybe<Array<User_Mfa_Factors_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  expires_on?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  is_active?: Maybe<Boolean_Comparison_Exp>;
  mfa_type?: Maybe<String_Comparison_Exp>;
  secret?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_mfa_factors" */
export enum User_Mfa_Factors_Constraint {
  /** unique or primary key constraint on columns "is_active", "mfa_type", "user_id" */
  UniqueUserMfaFactors = 'unique_user_mfa_factors',
  /** unique or primary key constraint on columns "id" */
  UserMfaFactorsPkey = 'user_mfa_factors_pkey'
}

/** input type for inserting data into table "user_mfa_factors" */
export type User_Mfa_Factors_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_on?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_active?: Maybe<Scalars['Boolean']>;
  mfa_type?: Maybe<Scalars['String']>;
  secret?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Mfa_Factors_Max_Fields = {
  __typename?: 'user_mfa_factors_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_on?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  mfa_type?: Maybe<Scalars['String']>;
  secret?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_mfa_factors" */
export type User_Mfa_Factors_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  expires_on?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mfa_type?: Maybe<Order_By>;
  secret?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Mfa_Factors_Min_Fields = {
  __typename?: 'user_mfa_factors_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_on?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  mfa_type?: Maybe<Scalars['String']>;
  secret?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_mfa_factors" */
export type User_Mfa_Factors_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  expires_on?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mfa_type?: Maybe<Order_By>;
  secret?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_mfa_factors" */
export type User_Mfa_Factors_Mutation_Response = {
  __typename?: 'user_mfa_factors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Mfa_Factors>;
};

/** on_conflict condition type for table "user_mfa_factors" */
export type User_Mfa_Factors_On_Conflict = {
  constraint: User_Mfa_Factors_Constraint;
  update_columns?: Array<User_Mfa_Factors_Update_Column>;
  where?: Maybe<User_Mfa_Factors_Bool_Exp>;
};

/** Ordering options when selecting data from "user_mfa_factors". */
export type User_Mfa_Factors_Order_By = {
  created_at?: Maybe<Order_By>;
  expires_on?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_active?: Maybe<Order_By>;
  mfa_type?: Maybe<Order_By>;
  secret?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: user_mfa_factors */
export type User_Mfa_Factors_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_mfa_factors" */
export enum User_Mfa_Factors_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresOn = 'expires_on',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MfaType = 'mfa_type',
  /** column name */
  Secret = 'secret',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "user_mfa_factors_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_mfa_factors" */
export enum User_Mfa_Factors_Select_Column_User_Mfa_Factors_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "user_mfa_factors_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_mfa_factors" */
export enum User_Mfa_Factors_Select_Column_User_Mfa_Factors_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "user_mfa_factors" */
export type User_Mfa_Factors_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_on?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_active?: Maybe<Scalars['Boolean']>;
  mfa_type?: Maybe<Scalars['String']>;
  secret?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_mfa_factors" */
export type User_Mfa_Factors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Mfa_Factors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Mfa_Factors_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_on?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_active?: Maybe<Scalars['Boolean']>;
  mfa_type?: Maybe<Scalars['String']>;
  secret?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "user_mfa_factors" */
export enum User_Mfa_Factors_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresOn = 'expires_on',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MfaType = 'mfa_type',
  /** column name */
  Secret = 'secret',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Mfa_Factors_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Mfa_Factors_Set_Input>;
  where: User_Mfa_Factors_Bool_Exp;
};

/** columns and relationships of "user_statuses" */
export type User_Statuses = {
  __typename?: 'user_statuses';
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  status: Statuses;
  status_id: Scalars['uuid'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_statuses" */
export type User_Statuses_Aggregate = {
  __typename?: 'user_statuses_aggregate';
  aggregate?: Maybe<User_Statuses_Aggregate_Fields>;
  nodes: Array<User_Statuses>;
};

export type User_Statuses_Aggregate_Bool_Exp = {
  count?: Maybe<User_Statuses_Aggregate_Bool_Exp_Count>;
};

export type User_Statuses_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Statuses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Statuses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_statuses" */
export type User_Statuses_Aggregate_Fields = {
  __typename?: 'user_statuses_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Statuses_Max_Fields>;
  min?: Maybe<User_Statuses_Min_Fields>;
};


/** aggregate fields of "user_statuses" */
export type User_Statuses_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Statuses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_statuses" */
export type User_Statuses_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<User_Statuses_Max_Order_By>;
  min?: Maybe<User_Statuses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_statuses" */
export type User_Statuses_Arr_Rel_Insert_Input = {
  data: Array<User_Statuses_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Statuses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_statuses". All fields are combined with a logical 'AND'. */
export type User_Statuses_Bool_Exp = {
  _and?: Maybe<Array<User_Statuses_Bool_Exp>>;
  _not?: Maybe<User_Statuses_Bool_Exp>;
  _or?: Maybe<Array<User_Statuses_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<Statuses_Bool_Exp>;
  status_id?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_statuses" */
export enum User_Statuses_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserStatusesPkey = 'user_statuses_pkey'
}

/** input type for inserting data into table "user_statuses" */
export type User_Statuses_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Statuses_Obj_Rel_Insert_Input>;
  status_id?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Statuses_Max_Fields = {
  __typename?: 'user_statuses_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_statuses" */
export type User_Statuses_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Statuses_Min_Fields = {
  __typename?: 'user_statuses_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_statuses" */
export type User_Statuses_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  status_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_statuses" */
export type User_Statuses_Mutation_Response = {
  __typename?: 'user_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Statuses>;
};

/** on_conflict condition type for table "user_statuses" */
export type User_Statuses_On_Conflict = {
  constraint: User_Statuses_Constraint;
  update_columns?: Array<User_Statuses_Update_Column>;
  where?: Maybe<User_Statuses_Bool_Exp>;
};

/** Ordering options when selecting data from "user_statuses". */
export type User_Statuses_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  status?: Maybe<Statuses_Order_By>;
  status_id?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: user_statuses */
export type User_Statuses_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_statuses" */
export enum User_Statuses_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_statuses" */
export type User_Statuses_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_statuses" */
export type User_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Statuses_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "user_statuses" */
export enum User_Statuses_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  UserId = 'user_id'
}

export type User_Statuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Statuses_Set_Input>;
  where: User_Statuses_Bool_Exp;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  email_verified_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  last_sign_in_at?: Maybe<Scalars['timestamptz']>;
  locale?: Maybe<Scalars['String']>;
  mfa_enabled: Scalars['Boolean'];
  name: Scalars['String'];
  party_id?: Maybe<Scalars['uuid']>;
  password: Scalars['String'];
  phone_number: Scalars['String'];
  salt: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_flags: Array<User_Flags>;
  /** An aggregate relationship */
  user_flags_aggregate: User_Flags_Aggregate;
  /** An array relationship */
  user_mfa_factors: Array<User_Mfa_Factors>;
  /** An aggregate relationship */
  user_mfa_factors_aggregate: User_Mfa_Factors_Aggregate;
  /** An array relationship */
  user_statuses: Array<User_Statuses>;
  /** An aggregate relationship */
  user_statuses_aggregate: User_Statuses_Aggregate;
};


/** columns and relationships of "users" */
export type UsersUser_FlagsArgs = {
  distinct_on?: Maybe<Array<User_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Flags_Order_By>>;
  where?: Maybe<User_Flags_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Flags_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Flags_Order_By>>;
  where?: Maybe<User_Flags_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Mfa_FactorsArgs = {
  distinct_on?: Maybe<Array<User_Mfa_Factors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Mfa_Factors_Order_By>>;
  where?: Maybe<User_Mfa_Factors_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Mfa_Factors_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Mfa_Factors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Mfa_Factors_Order_By>>;
  where?: Maybe<User_Mfa_Factors_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_StatusesArgs = {
  distinct_on?: Maybe<Array<User_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Statuses_Order_By>>;
  where?: Maybe<User_Statuses_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Statuses_Order_By>>;
  where?: Maybe<User_Statuses_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Users_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: Maybe<Array<Users_Bool_Exp>>;
  _not?: Maybe<Users_Bool_Exp>;
  _or?: Maybe<Array<Users_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  email_verified_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  is_active?: Maybe<Boolean_Comparison_Exp>;
  last_sign_in_at?: Maybe<Timestamptz_Comparison_Exp>;
  locale?: Maybe<String_Comparison_Exp>;
  mfa_enabled?: Maybe<Boolean_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  party_id?: Maybe<Uuid_Comparison_Exp>;
  password?: Maybe<String_Comparison_Exp>;
  phone_number?: Maybe<String_Comparison_Exp>;
  salt?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user_flags?: Maybe<User_Flags_Bool_Exp>;
  user_flags_aggregate?: Maybe<User_Flags_Aggregate_Bool_Exp>;
  user_mfa_factors?: Maybe<User_Mfa_Factors_Bool_Exp>;
  user_mfa_factors_aggregate?: Maybe<User_Mfa_Factors_Aggregate_Bool_Exp>;
  user_statuses?: Maybe<User_Statuses_Bool_Exp>;
  user_statuses_aggregate?: Maybe<User_Statuses_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "email" */
  UsersEmailUnique = 'users_email_unique',
  /** unique or primary key constraint on columns "phone_number" */
  UsersPhoneNumberUnique = 'users_phone_number_unique',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  email_verified_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_active?: Maybe<Scalars['Boolean']>;
  last_sign_in_at?: Maybe<Scalars['timestamptz']>;
  locale?: Maybe<Scalars['String']>;
  mfa_enabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  party_id?: Maybe<Scalars['uuid']>;
  password?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  salt?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_flags?: Maybe<User_Flags_Arr_Rel_Insert_Input>;
  user_mfa_factors?: Maybe<User_Mfa_Factors_Arr_Rel_Insert_Input>;
  user_statuses?: Maybe<User_Statuses_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  email_verified_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  last_sign_in_at?: Maybe<Scalars['timestamptz']>;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  party_id?: Maybe<Scalars['uuid']>;
  password?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  salt?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  email_verified_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  last_sign_in_at?: Maybe<Scalars['timestamptz']>;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  party_id?: Maybe<Scalars['uuid']>;
  password?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  salt?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: Maybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  email_verified_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_active?: Maybe<Order_By>;
  last_sign_in_at?: Maybe<Order_By>;
  locale?: Maybe<Order_By>;
  mfa_enabled?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  party_id?: Maybe<Order_By>;
  password?: Maybe<Order_By>;
  phone_number?: Maybe<Order_By>;
  salt?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_flags_aggregate?: Maybe<User_Flags_Aggregate_Order_By>;
  user_mfa_factors_aggregate?: Maybe<User_Mfa_Factors_Aggregate_Order_By>;
  user_statuses_aggregate?: Maybe<User_Statuses_Aggregate_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerifiedAt = 'email_verified_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastSignInAt = 'last_sign_in_at',
  /** column name */
  Locale = 'locale',
  /** column name */
  MfaEnabled = 'mfa_enabled',
  /** column name */
  Name = 'name',
  /** column name */
  PartyId = 'party_id',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Salt = 'salt',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  email_verified_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_active?: Maybe<Scalars['Boolean']>;
  last_sign_in_at?: Maybe<Scalars['timestamptz']>;
  locale?: Maybe<Scalars['String']>;
  mfa_enabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  party_id?: Maybe<Scalars['uuid']>;
  password?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  salt?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  email_verified_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_active?: Maybe<Scalars['Boolean']>;
  last_sign_in_at?: Maybe<Scalars['timestamptz']>;
  locale?: Maybe<Scalars['String']>;
  mfa_enabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  party_id?: Maybe<Scalars['uuid']>;
  password?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  salt?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerifiedAt = 'email_verified_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastSignInAt = 'last_sign_in_at',
  /** column name */
  Locale = 'locale',
  /** column name */
  MfaEnabled = 'mfa_enabled',
  /** column name */
  Name = 'name',
  /** column name */
  PartyId = 'party_id',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Salt = 'salt',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
};

export type CreateTeamMutationVariables = Exact<{
  input: CreateTeamInput;
}>;


export type CreateTeamMutation = { __typename?: 'mutation_root', createTeam?: Maybe<{ __typename?: 'CreateTeamOutput', message?: Maybe<string>, teamId?: Maybe<string> }> };

export type GenerateResetPasswordTokenMutationVariables = Exact<{
  input: GenerateResetPasswordTokenInput;
}>;


export type GenerateResetPasswordTokenMutation = { __typename?: 'mutation_root', generateResetPasswordToken?: Maybe<{ __typename?: 'GenerateResetPasswordTokenOutput', resetToken?: Maybe<string> }> };

export type GetStatsMutationVariables = Exact<{
  input: StatsInput;
}>;


export type GetStatsMutation = { __typename?: 'mutation_root', getStats?: Maybe<{ __typename?: 'MyStatsOutput', id: string, ranks?: Maybe<any>, scores?: Maybe<any> }> };

export type HubRegistrationMutationVariables = Exact<{
  input: Hub_Registrations_Insert_Input;
}>;


export type HubRegistrationMutation = { __typename?: 'mutation_root', insert_hub_registrations_one?: Maybe<{ __typename?: 'hub_registrations', id: any }> };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'mutation_root', login?: Maybe<{ __typename?: 'LoginOutput', message?: Maybe<string>, accessToken?: Maybe<string>, token?: Maybe<string> }> };

export type SignUpMutationVariables = Exact<{
  input: SignupInput;
}>;


export type SignUpMutation = { __typename?: 'mutation_root', signup?: Maybe<{ __typename?: 'SignupOutput', userId?: Maybe<string>, partyId?: Maybe<string>, message?: Maybe<string>, type?: Maybe<string> }> };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'mutation_root', resetPassword?: Maybe<{ __typename?: 'ResetPasswordOutput', message: string }> };

export type SendLiveEventMessageMutationVariables = Exact<{
  message: Scalars['String'];
  live_event_id: Scalars['uuid'];
}>;


export type SendLiveEventMessageMutation = { __typename?: 'mutation_root', insert_live_event_messages_one?: Maybe<{ __typename?: 'live_event_messages', id: any }> };

export type RegisterTeamForTournamentMutationVariables = Exact<{
  input: RegisterTeamForTournamentInput;
}>;


export type RegisterTeamForTournamentMutation = { __typename?: 'mutation_root', registerTeamForTournament?: Maybe<{ __typename?: 'RegisterTeamForTournamentOutput', message?: Maybe<string> }> };

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'mutation_root', updateProfile?: Maybe<{ __typename?: 'UpdateProfileOutput', id: string }> };

export type CheckIfTeamExistsQueryVariables = Exact<{
  input: CheckIfTeamExistsInput;
}>;


export type CheckIfTeamExistsQuery = { __typename?: 'query_root', checkIfTeamExists?: Maybe<{ __typename?: 'CheckIfTeamExistsOutput', message: string, type?: Maybe<string> }> };

export type GetAllPartiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPartiesQuery = { __typename?: 'query_root', parties: Array<{ __typename?: 'parties', id: any, name: string, nickname?: Maybe<string> }> };

export type GetGameStatsQueryVariables = Exact<{
  gameId: Scalars['uuid'];
}>;


export type GetGameStatsQuery = { __typename?: 'query_root', getGameStats?: Maybe<{ __typename?: 'GameStatsOutput', stats?: Maybe<Array<Maybe<any>>> }> };

export type GetGameQueryVariables = Exact<{
  gameId: Scalars['uuid'];
}>;


export type GetGameQuery = { __typename?: 'query_root', game?: Maybe<{ __typename?: 'games', id: any, name: string, description?: Maybe<string>, slug?: Maybe<string>, poster_url?: Maybe<string>, banner_url?: Maybe<string>, tournaments: Array<{ __typename?: 'tournaments', id: any, name: string, tournament_date?: Maybe<any>, tournament_details: Array<{ __typename?: 'tournament_details', id: any, key: string, value?: Maybe<string> }>, status: { __typename?: 'statuses', id: any, name: string }, matches: Array<{ __typename?: 'matches', id: any, status: { __typename?: 'statuses', id: any, name: string } }> }> }> };

export type GetGamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGamesQuery = { __typename?: 'query_root', games: Array<{ __typename?: 'games', id: any, name: string, description?: Maybe<string>, poster_url?: Maybe<string> }> };

export type GetHubRegistrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHubRegistrationsQuery = { __typename?: 'query_root', hub_registrations: Array<{ __typename?: 'hub_registrations', id: any, name: string, location: string, website?: Maybe<string>, selected_qualifiers: any, created_at: any }> };

export type GetLiveEventQueryVariables = Exact<{
  live_event_id: Scalars['uuid'];
}>;


export type GetLiveEventQuery = { __typename?: 'query_root', live_event?: Maybe<{ __typename?: 'live_events', id: any, description?: Maybe<string>, event_start?: Maybe<any>, event_end?: Maybe<any>, name: string, moderate_messages: boolean, stream_url?: Maybe<string>, status: { __typename?: 'statuses', id: any, name: string, value?: Maybe<string> }, type?: Maybe<{ __typename?: 'types', id: any, name: string, value?: Maybe<string> }> }> };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'query_root', me?: Maybe<{ __typename?: 'MeOutput', id: string, avatar?: Maybe<string>, name?: Maybe<string>, nickname?: Maybe<string>, email?: Maybe<string>, phone_number?: Maybe<string>, partyDetails: Array<{ __typename?: 'party_details', key: string, value?: Maybe<string> }>, tournament_registrations: Array<{ __typename?: 'tournament_registrations', id: any }> }> };

export type GetMyResultsQueryVariables = Exact<{
  participants?: Maybe<Scalars['jsonb']>;
  gameId: Scalars['uuid'];
}>;


export type GetMyResultsQuery = { __typename?: 'query_root', tournament_results: Array<{ __typename?: 'tournament_results', id: any, result: any, match: { __typename?: 'matches', id: any, match_time?: Maybe<any> } }> };

export type GetMyStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyStatsQuery = { __typename?: 'query_root', myStats?: Maybe<{ __typename?: 'MyStatsOutput', id: string, ranks?: Maybe<any>, scores?: Maybe<any> }> };

export type GetPartiesQueryVariables = Exact<{
  partyIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetPartiesQuery = { __typename?: 'query_root', parties: Array<{ __typename?: 'parties', id: any, name?: Maybe<string> }> };

export type GetPartyQueryVariables = Exact<{
  username?: Maybe<Scalars['String']>;
}>;


export type GetPartyQuery = { __typename?: 'query_root', party: Array<{ __typename?: 'parties', id: any, avatar?: Maybe<string>, name: string, nickname?: Maybe<string>, partyDetails: Array<{ __typename?: 'party_details', id: any, key: string, value?: Maybe<string> }>, tournament_registrations: Array<{ __typename?: 'tournament_registrations', id: any }> }> };

export type GetPlayerTournamentsStatsQueryVariables = Exact<{
  params: GetPlayerTournamentsStatsInput;
}>;


export type GetPlayerTournamentsStatsQuery = { __typename?: 'query_root', getPlayerTournamentsStats?: Maybe<{ __typename?: 'GetTournamentStatsOutput', stats?: Maybe<any> }> };

export type GetTournamentQueryVariables = Exact<{
  tournamentId: Scalars['uuid'];
}>;


export type GetTournamentQuery = { __typename?: 'query_root', tournament?: Maybe<{ __typename?: 'tournaments', id: any, name: string, description?: Maybe<string>, tournamentDate?: Maybe<any>, game: { __typename?: 'games', id: any, name: string, poster_url?: Maybe<string> }, tournamentStatuses: Array<{ __typename?: 'tournament_statuses', id: any, created_at?: Maybe<any>, status: { __typename?: 'statuses', name: string, value?: Maybe<string> } }>, tournamentType: { __typename?: 'types', id: any, name: string, value?: Maybe<string> }, tournamentDetails: Array<{ __typename?: 'tournament_details', id: any, key: string, value?: Maybe<string> }>, tournamentFlags: Array<{ __typename?: 'tournament_flags', id: any, created_at?: Maybe<any>, flag: { __typename?: 'flags', id: any, name: string, value?: Maybe<string> } }>, participants: Array<{ __typename?: 'tournament_registrations', id: any, party_id: any, created_at: any, party: { __typename?: 'parties', id: any, nickname?: Maybe<string>, name: string, party_relationships: Array<{ __typename?: 'party_relationships', id: any, participant: any, partyByParticipant: { __typename?: 'parties', id: any, name: string, nickname?: Maybe<string> } }> } }>, results: Array<{ __typename?: 'tournament_results', id: any, match_id: any, result: any, match: { __typename?: 'matches', id: any, match_time?: Maybe<any>, name: string } }> }> };

export type GetTournamentStatsQueryVariables = Exact<{
  params: GetTournamentStatsInput;
}>;


export type GetTournamentStatsQuery = { __typename?: 'query_root', getTournamentStats?: Maybe<{ __typename?: 'GetTournamentStatsOutput', stats?: Maybe<any> }> };

export type FindGamersQueryVariables = Exact<{
  searchTerm: Scalars['String'];
}>;


export type FindGamersQuery = { __typename?: 'query_root', parties: Array<{ __typename?: 'parties', id: any, name: string, nickname?: Maybe<string> }> };

export type SearchGamersQueryVariables = Exact<{
  searchTerm: Scalars['String'];
}>;


export type SearchGamersQuery = { __typename?: 'query_root', parties: Array<{ __typename?: 'parties', id: any, name: string, nickname?: Maybe<string> }> };

export type GetLiveEventMessagesSubscriptionVariables = Exact<{
  live_event_id: Scalars['uuid'];
}>;


export type GetLiveEventMessagesSubscription = { __typename?: 'subscription_root', live_event_messages: Array<{ __typename?: 'live_event_messages', id: any, message: string, parent_id?: Maybe<any>, sender: any, created_at: any, senderDetails: { __typename?: 'parties', id: any, name: string, nickname?: Maybe<string>, avatar?: Maybe<string> } }> };


export const CreateTeamDocument = gql`
    mutation CreateTeam($input: CreateTeamInput!) {
  createTeam(params: $input) {
    message
    teamId
  }
}
    `;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const GenerateResetPasswordTokenDocument = gql`
    mutation GenerateResetPasswordToken($input: GenerateResetPasswordTokenInput!) {
  generateResetPasswordToken(params: $input) {
    resetToken
  }
}
    `;
export type GenerateResetPasswordTokenMutationFn = Apollo.MutationFunction<GenerateResetPasswordTokenMutation, GenerateResetPasswordTokenMutationVariables>;

/**
 * __useGenerateResetPasswordTokenMutation__
 *
 * To run a mutation, you first call `useGenerateResetPasswordTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateResetPasswordTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateResetPasswordTokenMutation, { data, loading, error }] = useGenerateResetPasswordTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateResetPasswordTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateResetPasswordTokenMutation, GenerateResetPasswordTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateResetPasswordTokenMutation, GenerateResetPasswordTokenMutationVariables>(GenerateResetPasswordTokenDocument, options);
      }
export type GenerateResetPasswordTokenMutationHookResult = ReturnType<typeof useGenerateResetPasswordTokenMutation>;
export type GenerateResetPasswordTokenMutationResult = Apollo.MutationResult<GenerateResetPasswordTokenMutation>;
export type GenerateResetPasswordTokenMutationOptions = Apollo.BaseMutationOptions<GenerateResetPasswordTokenMutation, GenerateResetPasswordTokenMutationVariables>;
export const GetStatsDocument = gql`
    mutation GetStats($input: StatsInput!) {
  getStats(params: $input) {
    id
    ranks
    scores
  }
}
    `;
export type GetStatsMutationFn = Apollo.MutationFunction<GetStatsMutation, GetStatsMutationVariables>;

/**
 * __useGetStatsMutation__
 *
 * To run a mutation, you first call `useGetStatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetStatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getStatsMutation, { data, loading, error }] = useGetStatsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStatsMutation(baseOptions?: Apollo.MutationHookOptions<GetStatsMutation, GetStatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetStatsMutation, GetStatsMutationVariables>(GetStatsDocument, options);
      }
export type GetStatsMutationHookResult = ReturnType<typeof useGetStatsMutation>;
export type GetStatsMutationResult = Apollo.MutationResult<GetStatsMutation>;
export type GetStatsMutationOptions = Apollo.BaseMutationOptions<GetStatsMutation, GetStatsMutationVariables>;
export const HubRegistrationDocument = gql`
    mutation HubRegistration($input: hub_registrations_insert_input!) {
  insert_hub_registrations_one(object: $input) {
    id
  }
}
    `;
export type HubRegistrationMutationFn = Apollo.MutationFunction<HubRegistrationMutation, HubRegistrationMutationVariables>;

/**
 * __useHubRegistrationMutation__
 *
 * To run a mutation, you first call `useHubRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHubRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hubRegistrationMutation, { data, loading, error }] = useHubRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHubRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<HubRegistrationMutation, HubRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HubRegistrationMutation, HubRegistrationMutationVariables>(HubRegistrationDocument, options);
      }
export type HubRegistrationMutationHookResult = ReturnType<typeof useHubRegistrationMutation>;
export type HubRegistrationMutationResult = Apollo.MutationResult<HubRegistrationMutation>;
export type HubRegistrationMutationOptions = Apollo.BaseMutationOptions<HubRegistrationMutation, HubRegistrationMutationVariables>;
export const LoginDocument = gql`
    mutation Login($input: LoginInput!) {
  login(params: $input) {
    token: accessToken
    message
    accessToken
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const SignUpDocument = gql`
    mutation SignUp($input: SignupInput!) {
  signup(params: $input) {
    userId
    partyId
    message
    type
  }
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(params: $input) {
    message
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SendLiveEventMessageDocument = gql`
    mutation SendLiveEventMessage($message: String!, $live_event_id: uuid!) {
  insert_live_event_messages_one(
    object: {message: $message, live_event_id: $live_event_id}
  ) {
    id
  }
}
    `;
export type SendLiveEventMessageMutationFn = Apollo.MutationFunction<SendLiveEventMessageMutation, SendLiveEventMessageMutationVariables>;

/**
 * __useSendLiveEventMessageMutation__
 *
 * To run a mutation, you first call `useSendLiveEventMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendLiveEventMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendLiveEventMessageMutation, { data, loading, error }] = useSendLiveEventMessageMutation({
 *   variables: {
 *      message: // value for 'message'
 *      live_event_id: // value for 'live_event_id'
 *   },
 * });
 */
export function useSendLiveEventMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendLiveEventMessageMutation, SendLiveEventMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendLiveEventMessageMutation, SendLiveEventMessageMutationVariables>(SendLiveEventMessageDocument, options);
      }
export type SendLiveEventMessageMutationHookResult = ReturnType<typeof useSendLiveEventMessageMutation>;
export type SendLiveEventMessageMutationResult = Apollo.MutationResult<SendLiveEventMessageMutation>;
export type SendLiveEventMessageMutationOptions = Apollo.BaseMutationOptions<SendLiveEventMessageMutation, SendLiveEventMessageMutationVariables>;
export const RegisterTeamForTournamentDocument = gql`
    mutation RegisterTeamForTournament($input: RegisterTeamForTournamentInput!) {
  registerTeamForTournament(params: $input) {
    message
  }
}
    `;
export type RegisterTeamForTournamentMutationFn = Apollo.MutationFunction<RegisterTeamForTournamentMutation, RegisterTeamForTournamentMutationVariables>;

/**
 * __useRegisterTeamForTournamentMutation__
 *
 * To run a mutation, you first call `useRegisterTeamForTournamentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterTeamForTournamentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerTeamForTournamentMutation, { data, loading, error }] = useRegisterTeamForTournamentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterTeamForTournamentMutation(baseOptions?: Apollo.MutationHookOptions<RegisterTeamForTournamentMutation, RegisterTeamForTournamentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterTeamForTournamentMutation, RegisterTeamForTournamentMutationVariables>(RegisterTeamForTournamentDocument, options);
      }
export type RegisterTeamForTournamentMutationHookResult = ReturnType<typeof useRegisterTeamForTournamentMutation>;
export type RegisterTeamForTournamentMutationResult = Apollo.MutationResult<RegisterTeamForTournamentMutation>;
export type RegisterTeamForTournamentMutationOptions = Apollo.BaseMutationOptions<RegisterTeamForTournamentMutation, RegisterTeamForTournamentMutationVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($input: UpdateProfileInput!) {
  updateProfile(params: $input) {
    id
  }
}
    `;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const CheckIfTeamExistsDocument = gql`
    query CheckIfTeamExists($input: CheckIfTeamExistsInput!) {
  checkIfTeamExists(params: $input) {
    message
    type
  }
}
    `;

/**
 * __useCheckIfTeamExistsQuery__
 *
 * To run a query within a React component, call `useCheckIfTeamExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfTeamExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfTeamExistsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckIfTeamExistsQuery(baseOptions: Apollo.QueryHookOptions<CheckIfTeamExistsQuery, CheckIfTeamExistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIfTeamExistsQuery, CheckIfTeamExistsQueryVariables>(CheckIfTeamExistsDocument, options);
      }
export function useCheckIfTeamExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckIfTeamExistsQuery, CheckIfTeamExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIfTeamExistsQuery, CheckIfTeamExistsQueryVariables>(CheckIfTeamExistsDocument, options);
        }
export type CheckIfTeamExistsQueryHookResult = ReturnType<typeof useCheckIfTeamExistsQuery>;
export type CheckIfTeamExistsLazyQueryHookResult = ReturnType<typeof useCheckIfTeamExistsLazyQuery>;
export type CheckIfTeamExistsQueryResult = Apollo.QueryResult<CheckIfTeamExistsQuery, CheckIfTeamExistsQueryVariables>;
export const GetAllPartiesDocument = gql`
    query GetAllParties {
  parties {
    id
    name
    nickname
  }
}
    `;

/**
 * __useGetAllPartiesQuery__
 *
 * To run a query within a React component, call `useGetAllPartiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPartiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPartiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPartiesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPartiesQuery, GetAllPartiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPartiesQuery, GetAllPartiesQueryVariables>(GetAllPartiesDocument, options);
      }
export function useGetAllPartiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPartiesQuery, GetAllPartiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPartiesQuery, GetAllPartiesQueryVariables>(GetAllPartiesDocument, options);
        }
export type GetAllPartiesQueryHookResult = ReturnType<typeof useGetAllPartiesQuery>;
export type GetAllPartiesLazyQueryHookResult = ReturnType<typeof useGetAllPartiesLazyQuery>;
export type GetAllPartiesQueryResult = Apollo.QueryResult<GetAllPartiesQuery, GetAllPartiesQueryVariables>;
export const GetGameStatsDocument = gql`
    query GetGameStats($gameId: uuid!) {
  getGameStats(params: {gameId: $gameId}) {
    stats
  }
}
    `;

/**
 * __useGetGameStatsQuery__
 *
 * To run a query within a React component, call `useGetGameStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGameStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGameStatsQuery({
 *   variables: {
 *      gameId: // value for 'gameId'
 *   },
 * });
 */
export function useGetGameStatsQuery(baseOptions: Apollo.QueryHookOptions<GetGameStatsQuery, GetGameStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGameStatsQuery, GetGameStatsQueryVariables>(GetGameStatsDocument, options);
      }
export function useGetGameStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGameStatsQuery, GetGameStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGameStatsQuery, GetGameStatsQueryVariables>(GetGameStatsDocument, options);
        }
export type GetGameStatsQueryHookResult = ReturnType<typeof useGetGameStatsQuery>;
export type GetGameStatsLazyQueryHookResult = ReturnType<typeof useGetGameStatsLazyQuery>;
export type GetGameStatsQueryResult = Apollo.QueryResult<GetGameStatsQuery, GetGameStatsQueryVariables>;
export const GetGameDocument = gql`
    query GetGame($gameId: uuid!) {
  game: games_by_pk(id: $gameId) {
    id
    name
    description
    slug
    poster_url
    banner_url
    tournaments(order_by: {created_at: desc}) {
      id
      name
      tournament_date
      tournament_details {
        id
        key
        value
      }
      status {
        id
        name
      }
      matches {
        id
        status {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetGameQuery__
 *
 * To run a query within a React component, call `useGetGameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGameQuery({
 *   variables: {
 *      gameId: // value for 'gameId'
 *   },
 * });
 */
export function useGetGameQuery(baseOptions: Apollo.QueryHookOptions<GetGameQuery, GetGameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGameQuery, GetGameQueryVariables>(GetGameDocument, options);
      }
export function useGetGameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGameQuery, GetGameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGameQuery, GetGameQueryVariables>(GetGameDocument, options);
        }
export type GetGameQueryHookResult = ReturnType<typeof useGetGameQuery>;
export type GetGameLazyQueryHookResult = ReturnType<typeof useGetGameLazyQuery>;
export type GetGameQueryResult = Apollo.QueryResult<GetGameQuery, GetGameQueryVariables>;
export const GetGamesDocument = gql`
    query GetGames {
  games {
    id
    name
    description
    poster_url
  }
}
    `;

/**
 * __useGetGamesQuery__
 *
 * To run a query within a React component, call `useGetGamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGamesQuery(baseOptions?: Apollo.QueryHookOptions<GetGamesQuery, GetGamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGamesQuery, GetGamesQueryVariables>(GetGamesDocument, options);
      }
export function useGetGamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGamesQuery, GetGamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGamesQuery, GetGamesQueryVariables>(GetGamesDocument, options);
        }
export type GetGamesQueryHookResult = ReturnType<typeof useGetGamesQuery>;
export type GetGamesLazyQueryHookResult = ReturnType<typeof useGetGamesLazyQuery>;
export type GetGamesQueryResult = Apollo.QueryResult<GetGamesQuery, GetGamesQueryVariables>;
export const GetHubRegistrationsDocument = gql`
    query GetHubRegistrations {
  hub_registrations {
    id
    name
    location
    website
    selected_qualifiers
    created_at
  }
}
    `;

/**
 * __useGetHubRegistrationsQuery__
 *
 * To run a query within a React component, call `useGetHubRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHubRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHubRegistrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHubRegistrationsQuery(baseOptions?: Apollo.QueryHookOptions<GetHubRegistrationsQuery, GetHubRegistrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHubRegistrationsQuery, GetHubRegistrationsQueryVariables>(GetHubRegistrationsDocument, options);
      }
export function useGetHubRegistrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHubRegistrationsQuery, GetHubRegistrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHubRegistrationsQuery, GetHubRegistrationsQueryVariables>(GetHubRegistrationsDocument, options);
        }
export type GetHubRegistrationsQueryHookResult = ReturnType<typeof useGetHubRegistrationsQuery>;
export type GetHubRegistrationsLazyQueryHookResult = ReturnType<typeof useGetHubRegistrationsLazyQuery>;
export type GetHubRegistrationsQueryResult = Apollo.QueryResult<GetHubRegistrationsQuery, GetHubRegistrationsQueryVariables>;
export const GetLiveEventDocument = gql`
    query GetLiveEvent($live_event_id: uuid!) {
  live_event: live_events_by_pk(id: $live_event_id) {
    id
    description
    event_start
    event_end
    name
    moderate_messages
    stream_url
    status {
      id
      name
      value
    }
    type {
      id
      name
      value
    }
  }
}
    `;

/**
 * __useGetLiveEventQuery__
 *
 * To run a query within a React component, call `useGetLiveEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLiveEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiveEventQuery({
 *   variables: {
 *      live_event_id: // value for 'live_event_id'
 *   },
 * });
 */
export function useGetLiveEventQuery(baseOptions: Apollo.QueryHookOptions<GetLiveEventQuery, GetLiveEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLiveEventQuery, GetLiveEventQueryVariables>(GetLiveEventDocument, options);
      }
export function useGetLiveEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLiveEventQuery, GetLiveEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLiveEventQuery, GetLiveEventQueryVariables>(GetLiveEventDocument, options);
        }
export type GetLiveEventQueryHookResult = ReturnType<typeof useGetLiveEventQuery>;
export type GetLiveEventLazyQueryHookResult = ReturnType<typeof useGetLiveEventLazyQuery>;
export type GetLiveEventQueryResult = Apollo.QueryResult<GetLiveEventQuery, GetLiveEventQueryVariables>;
export const GetMeDocument = gql`
    query getMe {
  me {
    id
    avatar
    name
    nickname
    email
    phone_number
    partyDetails {
      key
      value
    }
    tournament_registrations {
      id
    }
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetMyResultsDocument = gql`
    query GetMyResults($participants: jsonb, $gameId: uuid!) {
  tournament_results(
    where: {result: {_contains: $participants}, match: {game_id: {_eq: $gameId}}}
  ) {
    id
    match {
      id
      match_time
    }
    result
  }
}
    `;

/**
 * __useGetMyResultsQuery__
 *
 * To run a query within a React component, call `useGetMyResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyResultsQuery({
 *   variables: {
 *      participants: // value for 'participants'
 *      gameId: // value for 'gameId'
 *   },
 * });
 */
export function useGetMyResultsQuery(baseOptions: Apollo.QueryHookOptions<GetMyResultsQuery, GetMyResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyResultsQuery, GetMyResultsQueryVariables>(GetMyResultsDocument, options);
      }
export function useGetMyResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyResultsQuery, GetMyResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyResultsQuery, GetMyResultsQueryVariables>(GetMyResultsDocument, options);
        }
export type GetMyResultsQueryHookResult = ReturnType<typeof useGetMyResultsQuery>;
export type GetMyResultsLazyQueryHookResult = ReturnType<typeof useGetMyResultsLazyQuery>;
export type GetMyResultsQueryResult = Apollo.QueryResult<GetMyResultsQuery, GetMyResultsQueryVariables>;
export const GetMyStatsDocument = gql`
    query GetMyStats {
  myStats {
    id
    ranks
    scores
  }
}
    `;

/**
 * __useGetMyStatsQuery__
 *
 * To run a query within a React component, call `useGetMyStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyStatsQuery, GetMyStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyStatsQuery, GetMyStatsQueryVariables>(GetMyStatsDocument, options);
      }
export function useGetMyStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyStatsQuery, GetMyStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyStatsQuery, GetMyStatsQueryVariables>(GetMyStatsDocument, options);
        }
export type GetMyStatsQueryHookResult = ReturnType<typeof useGetMyStatsQuery>;
export type GetMyStatsLazyQueryHookResult = ReturnType<typeof useGetMyStatsLazyQuery>;
export type GetMyStatsQueryResult = Apollo.QueryResult<GetMyStatsQuery, GetMyStatsQueryVariables>;
export const GetPartiesDocument = gql`
    query GetParties($partyIds: [uuid!]!) {
  parties(where: {id: {_in: $partyIds}}) {
    id
    name: nickname
  }
}
    `;

/**
 * __useGetPartiesQuery__
 *
 * To run a query within a React component, call `useGetPartiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartiesQuery({
 *   variables: {
 *      partyIds: // value for 'partyIds'
 *   },
 * });
 */
export function useGetPartiesQuery(baseOptions: Apollo.QueryHookOptions<GetPartiesQuery, GetPartiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartiesQuery, GetPartiesQueryVariables>(GetPartiesDocument, options);
      }
export function useGetPartiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartiesQuery, GetPartiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartiesQuery, GetPartiesQueryVariables>(GetPartiesDocument, options);
        }
export type GetPartiesQueryHookResult = ReturnType<typeof useGetPartiesQuery>;
export type GetPartiesLazyQueryHookResult = ReturnType<typeof useGetPartiesLazyQuery>;
export type GetPartiesQueryResult = Apollo.QueryResult<GetPartiesQuery, GetPartiesQueryVariables>;
export const GetPartyDocument = gql`
    query GetParty($username: String) {
  party: parties(where: {nickname: {_ilike: $username}}) {
    id
    avatar
    name
    nickname
    partyDetails: party_details {
      id
      key
      value
    }
    tournament_registrations {
      id
    }
  }
}
    `;

/**
 * __useGetPartyQuery__
 *
 * To run a query within a React component, call `useGetPartyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartyQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetPartyQuery(baseOptions?: Apollo.QueryHookOptions<GetPartyQuery, GetPartyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartyQuery, GetPartyQueryVariables>(GetPartyDocument, options);
      }
export function useGetPartyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartyQuery, GetPartyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartyQuery, GetPartyQueryVariables>(GetPartyDocument, options);
        }
export type GetPartyQueryHookResult = ReturnType<typeof useGetPartyQuery>;
export type GetPartyLazyQueryHookResult = ReturnType<typeof useGetPartyLazyQuery>;
export type GetPartyQueryResult = Apollo.QueryResult<GetPartyQuery, GetPartyQueryVariables>;
export const GetPlayerTournamentsStatsDocument = gql`
    query getPlayerTournamentsStats($params: GetPlayerTournamentsStatsInput!) {
  getPlayerTournamentsStats(params: $params) {
    stats
  }
}
    `;

/**
 * __useGetPlayerTournamentsStatsQuery__
 *
 * To run a query within a React component, call `useGetPlayerTournamentsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerTournamentsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerTournamentsStatsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetPlayerTournamentsStatsQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerTournamentsStatsQuery, GetPlayerTournamentsStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerTournamentsStatsQuery, GetPlayerTournamentsStatsQueryVariables>(GetPlayerTournamentsStatsDocument, options);
      }
export function useGetPlayerTournamentsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerTournamentsStatsQuery, GetPlayerTournamentsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerTournamentsStatsQuery, GetPlayerTournamentsStatsQueryVariables>(GetPlayerTournamentsStatsDocument, options);
        }
export type GetPlayerTournamentsStatsQueryHookResult = ReturnType<typeof useGetPlayerTournamentsStatsQuery>;
export type GetPlayerTournamentsStatsLazyQueryHookResult = ReturnType<typeof useGetPlayerTournamentsStatsLazyQuery>;
export type GetPlayerTournamentsStatsQueryResult = Apollo.QueryResult<GetPlayerTournamentsStatsQuery, GetPlayerTournamentsStatsQueryVariables>;
export const GetTournamentDocument = gql`
    query GetTournament($tournamentId: uuid!) {
  tournament: tournaments_by_pk(id: $tournamentId) {
    id
    name
    description
    tournamentDate: tournament_date
    game {
      id
      name
      poster_url
    }
    tournamentStatuses: tournament_statuses {
      id
      created_at
      status {
        name
        value
      }
    }
    tournamentType: type {
      id
      name
      value
    }
    tournamentDetails: tournament_details {
      id
      key
      value
    }
    tournamentFlags: tournament_flags {
      id
      created_at
      flag {
        id
        name
        value
      }
    }
    participants: tournament_registrations(
      where: {status: {value: {_eq: "ACCEPTED"}}}
    ) {
      id
      party_id
      created_at
      party {
        id
        nickname
        name
        party_relationships {
          id
          participant
          partyByParticipant {
            id
            name
            nickname
          }
        }
      }
    }
    results: tournament_results(order_by: {created_at: asc}) {
      id
      match_id
      result
      match {
        id
        match_time
        name
      }
    }
  }
}
    `;

/**
 * __useGetTournamentQuery__
 *
 * To run a query within a React component, call `useGetTournamentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTournamentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTournamentQuery({
 *   variables: {
 *      tournamentId: // value for 'tournamentId'
 *   },
 * });
 */
export function useGetTournamentQuery(baseOptions: Apollo.QueryHookOptions<GetTournamentQuery, GetTournamentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTournamentQuery, GetTournamentQueryVariables>(GetTournamentDocument, options);
      }
export function useGetTournamentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTournamentQuery, GetTournamentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTournamentQuery, GetTournamentQueryVariables>(GetTournamentDocument, options);
        }
export type GetTournamentQueryHookResult = ReturnType<typeof useGetTournamentQuery>;
export type GetTournamentLazyQueryHookResult = ReturnType<typeof useGetTournamentLazyQuery>;
export type GetTournamentQueryResult = Apollo.QueryResult<GetTournamentQuery, GetTournamentQueryVariables>;
export const GetTournamentStatsDocument = gql`
    query GetTournamentStats($params: GetTournamentStatsInput!) {
  getTournamentStats(params: $params) {
    stats
  }
}
    `;

/**
 * __useGetTournamentStatsQuery__
 *
 * To run a query within a React component, call `useGetTournamentStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTournamentStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTournamentStatsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetTournamentStatsQuery(baseOptions: Apollo.QueryHookOptions<GetTournamentStatsQuery, GetTournamentStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTournamentStatsQuery, GetTournamentStatsQueryVariables>(GetTournamentStatsDocument, options);
      }
export function useGetTournamentStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTournamentStatsQuery, GetTournamentStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTournamentStatsQuery, GetTournamentStatsQueryVariables>(GetTournamentStatsDocument, options);
        }
export type GetTournamentStatsQueryHookResult = ReturnType<typeof useGetTournamentStatsQuery>;
export type GetTournamentStatsLazyQueryHookResult = ReturnType<typeof useGetTournamentStatsLazyQuery>;
export type GetTournamentStatsQueryResult = Apollo.QueryResult<GetTournamentStatsQuery, GetTournamentStatsQueryVariables>;
export const FindGamersDocument = gql`
    query FindGamers($searchTerm: String!) {
  parties: search_gamers(args: {search: $searchTerm}) {
    id
    name
    nickname
  }
}
    `;

/**
 * __useFindGamersQuery__
 *
 * To run a query within a React component, call `useFindGamersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindGamersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindGamersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useFindGamersQuery(baseOptions: Apollo.QueryHookOptions<FindGamersQuery, FindGamersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindGamersQuery, FindGamersQueryVariables>(FindGamersDocument, options);
      }
export function useFindGamersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindGamersQuery, FindGamersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindGamersQuery, FindGamersQueryVariables>(FindGamersDocument, options);
        }
export type FindGamersQueryHookResult = ReturnType<typeof useFindGamersQuery>;
export type FindGamersLazyQueryHookResult = ReturnType<typeof useFindGamersLazyQuery>;
export type FindGamersQueryResult = Apollo.QueryResult<FindGamersQuery, FindGamersQueryVariables>;
export const SearchGamersDocument = gql`
    query SearchGamers($searchTerm: String!) {
  parties(
    where: {_or: [{name: {_ilike: $searchTerm}}, {nickname: {_ilike: $searchTerm}}], type: {value: {_eq: "GAMER"}}}
    limit: 10
  ) {
    id
    name
    nickname
  }
}
    `;

/**
 * __useSearchGamersQuery__
 *
 * To run a query within a React component, call `useSearchGamersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchGamersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchGamersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchGamersQuery(baseOptions: Apollo.QueryHookOptions<SearchGamersQuery, SearchGamersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchGamersQuery, SearchGamersQueryVariables>(SearchGamersDocument, options);
      }
export function useSearchGamersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchGamersQuery, SearchGamersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchGamersQuery, SearchGamersQueryVariables>(SearchGamersDocument, options);
        }
export type SearchGamersQueryHookResult = ReturnType<typeof useSearchGamersQuery>;
export type SearchGamersLazyQueryHookResult = ReturnType<typeof useSearchGamersLazyQuery>;
export type SearchGamersQueryResult = Apollo.QueryResult<SearchGamersQuery, SearchGamersQueryVariables>;
export const GetLiveEventMessagesDocument = gql`
    subscription GetLiveEventMessages($live_event_id: uuid!) {
  live_event_messages(where: {live_event_id: {_eq: $live_event_id}}) {
    id
    message
    parent_id
    sender
    senderDetails: party {
      id
      name
      nickname
      avatar
    }
    created_at
  }
}
    `;

/**
 * __useGetLiveEventMessagesSubscription__
 *
 * To run a query within a React component, call `useGetLiveEventMessagesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetLiveEventMessagesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiveEventMessagesSubscription({
 *   variables: {
 *      live_event_id: // value for 'live_event_id'
 *   },
 * });
 */
export function useGetLiveEventMessagesSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetLiveEventMessagesSubscription, GetLiveEventMessagesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetLiveEventMessagesSubscription, GetLiveEventMessagesSubscriptionVariables>(GetLiveEventMessagesDocument, options);
      }
export type GetLiveEventMessagesSubscriptionHookResult = ReturnType<typeof useGetLiveEventMessagesSubscription>;
export type GetLiveEventMessagesSubscriptionResult = Apollo.SubscriptionResult<GetLiveEventMessagesSubscription>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    